import { FeatureMap, FeatureInputMap, OpeningSuggestionInput } from '@mapmaker/core';
import { RenderablePropsWithRefs, RenderOutput } from '@mapmaker/renderable';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  FeatureInputMap: { input: FeatureInputMap; output: FeatureInputMap; }
  FeatureMap: { input: FeatureMap; output: FeatureMap; }
  GUID: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  OpeningSuggestionInput: { input: OpeningSuggestionInput; output: OpeningSuggestionInput; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RenderOutput: { input: RenderOutput; output: RenderOutput; }
  RenderablePropsWithRefs: { input: RenderablePropsWithRefs; output: RenderablePropsWithRefs; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  StorefrontColor: { input: any; output: any; }
  StorefrontDateTime: { input: string; output: string; }
  StorefrontDecimal: { input: string; output: string; }
  StorefrontHTML: { input: string; output: string; }
  StorefrontJSON: { input: any; output: any; }
  StorefrontURL: { input: string; output: string; }
  StorefrontUnsignedInt64: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AddMapmakerFileAccessInput = {
  fileId: Scalars['String']['input'];
  granteeEmail: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  role: FileAccessRole;
};

export type AddMapmakerFileAccessResponse = {
  __typename?: 'AddMapmakerFileAccessResponse';
  file: MapmakerFile;
  fileAccess: MapmakerFileAccess;
};

export type Aside = {
  __typename?: 'Aside';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  contentRaw?: Maybe<Scalars['JSON']['output']>;
  /** Optional header text. Keep it as short as possible. Will use the reason if left blank. */
  header?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type AsideFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  header?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringFilter>;
};

export type AsideOrBlockOrContentImageOrScreenshotOrYoutube = Aside | Block | ContentImage | Screenshot | Youtube;

export type AsideSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  header?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
};

export type Author = Document & {
  __typename?: 'Author';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Slug>;
};

export type AuthorFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  image?: InputMaybe<ImageFilter>;
  name?: InputMaybe<StringFilter>;
  slug?: InputMaybe<SlugFilter>;
};

export type AuthorSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
  name?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
};

export type BasicLineItem = OrderItem & {
  __typename?: 'BasicLineItem';
  attributes: Scalars['JSONObject']['output'];
  description: Scalars['String']['output'];
  discountedUnitPrice: Scalars['Float']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type Block = {
  __typename?: 'Block';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<Span>>>;
  list?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type BlockOrContentImageOrYoutube = Block | ContentImage | Youtube;

export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactField = {
  label: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentImage = {
  __typename?: 'ContentImage';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  /** Optional */
  caption?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
};

export type ContentImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
};

export type ContentImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  caption?: InputMaybe<SortOrder>;
  image?: InputMaybe<ImageSorting>;
};

export type ConvertLegacyMapmakerFileRequest = {
  legacyFile: Scalars['JSONObject']['input'];
};

export type ConvertLegacyMapmakerFileResponse = {
  __typename?: 'ConvertLegacyMapmakerFileResponse';
  fileId: Scalars['String']['output'];
};

export type CreateMapmakerFileInput = {
  designId: Scalars['String']['input'];
  inputs?: InputMaybe<Scalars['FeatureInputMap']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputScale?: InputMaybe<Scalars['Float']['input']>;
  outputType?: InputMaybe<ProjectOutputType>;
  retain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMapmakerFileResponse = {
  __typename?: 'CreateMapmakerFileResponse';
  file: MapmakerFile;
};

export type CreateOpeningSuggestionInput = {
  fileId: Scalars['String']['input'];
  input: Scalars['OpeningSuggestionInput']['input'];
  openingId: Scalars['String']['input'];
};

export type CreateOpeningSuggestionResponse = {
  __typename?: 'CreateOpeningSuggestionResponse';
  suggestion: OpeningSuggestion;
};

export type CreateRectangularPrintsRequest = {
  dpi?: InputMaybe<Scalars['Int']['input']>;
  fileId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  printLayouts: Array<RectangularPrintLayoutInput>;
  printOptions?: InputMaybe<RectangularPrintOptions>;
};

export type CreateRectangularPrintsResponse = {
  __typename?: 'CreateRectangularPrintsResponse';
  prints?: Maybe<Array<Maybe<RectangularPrintFile>>>;
};

export type CreateStickerOrderInput = {
  fileId: Scalars['String']['input'];
  /** Output type can be made required after July 2022 */
  outputType?: InputMaybe<ProjectOutputType>;
  stickers: Array<StickerOrderItemInput>;
};

export type CreateTicketInput = {
  email: Scalars['String']['input'];
  fields?: InputMaybe<Array<InputMaybe<ContactField>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTicketResult = {
  __typename?: 'CreateTicketResult';
  created: Scalars['Boolean']['output'];
};

export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Date']['input']>;
};

export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMapmakerFileAccessInput = {
  fileId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type DeleteMapmakerFileAccessResponse = {
  __typename?: 'DeleteMapmakerFileAccessResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteMapmakerFileInput = {
  fileId: Scalars['String']['input'];
};

export type DeleteMapmakerFileResponse = {
  __typename?: 'DeleteMapmakerFileResponse';
  file: MapmakerFile;
};

export type DeleteOpeningSuggestionInput = {
  fileId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
};

export type DeleteOpeningSuggestionResponse = {
  __typename?: 'DeleteOpeningSuggestionResponse';
  success: Scalars['Boolean']['output'];
};

/** A Sanity document */
export type Document = {
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
};

export type DocumentSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
};

export type DuplicateMapmakerFileInput = {
  fileId: Scalars['String']['input'];
};

export type DuplicateMapmakerFileResponse = {
  __typename?: 'DuplicateMapmakerFileResponse';
  file: MapmakerFile;
};

export type EnterPromotionRequest = {
  promotionId: Scalars['String']['input'];
  submission?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type EnterPromotionResponse = {
  __typename?: 'EnterPromotionResponse';
  entry: PromotionEntry;
  success: Scalars['Boolean']['output'];
};

export type File = {
  __typename?: 'File';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<SanityFileAsset>;
};

export enum FileAccessRole {
  Collaborator = 'COLLABORATOR',
  Viewer = 'VIEWER'
}

export type FileFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityFileAssetFilter>;
};

export type FileSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
};

export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Float']['input']>;
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  trackingInfo: Array<TrackingInfo>;
};

export type Geopoint = {
  __typename?: 'Geopoint';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type GeopointFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  alt?: InputMaybe<FloatFilter>;
  lat?: InputMaybe<FloatFilter>;
  lng?: InputMaybe<FloatFilter>;
};

export type GeopointSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  alt?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
};

export type GetMapmakerDesignsRequest = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HideOpeningSuggestionInput = {
  fileId: Scalars['String']['input'];
  hide: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
};

export type HideOpeningSuggestionResponse = {
  __typename?: 'HideOpeningSuggestionResponse';
  suggestion: OpeningSuggestion;
};

export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['ID']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['ID']['input']>;
  nin?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Image = {
  __typename?: 'Image';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<SanityImageAsset>;
  crop?: Maybe<SanityImageCrop>;
  height: Scalars['Int']['output'];
  hotspot?: Maybe<SanityImageHotspot>;
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type ImageDetails = {
  qty: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type ImageFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  asset?: InputMaybe<SanityImageAssetFilter>;
  crop?: InputMaybe<SanityImageCropFilter>;
  hotspot?: InputMaybe<SanityImageHotspotFilter>;
};

export type ImageSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  crop?: InputMaybe<SanityImageCropSorting>;
  hotspot?: InputMaybe<SanityImageHotspotSorting>;
};

export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Int']['input']>;
};

export type InvalidateMapmakerDesignCacheResponse = {
  __typename?: 'InvalidateMapmakerDesignCacheResponse';
  result: Scalars['Boolean']['output'];
};

export type MapLineItem = OrderItem & {
  __typename?: 'MapLineItem';
  attributes: Scalars['JSONObject']['output'];
  blueprintId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discountedUnitPrice: Scalars['Float']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type MapStickerInfo = {
  __typename?: 'MapStickerInfo';
  count: Scalars['Int']['output'];
  sizeClassGroups: Array<StickerSizeClassGroup>;
  tokens: Scalars['Float']['output'];
};

export type MapmakerAccount = {
  businessId: Scalars['String']['output'];
  files: Array<MapmakerFile>;
  id: Scalars['String']['output'];
  mapmakerFileCount: Scalars['Int']['output'];
  stickerOrders: Array<StickerOrder>;
  walgreensOrders: Array<WalgreensOrder>;
};


export type MapmakerAccountFilesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MapmakerAuthenticatedAccount = MapmakerAccount & {
  __typename?: 'MapmakerAuthenticatedAccount';
  businessId: Scalars['String']['output'];
  /** Authenticated Specific Fields */
  email: Scalars['String']['output'];
  files: Array<MapmakerFile>;
  id: Scalars['String']['output'];
  mapmakerFileCount: Scalars['Int']['output'];
  stickerOrders: Array<StickerOrder>;
  stickerTokenBalance: Scalars['Float']['output'];
  walgreensOrders: Array<WalgreensOrder>;
};


export type MapmakerAuthenticatedAccountFilesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MapmakerBusinessId {
  Pm = 'pm',
  Tbl = 'tbl'
}

export type MapmakerDesign = {
  __typename?: 'MapmakerDesign';
  businessId: Scalars['String']['output'];
  features: Scalars['FeatureMap']['output'];
  height: Scalars['Int']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  keywords: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  newProjectUrl: Scalars['String']['output'];
  outputOptions: Array<ProjectOutputOption>;
  regionCount: Scalars['Int']['output'];
  regionType: Scalars['String']['output'];
  regionTypePlural: Scalars['String']['output'];
  stickerInfo: MapStickerInfo;
  thumbnailUrl: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};


export type MapmakerDesignStickerInfoArgs = {
  outputType: ProjectOutputType;
  scale: Scalars['Float']['input'];
};

export type MapmakerFile = {
  __typename?: 'MapmakerFile';
  accessPolicy: MapmakerFileAccessPolicy;
  backupVersion: Scalars['String']['output'];
  businessId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  design: MapmakerDesign;
  designId: Scalars['String']['output'];
  fileAccesses: Array<MapmakerFileAccess>;
  id: Scalars['String']['output'];
  inputs: Scalars['FeatureInputMap']['output'];
  name: Scalars['String']['output'];
  openingSuggestions: Array<OpeningSuggestion>;
  openingsWithImages: Scalars['Int']['output'];
  outputScale: Scalars['Float']['output'];
  outputType: ProjectOutputType;
  ownerId: Scalars['String']['output'];
  previewImageUrl: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
  viewerPolicy: MapmakerFileViewerPolicy;
};

export type MapmakerFileAccess = {
  __typename?: 'MapmakerFileAccess';
  fileId: Scalars['String']['output'];
  granteeEmail: Scalars['String']['output'];
  granteeHasAccount: Scalars['Boolean']['output'];
  granteeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  role: FileAccessRole;
};

export enum MapmakerFileAccessPolicy {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  PublicCollaborators = 'PUBLIC_COLLABORATORS'
}

export type MapmakerFileOrDesignRequest = {
  designId?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
};

export type MapmakerFileOrDesignResponse = {
  __typename?: 'MapmakerFileOrDesignResponse';
  design: MapmakerDesign;
  file?: Maybe<MapmakerFile>;
};

export enum MapmakerFileViewerPolicy {
  Collaborator = 'COLLABORATOR',
  None = 'NONE',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export enum MapmakerLicensePolicy {
  FullDigitalRights = 'FULL_DIGITAL_RIGHTS',
  None = 'NONE'
}

export type MapmakerUnauthenticatedAccount = MapmakerAccount & {
  __typename?: 'MapmakerUnauthenticatedAccount';
  businessId: Scalars['String']['output'];
  files: Array<MapmakerFile>;
  id: Scalars['String']['output'];
  mapmakerFileCount: Scalars['Int']['output'];
  stickerOrders: Array<StickerOrder>;
  walgreensOrders: Array<WalgreensOrder>;
};


export type MapmakerUnauthenticatedAccountFilesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MergeMapmakerFileInput = {
  allowInputCollisions?: InputMaybe<Scalars['Boolean']['input']>;
  deleteSourceFiles?: InputMaybe<Scalars['Boolean']['input']>;
  fileIds: Array<Scalars['String']['input']>;
  newName?: InputMaybe<Scalars['String']['input']>;
};

export type MergeMapmakerFileResponse = {
  __typename?: 'MergeMapmakerFileResponse';
  file: MapmakerFile;
  sourceFiles: Array<MapmakerFile>;
};

export type MigrateMapmakerFileInput = {
  fileId: Scalars['String']['input'];
  newDesignId: Scalars['String']['input'];
};

export type MigrateMapmakerFileResponse = {
  __typename?: 'MigrateMapmakerFileResponse';
  file: MapmakerFile;
};

/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  addMapmakerFileAccess: AddMapmakerFileAccessResponse;
  convertLegacyMapmakerFile?: Maybe<ConvertLegacyMapmakerFileResponse>;
  createMapmakerFile: CreateMapmakerFileResponse;
  createOpeningSuggestion: CreateOpeningSuggestionResponse;
  createPresignedPost?: Maybe<PresignedPost>;
  createRectangularPrints?: Maybe<CreateRectangularPrintsResponse>;
  /** After July 2022 the input variable can be made required. */
  createStickerOrder: StickerOrder;
  createTicket?: Maybe<CreateTicketResult>;
  deleteMapmakerFile: DeleteMapmakerFileResponse;
  deleteMapmakerFileAccess: DeleteMapmakerFileAccessResponse;
  deleteOpeningSuggestion: DeleteOpeningSuggestionResponse;
  duplicateMapmakerFile: DuplicateMapmakerFileResponse;
  enterPromotion: EnterPromotionResponse;
  hideOpeningSuggestion: HideOpeningSuggestionResponse;
  invalidateMapmakerDesignCache: InvalidateMapmakerDesignCacheResponse;
  mergeMapmakerFiles: MergeMapmakerFileResponse;
  migrateMapmakerFile: MigrateMapmakerFileResponse;
  presignedImageUpload?: Maybe<PresignedPost>;
  redeemStickerTokenVoucher: RedeemStickerTokenVoucherResponse;
  render: RenderResult;
  /** Updates the attributes on a cart. */
  storefrontCartAttributesUpdate?: Maybe<StorefrontCartAttributesUpdatePayload>;
  /**
   * Updates customer information associated with a cart.
   * Buyer identity is used to determine
   * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
   * and should match the customer's shipping address.
   *
   */
  storefrontCartBuyerIdentityUpdate?: Maybe<StorefrontCartBuyerIdentityUpdatePayload>;
  /** Creates a new cart. */
  storefrontCartCreate?: Maybe<StorefrontCartCreatePayload>;
  /** Updates the discount codes applied to the cart. */
  storefrontCartDiscountCodesUpdate?: Maybe<StorefrontCartDiscountCodesUpdatePayload>;
  /** Adds a merchandise line to the cart. */
  storefrontCartLinesAdd?: Maybe<StorefrontCartLinesAddPayload>;
  /** Removes one or more merchandise lines from the cart. */
  storefrontCartLinesRemove?: Maybe<StorefrontCartLinesRemovePayload>;
  /** Updates one or more merchandise lines on a cart. */
  storefrontCartLinesUpdate?: Maybe<StorefrontCartLinesUpdatePayload>;
  /** Deletes a cart metafield. */
  storefrontCartMetafieldDelete?: Maybe<StorefrontCartMetafieldDeletePayload>;
  /**
   * Sets cart metafield values. Cart metafield values will be set regardless if they were previously created or not.
   *
   * Allows a maximum of 25 cart metafields to be set at a time.
   *
   */
  storefrontCartMetafieldsSet?: Maybe<StorefrontCartMetafieldsSetPayload>;
  /** Updates the note on the cart. */
  storefrontCartNoteUpdate?: Maybe<StorefrontCartNoteUpdatePayload>;
  /** Update the customer's payment method that will be used to checkout. */
  storefrontCartPaymentUpdate?: Maybe<StorefrontCartPaymentUpdatePayload>;
  /** Update the selected delivery options for a delivery group. */
  storefrontCartSelectedDeliveryOptionsUpdate?: Maybe<StorefrontCartSelectedDeliveryOptionsUpdatePayload>;
  /** Submit the cart for checkout completion. */
  storefrontCartSubmitForCompletion?: Maybe<StorefrontCartSubmitForCompletionPayload>;
  /** Updates the attributes of a checkout if `allowPartialAddresses` is `true`. */
  storefrontCheckoutAttributesUpdateV2?: Maybe<StorefrontCheckoutAttributesUpdateV2Payload>;
  /** Completes a checkout without providing payment information. You can use this mutation for free items or items whose purchase price is covered by a gift card. */
  storefrontCheckoutCompleteFree?: Maybe<StorefrontCheckoutCompleteFreePayload>;
  /** Completes a checkout using a credit card token from Shopify's card vault. Before you can complete checkouts using CheckoutCompleteWithCreditCardV2, you need to  [_request payment processing_](https://shopify.dev/apps/channels/getting-started#request-payment-processing). */
  storefrontCheckoutCompleteWithCreditCardV2?: Maybe<StorefrontCheckoutCompleteWithCreditCardV2Payload>;
  /** Completes a checkout with a tokenized payment. */
  storefrontCheckoutCompleteWithTokenizedPaymentV3?: Maybe<StorefrontCheckoutCompleteWithTokenizedPaymentV3Payload>;
  /** Creates a new checkout. */
  storefrontCheckoutCreate?: Maybe<StorefrontCheckoutCreatePayload>;
  /** Associates a customer to the checkout. */
  storefrontCheckoutCustomerAssociateV2?: Maybe<StorefrontCheckoutCustomerAssociateV2Payload>;
  /** Disassociates the current checkout customer from the checkout. */
  storefrontCheckoutCustomerDisassociateV2?: Maybe<StorefrontCheckoutCustomerDisassociateV2Payload>;
  /** Applies a discount to an existing checkout using a discount code. */
  storefrontCheckoutDiscountCodeApplyV2?: Maybe<StorefrontCheckoutDiscountCodeApplyV2Payload>;
  /** Removes the applied discounts from an existing checkout. */
  storefrontCheckoutDiscountCodeRemove?: Maybe<StorefrontCheckoutDiscountCodeRemovePayload>;
  /** Updates the email on an existing checkout. */
  storefrontCheckoutEmailUpdateV2?: Maybe<StorefrontCheckoutEmailUpdateV2Payload>;
  /** Removes an applied gift card from the checkout. */
  storefrontCheckoutGiftCardRemoveV2?: Maybe<StorefrontCheckoutGiftCardRemoveV2Payload>;
  /** Appends gift cards to an existing checkout. */
  storefrontCheckoutGiftCardsAppend?: Maybe<StorefrontCheckoutGiftCardsAppendPayload>;
  /** Adds a list of line items to a checkout. */
  storefrontCheckoutLineItemsAdd?: Maybe<StorefrontCheckoutLineItemsAddPayload>;
  /** Removes line items from an existing checkout. */
  storefrontCheckoutLineItemsRemove?: Maybe<StorefrontCheckoutLineItemsRemovePayload>;
  /** Sets a list of line items to a checkout. */
  storefrontCheckoutLineItemsReplace?: Maybe<StorefrontCheckoutLineItemsReplacePayload>;
  /** Updates line items on a checkout. */
  storefrontCheckoutLineItemsUpdate?: Maybe<StorefrontCheckoutLineItemsUpdatePayload>;
  /** Updates the shipping address of an existing checkout. */
  storefrontCheckoutShippingAddressUpdateV2?: Maybe<StorefrontCheckoutShippingAddressUpdateV2Payload>;
  /** Updates the shipping lines on an existing checkout. */
  storefrontCheckoutShippingLineUpdate?: Maybe<StorefrontCheckoutShippingLineUpdatePayload>;
  /**
   * Creates a customer access token.
   * The customer access token is required to modify the customer object in any way.
   *
   */
  storefrontCustomerAccessTokenCreate?: Maybe<StorefrontCustomerAccessTokenCreatePayload>;
  /**
   * Creates a customer access token using a
   * [multipass token](https://shopify.dev/api/multipass) instead of email and
   * password. A customer record is created if the customer doesn't exist. If a customer
   * record already exists but the record is disabled, then the customer record is enabled.
   *
   */
  storefrontCustomerAccessTokenCreateWithMultipass?: Maybe<StorefrontCustomerAccessTokenCreateWithMultipassPayload>;
  /** Permanently destroys a customer access token. */
  storefrontCustomerAccessTokenDelete?: Maybe<StorefrontCustomerAccessTokenDeletePayload>;
  /**
   * Renews a customer access token.
   *
   * Access token renewal must happen *before* a token expires.
   * If a token has already expired, a new one should be created instead via `customerAccessTokenCreate`.
   *
   */
  storefrontCustomerAccessTokenRenew?: Maybe<StorefrontCustomerAccessTokenRenewPayload>;
  /** Activates a customer. */
  storefrontCustomerActivate?: Maybe<StorefrontCustomerActivatePayload>;
  /** Activates a customer with the activation url received from `customerCreate`. */
  storefrontCustomerActivateByUrl?: Maybe<StorefrontCustomerActivateByUrlPayload>;
  /** Creates a new address for a customer. */
  storefrontCustomerAddressCreate?: Maybe<StorefrontCustomerAddressCreatePayload>;
  /** Permanently deletes the address of an existing customer. */
  storefrontCustomerAddressDelete?: Maybe<StorefrontCustomerAddressDeletePayload>;
  /** Updates the address of an existing customer. */
  storefrontCustomerAddressUpdate?: Maybe<StorefrontCustomerAddressUpdatePayload>;
  /** Creates a new customer. */
  storefrontCustomerCreate?: Maybe<StorefrontCustomerCreatePayload>;
  /** Updates the default address of an existing customer. */
  storefrontCustomerDefaultAddressUpdate?: Maybe<StorefrontCustomerDefaultAddressUpdatePayload>;
  /**
   * Sends a reset password email to the customer. The reset password
   * email contains a reset password URL and token that you can pass to
   * the [`customerResetByUrl`](https://shopify.dev/api/storefront/latest/mutations/customerResetByUrl) or
   * [`customerReset`](https://shopify.dev/api/storefront/latest/mutations/customerReset) mutation to reset the
   * customer password.
   *
   * This mutation is throttled by IP. With private access,
   * you can provide a [`Shopify-Storefront-Buyer-IP`](https://shopify.dev/api/usage/authentication#optional-ip-header) instead of the request IP.
   * The header is case-sensitive and must be sent as `Shopify-Storefront-Buyer-IP`.
   *
   * Make sure that the value provided to `Shopify-Storefront-Buyer-IP` is trusted. Unthrottled access to this
   * mutation presents a security risk.
   *
   */
  storefrontCustomerRecover?: Maybe<StorefrontCustomerRecoverPayload>;
  /**
   * "Resets a customer’s password with the token received from a reset password email. You can send a reset password email with the [`customerRecover`](https://shopify.dev/api/storefront/latest/mutations/customerRecover) mutation."
   *
   */
  storefrontCustomerReset?: Maybe<StorefrontCustomerResetPayload>;
  /**
   * "Resets a customer’s password with the reset password URL received from a reset password email. You can send a reset password email with the [`customerRecover`](https://shopify.dev/api/storefront/latest/mutations/customerRecover) mutation."
   *
   */
  storefrontCustomerResetByUrl?: Maybe<StorefrontCustomerResetByUrlPayload>;
  /** Updates an existing customer. */
  storefrontCustomerUpdate?: Maybe<StorefrontCustomerUpdatePayload>;
  submitOpeningSuggestion: SubmitOpeningSuggestionResponse;
  updateMapmakerFile: UpdateMapmakerFileResponse;
  updateOpeningSuggestion: UpdateOpeningSuggestionResponse;
  walgreensSubmitOrder?: Maybe<WalgreensSubmitOrderResponse>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationAddMapmakerFileAccessArgs = {
  input: AddMapmakerFileAccessInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationConvertLegacyMapmakerFileArgs = {
  input?: InputMaybe<ConvertLegacyMapmakerFileRequest>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateMapmakerFileArgs = {
  input: CreateMapmakerFileInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateOpeningSuggestionArgs = {
  input: CreateOpeningSuggestionInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreatePresignedPostArgs = {
  folder?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateRectangularPrintsArgs = {
  input?: InputMaybe<CreateRectangularPrintsRequest>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateStickerOrderArgs = {
  input?: InputMaybe<CreateStickerOrderInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationCreateTicketArgs = {
  input?: InputMaybe<CreateTicketInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteMapmakerFileArgs = {
  input: DeleteMapmakerFileInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteMapmakerFileAccessArgs = {
  input: DeleteMapmakerFileAccessInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDeleteOpeningSuggestionArgs = {
  input: DeleteOpeningSuggestionInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationDuplicateMapmakerFileArgs = {
  input: DuplicateMapmakerFileInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationEnterPromotionArgs = {
  input: EnterPromotionRequest;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationHideOpeningSuggestionArgs = {
  input: HideOpeningSuggestionInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationMergeMapmakerFilesArgs = {
  input: MergeMapmakerFileInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationMigrateMapmakerFileArgs = {
  input: MigrateMapmakerFileInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationRedeemStickerTokenVoucherArgs = {
  input: RedeemStickerTokenVoucherRequest;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationRenderArgs = {
  request: RenderRequest;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartAttributesUpdateArgs = {
  attributes: Array<StorefrontAttributeInput>;
  cartId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartBuyerIdentityUpdateArgs = {
  buyerIdentity: StorefrontCartBuyerIdentityInput;
  cartId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartCreateArgs = {
  input?: InputMaybe<StorefrontCartInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartDiscountCodesUpdateArgs = {
  cartId: Scalars['ID']['input'];
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartLinesAddArgs = {
  cartId: Scalars['ID']['input'];
  lines: Array<StorefrontCartLineInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartLinesRemoveArgs = {
  cartId: Scalars['ID']['input'];
  lineIds: Array<Scalars['ID']['input']>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartLinesUpdateArgs = {
  cartId: Scalars['ID']['input'];
  lines: Array<StorefrontCartLineUpdateInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartMetafieldDeleteArgs = {
  input: StorefrontCartMetafieldDeleteInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartMetafieldsSetArgs = {
  metafields: Array<StorefrontCartMetafieldsSetInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartNoteUpdateArgs = {
  cartId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartPaymentUpdateArgs = {
  cartId: Scalars['ID']['input'];
  payment: StorefrontCartPaymentInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartSelectedDeliveryOptionsUpdateArgs = {
  cartId: Scalars['ID']['input'];
  selectedDeliveryOptions: Array<StorefrontCartSelectedDeliveryOptionInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCartSubmitForCompletionArgs = {
  attemptToken: Scalars['String']['input'];
  cartId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutAttributesUpdateV2Args = {
  checkoutId: Scalars['ID']['input'];
  input: StorefrontCheckoutAttributesUpdateV2Input;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutCompleteFreeArgs = {
  checkoutId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutCompleteWithCreditCardV2Args = {
  checkoutId: Scalars['ID']['input'];
  payment: StorefrontCreditCardPaymentInputV2;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutCompleteWithTokenizedPaymentV3Args = {
  checkoutId: Scalars['ID']['input'];
  payment: StorefrontTokenizedPaymentInputV3;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutCreateArgs = {
  input: StorefrontCheckoutCreateInput;
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutCustomerAssociateV2Args = {
  checkoutId: Scalars['ID']['input'];
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutCustomerDisassociateV2Args = {
  checkoutId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutDiscountCodeApplyV2Args = {
  checkoutId: Scalars['ID']['input'];
  discountCode: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutDiscountCodeRemoveArgs = {
  checkoutId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutEmailUpdateV2Args = {
  checkoutId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutGiftCardRemoveV2Args = {
  appliedGiftCardId: Scalars['ID']['input'];
  checkoutId: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutGiftCardsAppendArgs = {
  checkoutId: Scalars['ID']['input'];
  giftCardCodes: Array<Scalars['String']['input']>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutLineItemsAddArgs = {
  checkoutId: Scalars['ID']['input'];
  lineItems: Array<StorefrontCheckoutLineItemInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutLineItemsRemoveArgs = {
  checkoutId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutLineItemsReplaceArgs = {
  checkoutId: Scalars['ID']['input'];
  lineItems: Array<StorefrontCheckoutLineItemInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutLineItemsUpdateArgs = {
  checkoutId: Scalars['ID']['input'];
  lineItems: Array<StorefrontCheckoutLineItemUpdateInput>;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutShippingAddressUpdateV2Args = {
  checkoutId: Scalars['ID']['input'];
  shippingAddress: StorefrontMailingAddressInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCheckoutShippingLineUpdateArgs = {
  checkoutId: Scalars['ID']['input'];
  shippingRateHandle: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAccessTokenCreateArgs = {
  input: StorefrontCustomerAccessTokenCreateInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAccessTokenCreateWithMultipassArgs = {
  multipassToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAccessTokenDeleteArgs = {
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAccessTokenRenewArgs = {
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerActivateArgs = {
  id: Scalars['ID']['input'];
  input: StorefrontCustomerActivateInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerActivateByUrlArgs = {
  activationUrl: Scalars['StorefrontURL']['input'];
  password: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAddressCreateArgs = {
  address: StorefrontMailingAddressInput;
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAddressDeleteArgs = {
  customerAccessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerAddressUpdateArgs = {
  address: StorefrontMailingAddressInput;
  customerAccessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerCreateArgs = {
  input: StorefrontCustomerCreateInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerDefaultAddressUpdateArgs = {
  addressId: Scalars['ID']['input'];
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerRecoverArgs = {
  email: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerResetArgs = {
  id: Scalars['ID']['input'];
  input: StorefrontCustomerResetInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerResetByUrlArgs = {
  password: Scalars['String']['input'];
  resetUrl: Scalars['StorefrontURL']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationStorefrontCustomerUpdateArgs = {
  customer: StorefrontCustomerUpdateInput;
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationSubmitOpeningSuggestionArgs = {
  input: SubmitOpeningSuggestionInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationUpdateMapmakerFileArgs = {
  input: UpdateMapmakerFileInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationUpdateOpeningSuggestionArgs = {
  input: UpdateOpeningSuggestionInput;
};


/** The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start. */
export type MutationWalgreensSubmitOrderArgs = {
  input?: InputMaybe<WalgreensSubmitOrderInput>;
};

export type Navigation = Document & {
  __typename?: 'Navigation';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  children?: Maybe<Array<Maybe<NavigationLink>>>;
  id?: Maybe<Slug>;
  /** The title of the navigation shown to users. */
  title?: Maybe<Scalars['String']['output']>;
};

export type NavigationFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
};

export type NavigationLink = {
  __typename?: 'NavigationLink';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Maybe<NavigationLink>>>;
  /** Do not hide truly sensitive things this way! */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** No target page turns the item into a subheading. */
  target?: Maybe<Page>;
  /** If you want the menu item to be titled differently than the page, set this. */
  title?: Maybe<Scalars['String']['output']>;
};

export type NavigationLinkFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  hidden?: InputMaybe<BooleanFilter>;
  target?: InputMaybe<PageFilter>;
  title?: InputMaybe<StringFilter>;
};

export type NavigationLinkSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  hidden?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type NavigationSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SlugSorting>;
  title?: InputMaybe<SortOrder>;
};

export type OpeningStickerInfo = {
  __typename?: 'OpeningStickerInfo';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OpeningSuggestion = {
  __typename?: 'OpeningSuggestion';
  fileId: Scalars['String']['output'];
  fileOwnerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  input: Scalars['OpeningSuggestionInput']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  openingId: Scalars['String']['output'];
  status: OpeningSuggestionStatus;
  submittedAt?: Maybe<Scalars['String']['output']>;
  suggesterId: Scalars['String']['output'];
};

export enum OpeningSuggestionStatus {
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Submitted = 'SUBMITTED'
}

export type Order = {
  __typename?: 'Order';
  billingAddressFormatted?: Maybe<Array<Scalars['String']['output']>>;
  billingAddressMatchesShippingAddress: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fulfillments: Array<Fulfillment>;
  id: Scalars['String']['output'];
  items: Array<OrderItem>;
  note?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  refunds: Array<Refund>;
  shippingAddressFormatted?: Maybe<Array<Scalars['String']['output']>>;
  subtotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalShipping: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
};

export type OrderItem = {
  attributes: Scalars['JSONObject']['output'];
  description: Scalars['String']['output'];
  discountedUnitPrice: Scalars['Float']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
};

export type OrderProductDetailsInput = {
  imageDetails: Array<ImageDetails>;
  productId: Scalars['String']['input'];
};

export type Page = Document & {
  __typename?: 'Page';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  contentRaw?: Maybe<Scalars['JSON']['output']>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PageSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
  title?: InputMaybe<SortOrder>;
};

export type Post = Document & {
  __typename?: 'Post';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  author?: Maybe<Author>;
  bodyRaw?: Maybe<Scalars['JSON']['output']>;
  mainImage?: Maybe<Image>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Slug>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PostFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  author?: InputMaybe<AuthorFilter>;
  mainImage?: InputMaybe<ImageFilter>;
  publishedAt?: InputMaybe<DatetimeFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PostSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  mainImage?: InputMaybe<ImageSorting>;
  publishedAt?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SlugSorting>;
  title?: InputMaybe<SortOrder>;
};

export type PresignedPost = {
  __typename?: 'PresignedPost';
  expires: Scalars['DateTime']['output'];
  fields: Scalars['JSONObject']['output'];
  url: Scalars['String']['output'];
};

export type ProductDetailsInput = {
  productId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export type ProjectOutputOption = {
  __typename?: 'ProjectOutputOption';
  inputs?: Maybe<Scalars['FeatureInputMap']['output']>;
  name: Scalars['String']['output'];
  scale: Scalars['Float']['output'];
  type: ProjectOutputType;
};

export enum ProjectOutputType {
  MatboardWallMap = 'MATBOARD_WALL_MAP',
  MatboardWallMapSingle = 'MATBOARD_WALL_MAP_SINGLE',
  VehicleMap = 'VEHICLE_MAP',
  VinylWallMap = 'VINYL_WALL_MAP'
}

export type Promotion = {
  __typename?: 'Promotion';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endsAt?: Maybe<Scalars['String']['output']>;
  entries: Array<PromotionEntry>;
  id: Scalars['String']['output'];
  maxEntries?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** These properties refer the user's participation in the promotion, not the promotion itself. */
  numEntries: Scalars['Int']['output'];
  status: PromotionStatus;
};

export type PromotionEntry = {
  __typename?: 'PromotionEntry';
  businessId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  denialReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  promotionId: Scalars['String']['output'];
  status: PromotionEntryStatus;
  submission?: Maybe<Scalars['JSONObject']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export enum PromotionEntryStatus {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Denied = 'DENIED'
}

export enum PromotionStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type Query = {
  __typename?: 'Query';
  Author?: Maybe<Author>;
  Document?: Maybe<Document>;
  Navigation?: Maybe<Navigation>;
  Page?: Maybe<Page>;
  Post?: Maybe<Post>;
  SanityFileAsset?: Maybe<SanityFileAsset>;
  SanityImageAsset?: Maybe<SanityImageAsset>;
  _empty?: Maybe<Scalars['String']['output']>;
  account?: Maybe<MapmakerAccount>;
  allAuthor: Array<Author>;
  allDocument: Array<Document>;
  allNavigation: Array<Navigation>;
  allPage: Array<Page>;
  allPost: Array<Post>;
  allSanityFileAsset: Array<SanityFileAsset>;
  allSanityImageAsset: Array<SanityImageAsset>;
  mapmakerDesign: MapmakerDesign;
  mapmakerDesigns: Array<MapmakerDesign>;
  mapmakerFile?: Maybe<MapmakerFile>;
  mapmakerFileOrDesign: MapmakerFileOrDesignResponse;
  mapmakerFileVersions: Array<MapmakerFile>;
  mapmakerFiles: Array<MapmakerFile>;
  openingSuggestion: OpeningSuggestion;
  order: Order;
  orders: Array<Order>;
  promotion: Promotion;
  sanityReference: SanityReferenceResult;
  sharedMapmakerFiles: Array<MapmakerFile>;
  shippingOptions: ShippingOptionsResult;
  stickerOffer: StickerOffer;
  stickerOrder: StickerOrder;
  stickerOrders: Array<StickerOrder>;
  stickerTokenTransactions: Array<StickerTokenTransaction>;
  /** Fetch a specific Article by its ID. */
  storefrontArticle?: Maybe<StorefrontArticle>;
  /** List of the shop's articles. */
  storefrontArticles: StorefrontArticleConnection;
  /** Fetch a specific `Blog` by one of its unique attributes. */
  storefrontBlog?: Maybe<StorefrontBlog>;
  /**
   * Find a blog by its handle.
   * @deprecated Use `blog` instead.
   */
  storefrontBlogByHandle?: Maybe<StorefrontBlog>;
  /** List of the shop's blogs. */
  storefrontBlogs: StorefrontBlogConnection;
  /**
   * Retrieve a cart by its ID. For more information, refer to
   * [Manage a cart with the Storefront API](https://shopify.dev/custom-storefronts/cart/manage).
   *
   */
  storefrontCart?: Maybe<StorefrontCart>;
  /** A poll for the status of the cart checkout completion and order creation. */
  storefrontCartCompletionAttempt?: Maybe<StorefrontCartCompletionAttemptResult>;
  /** Fetch a specific `Collection` by one of its unique attributes. */
  storefrontCollection?: Maybe<StorefrontCollection>;
  /**
   * Find a collection by its handle.
   * @deprecated Use `collection` instead.
   */
  storefrontCollectionByHandle?: Maybe<StorefrontCollection>;
  /** List of the shop’s collections. */
  storefrontCollections: StorefrontCollectionConnection;
  /**
   * The customer associated with the given access token. Tokens are obtained by using the
   * [`customerAccessTokenCreate` mutation](https://shopify.dev/docs/api/storefront/latest/mutations/customerAccessTokenCreate).
   *
   */
  storefrontCustomer?: Maybe<StorefrontCustomer>;
  /** Returns the localized experiences configured for the shop. */
  storefrontLocalization: StorefrontLocalization;
  /**
   * List of the shop's locations that support in-store pickup.
   *
   * When sorting by distance, you must specify a location via the `near` argument.
   *
   */
  storefrontLocations: StorefrontLocationConnection;
  /**
   * Retrieve a [navigation menu](https://help.shopify.com/manual/online-store/menus-and-links) by its handle.
   *
   */
  storefrontMenu?: Maybe<StorefrontMenu>;
  /** Fetch a specific Metaobject by one of its unique identifiers. */
  storefrontMetaobject?: Maybe<StorefrontMetaobject>;
  /** All active metaobjects for the shop. */
  storefrontMetaobjects: StorefrontMetaobjectConnection;
  /** Returns a specific node by ID. */
  storefrontNode?: Maybe<StorefrontNode>;
  /** Returns the list of nodes with the given IDs. */
  storefrontNodes: Array<Maybe<StorefrontNode>>;
  /** Fetch a specific `Page` by one of its unique attributes. */
  storefrontPage?: Maybe<StorefrontPage>;
  /**
   * Find a page by its handle.
   * @deprecated Use `page` instead.
   */
  storefrontPageByHandle?: Maybe<StorefrontPage>;
  /** List of the shop's pages. */
  storefrontPages: StorefrontPageConnection;
  /** List of the predictive search results. */
  storefrontPredictiveSearch?: Maybe<StorefrontPredictiveSearchResult>;
  /** Fetch a specific `Product` by one of its unique attributes. */
  storefrontProduct?: Maybe<StorefrontProduct>;
  /**
   * Find a product by its handle.
   * @deprecated Use `product` instead.
   */
  storefrontProductByHandle?: Maybe<StorefrontProduct>;
  /**
   * Find recommended products related to a given `product_id`.
   * To learn more about how recommendations are generated, see
   * [*Showing product recommendations on product pages*](https://help.shopify.com/themes/development/recommended-products).
   *
   */
  storefrontProductRecommendations?: Maybe<Array<StorefrontProduct>>;
  /**
   * Tags added to products.
   * Additional access scope required: unauthenticated_read_product_tags.
   *
   */
  storefrontProductTags: StorefrontStringConnection;
  /** List of product types for the shop's products that are published to your app. */
  storefrontProductTypes: StorefrontStringConnection;
  /** List of the shop’s products. */
  storefrontProducts: StorefrontProductConnection;
  /** The list of public Storefront API versions, including supported, release candidate and unstable versions. */
  storefrontPublicApiVersions: Array<StorefrontApiVersion>;
  /** List of the search results. */
  storefrontSearch: StorefrontSearchResultItemConnection;
  /** The shop associated with the storefront access token. */
  storefrontShop: StorefrontShop;
  /** A list of redirects for a shop. */
  storefrontUrlRedirects: StorefrontUrlRedirectConnection;
  walgreensOrder: WalgreensOrder;
  walgreensOrderStatus: WalgreensOrderStatus;
  walgreensProducts: Array<WalgreensProduct>;
  walgreensStores: Array<WalgreensStore>;
  walgreensValidateCoupon: WalgreensValidateCouponResponse;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAuthorArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryNavigationArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryPageArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryPostArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QuerySanityFileAssetArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QuerySanityImageAssetArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAccountArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllAuthorArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AuthorSorting>>;
  where?: InputMaybe<AuthorFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentSorting>>;
  where?: InputMaybe<DocumentFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllNavigationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NavigationSorting>>;
  where?: InputMaybe<NavigationFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageSorting>>;
  where?: InputMaybe<PageFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllPostArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostSorting>>;
  where?: InputMaybe<PostFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllSanityFileAssetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SanityFileAssetSorting>>;
  where?: InputMaybe<SanityFileAssetFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryAllSanityImageAssetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SanityImageAssetSorting>>;
  where?: InputMaybe<SanityImageAssetFilter>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMapmakerDesignArgs = {
  id: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMapmakerDesignsArgs = {
  request?: InputMaybe<GetMapmakerDesignsRequest>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMapmakerFileArgs = {
  id: Scalars['String']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMapmakerFileOrDesignArgs = {
  input: MapmakerFileOrDesignRequest;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryMapmakerFileVersionsArgs = {
  fileId: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryOpeningSuggestionArgs = {
  fileId: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
  suggestionId: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryOrderArgs = {
  number: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryPromotionArgs = {
  promotionId: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QuerySanityReferenceArgs = {
  input: SanityReferenceInput;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryShippingOptionsArgs = {
  input: ShippingOptionsInput;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStickerOfferArgs = {
  input: StickerOfferInput;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStickerOrderArgs = {
  id: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStickerOrdersArgs = {
  ids: Array<Scalars['String']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStickerTokenTransactionsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontArticleArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontArticleSortKeys>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontBlogArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontBlogByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontBlogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontBlogSortKeys>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontCartArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontCartCompletionAttemptArgs = {
  attemptId: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontCollectionArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontCollectionByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontCollectionSortKeys>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontCustomerArgs = {
  customerAccessToken: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  near?: InputMaybe<StorefrontGeoCoordinateInput>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontLocationSortKeys>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontMenuArgs = {
  handle: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontMetaobjectArgs = {
  handle?: InputMaybe<StorefrontMetaobjectHandleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontMetaobjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontPageArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontPageByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontPageSortKeys>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontPredictiveSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitScope?: InputMaybe<StorefrontPredictiveSearchLimitScope>;
  query: Scalars['String']['input'];
  searchableFields?: InputMaybe<Array<StorefrontSearchableField>>;
  types?: InputMaybe<Array<StorefrontPredictiveSearchType>>;
  unavailableProducts?: InputMaybe<StorefrontSearchUnavailableProductsType>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontProductArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontProductByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontProductRecommendationsArgs = {
  intent?: InputMaybe<StorefrontProductRecommendationIntent>;
  productId: Scalars['ID']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontProductTagsArgs = {
  first: Scalars['Int']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontProductTypesArgs = {
  first: Scalars['Int']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontProductSortKeys>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<StorefrontSearchPrefixQueryType>;
  productFilters?: InputMaybe<Array<StorefrontProductFilter>>;
  query: Scalars['String']['input'];
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontSearchSortKeys>;
  types?: InputMaybe<Array<StorefrontSearchType>>;
  unavailableProducts?: InputMaybe<StorefrontSearchUnavailableProductsType>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryStorefrontUrlRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryWalgreensOrderArgs = {
  id: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryWalgreensOrderStatusArgs = {
  orderId: Scalars['String']['input'];
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryWalgreensStoresArgs = {
  input: WalgreensStoresInput;
};


/** The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start. */
export type QueryWalgreensValidateCouponArgs = {
  input: WalgreensValidateCouponInput;
};

export type RectangularPrintFile = {
  __typename?: 'RectangularPrintFile';
  format: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RectangularPrintLayoutInput = {
  downloadFilename?: InputMaybe<Scalars['String']['input']>;
  /** Height in pt (1/72 in) */
  height: Scalars['Int']['input'];
  printOpenings: Array<RectangularPrintOpening>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  /** Width in pt (1/72 in) */
  width: Scalars['Int']['input'];
};

export type RectangularPrintOpening = {
  openingId: Scalars['String']['input'];
  rotation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type RectangularPrintOptions = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderWidth?: InputMaybe<Scalars['Float']['input']>;
  clipImage?: InputMaybe<Scalars['Boolean']['input']>;
  includeBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  printingGuides?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedeemStickerTokenVoucherRequest = {
  voucherId: Scalars['String']['input'];
};

export type RedeemStickerTokenVoucherResponse = {
  __typename?: 'RedeemStickerTokenVoucherResponse';
  account: MapmakerAccount;
  transaction: StickerTokenTransaction;
};

export type Refund = {
  __typename?: 'Refund';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  totalRefunded: Scalars['Float']['output'];
};

export type RenderRequest = {
  output: Scalars['RenderOutput']['input'];
  props: Scalars['RenderablePropsWithRefs']['input'];
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RenderResult = {
  __typename?: 'RenderResult';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum Role {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Guest = 'GUEST',
  User = 'USER'
}

export type SanityAssetSourceData = {
  __typename?: 'SanityAssetSourceData';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']['output']>;
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']['output']>;
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']['output']>;
};

export type SanityAssetSourceDataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityAssetSourceDataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityFileAsset = Document & {
  __typename?: 'SanityFileAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sha1hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityFileAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityImageAsset = Document & {
  __typename?: 'SanityImageAsset';
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Document ID */
  _id?: Maybe<Scalars['ID']['output']>;
  _key?: Maybe<Scalars['String']['output']>;
  /** Current document revision */
  _rev?: Maybe<Scalars['String']['output']>;
  /** Document type */
  _type?: Maybe<Scalars['String']['output']>;
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']['output']>;
  altText?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<SanityImageMetadata>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalFilename?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sha1hash?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<SanityAssetSourceData>;
  title?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>;
  _createdAt?: InputMaybe<DatetimeFilter>;
  _id?: InputMaybe<IdFilter>;
  _key?: InputMaybe<StringFilter>;
  _rev?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  _updatedAt?: InputMaybe<DatetimeFilter>;
  altText?: InputMaybe<StringFilter>;
  assetId?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  extension?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<SanityImageMetadataFilter>;
  mimeType?: InputMaybe<StringFilter>;
  originalFilename?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  sha1hash?: InputMaybe<StringFilter>;
  size?: InputMaybe<FloatFilter>;
  source?: InputMaybe<SanityAssetSourceDataFilter>;
  title?: InputMaybe<StringFilter>;
  uploadId?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SanityImageAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>;
  _id?: InputMaybe<SortOrder>;
  _key?: InputMaybe<SortOrder>;
  _rev?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  _updatedAt?: InputMaybe<SortOrder>;
  altText?: InputMaybe<SortOrder>;
  assetId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  extension?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SanityImageMetadataSorting>;
  mimeType?: InputMaybe<SortOrder>;
  originalFilename?: InputMaybe<SortOrder>;
  path?: InputMaybe<SortOrder>;
  sha1hash?: InputMaybe<SortOrder>;
  size?: InputMaybe<SortOrder>;
  source?: InputMaybe<SanityAssetSourceDataSorting>;
  title?: InputMaybe<SortOrder>;
  uploadId?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type SanityImageCrop = {
  __typename?: 'SanityImageCrop';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  bottom?: Maybe<Scalars['Float']['output']>;
  left?: Maybe<Scalars['Float']['output']>;
  right?: Maybe<Scalars['Float']['output']>;
  top?: Maybe<Scalars['Float']['output']>;
};

export type SanityImageCropFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  bottom?: InputMaybe<FloatFilter>;
  left?: InputMaybe<FloatFilter>;
  right?: InputMaybe<FloatFilter>;
  top?: InputMaybe<FloatFilter>;
};

export type SanityImageCropSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  bottom?: InputMaybe<SortOrder>;
  left?: InputMaybe<SortOrder>;
  right?: InputMaybe<SortOrder>;
  top?: InputMaybe<SortOrder>;
};

export type SanityImageDimensions = {
  __typename?: 'SanityImageDimensions';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type SanityImageDimensionsFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<FloatFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
};

export type SanityImageDimensionsSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  aspectRatio?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type SanityImageHotspotFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  height?: InputMaybe<FloatFilter>;
  width?: InputMaybe<FloatFilter>;
  x?: InputMaybe<FloatFilter>;
  y?: InputMaybe<FloatFilter>;
};

export type SanityImageHotspotSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  height?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
  x?: InputMaybe<SortOrder>;
  y?: InputMaybe<SortOrder>;
};

export type SanityImageMetadata = {
  __typename?: 'SanityImageMetadata';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  blurHash?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<SanityImageDimensions>;
  hasAlpha?: Maybe<Scalars['Boolean']['output']>;
  isOpaque?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Geopoint>;
  lqip?: Maybe<Scalars['String']['output']>;
  palette?: Maybe<SanityImagePalette>;
};

export type SanityImageMetadataFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  blurHash?: InputMaybe<StringFilter>;
  dimensions?: InputMaybe<SanityImageDimensionsFilter>;
  hasAlpha?: InputMaybe<BooleanFilter>;
  isOpaque?: InputMaybe<BooleanFilter>;
  location?: InputMaybe<GeopointFilter>;
  lqip?: InputMaybe<StringFilter>;
  palette?: InputMaybe<SanityImagePaletteFilter>;
};

export type SanityImageMetadataSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  blurHash?: InputMaybe<SortOrder>;
  dimensions?: InputMaybe<SanityImageDimensionsSorting>;
  hasAlpha?: InputMaybe<SortOrder>;
  isOpaque?: InputMaybe<SortOrder>;
  location?: InputMaybe<GeopointSorting>;
  lqip?: InputMaybe<SortOrder>;
  palette?: InputMaybe<SanityImagePaletteSorting>;
};

export type SanityImagePalette = {
  __typename?: 'SanityImagePalette';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  darkMuted?: Maybe<SanityImagePaletteSwatch>;
  darkVibrant?: Maybe<SanityImagePaletteSwatch>;
  dominant?: Maybe<SanityImagePaletteSwatch>;
  lightMuted?: Maybe<SanityImagePaletteSwatch>;
  lightVibrant?: Maybe<SanityImagePaletteSwatch>;
  muted?: Maybe<SanityImagePaletteSwatch>;
  vibrant?: Maybe<SanityImagePaletteSwatch>;
};

export type SanityImagePaletteFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  dominant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
  muted?: InputMaybe<SanityImagePaletteSwatchFilter>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchFilter>;
};

export type SanityImagePaletteSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  darkMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  dominant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightMuted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
  muted?: InputMaybe<SanityImagePaletteSwatchSorting>;
  vibrant?: InputMaybe<SanityImagePaletteSwatchSorting>;
};

export type SanityImagePaletteSwatch = {
  __typename?: 'SanityImagePaletteSwatch';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Scalars['String']['output']>;
  foreground?: Maybe<Scalars['String']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SanityImagePaletteSwatchFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  background?: InputMaybe<StringFilter>;
  foreground?: InputMaybe<StringFilter>;
  population?: InputMaybe<FloatFilter>;
  title?: InputMaybe<StringFilter>;
};

export type SanityImagePaletteSwatchSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  background?: InputMaybe<SortOrder>;
  foreground?: InputMaybe<SortOrder>;
  population?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type SanityReferenceInput = {
  ref: Scalars['String']['input'];
};

export type SanityReferenceResult = {
  __typename?: 'SanityReferenceResult';
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Sanity_DocumentFilter = {
  /** All documents that are drafts. */
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** All documents referencing the given document ID. */
  references?: InputMaybe<Scalars['ID']['input']>;
};

export type Screenshot = {
  __typename?: 'Screenshot';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  /** Used for both images by default. */
  caption?: Maybe<Scalars['String']['output']>;
  desktop?: Maybe<Image>;
  /** Used for only the desktop image. */
  desktopCaption?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Image>;
  /** Used for only the mobile image. */
  mobileCaption?: Maybe<Scalars['String']['output']>;
};

export type ScreenshotFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  caption?: InputMaybe<StringFilter>;
  desktop?: InputMaybe<ImageFilter>;
  desktopCaption?: InputMaybe<StringFilter>;
  mobile?: InputMaybe<ImageFilter>;
  mobileCaption?: InputMaybe<StringFilter>;
};

export type ScreenshotSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  caption?: InputMaybe<SortOrder>;
  desktop?: InputMaybe<ImageSorting>;
  desktopCaption?: InputMaybe<SortOrder>;
  mobile?: InputMaybe<ImageSorting>;
  mobileCaption?: InputMaybe<SortOrder>;
};

export type ShippingOption = {
  __typename?: 'ShippingOption';
  available: Scalars['Boolean']['output'];
  guaranteed: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  maxTransitDays: Scalars['Int']['output'];
  minTransitDays: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ShippingOptionsInput = {
  zip: Scalars['String']['input'];
};

export type ShippingOptionsResult = {
  __typename?: 'ShippingOptionsResult';
  options: Array<ShippingOption>;
};

export type Slug = {
  __typename?: 'Slug';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['String']['output']>;
};

export type SlugFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  current?: InputMaybe<StringFilter>;
};

export type SlugSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  current?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  /** Sorts on the value in ascending order. */
  Asc = 'ASC',
  /** Sorts on the value in descending order. */
  Desc = 'DESC'
}

export type Span = {
  __typename?: 'Span';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  marks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
};

export type StickerLineItem = OrderItem & {
  __typename?: 'StickerLineItem';
  attributes: Scalars['JSONObject']['output'];
  description: Scalars['String']['output'];
  discountedUnitPrice: Scalars['Float']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  stickerOrderId: Scalars['String']['output'];
  tokensUsed: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type StickerOffer = {
  __typename?: 'StickerOffer';
  stickers: Array<StickerOfferItem>;
};

export type StickerOfferInput = {
  fileId: Scalars['String']['input'];
  outputType?: InputMaybe<ProjectOutputType>;
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export type StickerOfferItem = {
  __typename?: 'StickerOfferItem';
  openingId: Scalars['String']['output'];
  render: StickerRender;
  scale: Scalars['Float']['output'];
  sizeClass: StickerSizeClass;
};

export type StickerOrder = {
  __typename?: 'StickerOrder';
  businessId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  file: MapmakerFile;
  id: Scalars['String']['output'];
  outputType: ProjectOutputType;
  /**
   * All of these properties can be removed after June 30th 2022. We no longer manage details of ordering in the Map Maker.
   * @deprecated No longer supported
   */
  recipientName?: Maybe<Scalars['String']['output']>;
  status: StickerOrderStatus;
  stickers: Array<StickerOrderItem>;
  /** @deprecated No longer supported */
  storeOrderId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  storeOrderIncludesLargerItem?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer supported */
  storeOrderIncludesOtherStickers?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type StickerOrderItem = {
  __typename?: 'StickerOrderItem';
  openingId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  quantityWithMoney: Scalars['Int']['output'];
  quantityWithTokens: Scalars['Int']['output'];
  render: StickerRender;
  scale: Scalars['Float']['output'];
  sizeClass: StickerSizeClass;
};

export type StickerOrderItemInput = {
  openingId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  quantityWithMoney?: InputMaybe<Scalars['Int']['input']>;
  quantityWithTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Scale can be made required after July 2022 */
  scale?: InputMaybe<Scalars['Float']['input']>;
};

export enum StickerOrderStatus {
  AwaitingPayment = 'AWAITING_PAYMENT',
  AwaitingShipment = 'AWAITING_SHIPMENT',
  Cancelled = 'CANCELLED',
  Shipped = 'SHIPPED'
}

export type StickerRender = {
  __typename?: 'StickerRender';
  url: Scalars['String']['output'];
};

export enum StickerSizeClass {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type StickerSizeClassGroup = {
  __typename?: 'StickerSizeClassGroup';
  count: Scalars['Int']['output'];
  openings: Array<OpeningStickerInfo>;
  sizeClass: StickerSizeClass;
  tokens: Scalars['Float']['output'];
};

export type StickerTokenLineItem = OrderItem & {
  __typename?: 'StickerTokenLineItem';
  attributes: Scalars['JSONObject']['output'];
  description: Scalars['String']['output'];
  discountedUnitPrice: Scalars['Float']['output'];
  handle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  image?: Maybe<Image>;
  name: Scalars['String']['output'];
  numTokens: Scalars['Int']['output'];
  originalUnitPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type StickerTokenTransaction = {
  __typename?: 'StickerTokenTransaction';
  businessId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  creator: Scalars['String']['output'];
  endingBalance: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  prettyReason: Scalars['String']['output'];
  reason: StickerTokenTransactionReason;
  startingBalance: Scalars['Float']['output'];
  tokens: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export enum StickerTokenTransactionReason {
  AdminAdjustment = 'ADMIN_ADJUSTMENT',
  Promotion = 'PROMOTION',
  StickerPurchase = 'STICKER_PURCHASE',
  VoucherRedemption = 'VOUCHER_REDEMPTION'
}

/**
 * A version of the API, as defined by [Shopify API versioning](https://shopify.dev/api/usage/versioning).
 * Versions are commonly referred to by their handle (for example, `2021-10`).
 *
 */
export type StorefrontApiVersion = {
  __typename?: 'StorefrontApiVersion';
  /** The human-readable name of the version. */
  displayName: Scalars['String']['output'];
  /** The unique identifier of an ApiVersion. All supported API versions have a date-based (YYYY-MM) or `unstable` handle. */
  handle: Scalars['String']['output'];
  /** Whether the version is actively supported by Shopify. Supported API versions are guaranteed to be stable. Unsupported API versions include unstable, release candidate, and end-of-life versions that are marked as unsupported. For more information, refer to [Versioning](https://shopify.dev/api/usage/versioning). */
  supported: Scalars['Boolean']['output'];
};

/**
 * The input fields for submitting Apple Pay payment method information for checkout.
 *
 */
export type StorefrontApplePayWalletContentInput = {
  /** The customer's billing address. */
  billingAddress: StorefrontMailingAddressInput;
  /** The data for the Apple Pay wallet. */
  data: Scalars['String']['input'];
  /** The header data for the Apple Pay wallet. */
  header: StorefrontApplePayWalletHeaderInput;
  /** The last digits of the card used to create the payment. */
  lastDigits?: InputMaybe<Scalars['String']['input']>;
  /** The signature for the Apple Pay wallet. */
  signature: Scalars['String']['input'];
  /** The version for the Apple Pay wallet. */
  version: Scalars['String']['input'];
};

/**
 * The input fields for submitting wallet payment method information for checkout.
 *
 */
export type StorefrontApplePayWalletHeaderInput = {
  /** The application data for the Apple Pay wallet. */
  applicationData?: InputMaybe<Scalars['String']['input']>;
  /** The ephemeral public key for the Apple Pay wallet. */
  ephemeralPublicKey: Scalars['String']['input'];
  /** The public key hash for the Apple Pay wallet. */
  publicKeyHash: Scalars['String']['input'];
  /** The transaction ID for the Apple Pay wallet. */
  transactionId: Scalars['String']['input'];
};

/** Details about the gift card used on the checkout. */
export type StorefrontAppliedGiftCard = StorefrontNode & {
  __typename?: 'StorefrontAppliedGiftCard';
  /** The amount that was taken from the gift card by applying it. */
  amountUsed: StorefrontMoneyV2;
  /**
   * The amount that was taken from the gift card by applying it.
   * @deprecated Use `amountUsed` instead.
   */
  amountUsedV2: StorefrontMoneyV2;
  /** The amount left on the gift card. */
  balance: StorefrontMoneyV2;
  /**
   * The amount left on the gift card.
   * @deprecated Use `balance` instead.
   */
  balanceV2: StorefrontMoneyV2;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last characters of the gift card. */
  lastCharacters: Scalars['String']['output'];
  /** The amount that was applied to the checkout in its currency. */
  presentmentAmountUsed: StorefrontMoneyV2;
};

/** An article in an online store blog. */
export type StorefrontArticle = StorefrontHasMetafields & StorefrontNode & StorefrontOnlineStorePublishable & StorefrontTrackable & {
  __typename?: 'StorefrontArticle';
  /**
   * The article's author.
   * @deprecated Use `authorV2` instead.
   */
  author: StorefrontArticleAuthor;
  /** The article's author. */
  authorV2?: Maybe<StorefrontArticleAuthor>;
  /** The blog that the article belongs to. */
  blog: StorefrontBlog;
  /** List of comments posted on the article. */
  comments: StorefrontCommentConnection;
  /** Stripped content of the article, single line with HTML tags removed. */
  content: Scalars['String']['output'];
  /** The content of the article, complete with HTML formatting. */
  contentHtml: Scalars['StorefrontHTML']['output'];
  /** Stripped excerpt of the article, single line with HTML tags removed. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The excerpt of the article, complete with HTML formatting. */
  excerptHtml?: Maybe<Scalars['StorefrontHTML']['output']>;
  /**
   * A human-friendly unique string for the Article automatically generated from its title.
   *
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image associated with the article. */
  image?: Maybe<StorefrontImage>;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** The date and time when the article was published. */
  publishedAt: Scalars['StorefrontDateTime']['output'];
  /** The article’s SEO information. */
  seo?: Maybe<StorefrontSeo>;
  /** A categorization that a article can be tagged with. */
  tags: Array<Scalars['String']['output']>;
  /** The article’s name. */
  title: Scalars['String']['output'];
  /** A URL parameters to be added to a page URL when it is linked from a GraphQL result. This allows for tracking the origin of the traffic. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
};


/** An article in an online store blog. */
export type StorefrontArticleCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An article in an online store blog. */
export type StorefrontArticleContentArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};


/** An article in an online store blog. */
export type StorefrontArticleExcerptArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};


/** An article in an online store blog. */
export type StorefrontArticleMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** An article in an online store blog. */
export type StorefrontArticleMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/** The author of an article. */
export type StorefrontArticleAuthor = {
  __typename?: 'StorefrontArticleAuthor';
  /** The author's bio. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The author’s email. */
  email: Scalars['String']['output'];
  /** The author's first name. */
  firstName: Scalars['String']['output'];
  /** The author's last name. */
  lastName: Scalars['String']['output'];
  /** The author's full name. */
  name: Scalars['String']['output'];
};

/**
 * An auto-generated type for paginating through multiple Articles.
 *
 */
export type StorefrontArticleConnection = {
  __typename?: 'StorefrontArticleConnection';
  /** A list of edges. */
  edges: Array<StorefrontArticleEdge>;
  /** A list of the nodes contained in ArticleEdge. */
  nodes: Array<StorefrontArticle>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Article and a cursor during pagination.
 *
 */
export type StorefrontArticleEdge = {
  __typename?: 'StorefrontArticleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ArticleEdge. */
  node: StorefrontArticle;
};

/** The set of valid sort keys for the Article query. */
export enum StorefrontArticleSortKeys {
  /** Sort by the `author` value. */
  Author = 'AUTHOR',
  /** Sort by the `blog_title` value. */
  BlogTitle = 'BLOG_TITLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `published_at` value. */
  PublishedAt = 'PUBLISHED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents a generic custom attribute. */
export type StorefrontAttribute = {
  __typename?: 'StorefrontAttribute';
  /** Key or name of the attribute. */
  key: Scalars['String']['output'];
  /** Value of the attribute. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The input fields for an attribute. */
export type StorefrontAttributeInput = {
  /** Key or name of the attribute. */
  key: Scalars['String']['input'];
  /** Value of the attribute. */
  value: Scalars['String']['input'];
};

/**
 * Automatic discount applications capture the intentions of a discount that was automatically applied.
 *
 */
export type StorefrontAutomaticDiscountApplication = StorefrontDiscountApplication & {
  __typename?: 'StorefrontAutomaticDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: StorefrontDiscountApplicationAllocationMethod;
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: StorefrontDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: StorefrontDiscountApplicationTargetType;
  /** The title of the application. */
  title: Scalars['String']['output'];
  /** The value of the discount application. */
  value: StorefrontPricingValue;
};

/** A collection of available shipping rates for a checkout. */
export type StorefrontAvailableShippingRates = {
  __typename?: 'StorefrontAvailableShippingRates';
  /**
   * Whether or not the shipping rates are ready.
   * The `shippingRates` field is `null` when this value is `false`.
   * This field should be polled until its value becomes `true`.
   *
   */
  ready: Scalars['Boolean']['output'];
  /** The fetched shipping rates. `null` until the `ready` field is `true`. */
  shippingRates?: Maybe<Array<StorefrontShippingRate>>;
};

/** Represents a cart line common fields. */
export type StorefrontBaseCartLine = {
  /** An attribute associated with the cart line. */
  attribute?: Maybe<StorefrontAttribute>;
  /** The attributes associated with the cart line. Attributes are represented as key-value pairs. */
  attributes: Array<StorefrontAttribute>;
  /** The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout. */
  cost: StorefrontCartLineCost;
  /** The discounts that have been applied to the cart line. */
  discountAllocations: Array<StorefrontCartDiscountAllocation>;
  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   * @deprecated Use `cost` instead.
   */
  estimatedCost: StorefrontCartLineEstimatedCost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The merchandise that the buyer intends to purchase. */
  merchandise: StorefrontMerchandise;
  /** The quantity of the merchandise that the customer intends to purchase. */
  quantity: Scalars['Int']['output'];
  /** The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased. */
  sellingPlanAllocation?: Maybe<StorefrontSellingPlanAllocation>;
};


/** Represents a cart line common fields. */
export type StorefrontBaseCartLineAttributeArgs = {
  key: Scalars['String']['input'];
};

/**
 * An auto-generated type for paginating through multiple BaseCartLines.
 *
 */
export type StorefrontBaseCartLineConnection = {
  __typename?: 'StorefrontBaseCartLineConnection';
  /** A list of edges. */
  edges: Array<StorefrontBaseCartLineEdge>;
  /** A list of the nodes contained in BaseCartLineEdge. */
  nodes: Array<StorefrontBaseCartLine>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one BaseCartLine and a cursor during pagination.
 *
 */
export type StorefrontBaseCartLineEdge = {
  __typename?: 'StorefrontBaseCartLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of BaseCartLineEdge. */
  node: StorefrontBaseCartLine;
};

/** An online store blog. */
export type StorefrontBlog = StorefrontHasMetafields & StorefrontNode & StorefrontOnlineStorePublishable & {
  __typename?: 'StorefrontBlog';
  /** Find an article by its handle. */
  articleByHandle?: Maybe<StorefrontArticle>;
  /** List of the blog's articles. */
  articles: StorefrontArticleConnection;
  /** The authors who have contributed to the blog. */
  authors: Array<StorefrontArticleAuthor>;
  /**
   * A human-friendly unique string for the Blog automatically generated from its title.
   *
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** The blog's SEO information. */
  seo?: Maybe<StorefrontSeo>;
  /** The blogs’s title. */
  title: Scalars['String']['output'];
};


/** An online store blog. */
export type StorefrontBlogArticleByHandleArgs = {
  handle: Scalars['String']['input'];
};


/** An online store blog. */
export type StorefrontBlogArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontArticleSortKeys>;
};


/** An online store blog. */
export type StorefrontBlogMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** An online store blog. */
export type StorefrontBlogMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/**
 * An auto-generated type for paginating through multiple Blogs.
 *
 */
export type StorefrontBlogConnection = {
  __typename?: 'StorefrontBlogConnection';
  /** A list of edges. */
  edges: Array<StorefrontBlogEdge>;
  /** A list of the nodes contained in BlogEdge. */
  nodes: Array<StorefrontBlog>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Blog and a cursor during pagination.
 *
 */
export type StorefrontBlogEdge = {
  __typename?: 'StorefrontBlogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of BlogEdge. */
  node: StorefrontBlog;
};

/** The set of valid sort keys for the Blog query. */
export enum StorefrontBlogSortKeys {
  /** Sort by the `handle` value. */
  Handle = 'HANDLE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/**
 * The store's [branding configuration](https://help.shopify.com/en/manual/promoting-marketing/managing-brand-assets).
 *
 */
export type StorefrontBrand = {
  __typename?: 'StorefrontBrand';
  /** The colors of the store's brand. */
  colors: StorefrontBrandColors;
  /** The store's cover image. */
  coverImage?: Maybe<StorefrontMediaImage>;
  /** The store's default logo. */
  logo?: Maybe<StorefrontMediaImage>;
  /** The store's short description. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** The store's slogan. */
  slogan?: Maybe<Scalars['String']['output']>;
  /** The store's preferred logo for square UI elements. */
  squareLogo?: Maybe<StorefrontMediaImage>;
};

/**
 * A group of related colors for the shop's brand.
 *
 */
export type StorefrontBrandColorGroup = {
  __typename?: 'StorefrontBrandColorGroup';
  /** The background color. */
  background?: Maybe<Scalars['StorefrontColor']['output']>;
  /** The foreground color. */
  foreground?: Maybe<Scalars['StorefrontColor']['output']>;
};

/**
 * The colors of the shop's brand.
 *
 */
export type StorefrontBrandColors = {
  __typename?: 'StorefrontBrandColors';
  /** The shop's primary brand colors. */
  primary: Array<StorefrontBrandColorGroup>;
  /** The shop's secondary brand colors. */
  secondary: Array<StorefrontBrandColorGroup>;
};

/** Card brand, such as Visa or Mastercard, which can be used for payments. */
export enum StorefrontCardBrand {
  /** American Express. */
  AmericanExpress = 'AMERICAN_EXPRESS',
  /** Diners Club. */
  DinersClub = 'DINERS_CLUB',
  /** Discover. */
  Discover = 'DISCOVER',
  /** JCB. */
  Jcb = 'JCB',
  /** Mastercard. */
  Mastercard = 'MASTERCARD',
  /** Visa. */
  Visa = 'VISA'
}

/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type StorefrontCart = StorefrontHasMetafields & StorefrontNode & {
  __typename?: 'StorefrontCart';
  /** An attribute associated with the cart. */
  attribute?: Maybe<StorefrontAttribute>;
  /** The attributes associated with the cart. Attributes are represented as key-value pairs. */
  attributes: Array<StorefrontAttribute>;
  /** Information about the buyer that's interacting with the cart. */
  buyerIdentity: StorefrontCartBuyerIdentity;
  /** The URL of the checkout for the cart. */
  checkoutUrl: Scalars['StorefrontURL']['output'];
  /** The estimated costs that the buyer will pay at checkout. The costs are subject to change and changes will be reflected at checkout. The `cost` field uses the `buyerIdentity` field to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing). */
  cost: StorefrontCartCost;
  /** The date and time when the cart was created. */
  createdAt: Scalars['StorefrontDateTime']['output'];
  /**
   * The delivery groups available for the cart, based on the buyer identity default
   * delivery address preference or the default address of the logged-in customer.
   *
   */
  deliveryGroups: StorefrontCartDeliveryGroupConnection;
  /** The discounts that have been applied to the entire cart. */
  discountAllocations: Array<StorefrontCartDiscountAllocation>;
  /**
   * The case-insensitive discount codes that the customer added at checkout.
   *
   */
  discountCodes: Array<StorefrontCartDiscountCode>;
  /**
   * The estimated costs that the buyer will pay at checkout.
   * The estimated costs are subject to change and changes will be reflected at checkout.
   * The `estimatedCost` field uses the `buyerIdentity` field to determine
   * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
   *
   * @deprecated Use `cost` instead.
   */
  estimatedCost: StorefrontCartEstimatedCost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A list of lines containing information about the items the customer intends to purchase. */
  lines: StorefrontBaseCartLineConnection;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** A note that's associated with the cart. For example, the note can be a personalized message to the buyer. */
  note?: Maybe<Scalars['String']['output']>;
  /** The total number of items in the cart. */
  totalQuantity: Scalars['Int']['output'];
  /** The date and time when the cart was updated. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
};


/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type StorefrontCartAttributeArgs = {
  key: Scalars['String']['input'];
};


/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type StorefrontCartDeliveryGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type StorefrontCartLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type StorefrontCartMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/**
 * A cart represents the merchandise that a buyer intends to purchase,
 * and the estimated cost associated with the cart. Learn how to
 * [interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * during a customer's session.
 *
 */
export type StorefrontCartMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/** Return type for `cartAttributesUpdate` mutation. */
export type StorefrontCartAttributesUpdatePayload = {
  __typename?: 'StorefrontCartAttributesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** The discounts automatically applied to the cart line based on prerequisites that have been met. */
export type StorefrontCartAutomaticDiscountAllocation = StorefrontCartDiscountAllocation & {
  __typename?: 'StorefrontCartAutomaticDiscountAllocation';
  /** The discounted amount that has been applied to the cart line. */
  discountedAmount: StorefrontMoneyV2;
  /** The title of the allocated discount. */
  title: Scalars['String']['output'];
};

/** Represents information about the buyer that is interacting with the cart. */
export type StorefrontCartBuyerIdentity = {
  __typename?: 'StorefrontCartBuyerIdentity';
  /** The country where the buyer is located. */
  countryCode?: Maybe<StorefrontCountryCode>;
  /** The customer account associated with the cart. */
  customer?: Maybe<StorefrontCustomer>;
  /**
   * An ordered set of delivery addresses tied to the buyer that is interacting with the cart.
   * The rank of the preferences is determined by the order of the addresses in the array. Preferences
   * can be used to populate relevant fields in the checkout flow.
   *
   */
  deliveryAddressPreferences: Array<StorefrontDeliveryAddress>;
  /** The email address of the buyer that's interacting with the cart. */
  email?: Maybe<Scalars['String']['output']>;
  /** The phone number of the buyer that's interacting with the cart. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * A set of wallet preferences tied to the buyer that is interacting with the cart.
   * Preferences can be used to populate relevant payment fields in the checkout flow.
   *
   */
  walletPreferences: Array<Scalars['String']['output']>;
};

/**
 * Specifies the input fields to update the buyer information associated with a cart.
 * Buyer identity is used to determine
 * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
 * and should match the customer's shipping address.
 *
 */
export type StorefrontCartBuyerIdentityInput = {
  /** The country where the buyer is located. */
  countryCode?: InputMaybe<StorefrontCountryCode>;
  /** The access token used to identify the customer associated with the cart. */
  customerAccessToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * An ordered set of delivery addresses tied to the buyer that is interacting with the cart.
   * The rank of the preferences is determined by the order of the addresses in the array. Preferences
   * can be used to populate relevant fields in the checkout flow.
   *
   */
  deliveryAddressPreferences?: InputMaybe<Array<StorefrontDeliveryAddressInput>>;
  /** The email address of the buyer that is interacting with the cart. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the buyer that is interacting with the cart. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * A set of wallet preferences tied to the buyer that is interacting with the cart.
   * Preferences can be used to populate relevant payment fields in the checkout flow.
   *   Accepted value: `["shop_pay"]`.
   *
   */
  walletPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Return type for `cartBuyerIdentityUpdate` mutation. */
export type StorefrontCartBuyerIdentityUpdatePayload = {
  __typename?: 'StorefrontCartBuyerIdentityUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/**
 * Represents how credit card details are provided for a direct payment.
 *
 */
export enum StorefrontCartCardSource {
  /**
   * The credit card was provided by a third party and vaulted on their system.
   * Using this value requires a separate permission from Shopify.
   *
   */
  SavedCreditCard = 'SAVED_CREDIT_CARD'
}

/** The discount that has been applied to the cart line using a discount code. */
export type StorefrontCartCodeDiscountAllocation = StorefrontCartDiscountAllocation & {
  __typename?: 'StorefrontCartCodeDiscountAllocation';
  /** The code used to apply the discount. */
  code: Scalars['String']['output'];
  /** The discounted amount that has been applied to the cart line. */
  discountedAmount: StorefrontMoneyV2;
};

/** The completion action to checkout a cart. */
export type StorefrontCartCompletionAction = StorefrontCompletePaymentChallenge;

/** The required completion action to checkout a cart. */
export type StorefrontCartCompletionActionRequired = {
  __typename?: 'StorefrontCartCompletionActionRequired';
  /** The action required to complete the cart completion attempt. */
  action?: Maybe<StorefrontCartCompletionAction>;
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
};

/** The result of a cart completion attempt. */
export type StorefrontCartCompletionAttemptResult = StorefrontCartCompletionActionRequired | StorefrontCartCompletionFailed | StorefrontCartCompletionProcessing | StorefrontCartCompletionSuccess;

/** A failed completion to checkout a cart. */
export type StorefrontCartCompletionFailed = {
  __typename?: 'StorefrontCartCompletionFailed';
  /** The errors that caused the checkout to fail. */
  errors: Array<StorefrontCompletionError>;
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
};

/** A cart checkout completion that's still processing. */
export type StorefrontCartCompletionProcessing = {
  __typename?: 'StorefrontCartCompletionProcessing';
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
  /** The number of milliseconds to wait before polling again. */
  pollDelay: Scalars['Int']['output'];
};

/** A successful completion to checkout a cart and a created order. */
export type StorefrontCartCompletionSuccess = {
  __typename?: 'StorefrontCartCompletionSuccess';
  /** The date and time when the job completed. */
  completedAt?: Maybe<Scalars['StorefrontDateTime']['output']>;
  /** The ID of the cart completion attempt. */
  id: Scalars['String']['output'];
  /** The ID of the order that's created in Shopify. */
  orderId: Scalars['ID']['output'];
  /** The URL of the order confirmation in Shopify. */
  orderUrl: Scalars['StorefrontURL']['output'];
};

/**
 * The costs that the buyer will pay at checkout.
 * The cart cost uses [`CartBuyerIdentity`](https://shopify.dev/api/storefront/reference/cart/cartbuyeridentity) to determine
 * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
 *
 */
export type StorefrontCartCost = {
  __typename?: 'StorefrontCartCost';
  /** The estimated amount, before taxes and discounts, for the customer to pay at checkout. The checkout charge amount doesn't include any deferred payments that'll be paid at a later date. If the cart has no deferred payments, then the checkout charge amount is equivalent to `subtotalAmount`. */
  checkoutChargeAmount: StorefrontMoneyV2;
  /** The amount, before taxes and cart-level discounts, for the customer to pay. */
  subtotalAmount: StorefrontMoneyV2;
  /** Whether the subtotal amount is estimated. */
  subtotalAmountEstimated: Scalars['Boolean']['output'];
  /** The total amount for the customer to pay. */
  totalAmount: StorefrontMoneyV2;
  /** Whether the total amount is estimated. */
  totalAmountEstimated: Scalars['Boolean']['output'];
  /** The duty amount for the customer to pay at checkout. */
  totalDutyAmount?: Maybe<StorefrontMoneyV2>;
  /** Whether the total duty amount is estimated. */
  totalDutyAmountEstimated: Scalars['Boolean']['output'];
  /** The tax amount for the customer to pay at checkout. */
  totalTaxAmount?: Maybe<StorefrontMoneyV2>;
  /** Whether the total tax amount is estimated. */
  totalTaxAmountEstimated: Scalars['Boolean']['output'];
};

/** Return type for `cartCreate` mutation. */
export type StorefrontCartCreatePayload = {
  __typename?: 'StorefrontCartCreatePayload';
  /** The new cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** The discounts automatically applied to the cart line based on prerequisites that have been met. */
export type StorefrontCartCustomDiscountAllocation = StorefrontCartDiscountAllocation & {
  __typename?: 'StorefrontCartCustomDiscountAllocation';
  /** The discounted amount that has been applied to the cart line. */
  discountedAmount: StorefrontMoneyV2;
  /** The title of the allocated discount. */
  title: Scalars['String']['output'];
};

/** Information about the options available for one or more line items to be delivered to a specific address. */
export type StorefrontCartDeliveryGroup = {
  __typename?: 'StorefrontCartDeliveryGroup';
  /** A list of cart lines for the delivery group. */
  cartLines: StorefrontBaseCartLineConnection;
  /** The destination address for the delivery group. */
  deliveryAddress: StorefrontMailingAddress;
  /** The delivery options available for the delivery group. */
  deliveryOptions: Array<StorefrontCartDeliveryOption>;
  /** The ID for the delivery group. */
  id: Scalars['ID']['output'];
  /** The selected delivery option for the delivery group. */
  selectedDeliveryOption?: Maybe<StorefrontCartDeliveryOption>;
};


/** Information about the options available for one or more line items to be delivered to a specific address. */
export type StorefrontCartDeliveryGroupCartLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple CartDeliveryGroups.
 *
 */
export type StorefrontCartDeliveryGroupConnection = {
  __typename?: 'StorefrontCartDeliveryGroupConnection';
  /** A list of edges. */
  edges: Array<StorefrontCartDeliveryGroupEdge>;
  /** A list of the nodes contained in CartDeliveryGroupEdge. */
  nodes: Array<StorefrontCartDeliveryGroup>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one CartDeliveryGroup and a cursor during pagination.
 *
 */
export type StorefrontCartDeliveryGroupEdge = {
  __typename?: 'StorefrontCartDeliveryGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CartDeliveryGroupEdge. */
  node: StorefrontCartDeliveryGroup;
};

/** Information about a delivery option. */
export type StorefrontCartDeliveryOption = {
  __typename?: 'StorefrontCartDeliveryOption';
  /** The code of the delivery option. */
  code?: Maybe<Scalars['String']['output']>;
  /** The method for the delivery option. */
  deliveryMethodType: StorefrontDeliveryMethodType;
  /** The description of the delivery option. */
  description?: Maybe<Scalars['String']['output']>;
  /** The estimated cost for the delivery option. */
  estimatedCost: StorefrontMoneyV2;
  /** The unique identifier of the delivery option. */
  handle: Scalars['String']['output'];
  /** The title of the delivery option. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * The input fields for submitting direct payment method information for checkout.
 *
 */
export type StorefrontCartDirectPaymentMethodInput = {
  /** The customer's billing address. */
  billingAddress: StorefrontMailingAddressInput;
  /** The source of the credit card payment. */
  cardSource?: InputMaybe<StorefrontCartCardSource>;
  /** The session ID for the direct payment method used to create the payment. */
  sessionId: Scalars['String']['input'];
};

/** The discounts that have been applied to the cart line. */
export type StorefrontCartDiscountAllocation = {
  /** The discounted amount that has been applied to the cart line. */
  discountedAmount: StorefrontMoneyV2;
};

/** The discount codes applied to the cart. */
export type StorefrontCartDiscountCode = {
  __typename?: 'StorefrontCartDiscountCode';
  /** Whether the discount code is applicable to the cart's current contents. */
  applicable: Scalars['Boolean']['output'];
  /** The code for the discount. */
  code: Scalars['String']['output'];
};

/** Return type for `cartDiscountCodesUpdate` mutation. */
export type StorefrontCartDiscountCodesUpdatePayload = {
  __typename?: 'StorefrontCartDiscountCodesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** Possible error codes that can be returned by `CartUserError`. */
export enum StorefrontCartErrorCode {
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Delivery group was not found in cart. */
  InvalidDeliveryGroup = 'INVALID_DELIVERY_GROUP',
  /** Delivery option was not valid. */
  InvalidDeliveryOption = 'INVALID_DELIVERY_OPTION',
  /** Merchandise line was not found in cart. */
  InvalidMerchandiseLine = 'INVALID_MERCHANDISE_LINE',
  /** The metafields were not valid. */
  InvalidMetafields = 'INVALID_METAFIELDS',
  /** The payment wasn't valid. */
  InvalidPayment = 'INVALID_PAYMENT',
  /** Cannot update payment on an empty cart */
  InvalidPaymentEmptyCart = 'INVALID_PAYMENT_EMPTY_CART',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** Missing discount code. */
  MissingDiscountCode = 'MISSING_DISCOUNT_CODE',
  /** Missing note. */
  MissingNote = 'MISSING_NOTE',
  /** The payment method is not supported. */
  PaymentMethodNotSupported = 'PAYMENT_METHOD_NOT_SUPPORTED'
}

/**
 * The estimated costs that the buyer will pay at checkout.
 * The estimated cost uses
 * [`CartBuyerIdentity`](https://shopify.dev/api/storefront/reference/cart/cartbuyeridentity)
 * to determine
 * [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
 *
 */
export type StorefrontCartEstimatedCost = {
  __typename?: 'StorefrontCartEstimatedCost';
  /** The estimated amount, before taxes and discounts, for the customer to pay at checkout. The checkout charge amount doesn't include any deferred payments that'll be paid at a later date. If the cart has no deferred payments, then the checkout charge amount is equivalent to`subtotal_amount`. */
  checkoutChargeAmount: StorefrontMoneyV2;
  /** The estimated amount, before taxes and discounts, for the customer to pay. */
  subtotalAmount: StorefrontMoneyV2;
  /** The estimated total amount for the customer to pay. */
  totalAmount: StorefrontMoneyV2;
  /** The estimated duty amount for the customer to pay at checkout. */
  totalDutyAmount?: Maybe<StorefrontMoneyV2>;
  /** The estimated tax amount for the customer to pay at checkout. */
  totalTaxAmount?: Maybe<StorefrontMoneyV2>;
};

/**
 * The input fields for submitting a billing address without a selected payment method.
 *
 */
export type StorefrontCartFreePaymentMethodInput = {
  /** The customer's billing address. */
  billingAddress: StorefrontMailingAddressInput;
};

/** The input fields to create a cart. */
export type StorefrontCartInput = {
  /** An array of key-value pairs that contains additional information about the cart. */
  attributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /**
   * The customer associated with the cart. Used to determine [international pricing]
   * (https://shopify.dev/custom-storefronts/internationalization/international-pricing).
   * Buyer identity should match the customer's shipping address.
   *
   */
  buyerIdentity?: InputMaybe<StorefrontCartBuyerIdentityInput>;
  /**
   * The case-insensitive discount codes that the customer added at checkout.
   *
   */
  discountCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of merchandise lines to add to the cart. */
  lines?: InputMaybe<Array<StorefrontCartLineInput>>;
  /** The metafields to associate with this cart. */
  metafields?: InputMaybe<Array<StorefrontCartInputMetafieldInput>>;
  /** A note that's associated with the cart. For example, the note can be a personalized message to the buyer. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** The input fields for a cart metafield value to set. */
export type StorefrontCartInputMetafieldInput = {
  /** The key name of the metafield. */
  key: Scalars['String']['input'];
  /**
   * The type of data that the cart metafield stores.
   * The type of data must be a [supported type](https://shopify.dev/apps/metafields/types).
   *
   */
  type: Scalars['String']['input'];
  /**
   * The data to store in the cart metafield. The data is always stored as a string, regardless of the metafield's type.
   *
   */
  value: Scalars['String']['input'];
};

/** Represents information about the merchandise in the cart. */
export type StorefrontCartLine = StorefrontBaseCartLine & StorefrontNode & {
  __typename?: 'StorefrontCartLine';
  /** An attribute associated with the cart line. */
  attribute?: Maybe<StorefrontAttribute>;
  /** The attributes associated with the cart line. Attributes are represented as key-value pairs. */
  attributes: Array<StorefrontAttribute>;
  /** The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout. */
  cost: StorefrontCartLineCost;
  /** The discounts that have been applied to the cart line. */
  discountAllocations: Array<StorefrontCartDiscountAllocation>;
  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   * @deprecated Use `cost` instead.
   */
  estimatedCost: StorefrontCartLineEstimatedCost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The merchandise that the buyer intends to purchase. */
  merchandise: StorefrontMerchandise;
  /** The quantity of the merchandise that the customer intends to purchase. */
  quantity: Scalars['Int']['output'];
  /** The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased. */
  sellingPlanAllocation?: Maybe<StorefrontSellingPlanAllocation>;
};


/** Represents information about the merchandise in the cart. */
export type StorefrontCartLineAttributeArgs = {
  key: Scalars['String']['input'];
};

/** The cost of the merchandise line that the buyer will pay at checkout. */
export type StorefrontCartLineCost = {
  __typename?: 'StorefrontCartLineCost';
  /** The amount of the merchandise line. */
  amountPerQuantity: StorefrontMoneyV2;
  /** The compare at amount of the merchandise line. */
  compareAtAmountPerQuantity?: Maybe<StorefrontMoneyV2>;
  /** The cost of the merchandise line before line-level discounts. */
  subtotalAmount: StorefrontMoneyV2;
  /** The total cost of the merchandise line. */
  totalAmount: StorefrontMoneyV2;
};

/** The estimated cost of the merchandise line that the buyer will pay at checkout. */
export type StorefrontCartLineEstimatedCost = {
  __typename?: 'StorefrontCartLineEstimatedCost';
  /** The amount of the merchandise line. */
  amount: StorefrontMoneyV2;
  /** The compare at amount of the merchandise line. */
  compareAtAmount?: Maybe<StorefrontMoneyV2>;
  /** The estimated cost of the merchandise line before discounts. */
  subtotalAmount: StorefrontMoneyV2;
  /** The estimated total cost of the merchandise line. */
  totalAmount: StorefrontMoneyV2;
};

/** The input fields to create a merchandise line on a cart. */
export type StorefrontCartLineInput = {
  /** An array of key-value pairs that contains additional information about the merchandise line. */
  attributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /** The ID of the merchandise that the buyer intends to purchase. */
  merchandiseId: Scalars['ID']['input'];
  /** The quantity of the merchandise. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the selling plan that the merchandise is being purchased with. */
  sellingPlanId?: InputMaybe<Scalars['ID']['input']>;
};

/** The input fields to update a line item on a cart. */
export type StorefrontCartLineUpdateInput = {
  /** An array of key-value pairs that contains additional information about the merchandise line. */
  attributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /** The ID of the merchandise line. */
  id: Scalars['ID']['input'];
  /** The ID of the merchandise for the line item. */
  merchandiseId?: InputMaybe<Scalars['ID']['input']>;
  /** The quantity of the line item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the selling plan that the merchandise is being purchased with. */
  sellingPlanId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `cartLinesAdd` mutation. */
export type StorefrontCartLinesAddPayload = {
  __typename?: 'StorefrontCartLinesAddPayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** Return type for `cartLinesRemove` mutation. */
export type StorefrontCartLinesRemovePayload = {
  __typename?: 'StorefrontCartLinesRemovePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** Return type for `cartLinesUpdate` mutation. */
export type StorefrontCartLinesUpdatePayload = {
  __typename?: 'StorefrontCartLinesUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** The input fields to delete a cart metafield. */
export type StorefrontCartMetafieldDeleteInput = {
  /**
   * The key name of the cart metafield. Can either be a composite key (`namespace.key`) or a simple key
   *  that relies on the default app-reserved namespace.
   *
   */
  key: Scalars['String']['input'];
  /** The ID of the cart resource. */
  ownerId: Scalars['ID']['input'];
};

/** Return type for `cartMetafieldDelete` mutation. */
export type StorefrontCartMetafieldDeletePayload = {
  __typename?: 'StorefrontCartMetafieldDeletePayload';
  /** The ID of the deleted cart metafield. */
  deletedId?: Maybe<Scalars['ID']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontMetafieldDeleteUserError>;
};

/** The input fields for a cart metafield value to set. */
export type StorefrontCartMetafieldsSetInput = {
  /** The key name of the cart metafield. */
  key: Scalars['String']['input'];
  /** The ID of the cart resource. */
  ownerId: Scalars['ID']['input'];
  /**
   * The type of data that the cart metafield stores.
   * The type of data must be a [supported type](https://shopify.dev/apps/metafields/types).
   *
   */
  type: Scalars['String']['input'];
  /**
   * The data to store in the cart metafield. The data is always stored as a string, regardless of the metafield's type.
   *
   */
  value: Scalars['String']['input'];
};

/** Return type for `cartMetafieldsSet` mutation. */
export type StorefrontCartMetafieldsSetPayload = {
  __typename?: 'StorefrontCartMetafieldsSetPayload';
  /** The list of cart metafields that were set. */
  metafields?: Maybe<Array<StorefrontMetafield>>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontMetafieldsSetUserError>;
};

/** Return type for `cartNoteUpdate` mutation. */
export type StorefrontCartNoteUpdatePayload = {
  __typename?: 'StorefrontCartNoteUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/**
 * The input fields for updating the payment method that will be used to checkout.
 *
 */
export type StorefrontCartPaymentInput = {
  /** The amount that the customer will be charged at checkout. */
  amount: StorefrontMoneyInput;
  /**
   * The input fields to use when checking out a cart with a direct payment method (like a credit card).
   *
   */
  directPaymentMethod?: InputMaybe<StorefrontCartDirectPaymentMethodInput>;
  /**
   * The input fields to use to checkout a cart without providing a payment method.
   * Use this payment method input if the total cost of the cart is 0.
   *
   */
  freePaymentMethod?: InputMaybe<StorefrontCartFreePaymentMethodInput>;
  /**
   * An ID of the order placed on the originating platform.
   * Note that this value doesn't correspond to the Shopify Order ID.
   *
   */
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * The input fields to use when checking out a cart with a wallet payment method (like Shop Pay or Apple Pay).
   *
   */
  walletPaymentMethod?: InputMaybe<StorefrontCartWalletPaymentMethodInput>;
};

/** Return type for `cartPaymentUpdate` mutation. */
export type StorefrontCartPaymentUpdatePayload = {
  __typename?: 'StorefrontCartPaymentUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/**
 * The input fields for updating the selected delivery options for a delivery group.
 *
 */
export type StorefrontCartSelectedDeliveryOptionInput = {
  /** The ID of the cart delivery group. */
  deliveryGroupId: Scalars['ID']['input'];
  /** The handle of the selected delivery option. */
  deliveryOptionHandle: Scalars['String']['input'];
};

/** Return type for `cartSelectedDeliveryOptionsUpdate` mutation. */
export type StorefrontCartSelectedDeliveryOptionsUpdatePayload = {
  __typename?: 'StorefrontCartSelectedDeliveryOptionsUpdatePayload';
  /** The updated cart. */
  cart?: Maybe<StorefrontCart>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** Return type for `cartSubmitForCompletion` mutation. */
export type StorefrontCartSubmitForCompletionPayload = {
  __typename?: 'StorefrontCartSubmitForCompletionPayload';
  /** The result of cart submission for completion. */
  result?: Maybe<StorefrontCartSubmitForCompletionResult>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCartUserError>;
};

/** The result of cart submit completion. */
export type StorefrontCartSubmitForCompletionResult = StorefrontSubmitAlreadyAccepted | StorefrontSubmitFailed | StorefrontSubmitSuccess | StorefrontSubmitThrottled;

/** Represents an error that happens during execution of a cart mutation. */
export type StorefrontCartUserError = StorefrontDisplayableError & {
  __typename?: 'StorefrontCartUserError';
  /** The error code. */
  code?: Maybe<StorefrontCartErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * The input fields for submitting wallet payment method information for checkout.
 *
 */
export type StorefrontCartWalletPaymentMethodInput = {
  /** The payment method information for the Apple Pay wallet. */
  applePayWalletContent?: InputMaybe<StorefrontApplePayWalletContentInput>;
  /** The payment method information for the Shop Pay wallet. */
  shopPayWalletContent?: InputMaybe<StorefrontShopPayWalletContentInput>;
};

/** A container for all the information required to checkout items and pay. */
export type StorefrontCheckout = StorefrontNode & {
  __typename?: 'StorefrontCheckout';
  /** The gift cards used on the checkout. */
  appliedGiftCards: Array<StorefrontAppliedGiftCard>;
  /**
   * The available shipping rates for this Checkout.
   * Should only be used when checkout `requiresShipping` is `true` and
   * the shipping address is valid.
   *
   */
  availableShippingRates?: Maybe<StorefrontAvailableShippingRates>;
  /** The identity of the customer associated with the checkout. */
  buyerIdentity: StorefrontCheckoutBuyerIdentity;
  /** The date and time when the checkout was completed. */
  completedAt?: Maybe<Scalars['StorefrontDateTime']['output']>;
  /** The date and time when the checkout was created. */
  createdAt: Scalars['StorefrontDateTime']['output'];
  /** The currency code for the checkout. */
  currencyCode: StorefrontCurrencyCode;
  /** A list of extra information that's added to the checkout. */
  customAttributes: Array<StorefrontAttribute>;
  /** Discounts that have been applied on the checkout. */
  discountApplications: StorefrontDiscountApplicationConnection;
  /** The email attached to this checkout. */
  email?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** A list of line item objects, each one containing information about an item in the checkout. */
  lineItems: StorefrontCheckoutLineItemConnection;
  /** The sum of all the prices of all the items in the checkout. Duties, taxes, shipping and discounts excluded. */
  lineItemsSubtotalPrice: StorefrontMoneyV2;
  /** The note associated with the checkout. */
  note?: Maybe<Scalars['String']['output']>;
  /** The resulting order from a paid checkout. */
  order?: Maybe<StorefrontOrder>;
  /** The Order Status Page for this Checkout, null when checkout isn't completed. */
  orderStatusUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** The amount left to be paid. This is equal to the cost of the line items, taxes, and shipping, minus discounts and gift cards. */
  paymentDue: StorefrontMoneyV2;
  /**
   * The amount left to be paid. This is equal to the cost of the line items, duties, taxes, and shipping, minus discounts and gift cards.
   * @deprecated Use `paymentDue` instead.
   */
  paymentDueV2: StorefrontMoneyV2;
  /**
   * Whether or not the Checkout is ready and can be completed. Checkouts may
   * have asynchronous operations that can take time to finish. If you want
   * to complete a checkout or ensure all the fields are populated and up to
   * date, polling is required until the value is true.
   *
   */
  ready: Scalars['Boolean']['output'];
  /** States whether or not the fulfillment requires shipping. */
  requiresShipping: Scalars['Boolean']['output'];
  /** The shipping address to where the line items will be shipped. */
  shippingAddress?: Maybe<StorefrontMailingAddress>;
  /**
   * The discounts that have been allocated onto the shipping line by discount applications.
   *
   */
  shippingDiscountAllocations: Array<StorefrontDiscountAllocation>;
  /** Once a shipping rate is selected by the customer it's transitioned to a `shipping_line` object. */
  shippingLine?: Maybe<StorefrontShippingRate>;
  /** The price at checkout before shipping and taxes. */
  subtotalPrice: StorefrontMoneyV2;
  /**
   * The price at checkout before duties, shipping, and taxes.
   * @deprecated Use `subtotalPrice` instead.
   */
  subtotalPriceV2: StorefrontMoneyV2;
  /** Whether the checkout is tax exempt. */
  taxExempt: Scalars['Boolean']['output'];
  /** Whether taxes are included in the line item and shipping line prices. */
  taxesIncluded: Scalars['Boolean']['output'];
  /** The sum of all the duties applied to the line items in the checkout. */
  totalDuties?: Maybe<StorefrontMoneyV2>;
  /** The sum of all the prices of all the items in the checkout, including taxes and duties. */
  totalPrice: StorefrontMoneyV2;
  /**
   * The sum of all the prices of all the items in the checkout, including taxes and duties.
   * @deprecated Use `totalPrice` instead.
   */
  totalPriceV2: StorefrontMoneyV2;
  /** The sum of all the taxes applied to the line items and shipping lines in the checkout. */
  totalTax: StorefrontMoneyV2;
  /**
   * The sum of all the taxes applied to the line items and shipping lines in the checkout.
   * @deprecated Use `totalTax` instead.
   */
  totalTaxV2: StorefrontMoneyV2;
  /** The date and time when the checkout was last updated. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
  /** The url pointing to the checkout accessible from the web. */
  webUrl: Scalars['StorefrontURL']['output'];
};


/** A container for all the information required to checkout items and pay. */
export type StorefrontCheckoutDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A container for all the information required to checkout items and pay. */
export type StorefrontCheckoutLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input fields required to update a checkout's attributes. */
export type StorefrontCheckoutAttributesUpdateV2Input = {
  /**
   * Allows setting partial addresses on a Checkout, skipping the full validation of attributes.
   * The required attributes are city, province, and country.
   * Full validation of the addresses is still done at completion time. Defaults to `false` with
   * each operation.
   *
   */
  allowPartialAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of extra information that's added to the checkout. */
  customAttributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /** The text of an optional note that a shop owner can attach to the checkout. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `checkoutAttributesUpdateV2` mutation. */
export type StorefrontCheckoutAttributesUpdateV2Payload = {
  __typename?: 'StorefrontCheckoutAttributesUpdateV2Payload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** The identity of the customer associated with the checkout. */
export type StorefrontCheckoutBuyerIdentity = {
  __typename?: 'StorefrontCheckoutBuyerIdentity';
  /** The country code for the checkout. For example, `CA`. */
  countryCode?: Maybe<StorefrontCountryCode>;
};

/** The input fields for the identity of the customer associated with the checkout. */
export type StorefrontCheckoutBuyerIdentityInput = {
  /**
   * The country code of one of the shop's
   * [enabled countries](https://help.shopify.com/en/manual/payments/shopify-payments/multi-currency/setup).
   * For example, `CA`. Including this field creates a checkout in the specified country's currency.
   *
   */
  countryCode: StorefrontCountryCode;
};

/** Return type for `checkoutCompleteFree` mutation. */
export type StorefrontCheckoutCompleteFreePayload = {
  __typename?: 'StorefrontCheckoutCompleteFreePayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutCompleteWithCreditCardV2` mutation. */
export type StorefrontCheckoutCompleteWithCreditCardV2Payload = {
  __typename?: 'StorefrontCheckoutCompleteWithCreditCardV2Payload';
  /** The checkout on which the payment was applied. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /** A representation of the attempted payment. */
  payment?: Maybe<StorefrontPayment>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutCompleteWithTokenizedPaymentV3` mutation. */
export type StorefrontCheckoutCompleteWithTokenizedPaymentV3Payload = {
  __typename?: 'StorefrontCheckoutCompleteWithTokenizedPaymentV3Payload';
  /** The checkout on which the payment was applied. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /** A representation of the attempted payment. */
  payment?: Maybe<StorefrontPayment>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** The input fields required to create a checkout. */
export type StorefrontCheckoutCreateInput = {
  /**
   * Allows setting partial addresses on a Checkout, skipping the full validation of attributes.
   * The required attributes are city, province, and country.
   * Full validation of addresses is still done at completion time. Defaults to `null`.
   *
   */
  allowPartialAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  /** The identity of the customer associated with the checkout. */
  buyerIdentity?: InputMaybe<StorefrontCheckoutBuyerIdentityInput>;
  /** A list of extra information that's added to the checkout. */
  customAttributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /** The email with which the customer wants to checkout. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** A list of line item objects, each one containing information about an item in the checkout. */
  lineItems?: InputMaybe<Array<StorefrontCheckoutLineItemInput>>;
  /** The text of an optional note that a shop owner can attach to the checkout. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The shipping address to where the line items will be shipped. */
  shippingAddress?: InputMaybe<StorefrontMailingAddressInput>;
};

/** Return type for `checkoutCreate` mutation. */
export type StorefrontCheckoutCreatePayload = {
  __typename?: 'StorefrontCheckoutCreatePayload';
  /** The new checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /** The checkout queue token. Available only to selected stores. */
  queueToken?: Maybe<Scalars['String']['output']>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutCustomerAssociateV2` mutation. */
export type StorefrontCheckoutCustomerAssociateV2Payload = {
  __typename?: 'StorefrontCheckoutCustomerAssociateV2Payload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /** The associated customer object. */
  customer?: Maybe<StorefrontCustomer>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutCustomerDisassociateV2` mutation. */
export type StorefrontCheckoutCustomerDisassociateV2Payload = {
  __typename?: 'StorefrontCheckoutCustomerDisassociateV2Payload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutDiscountCodeApplyV2` mutation. */
export type StorefrontCheckoutDiscountCodeApplyV2Payload = {
  __typename?: 'StorefrontCheckoutDiscountCodeApplyV2Payload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutDiscountCodeRemove` mutation. */
export type StorefrontCheckoutDiscountCodeRemovePayload = {
  __typename?: 'StorefrontCheckoutDiscountCodeRemovePayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutEmailUpdateV2` mutation. */
export type StorefrontCheckoutEmailUpdateV2Payload = {
  __typename?: 'StorefrontCheckoutEmailUpdateV2Payload';
  /** The checkout object with the updated email. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Possible error codes that can be returned by `CheckoutUserError`. */
export enum StorefrontCheckoutErrorCode {
  /** Checkout is already completed. */
  AlreadyCompleted = 'ALREADY_COMPLETED',
  /** Input email contains an invalid domain name. */
  BadDomain = 'BAD_DOMAIN',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Cart does not meet discount requirements notice. */
  CartDoesNotMeetDiscountRequirementsNotice = 'CART_DOES_NOT_MEET_DISCOUNT_REQUIREMENTS_NOTICE',
  /** Customer already used once per customer discount notice. */
  CustomerAlreadyUsedOncePerCustomerDiscountNotice = 'CUSTOMER_ALREADY_USED_ONCE_PER_CUSTOMER_DISCOUNT_NOTICE',
  /** Discount already applied. */
  DiscountAlreadyApplied = 'DISCOUNT_ALREADY_APPLIED',
  /** Discount code isn't working right now. Please contact us for help. */
  DiscountCodeApplicationFailed = 'DISCOUNT_CODE_APPLICATION_FAILED',
  /** Discount disabled. */
  DiscountDisabled = 'DISCOUNT_DISABLED',
  /** Discount expired. */
  DiscountExpired = 'DISCOUNT_EXPIRED',
  /** Discount limit reached. */
  DiscountLimitReached = 'DISCOUNT_LIMIT_REACHED',
  /** Discount not found. */
  DiscountNotFound = 'DISCOUNT_NOT_FOUND',
  /** Checkout is already completed. */
  Empty = 'EMPTY',
  /** Queue token has expired. */
  ExpiredQueueToken = 'EXPIRED_QUEUE_TOKEN',
  /** Gift card has already been applied. */
  GiftCardAlreadyApplied = 'GIFT_CARD_ALREADY_APPLIED',
  /** Gift card code is invalid. */
  GiftCardCodeInvalid = 'GIFT_CARD_CODE_INVALID',
  /** Gift card currency does not match checkout currency. */
  GiftCardCurrencyMismatch = 'GIFT_CARD_CURRENCY_MISMATCH',
  /** Gift card has no funds left. */
  GiftCardDepleted = 'GIFT_CARD_DEPLETED',
  /** Gift card is disabled. */
  GiftCardDisabled = 'GIFT_CARD_DISABLED',
  /** Gift card is expired. */
  GiftCardExpired = 'GIFT_CARD_EXPIRED',
  /** Gift card was not found. */
  GiftCardNotFound = 'GIFT_CARD_NOT_FOUND',
  /** Gift card cannot be applied to a checkout that contains a gift card. */
  GiftCardUnusable = 'GIFT_CARD_UNUSABLE',
  /** The input value should be greater than or equal to the minimum value allowed. */
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  /** Higher value discount applied. */
  HigherValueDiscountApplied = 'HIGHER_VALUE_DISCOUNT_APPLIED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Cannot specify country and presentment currency code. */
  InvalidCountryAndCurrency = 'INVALID_COUNTRY_AND_CURRENCY',
  /** Input Zip is invalid for country provided. */
  InvalidForCountry = 'INVALID_FOR_COUNTRY',
  /** Input Zip is invalid for country and province provided. */
  InvalidForCountryAndProvince = 'INVALID_FOR_COUNTRY_AND_PROVINCE',
  /** Invalid province in country. */
  InvalidProvinceInCountry = 'INVALID_PROVINCE_IN_COUNTRY',
  /** Queue token is invalid. */
  InvalidQueueToken = 'INVALID_QUEUE_TOKEN',
  /** Invalid region in country. */
  InvalidRegionInCountry = 'INVALID_REGION_IN_COUNTRY',
  /** Invalid state in country. */
  InvalidStateInCountry = 'INVALID_STATE_IN_COUNTRY',
  /** The input value should be less than the maximum value allowed. */
  LessThan = 'LESS_THAN',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** Line item was not found in checkout. */
  LineItemNotFound = 'LINE_ITEM_NOT_FOUND',
  /** Checkout is locked. */
  Locked = 'LOCKED',
  /** Maximum number of discount codes limit reached. */
  MaximumDiscountCodeLimitReached = 'MAXIMUM_DISCOUNT_CODE_LIMIT_REACHED',
  /** Missing payment input. */
  MissingPaymentInput = 'MISSING_PAYMENT_INPUT',
  /** Not enough in stock. */
  NotEnoughInStock = 'NOT_ENOUGH_IN_STOCK',
  /** Input value is not supported. */
  NotSupported = 'NOT_SUPPORTED',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** Product is not published for this customer. */
  ProductNotAvailable = 'PRODUCT_NOT_AVAILABLE',
  /** Shipping rate expired. */
  ShippingRateExpired = 'SHIPPING_RATE_EXPIRED',
  /** Throttled during checkout. */
  ThrottledDuringCheckout = 'THROTTLED_DURING_CHECKOUT',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The amount of the payment does not match the value to be paid. */
  TotalPriceMismatch = 'TOTAL_PRICE_MISMATCH',
  /** Unable to apply discount. */
  UnableToApply = 'UNABLE_TO_APPLY'
}

/** Return type for `checkoutGiftCardRemoveV2` mutation. */
export type StorefrontCheckoutGiftCardRemoveV2Payload = {
  __typename?: 'StorefrontCheckoutGiftCardRemoveV2Payload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutGiftCardsAppend` mutation. */
export type StorefrontCheckoutGiftCardsAppendPayload = {
  __typename?: 'StorefrontCheckoutGiftCardsAppendPayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** A single line item in the checkout, grouped by variant and attributes. */
export type StorefrontCheckoutLineItem = StorefrontNode & {
  __typename?: 'StorefrontCheckoutLineItem';
  /** Extra information in the form of an array of Key-Value pairs about the line item. */
  customAttributes: Array<StorefrontAttribute>;
  /** The discounts that have been allocated onto the checkout line item by discount applications. */
  discountAllocations: Array<StorefrontDiscountAllocation>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The quantity of the line item. */
  quantity: Scalars['Int']['output'];
  /** Title of the line item. Defaults to the product's title. */
  title: Scalars['String']['output'];
  /** Unit price of the line item. */
  unitPrice?: Maybe<StorefrontMoneyV2>;
  /** Product variant of the line item. */
  variant?: Maybe<StorefrontProductVariant>;
};

/**
 * An auto-generated type for paginating through multiple CheckoutLineItems.
 *
 */
export type StorefrontCheckoutLineItemConnection = {
  __typename?: 'StorefrontCheckoutLineItemConnection';
  /** A list of edges. */
  edges: Array<StorefrontCheckoutLineItemEdge>;
  /** A list of the nodes contained in CheckoutLineItemEdge. */
  nodes: Array<StorefrontCheckoutLineItem>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one CheckoutLineItem and a cursor during pagination.
 *
 */
export type StorefrontCheckoutLineItemEdge = {
  __typename?: 'StorefrontCheckoutLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CheckoutLineItemEdge. */
  node: StorefrontCheckoutLineItem;
};

/** The input fields to create a line item on a checkout. */
export type StorefrontCheckoutLineItemInput = {
  /** Extra information in the form of an array of Key-Value pairs about the line item. */
  customAttributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /** The quantity of the line item. */
  quantity: Scalars['Int']['input'];
  /** The ID of the product variant for the line item. */
  variantId: Scalars['ID']['input'];
};

/** The input fields to update a line item on the checkout. */
export type StorefrontCheckoutLineItemUpdateInput = {
  /** Extra information in the form of an array of Key-Value pairs about the line item. */
  customAttributes?: InputMaybe<Array<StorefrontAttributeInput>>;
  /** The ID of the line item. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The quantity of the line item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The variant ID of the line item. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Return type for `checkoutLineItemsAdd` mutation. */
export type StorefrontCheckoutLineItemsAddPayload = {
  __typename?: 'StorefrontCheckoutLineItemsAddPayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutLineItemsRemove` mutation. */
export type StorefrontCheckoutLineItemsRemovePayload = {
  __typename?: 'StorefrontCheckoutLineItemsRemovePayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutLineItemsReplace` mutation. */
export type StorefrontCheckoutLineItemsReplacePayload = {
  __typename?: 'StorefrontCheckoutLineItemsReplacePayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontCheckoutUserError>;
};

/** Return type for `checkoutLineItemsUpdate` mutation. */
export type StorefrontCheckoutLineItemsUpdatePayload = {
  __typename?: 'StorefrontCheckoutLineItemsUpdatePayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutShippingAddressUpdateV2` mutation. */
export type StorefrontCheckoutShippingAddressUpdateV2Payload = {
  __typename?: 'StorefrontCheckoutShippingAddressUpdateV2Payload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `checkoutShippingLineUpdate` mutation. */
export type StorefrontCheckoutShippingLineUpdatePayload = {
  __typename?: 'StorefrontCheckoutShippingLineUpdatePayload';
  /** The updated checkout object. */
  checkout?: Maybe<StorefrontCheckout>;
  /** The list of errors that occurred from executing the mutation. */
  checkoutUserErrors: Array<StorefrontCheckoutUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `checkoutUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Represents an error that happens during execution of a checkout mutation. */
export type StorefrontCheckoutUserError = StorefrontDisplayableError & {
  __typename?: 'StorefrontCheckoutUserError';
  /** The error code. */
  code?: Maybe<StorefrontCheckoutErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** A collection represents a grouping of products that a shop owner can create to organize them or make their shops easier to browse. */
export type StorefrontCollection = StorefrontHasMetafields & StorefrontNode & StorefrontOnlineStorePublishable & StorefrontTrackable & {
  __typename?: 'StorefrontCollection';
  /** Stripped description of the collection, single line with HTML tags removed. */
  description: Scalars['String']['output'];
  /** The description of the collection, complete with HTML formatting. */
  descriptionHtml: Scalars['StorefrontHTML']['output'];
  /**
   * A human-friendly unique string for the collection automatically generated from its title.
   * Limit of 255 characters.
   *
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Image associated with the collection. */
  image?: Maybe<StorefrontImage>;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** List of products in the collection. */
  products: StorefrontProductConnection;
  /** The collection's SEO information. */
  seo: StorefrontSeo;
  /** The collection’s name. Limit of 255 characters. */
  title: Scalars['String']['output'];
  /** A URL parameters to be added to a page URL when it is linked from a GraphQL result. This allows for tracking the origin of the traffic. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
  /** The date and time when the collection was last modified. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
};


/** A collection represents a grouping of products that a shop owner can create to organize them or make their shops easier to browse. */
export type StorefrontCollectionDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};


/** A collection represents a grouping of products that a shop owner can create to organize them or make their shops easier to browse. */
export type StorefrontCollectionMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** A collection represents a grouping of products that a shop owner can create to organize them or make their shops easier to browse. */
export type StorefrontCollectionMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};


/** A collection represents a grouping of products that a shop owner can create to organize them or make their shops easier to browse. */
export type StorefrontCollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<StorefrontProductFilter>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontProductCollectionSortKeys>;
};

/**
 * An auto-generated type for paginating through multiple Collections.
 *
 */
export type StorefrontCollectionConnection = {
  __typename?: 'StorefrontCollectionConnection';
  /** A list of edges. */
  edges: Array<StorefrontCollectionEdge>;
  /** A list of the nodes contained in CollectionEdge. */
  nodes: Array<StorefrontCollection>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
  /** The total count of Collections. */
  totalCount: Scalars['StorefrontUnsignedInt64']['output'];
};

/**
 * An auto-generated type which holds one Collection and a cursor during pagination.
 *
 */
export type StorefrontCollectionEdge = {
  __typename?: 'StorefrontCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CollectionEdge. */
  node: StorefrontCollection;
};

/** The set of valid sort keys for the Collection query. */
export enum StorefrontCollectionSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** A comment on an article. */
export type StorefrontComment = StorefrontNode & {
  __typename?: 'StorefrontComment';
  /** The comment’s author. */
  author: StorefrontCommentAuthor;
  /** Stripped content of the comment, single line with HTML tags removed. */
  content: Scalars['String']['output'];
  /** The content of the comment, complete with HTML formatting. */
  contentHtml: Scalars['StorefrontHTML']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};


/** A comment on an article. */
export type StorefrontCommentContentArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};

/** The author of a comment. */
export type StorefrontCommentAuthor = {
  __typename?: 'StorefrontCommentAuthor';
  /** The author's email. */
  email: Scalars['String']['output'];
  /** The author’s name. */
  name: Scalars['String']['output'];
};

/**
 * An auto-generated type for paginating through multiple Comments.
 *
 */
export type StorefrontCommentConnection = {
  __typename?: 'StorefrontCommentConnection';
  /** A list of edges. */
  edges: Array<StorefrontCommentEdge>;
  /** A list of the nodes contained in CommentEdge. */
  nodes: Array<StorefrontComment>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Comment and a cursor during pagination.
 *
 */
export type StorefrontCommentEdge = {
  __typename?: 'StorefrontCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of CommentEdge. */
  node: StorefrontComment;
};

/** The action for the 3DS payment redirect. */
export type StorefrontCompletePaymentChallenge = {
  __typename?: 'StorefrontCompletePaymentChallenge';
  /** The URL for the 3DS payment redirect. */
  redirectUrl?: Maybe<Scalars['StorefrontURL']['output']>;
};

/** An error that occurred during a cart completion attempt. */
export type StorefrontCompletionError = {
  __typename?: 'StorefrontCompletionError';
  /** The error code. */
  code: StorefrontCompletionErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** The code of the error that occurred during a cart completion attempt. */
export enum StorefrontCompletionErrorCode {
  Error = 'ERROR',
  InventoryReservationError = 'INVENTORY_RESERVATION_ERROR',
  PaymentAmountTooSmall = 'PAYMENT_AMOUNT_TOO_SMALL',
  PaymentCallIssuer = 'PAYMENT_CALL_ISSUER',
  PaymentCardDeclined = 'PAYMENT_CARD_DECLINED',
  PaymentError = 'PAYMENT_ERROR',
  PaymentGatewayNotEnabledError = 'PAYMENT_GATEWAY_NOT_ENABLED_ERROR',
  PaymentInsufficientFunds = 'PAYMENT_INSUFFICIENT_FUNDS',
  PaymentInvalidBillingAddress = 'PAYMENT_INVALID_BILLING_ADDRESS',
  PaymentInvalidCreditCard = 'PAYMENT_INVALID_CREDIT_CARD',
  PaymentInvalidCurrency = 'PAYMENT_INVALID_CURRENCY',
  PaymentInvalidPaymentMethod = 'PAYMENT_INVALID_PAYMENT_METHOD',
  PaymentTransientError = 'PAYMENT_TRANSIENT_ERROR'
}

/** Represents information about the grouped merchandise in the cart. */
export type StorefrontComponentizableCartLine = StorefrontBaseCartLine & StorefrontNode & {
  __typename?: 'StorefrontComponentizableCartLine';
  /** An attribute associated with the cart line. */
  attribute?: Maybe<StorefrontAttribute>;
  /** The attributes associated with the cart line. Attributes are represented as key-value pairs. */
  attributes: Array<StorefrontAttribute>;
  /** The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout. */
  cost: StorefrontCartLineCost;
  /** The discounts that have been applied to the cart line. */
  discountAllocations: Array<StorefrontCartDiscountAllocation>;
  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   * @deprecated Use `cost` instead.
   */
  estimatedCost: StorefrontCartLineEstimatedCost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The components of the line item. */
  lineComponents: Array<StorefrontCartLine>;
  /** The merchandise that the buyer intends to purchase. */
  merchandise: StorefrontMerchandise;
  /** The quantity of the merchandise that the customer intends to purchase. */
  quantity: Scalars['Int']['output'];
  /** The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased. */
  sellingPlanAllocation?: Maybe<StorefrontSellingPlanAllocation>;
};


/** Represents information about the grouped merchandise in the cart. */
export type StorefrontComponentizableCartLineAttributeArgs = {
  key: Scalars['String']['input'];
};

/** A country. */
export type StorefrontCountry = {
  __typename?: 'StorefrontCountry';
  /** The languages available for the country. */
  availableLanguages: Array<StorefrontLanguage>;
  /** The currency of the country. */
  currency: StorefrontCurrency;
  /** The ISO code of the country. */
  isoCode: StorefrontCountryCode;
  /** The market that includes this country. */
  market?: Maybe<StorefrontMarket>;
  /** The name of the country. */
  name: Scalars['String']['output'];
  /** The unit system used in the country. */
  unitSystem: StorefrontUnitSystem;
};

/**
 * The code designating a country/region, which generally follows ISO 3166-1 alpha-2 guidelines.
 * If a territory doesn't have a country code value in the `CountryCode` enum, then it might be considered a subdivision
 * of another country. For example, the territories associated with Spain are represented by the country code `ES`,
 * and the territories associated with the United States of America are represented by the country code `US`.
 *
 */
export enum StorefrontCountryCode {
  /** Ascension Island. */
  Ac = 'AC',
  /** Andorra. */
  Ad = 'AD',
  /** United Arab Emirates. */
  Ae = 'AE',
  /** Afghanistan. */
  Af = 'AF',
  /** Antigua & Barbuda. */
  Ag = 'AG',
  /** Anguilla. */
  Ai = 'AI',
  /** Albania. */
  Al = 'AL',
  /** Armenia. */
  Am = 'AM',
  /** Netherlands Antilles. */
  An = 'AN',
  /** Angola. */
  Ao = 'AO',
  /** Argentina. */
  Ar = 'AR',
  /** Austria. */
  At = 'AT',
  /** Australia. */
  Au = 'AU',
  /** Aruba. */
  Aw = 'AW',
  /** Åland Islands. */
  Ax = 'AX',
  /** Azerbaijan. */
  Az = 'AZ',
  /** Bosnia & Herzegovina. */
  Ba = 'BA',
  /** Barbados. */
  Bb = 'BB',
  /** Bangladesh. */
  Bd = 'BD',
  /** Belgium. */
  Be = 'BE',
  /** Burkina Faso. */
  Bf = 'BF',
  /** Bulgaria. */
  Bg = 'BG',
  /** Bahrain. */
  Bh = 'BH',
  /** Burundi. */
  Bi = 'BI',
  /** Benin. */
  Bj = 'BJ',
  /** St. Barthélemy. */
  Bl = 'BL',
  /** Bermuda. */
  Bm = 'BM',
  /** Brunei. */
  Bn = 'BN',
  /** Bolivia. */
  Bo = 'BO',
  /** Caribbean Netherlands. */
  Bq = 'BQ',
  /** Brazil. */
  Br = 'BR',
  /** Bahamas. */
  Bs = 'BS',
  /** Bhutan. */
  Bt = 'BT',
  /** Bouvet Island. */
  Bv = 'BV',
  /** Botswana. */
  Bw = 'BW',
  /** Belarus. */
  By = 'BY',
  /** Belize. */
  Bz = 'BZ',
  /** Canada. */
  Ca = 'CA',
  /** Cocos (Keeling) Islands. */
  Cc = 'CC',
  /** Congo - Kinshasa. */
  Cd = 'CD',
  /** Central African Republic. */
  Cf = 'CF',
  /** Congo - Brazzaville. */
  Cg = 'CG',
  /** Switzerland. */
  Ch = 'CH',
  /** Côte d’Ivoire. */
  Ci = 'CI',
  /** Cook Islands. */
  Ck = 'CK',
  /** Chile. */
  Cl = 'CL',
  /** Cameroon. */
  Cm = 'CM',
  /** China. */
  Cn = 'CN',
  /** Colombia. */
  Co = 'CO',
  /** Costa Rica. */
  Cr = 'CR',
  /** Cuba. */
  Cu = 'CU',
  /** Cape Verde. */
  Cv = 'CV',
  /** Curaçao. */
  Cw = 'CW',
  /** Christmas Island. */
  Cx = 'CX',
  /** Cyprus. */
  Cy = 'CY',
  /** Czechia. */
  Cz = 'CZ',
  /** Germany. */
  De = 'DE',
  /** Djibouti. */
  Dj = 'DJ',
  /** Denmark. */
  Dk = 'DK',
  /** Dominica. */
  Dm = 'DM',
  /** Dominican Republic. */
  Do = 'DO',
  /** Algeria. */
  Dz = 'DZ',
  /** Ecuador. */
  Ec = 'EC',
  /** Estonia. */
  Ee = 'EE',
  /** Egypt. */
  Eg = 'EG',
  /** Western Sahara. */
  Eh = 'EH',
  /** Eritrea. */
  Er = 'ER',
  /** Spain. */
  Es = 'ES',
  /** Ethiopia. */
  Et = 'ET',
  /** Finland. */
  Fi = 'FI',
  /** Fiji. */
  Fj = 'FJ',
  /** Falkland Islands. */
  Fk = 'FK',
  /** Faroe Islands. */
  Fo = 'FO',
  /** France. */
  Fr = 'FR',
  /** Gabon. */
  Ga = 'GA',
  /** United Kingdom. */
  Gb = 'GB',
  /** Grenada. */
  Gd = 'GD',
  /** Georgia. */
  Ge = 'GE',
  /** French Guiana. */
  Gf = 'GF',
  /** Guernsey. */
  Gg = 'GG',
  /** Ghana. */
  Gh = 'GH',
  /** Gibraltar. */
  Gi = 'GI',
  /** Greenland. */
  Gl = 'GL',
  /** Gambia. */
  Gm = 'GM',
  /** Guinea. */
  Gn = 'GN',
  /** Guadeloupe. */
  Gp = 'GP',
  /** Equatorial Guinea. */
  Gq = 'GQ',
  /** Greece. */
  Gr = 'GR',
  /** South Georgia & South Sandwich Islands. */
  Gs = 'GS',
  /** Guatemala. */
  Gt = 'GT',
  /** Guinea-Bissau. */
  Gw = 'GW',
  /** Guyana. */
  Gy = 'GY',
  /** Hong Kong SAR. */
  Hk = 'HK',
  /** Heard & McDonald Islands. */
  Hm = 'HM',
  /** Honduras. */
  Hn = 'HN',
  /** Croatia. */
  Hr = 'HR',
  /** Haiti. */
  Ht = 'HT',
  /** Hungary. */
  Hu = 'HU',
  /** Indonesia. */
  Id = 'ID',
  /** Ireland. */
  Ie = 'IE',
  /** Israel. */
  Il = 'IL',
  /** Isle of Man. */
  Im = 'IM',
  /** India. */
  In = 'IN',
  /** British Indian Ocean Territory. */
  Io = 'IO',
  /** Iraq. */
  Iq = 'IQ',
  /** Iran. */
  Ir = 'IR',
  /** Iceland. */
  Is = 'IS',
  /** Italy. */
  It = 'IT',
  /** Jersey. */
  Je = 'JE',
  /** Jamaica. */
  Jm = 'JM',
  /** Jordan. */
  Jo = 'JO',
  /** Japan. */
  Jp = 'JP',
  /** Kenya. */
  Ke = 'KE',
  /** Kyrgyzstan. */
  Kg = 'KG',
  /** Cambodia. */
  Kh = 'KH',
  /** Kiribati. */
  Ki = 'KI',
  /** Comoros. */
  Km = 'KM',
  /** St. Kitts & Nevis. */
  Kn = 'KN',
  /** North Korea. */
  Kp = 'KP',
  /** South Korea. */
  Kr = 'KR',
  /** Kuwait. */
  Kw = 'KW',
  /** Cayman Islands. */
  Ky = 'KY',
  /** Kazakhstan. */
  Kz = 'KZ',
  /** Laos. */
  La = 'LA',
  /** Lebanon. */
  Lb = 'LB',
  /** St. Lucia. */
  Lc = 'LC',
  /** Liechtenstein. */
  Li = 'LI',
  /** Sri Lanka. */
  Lk = 'LK',
  /** Liberia. */
  Lr = 'LR',
  /** Lesotho. */
  Ls = 'LS',
  /** Lithuania. */
  Lt = 'LT',
  /** Luxembourg. */
  Lu = 'LU',
  /** Latvia. */
  Lv = 'LV',
  /** Libya. */
  Ly = 'LY',
  /** Morocco. */
  Ma = 'MA',
  /** Monaco. */
  Mc = 'MC',
  /** Moldova. */
  Md = 'MD',
  /** Montenegro. */
  Me = 'ME',
  /** St. Martin. */
  Mf = 'MF',
  /** Madagascar. */
  Mg = 'MG',
  /** North Macedonia. */
  Mk = 'MK',
  /** Mali. */
  Ml = 'ML',
  /** Myanmar (Burma). */
  Mm = 'MM',
  /** Mongolia. */
  Mn = 'MN',
  /** Macao SAR. */
  Mo = 'MO',
  /** Martinique. */
  Mq = 'MQ',
  /** Mauritania. */
  Mr = 'MR',
  /** Montserrat. */
  Ms = 'MS',
  /** Malta. */
  Mt = 'MT',
  /** Mauritius. */
  Mu = 'MU',
  /** Maldives. */
  Mv = 'MV',
  /** Malawi. */
  Mw = 'MW',
  /** Mexico. */
  Mx = 'MX',
  /** Malaysia. */
  My = 'MY',
  /** Mozambique. */
  Mz = 'MZ',
  /** Namibia. */
  Na = 'NA',
  /** New Caledonia. */
  Nc = 'NC',
  /** Niger. */
  Ne = 'NE',
  /** Norfolk Island. */
  Nf = 'NF',
  /** Nigeria. */
  Ng = 'NG',
  /** Nicaragua. */
  Ni = 'NI',
  /** Netherlands. */
  Nl = 'NL',
  /** Norway. */
  No = 'NO',
  /** Nepal. */
  Np = 'NP',
  /** Nauru. */
  Nr = 'NR',
  /** Niue. */
  Nu = 'NU',
  /** New Zealand. */
  Nz = 'NZ',
  /** Oman. */
  Om = 'OM',
  /** Panama. */
  Pa = 'PA',
  /** Peru. */
  Pe = 'PE',
  /** French Polynesia. */
  Pf = 'PF',
  /** Papua New Guinea. */
  Pg = 'PG',
  /** Philippines. */
  Ph = 'PH',
  /** Pakistan. */
  Pk = 'PK',
  /** Poland. */
  Pl = 'PL',
  /** St. Pierre & Miquelon. */
  Pm = 'PM',
  /** Pitcairn Islands. */
  Pn = 'PN',
  /** Palestinian Territories. */
  Ps = 'PS',
  /** Portugal. */
  Pt = 'PT',
  /** Paraguay. */
  Py = 'PY',
  /** Qatar. */
  Qa = 'QA',
  /** Réunion. */
  Re = 'RE',
  /** Romania. */
  Ro = 'RO',
  /** Serbia. */
  Rs = 'RS',
  /** Russia. */
  Ru = 'RU',
  /** Rwanda. */
  Rw = 'RW',
  /** Saudi Arabia. */
  Sa = 'SA',
  /** Solomon Islands. */
  Sb = 'SB',
  /** Seychelles. */
  Sc = 'SC',
  /** Sudan. */
  Sd = 'SD',
  /** Sweden. */
  Se = 'SE',
  /** Singapore. */
  Sg = 'SG',
  /** St. Helena. */
  Sh = 'SH',
  /** Slovenia. */
  Si = 'SI',
  /** Svalbard & Jan Mayen. */
  Sj = 'SJ',
  /** Slovakia. */
  Sk = 'SK',
  /** Sierra Leone. */
  Sl = 'SL',
  /** San Marino. */
  Sm = 'SM',
  /** Senegal. */
  Sn = 'SN',
  /** Somalia. */
  So = 'SO',
  /** Suriname. */
  Sr = 'SR',
  /** South Sudan. */
  Ss = 'SS',
  /** São Tomé & Príncipe. */
  St = 'ST',
  /** El Salvador. */
  Sv = 'SV',
  /** Sint Maarten. */
  Sx = 'SX',
  /** Syria. */
  Sy = 'SY',
  /** Eswatini. */
  Sz = 'SZ',
  /** Tristan da Cunha. */
  Ta = 'TA',
  /** Turks & Caicos Islands. */
  Tc = 'TC',
  /** Chad. */
  Td = 'TD',
  /** French Southern Territories. */
  Tf = 'TF',
  /** Togo. */
  Tg = 'TG',
  /** Thailand. */
  Th = 'TH',
  /** Tajikistan. */
  Tj = 'TJ',
  /** Tokelau. */
  Tk = 'TK',
  /** Timor-Leste. */
  Tl = 'TL',
  /** Turkmenistan. */
  Tm = 'TM',
  /** Tunisia. */
  Tn = 'TN',
  /** Tonga. */
  To = 'TO',
  /** Turkey. */
  Tr = 'TR',
  /** Trinidad & Tobago. */
  Tt = 'TT',
  /** Tuvalu. */
  Tv = 'TV',
  /** Taiwan. */
  Tw = 'TW',
  /** Tanzania. */
  Tz = 'TZ',
  /** Ukraine. */
  Ua = 'UA',
  /** Uganda. */
  Ug = 'UG',
  /** U.S. Outlying Islands. */
  Um = 'UM',
  /** United States. */
  Us = 'US',
  /** Uruguay. */
  Uy = 'UY',
  /** Uzbekistan. */
  Uz = 'UZ',
  /** Vatican City. */
  Va = 'VA',
  /** St. Vincent & Grenadines. */
  Vc = 'VC',
  /** Venezuela. */
  Ve = 'VE',
  /** British Virgin Islands. */
  Vg = 'VG',
  /** Vietnam. */
  Vn = 'VN',
  /** Vanuatu. */
  Vu = 'VU',
  /** Wallis & Futuna. */
  Wf = 'WF',
  /** Samoa. */
  Ws = 'WS',
  /** Kosovo. */
  Xk = 'XK',
  /** Yemen. */
  Ye = 'YE',
  /** Mayotte. */
  Yt = 'YT',
  /** South Africa. */
  Za = 'ZA',
  /** Zambia. */
  Zm = 'ZM',
  /** Zimbabwe. */
  Zw = 'ZW',
  /** Unknown Region. */
  Zz = 'ZZ'
}

/** Credit card information used for a payment. */
export type StorefrontCreditCard = {
  __typename?: 'StorefrontCreditCard';
  /** The brand of the credit card. */
  brand?: Maybe<Scalars['String']['output']>;
  /** The expiry month of the credit card. */
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  /** The expiry year of the credit card. */
  expiryYear?: Maybe<Scalars['Int']['output']>;
  /** The credit card's BIN number. */
  firstDigits?: Maybe<Scalars['String']['output']>;
  /** The first name of the card holder. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The last 4 digits of the credit card. */
  lastDigits?: Maybe<Scalars['String']['output']>;
  /** The last name of the card holder. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The masked credit card number with only the last 4 digits displayed. */
  maskedNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Specifies the fields required to complete a checkout with
 * a Shopify vaulted credit card payment.
 *
 */
export type StorefrontCreditCardPaymentInputV2 = {
  /** The billing address for the payment. */
  billingAddress: StorefrontMailingAddressInput;
  /** A unique client generated key used to avoid duplicate charges. When a duplicate payment is found, the original is returned instead of creating a new one. For more information, refer to [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests). */
  idempotencyKey: Scalars['String']['input'];
  /** The amount and currency of the payment. */
  paymentAmount: StorefrontMoneyInput;
  /** Executes the payment in test mode if possible. Defaults to `false`. */
  test?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID returned by Shopify's Card Vault. */
  vaultId: Scalars['String']['input'];
};

/** The part of the image that should remain after cropping. */
export enum StorefrontCropRegion {
  /** Keep the bottom of the image. */
  Bottom = 'BOTTOM',
  /** Keep the center of the image. */
  Center = 'CENTER',
  /** Keep the left of the image. */
  Left = 'LEFT',
  /** Keep the right of the image. */
  Right = 'RIGHT',
  /** Keep the top of the image. */
  Top = 'TOP'
}

/** A currency. */
export type StorefrontCurrency = {
  __typename?: 'StorefrontCurrency';
  /** The ISO code of the currency. */
  isoCode: StorefrontCurrencyCode;
  /** The name of the currency. */
  name: Scalars['String']['output'];
  /** The symbol of the currency. */
  symbol: Scalars['String']['output'];
};

/**
 * The three-letter currency codes that represent the world currencies used in stores. These include standard ISO 4217 codes, legacy codes,
 * and non-standard codes.
 *
 */
export enum StorefrontCurrencyCode {
  /** United Arab Emirates Dirham (AED). */
  Aed = 'AED',
  /** Afghan Afghani (AFN). */
  Afn = 'AFN',
  /** Albanian Lek (ALL). */
  All = 'ALL',
  /** Armenian Dram (AMD). */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder. */
  Ang = 'ANG',
  /** Angolan Kwanza (AOA). */
  Aoa = 'AOA',
  /** Argentine Pesos (ARS). */
  Ars = 'ARS',
  /** Australian Dollars (AUD). */
  Aud = 'AUD',
  /** Aruban Florin (AWG). */
  Awg = 'AWG',
  /** Azerbaijani Manat (AZN). */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark (BAM). */
  Bam = 'BAM',
  /** Barbadian Dollar (BBD). */
  Bbd = 'BBD',
  /** Bangladesh Taka (BDT). */
  Bdt = 'BDT',
  /** Bulgarian Lev (BGN). */
  Bgn = 'BGN',
  /** Bahraini Dinar (BHD). */
  Bhd = 'BHD',
  /** Burundian Franc (BIF). */
  Bif = 'BIF',
  /** Bermudian Dollar (BMD). */
  Bmd = 'BMD',
  /** Brunei Dollar (BND). */
  Bnd = 'BND',
  /** Bolivian Boliviano (BOB). */
  Bob = 'BOB',
  /** Brazilian Real (BRL). */
  Brl = 'BRL',
  /** Bahamian Dollar (BSD). */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum (BTN). */
  Btn = 'BTN',
  /** Botswana Pula (BWP). */
  Bwp = 'BWP',
  /** Belarusian Ruble (BYN). */
  Byn = 'BYN',
  /**
   * Belarusian Ruble (BYR).
   * @deprecated `BYR` is deprecated. Use `BYN` available from version `2021-01` onwards instead.
   */
  Byr = 'BYR',
  /** Belize Dollar (BZD). */
  Bzd = 'BZD',
  /** Canadian Dollars (CAD). */
  Cad = 'CAD',
  /** Congolese franc (CDF). */
  Cdf = 'CDF',
  /** Swiss Francs (CHF). */
  Chf = 'CHF',
  /** Chilean Peso (CLP). */
  Clp = 'CLP',
  /** Chinese Yuan Renminbi (CNY). */
  Cny = 'CNY',
  /** Colombian Peso (COP). */
  Cop = 'COP',
  /** Costa Rican Colones (CRC). */
  Crc = 'CRC',
  /** Cape Verdean escudo (CVE). */
  Cve = 'CVE',
  /** Czech Koruny (CZK). */
  Czk = 'CZK',
  /** Djiboutian Franc (DJF). */
  Djf = 'DJF',
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Dominican Peso (DOP). */
  Dop = 'DOP',
  /** Algerian Dinar (DZD). */
  Dzd = 'DZD',
  /** Egyptian Pound (EGP). */
  Egp = 'EGP',
  /** Eritrean Nakfa (ERN). */
  Ern = 'ERN',
  /** Ethiopian Birr (ETB). */
  Etb = 'ETB',
  /** Euro (EUR). */
  Eur = 'EUR',
  /** Fijian Dollars (FJD). */
  Fjd = 'FJD',
  /** Falkland Islands Pounds (FKP). */
  Fkp = 'FKP',
  /** United Kingdom Pounds (GBP). */
  Gbp = 'GBP',
  /** Georgian Lari (GEL). */
  Gel = 'GEL',
  /** Ghanaian Cedi (GHS). */
  Ghs = 'GHS',
  /** Gibraltar Pounds (GIP). */
  Gip = 'GIP',
  /** Gambian Dalasi (GMD). */
  Gmd = 'GMD',
  /** Guinean Franc (GNF). */
  Gnf = 'GNF',
  /** Guatemalan Quetzal (GTQ). */
  Gtq = 'GTQ',
  /** Guyanese Dollar (GYD). */
  Gyd = 'GYD',
  /** Hong Kong Dollars (HKD). */
  Hkd = 'HKD',
  /** Honduran Lempira (HNL). */
  Hnl = 'HNL',
  /** Croatian Kuna (HRK). */
  Hrk = 'HRK',
  /** Haitian Gourde (HTG). */
  Htg = 'HTG',
  /** Hungarian Forint (HUF). */
  Huf = 'HUF',
  /** Indonesian Rupiah (IDR). */
  Idr = 'IDR',
  /** Israeli New Shekel (NIS). */
  Ils = 'ILS',
  /** Indian Rupees (INR). */
  Inr = 'INR',
  /** Iraqi Dinar (IQD). */
  Iqd = 'IQD',
  /** Iranian Rial (IRR). */
  Irr = 'IRR',
  /** Icelandic Kronur (ISK). */
  Isk = 'ISK',
  /** Jersey Pound. */
  Jep = 'JEP',
  /** Jamaican Dollars (JMD). */
  Jmd = 'JMD',
  /** Jordanian Dinar (JOD). */
  Jod = 'JOD',
  /** Japanese Yen (JPY). */
  Jpy = 'JPY',
  /** Kenyan Shilling (KES). */
  Kes = 'KES',
  /** Kyrgyzstani Som (KGS). */
  Kgs = 'KGS',
  /** Cambodian Riel. */
  Khr = 'KHR',
  /** Kiribati Dollar (KID). */
  Kid = 'KID',
  /** Comorian Franc (KMF). */
  Kmf = 'KMF',
  /** South Korean Won (KRW). */
  Krw = 'KRW',
  /** Kuwaiti Dinar (KWD). */
  Kwd = 'KWD',
  /** Cayman Dollars (KYD). */
  Kyd = 'KYD',
  /** Kazakhstani Tenge (KZT). */
  Kzt = 'KZT',
  /** Laotian Kip (LAK). */
  Lak = 'LAK',
  /** Lebanese Pounds (LBP). */
  Lbp = 'LBP',
  /** Sri Lankan Rupees (LKR). */
  Lkr = 'LKR',
  /** Liberian Dollar (LRD). */
  Lrd = 'LRD',
  /** Lesotho Loti (LSL). */
  Lsl = 'LSL',
  /** Lithuanian Litai (LTL). */
  Ltl = 'LTL',
  /** Latvian Lati (LVL). */
  Lvl = 'LVL',
  /** Libyan Dinar (LYD). */
  Lyd = 'LYD',
  /** Moroccan Dirham. */
  Mad = 'MAD',
  /** Moldovan Leu (MDL). */
  Mdl = 'MDL',
  /** Malagasy Ariary (MGA). */
  Mga = 'MGA',
  /** Macedonia Denar (MKD). */
  Mkd = 'MKD',
  /** Burmese Kyat (MMK). */
  Mmk = 'MMK',
  /** Mongolian Tugrik. */
  Mnt = 'MNT',
  /** Macanese Pataca (MOP). */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (MRU). */
  Mru = 'MRU',
  /** Mauritian Rupee (MUR). */
  Mur = 'MUR',
  /** Maldivian Rufiyaa (MVR). */
  Mvr = 'MVR',
  /** Malawian Kwacha (MWK). */
  Mwk = 'MWK',
  /** Mexican Pesos (MXN). */
  Mxn = 'MXN',
  /** Malaysian Ringgits (MYR). */
  Myr = 'MYR',
  /** Mozambican Metical. */
  Mzn = 'MZN',
  /** Namibian Dollar. */
  Nad = 'NAD',
  /** Nigerian Naira (NGN). */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (NIO). */
  Nio = 'NIO',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Nepalese Rupee (NPR). */
  Npr = 'NPR',
  /** New Zealand Dollars (NZD). */
  Nzd = 'NZD',
  /** Omani Rial (OMR). */
  Omr = 'OMR',
  /** Panamian Balboa (PAB). */
  Pab = 'PAB',
  /** Peruvian Nuevo Sol (PEN). */
  Pen = 'PEN',
  /** Papua New Guinean Kina (PGK). */
  Pgk = 'PGK',
  /** Philippine Peso (PHP). */
  Php = 'PHP',
  /** Pakistani Rupee (PKR). */
  Pkr = 'PKR',
  /** Polish Zlotych (PLN). */
  Pln = 'PLN',
  /** Paraguayan Guarani (PYG). */
  Pyg = 'PYG',
  /** Qatari Rial (QAR). */
  Qar = 'QAR',
  /** Romanian Lei (RON). */
  Ron = 'RON',
  /** Serbian dinar (RSD). */
  Rsd = 'RSD',
  /** Russian Rubles (RUB). */
  Rub = 'RUB',
  /** Rwandan Franc (RWF). */
  Rwf = 'RWF',
  /** Saudi Riyal (SAR). */
  Sar = 'SAR',
  /** Solomon Islands Dollar (SBD). */
  Sbd = 'SBD',
  /** Seychellois Rupee (SCR). */
  Scr = 'SCR',
  /** Sudanese Pound (SDG). */
  Sdg = 'SDG',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK',
  /** Singapore Dollars (SGD). */
  Sgd = 'SGD',
  /** Saint Helena Pounds (SHP). */
  Shp = 'SHP',
  /** Sierra Leonean Leone (SLL). */
  Sll = 'SLL',
  /** Somali Shilling (SOS). */
  Sos = 'SOS',
  /** Surinamese Dollar (SRD). */
  Srd = 'SRD',
  /** South Sudanese Pound (SSP). */
  Ssp = 'SSP',
  /**
   * Sao Tome And Principe Dobra (STD).
   * @deprecated `STD` is deprecated. Use `STN` available from version `2022-07` onwards instead.
   */
  Std = 'STD',
  /** Sao Tome And Principe Dobra (STN). */
  Stn = 'STN',
  /** Syrian Pound (SYP). */
  Syp = 'SYP',
  /** Swazi Lilangeni (SZL). */
  Szl = 'SZL',
  /** Thai baht (THB). */
  Thb = 'THB',
  /** Tajikistani Somoni (TJS). */
  Tjs = 'TJS',
  /** Turkmenistani Manat (TMT). */
  Tmt = 'TMT',
  /** Tunisian Dinar (TND). */
  Tnd = 'TND',
  /** Tongan Pa'anga (TOP). */
  Top = 'TOP',
  /** Turkish Lira (TRY). */
  Try = 'TRY',
  /** Trinidad and Tobago Dollars (TTD). */
  Ttd = 'TTD',
  /** Taiwan Dollars (TWD). */
  Twd = 'TWD',
  /** Tanzanian Shilling (TZS). */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia (UAH). */
  Uah = 'UAH',
  /** Ugandan Shilling (UGX). */
  Ugx = 'UGX',
  /** United States Dollars (USD). */
  Usd = 'USD',
  /** Uruguayan Pesos (UYU). */
  Uyu = 'UYU',
  /** Uzbekistan som (UZS). */
  Uzs = 'UZS',
  /** Venezuelan Bolivares (VED). */
  Ved = 'VED',
  /**
   * Venezuelan Bolivares (VEF).
   * @deprecated `VEF` is deprecated. Use `VES` available from version `2020-10` onwards instead.
   */
  Vef = 'VEF',
  /** Venezuelan Bolivares (VES). */
  Ves = 'VES',
  /** Vietnamese đồng (VND). */
  Vnd = 'VND',
  /** Vanuatu Vatu (VUV). */
  Vuv = 'VUV',
  /** Samoan Tala (WST). */
  Wst = 'WST',
  /** Central African CFA Franc (XAF). */
  Xaf = 'XAF',
  /** East Caribbean Dollar (XCD). */
  Xcd = 'XCD',
  /** West African CFA franc (XOF). */
  Xof = 'XOF',
  /** CFP Franc (XPF). */
  Xpf = 'XPF',
  /** Unrecognized currency. */
  Xxx = 'XXX',
  /** Yemeni Rial (YER). */
  Yer = 'YER',
  /** South African Rand (ZAR). */
  Zar = 'ZAR',
  /** Zambian Kwacha (ZMW). */
  Zmw = 'ZMW'
}

/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type StorefrontCustomer = StorefrontHasMetafields & {
  __typename?: 'StorefrontCustomer';
  /** Indicates whether the customer has consented to be sent marketing material via email. */
  acceptsMarketing: Scalars['Boolean']['output'];
  /** A list of addresses for the customer. */
  addresses: StorefrontMailingAddressConnection;
  /** The date and time when the customer was created. */
  createdAt: Scalars['StorefrontDateTime']['output'];
  /** The customer’s default address. */
  defaultAddress?: Maybe<StorefrontMailingAddress>;
  /** The customer’s name, email or phone number. */
  displayName: Scalars['String']['output'];
  /** The customer’s email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer’s first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A unique ID for the customer. */
  id: Scalars['ID']['output'];
  /** The customer's most recently updated, incomplete checkout. */
  lastIncompleteCheckout?: Maybe<StorefrontCheckout>;
  /** The customer’s last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The number of orders that the customer has made at the store in their lifetime. */
  numberOfOrders: Scalars['StorefrontUnsignedInt64']['output'];
  /** The orders associated with the customer. */
  orders: StorefrontOrderConnection;
  /** The customer’s phone number. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * A comma separated list of tags that have been added to the customer.
   * Additional access scope required: unauthenticated_read_customer_tags.
   *
   */
  tags: Array<Scalars['String']['output']>;
  /** The date and time when the customer information was updated. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
};


/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type StorefrontCustomerAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type StorefrontCustomerMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type StorefrontCustomerMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};


/** A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout. */
export type StorefrontCustomerOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontOrderSortKeys>;
};

/** A CustomerAccessToken represents the unique token required to make modifications to the customer object. */
export type StorefrontCustomerAccessToken = {
  __typename?: 'StorefrontCustomerAccessToken';
  /** The customer’s access token. */
  accessToken: Scalars['String']['output'];
  /** The date and time when the customer access token expires. */
  expiresAt: Scalars['StorefrontDateTime']['output'];
};

/** The input fields required to create a customer access token. */
export type StorefrontCustomerAccessTokenCreateInput = {
  /** The email associated to the customer. */
  email: Scalars['String']['input'];
  /** The login password to be used by the customer. */
  password: Scalars['String']['input'];
};

/** Return type for `customerAccessTokenCreate` mutation. */
export type StorefrontCustomerAccessTokenCreatePayload = {
  __typename?: 'StorefrontCustomerAccessTokenCreatePayload';
  /** The newly created customer access token object. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerAccessTokenCreateWithMultipass` mutation. */
export type StorefrontCustomerAccessTokenCreateWithMultipassPayload = {
  __typename?: 'StorefrontCustomerAccessTokenCreateWithMultipassPayload';
  /** An access token object associated with the customer. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
};

/** Return type for `customerAccessTokenDelete` mutation. */
export type StorefrontCustomerAccessTokenDeletePayload = {
  __typename?: 'StorefrontCustomerAccessTokenDeletePayload';
  /** The destroyed access token. */
  deletedAccessToken?: Maybe<Scalars['String']['output']>;
  /** ID of the destroyed customer access token. */
  deletedCustomerAccessTokenId?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerAccessTokenRenew` mutation. */
export type StorefrontCustomerAccessTokenRenewPayload = {
  __typename?: 'StorefrontCustomerAccessTokenRenewPayload';
  /** The renewed customer access token object. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerActivateByUrl` mutation. */
export type StorefrontCustomerActivateByUrlPayload = {
  __typename?: 'StorefrontCustomerActivateByUrlPayload';
  /** The customer that was activated. */
  customer?: Maybe<StorefrontCustomer>;
  /** A new customer access token for the customer. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
};

/** The input fields to activate a customer. */
export type StorefrontCustomerActivateInput = {
  /** The activation token required to activate the customer. */
  activationToken: Scalars['String']['input'];
  /** New password that will be set during activation. */
  password: Scalars['String']['input'];
};

/** Return type for `customerActivate` mutation. */
export type StorefrontCustomerActivatePayload = {
  __typename?: 'StorefrontCustomerActivatePayload';
  /** The customer object. */
  customer?: Maybe<StorefrontCustomer>;
  /** A newly created customer access token object for the customer. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerAddressCreate` mutation. */
export type StorefrontCustomerAddressCreatePayload = {
  __typename?: 'StorefrontCustomerAddressCreatePayload';
  /** The new customer address object. */
  customerAddress?: Maybe<StorefrontMailingAddress>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerAddressDelete` mutation. */
export type StorefrontCustomerAddressDeletePayload = {
  __typename?: 'StorefrontCustomerAddressDeletePayload';
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /** ID of the deleted customer address. */
  deletedCustomerAddressId?: Maybe<Scalars['String']['output']>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerAddressUpdate` mutation. */
export type StorefrontCustomerAddressUpdatePayload = {
  __typename?: 'StorefrontCustomerAddressUpdatePayload';
  /** The customer’s updated mailing address. */
  customerAddress?: Maybe<StorefrontMailingAddress>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** The input fields to create a new customer. */
export type StorefrontCustomerCreateInput = {
  /** Indicates whether the customer has consented to be sent marketing material via email. */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer’s email. */
  email: Scalars['String']['input'];
  /** The customer’s first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer’s last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The login password used by the customer. */
  password: Scalars['String']['input'];
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `customerCreate` mutation. */
export type StorefrontCustomerCreatePayload = {
  __typename?: 'StorefrontCustomerCreatePayload';
  /** The created customer object. */
  customer?: Maybe<StorefrontCustomer>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerDefaultAddressUpdate` mutation. */
export type StorefrontCustomerDefaultAddressUpdatePayload = {
  __typename?: 'StorefrontCustomerDefaultAddressUpdatePayload';
  /** The updated customer object. */
  customer?: Maybe<StorefrontCustomer>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Possible error codes that can be returned by `CustomerUserError`. */
export enum StorefrontCustomerErrorCode {
  /** Customer already enabled. */
  AlreadyEnabled = 'ALREADY_ENABLED',
  /** Input email contains an invalid domain name. */
  BadDomain = 'BAD_DOMAIN',
  /** The input value is blank. */
  Blank = 'BLANK',
  /** Input contains HTML tags. */
  ContainsHtmlTags = 'CONTAINS_HTML_TAGS',
  /** Input contains URL. */
  ContainsUrl = 'CONTAINS_URL',
  /** Customer is disabled. */
  CustomerDisabled = 'CUSTOMER_DISABLED',
  /** The input value is invalid. */
  Invalid = 'INVALID',
  /** Multipass token is not valid. */
  InvalidMultipassRequest = 'INVALID_MULTIPASS_REQUEST',
  /** Address does not exist. */
  NotFound = 'NOT_FOUND',
  /** Input password starts or ends with whitespace. */
  PasswordStartsOrEndsWithWhitespace = 'PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE',
  /** The input value is already taken. */
  Taken = 'TAKEN',
  /** Invalid activation token. */
  TokenInvalid = 'TOKEN_INVALID',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Unidentified customer. */
  UnidentifiedCustomer = 'UNIDENTIFIED_CUSTOMER'
}

/** Return type for `customerRecover` mutation. */
export type StorefrontCustomerRecoverPayload = {
  __typename?: 'StorefrontCustomerRecoverPayload';
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Return type for `customerResetByUrl` mutation. */
export type StorefrontCustomerResetByUrlPayload = {
  __typename?: 'StorefrontCustomerResetByUrlPayload';
  /** The customer object which was reset. */
  customer?: Maybe<StorefrontCustomer>;
  /** A newly created customer access token object for the customer. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** The input fields to reset a customer's password. */
export type StorefrontCustomerResetInput = {
  /** New password that will be set as part of the reset password process. */
  password: Scalars['String']['input'];
  /** The reset token required to reset the customer’s password. */
  resetToken: Scalars['String']['input'];
};

/** Return type for `customerReset` mutation. */
export type StorefrontCustomerResetPayload = {
  __typename?: 'StorefrontCustomerResetPayload';
  /** The customer object which was reset. */
  customer?: Maybe<StorefrontCustomer>;
  /** A newly created customer access token object for the customer. */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** The input fields to update the Customer information. */
export type StorefrontCustomerUpdateInput = {
  /** Indicates whether the customer has consented to be sent marketing material via email. */
  acceptsMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer’s email. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer’s first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The customer’s last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The login password used by the customer. */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_. To remove the phone number, specify `null`.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Return type for `customerUpdate` mutation. */
export type StorefrontCustomerUpdatePayload = {
  __typename?: 'StorefrontCustomerUpdatePayload';
  /** The updated customer object. */
  customer?: Maybe<StorefrontCustomer>;
  /**
   * The newly created customer access token. If the customer's password is updated, all previous access tokens
   * (including the one used to perform this mutation) become invalid, and a new token is generated.
   *
   */
  customerAccessToken?: Maybe<StorefrontCustomerAccessToken>;
  /** The list of errors that occurred from executing the mutation. */
  customerUserErrors: Array<StorefrontCustomerUserError>;
  /**
   * The list of errors that occurred from executing the mutation.
   * @deprecated Use `customerUserErrors` instead.
   */
  userErrors: Array<StorefrontUserError>;
};

/** Represents an error that happens during execution of a customer mutation. */
export type StorefrontCustomerUserError = StorefrontDisplayableError & {
  __typename?: 'StorefrontCustomerUserError';
  /** The error code. */
  code?: Maybe<StorefrontCustomerErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** A delivery address of the buyer that is interacting with the cart. */
export type StorefrontDeliveryAddress = StorefrontMailingAddress;

/**
 * The input fields for delivery address preferences.
 *
 */
export type StorefrontDeliveryAddressInput = {
  /**
   * The ID of a customer address that is associated with the buyer that is interacting with the cart.
   *
   */
  customerAddressId?: InputMaybe<Scalars['ID']['input']>;
  /** A delivery address preference of a buyer that is interacting with the cart. */
  deliveryAddress?: InputMaybe<StorefrontMailingAddressInput>;
};

/** List of different delivery method types. */
export enum StorefrontDeliveryMethodType {
  /** Local Delivery. */
  Local = 'LOCAL',
  /** None. */
  None = 'NONE',
  /** Shipping to a Pickup Point. */
  PickupPoint = 'PICKUP_POINT',
  /** Local Pickup. */
  PickUp = 'PICK_UP',
  /** Retail. */
  Retail = 'RETAIL',
  /** Shipping. */
  Shipping = 'SHIPPING'
}

/** Digital wallet, such as Apple Pay, which can be used for accelerated checkouts. */
export enum StorefrontDigitalWallet {
  /** Android Pay. */
  AndroidPay = 'ANDROID_PAY',
  /** Apple Pay. */
  ApplePay = 'APPLE_PAY',
  /** Google Pay. */
  GooglePay = 'GOOGLE_PAY',
  /** Shopify Pay. */
  ShopifyPay = 'SHOPIFY_PAY'
}

/**
 * An amount discounting the line that has been allocated by a discount.
 *
 */
export type StorefrontDiscountAllocation = {
  __typename?: 'StorefrontDiscountAllocation';
  /** Amount of discount allocated. */
  allocatedAmount: StorefrontMoneyV2;
  /** The discount this allocated amount originated from. */
  discountApplication: StorefrontDiscountApplication;
};

/**
 * Discount applications capture the intentions of a discount source at
 * the time of application.
 *
 */
export type StorefrontDiscountApplication = {
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: StorefrontDiscountApplicationAllocationMethod;
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: StorefrontDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: StorefrontDiscountApplicationTargetType;
  /** The value of the discount application. */
  value: StorefrontPricingValue;
};

/** The method by which the discount's value is allocated onto its entitled lines. */
export enum StorefrontDiscountApplicationAllocationMethod {
  /** The value is spread across all entitled lines. */
  Across = 'ACROSS',
  /** The value is applied onto every entitled line. */
  Each = 'EACH',
  /**
   * The value is specifically applied onto a particular line.
   * @deprecated Use ACROSS instead.
   */
  One = 'ONE'
}

/**
 * An auto-generated type for paginating through multiple DiscountApplications.
 *
 */
export type StorefrontDiscountApplicationConnection = {
  __typename?: 'StorefrontDiscountApplicationConnection';
  /** A list of edges. */
  edges: Array<StorefrontDiscountApplicationEdge>;
  /** A list of the nodes contained in DiscountApplicationEdge. */
  nodes: Array<StorefrontDiscountApplication>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one DiscountApplication and a cursor during pagination.
 *
 */
export type StorefrontDiscountApplicationEdge = {
  __typename?: 'StorefrontDiscountApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of DiscountApplicationEdge. */
  node: StorefrontDiscountApplication;
};

/**
 * The lines on the order to which the discount is applied, of the type defined by
 * the discount application's `targetType`. For example, the value `ENTITLED`, combined with a `targetType` of
 * `LINE_ITEM`, applies the discount on all line items that are entitled to the discount.
 * The value `ALL`, combined with a `targetType` of `SHIPPING_LINE`, applies the discount on all shipping lines.
 *
 */
export enum StorefrontDiscountApplicationTargetSelection {
  /** The discount is allocated onto all the lines. */
  All = 'ALL',
  /** The discount is allocated onto only the lines that it's entitled for. */
  Entitled = 'ENTITLED',
  /** The discount is allocated onto explicitly chosen lines. */
  Explicit = 'EXPLICIT'
}

/**
 * The type of line (i.e. line item or shipping line) on an order that the discount is applicable towards.
 *
 */
export enum StorefrontDiscountApplicationTargetType {
  /** The discount applies onto line items. */
  LineItem = 'LINE_ITEM',
  /** The discount applies onto shipping lines. */
  ShippingLine = 'SHIPPING_LINE'
}

/**
 * Discount code applications capture the intentions of a discount code at
 * the time that it is applied.
 *
 */
export type StorefrontDiscountCodeApplication = StorefrontDiscountApplication & {
  __typename?: 'StorefrontDiscountCodeApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: StorefrontDiscountApplicationAllocationMethod;
  /** Specifies whether the discount code was applied successfully. */
  applicable: Scalars['Boolean']['output'];
  /** The string identifying the discount code that was used at the time of application. */
  code: Scalars['String']['output'];
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: StorefrontDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: StorefrontDiscountApplicationTargetType;
  /** The value of the discount application. */
  value: StorefrontPricingValue;
};

/** Represents an error in the input of a mutation. */
export type StorefrontDisplayableError = {
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Represents a web address. */
export type StorefrontDomain = {
  __typename?: 'StorefrontDomain';
  /** The host name of the domain (eg: `example.com`). */
  host: Scalars['String']['output'];
  /** Whether SSL is enabled or not. */
  sslEnabled: Scalars['Boolean']['output'];
  /** The URL of the domain (eg: `https://example.com`). */
  url: Scalars['StorefrontURL']['output'];
};

/** Represents a video hosted outside of Shopify. */
export type StorefrontExternalVideo = StorefrontMedia & StorefrontNode & {
  __typename?: 'StorefrontExternalVideo';
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The embed URL of the video for the respective host. */
  embedUrl: Scalars['StorefrontURL']['output'];
  /**
   * The URL.
   * @deprecated Use `originUrl` instead.
   */
  embeddedUrl: Scalars['StorefrontURL']['output'];
  /** The host of the external video. */
  host: StorefrontMediaHost;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: StorefrontMediaContentType;
  /** The origin URL of the video on the respective host. */
  originUrl: Scalars['StorefrontURL']['output'];
  /** The presentation for a media. */
  presentation?: Maybe<StorefrontMediaPresentation>;
  /** The preview image for the media. */
  previewImage?: Maybe<StorefrontImage>;
};

/** A filter that is supported on the parent field. */
export type StorefrontFilter = {
  __typename?: 'StorefrontFilter';
  /** A unique identifier. */
  id: Scalars['String']['output'];
  /** A human-friendly string for this filter. */
  label: Scalars['String']['output'];
  /** An enumeration that denotes the type of data this filter represents. */
  type: StorefrontFilterType;
  /** The list of values for this filter. */
  values: Array<StorefrontFilterValue>;
};

/**
 * The type of data that the filter group represents.
 *
 * For more information, refer to [Filter products in a collection with the Storefront API]
 * (https://shopify.dev/custom-storefronts/products-collections/filter-products).
 *
 */
export enum StorefrontFilterType {
  /** A boolean value. */
  Boolean = 'BOOLEAN',
  /** A list of selectable values. */
  List = 'LIST',
  /** A range of prices. */
  PriceRange = 'PRICE_RANGE'
}

/** A selectable value within a filter. */
export type StorefrontFilterValue = {
  __typename?: 'StorefrontFilterValue';
  /** The number of results that match this filter value. */
  count: Scalars['Int']['output'];
  /** A unique identifier. */
  id: Scalars['String']['output'];
  /**
   * An input object that can be used to filter by this value on the parent field.
   *
   * The value is provided as a helper for building dynamic filtering UI. For example, if you have a list of selected `FilterValue` objects, you can combine their respective `input` values to use in a subsequent query.
   *
   */
  input: Scalars['StorefrontJSON']['output'];
  /** A human-friendly string for this filter value. */
  label: Scalars['String']['output'];
};

/** Represents a single fulfillment in an order. */
export type StorefrontFulfillment = {
  __typename?: 'StorefrontFulfillment';
  /** List of the fulfillment's line items. */
  fulfillmentLineItems: StorefrontFulfillmentLineItemConnection;
  /** The name of the tracking company. */
  trackingCompany?: Maybe<Scalars['String']['output']>;
  /**
   * Tracking information associated with the fulfillment,
   * such as the tracking number and tracking URL.
   *
   */
  trackingInfo: Array<StorefrontFulfillmentTrackingInfo>;
};


/** Represents a single fulfillment in an order. */
export type StorefrontFulfillmentFulfillmentLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a single fulfillment in an order. */
export type StorefrontFulfillmentTrackingInfoArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a single line item in a fulfillment. There is at most one fulfillment line item for each order line item. */
export type StorefrontFulfillmentLineItem = {
  __typename?: 'StorefrontFulfillmentLineItem';
  /** The associated order's line item. */
  lineItem: StorefrontOrderLineItem;
  /** The amount fulfilled in this fulfillment. */
  quantity: Scalars['Int']['output'];
};

/**
 * An auto-generated type for paginating through multiple FulfillmentLineItems.
 *
 */
export type StorefrontFulfillmentLineItemConnection = {
  __typename?: 'StorefrontFulfillmentLineItemConnection';
  /** A list of edges. */
  edges: Array<StorefrontFulfillmentLineItemEdge>;
  /** A list of the nodes contained in FulfillmentLineItemEdge. */
  nodes: Array<StorefrontFulfillmentLineItem>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one FulfillmentLineItem and a cursor during pagination.
 *
 */
export type StorefrontFulfillmentLineItemEdge = {
  __typename?: 'StorefrontFulfillmentLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of FulfillmentLineItemEdge. */
  node: StorefrontFulfillmentLineItem;
};

/** Tracking information associated with the fulfillment. */
export type StorefrontFulfillmentTrackingInfo = {
  __typename?: 'StorefrontFulfillmentTrackingInfo';
  /** The tracking number of the fulfillment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The URL to track the fulfillment. */
  url?: Maybe<Scalars['StorefrontURL']['output']>;
};

/** The generic file resource lets you manage files in a merchant’s store. Generic files include any file that doesn’t fit into a designated type such as image or video. Example: PDF, JSON. */
export type StorefrontGenericFile = StorefrontNode & {
  __typename?: 'StorefrontGenericFile';
  /** A word or phrase to indicate the contents of a file. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The MIME type of the file. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The size of the original file in bytes. */
  originalFileSize?: Maybe<Scalars['Int']['output']>;
  /** The preview image for the file. */
  previewImage?: Maybe<StorefrontImage>;
  /** The URL of the file. */
  url?: Maybe<Scalars['StorefrontURL']['output']>;
};

/** The input fields used to specify a geographical location. */
export type StorefrontGeoCoordinateInput = {
  /** The coordinate's latitude value. */
  latitude: Scalars['Float']['input'];
  /** The coordinate's longitude value. */
  longitude: Scalars['Float']['input'];
};

/** Represents information about the metafields associated to the specified resource. */
export type StorefrontHasMetafields = {
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
};


/** Represents information about the metafields associated to the specified resource. */
export type StorefrontHasMetafieldsMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** Represents information about the metafields associated to the specified resource. */
export type StorefrontHasMetafieldsMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/** The input fields to identify a metafield on an owner resource by namespace and key. */
export type StorefrontHasMetafieldsIdentifier = {
  /** The identifier for the metafield. */
  key: Scalars['String']['input'];
  /** A container for a set of metafields. */
  namespace: Scalars['String']['input'];
};

/** Represents an image resource. */
export type StorefrontImage = {
  __typename?: 'StorefrontImage';
  /** A word or phrase to share the nature or contents of an image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The original height of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  height?: Maybe<Scalars['Int']['output']>;
  /** A unique ID for the image. */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * The location of the original image as a URL.
   *
   * If there are any existing transformations in the original source URL, they will remain and not be stripped.
   *
   * @deprecated Use `url` instead.
   */
  originalSrc: Scalars['StorefrontURL']['output'];
  /**
   * The location of the image as a URL.
   * @deprecated Use `url` instead.
   */
  src: Scalars['StorefrontURL']['output'];
  /**
   * The location of the transformed image as a URL.
   *
   * All transformation arguments are considered "best-effort". If they can be applied to an image, they will be.
   * Otherwise any transformations which an image type doesn't support will be ignored.
   *
   * @deprecated Use `url(transform:)` instead
   */
  transformedSrc: Scalars['StorefrontURL']['output'];
  /**
   * The location of the image as a URL.
   *
   * If no transform options are specified, then the original image will be preserved including any pre-applied transforms.
   *
   * All transformation options are considered "best-effort". Any transformation that the original image type doesn't support will be ignored.
   *
   * If you need multiple variations of the same image, then you can use [GraphQL aliases](https://graphql.org/learn/queries/#aliases).
   *
   */
  url: Scalars['StorefrontURL']['output'];
  /** The original width of the image in pixels. Returns `null` if the image isn't hosted by Shopify. */
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents an image resource. */
export type StorefrontImageTransformedSrcArgs = {
  crop?: InputMaybe<StorefrontCropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  preferredContentType?: InputMaybe<StorefrontImageContentType>;
  scale?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an image resource. */
export type StorefrontImageUrlArgs = {
  transform?: InputMaybe<StorefrontImageTransformInput>;
};

/**
 * An auto-generated type for paginating through multiple Images.
 *
 */
export type StorefrontImageConnection = {
  __typename?: 'StorefrontImageConnection';
  /** A list of edges. */
  edges: Array<StorefrontImageEdge>;
  /** A list of the nodes contained in ImageEdge. */
  nodes: Array<StorefrontImage>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/** List of supported image content types. */
export enum StorefrontImageContentType {
  /** A JPG image. */
  Jpg = 'JPG',
  /** A PNG image. */
  Png = 'PNG',
  /** A WEBP image. */
  Webp = 'WEBP'
}

/**
 * An auto-generated type which holds one Image and a cursor during pagination.
 *
 */
export type StorefrontImageEdge = {
  __typename?: 'StorefrontImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ImageEdge. */
  node: StorefrontImage;
};

/**
 * The available options for transforming an image.
 *
 * All transformation options are considered best effort. Any transformation that the original image type doesn't support will be ignored.
 *
 */
export type StorefrontImageTransformInput = {
  /**
   * The region of the image to remain after cropping.
   * Must be used in conjunction with the `maxWidth` and/or `maxHeight` fields, where the `maxWidth` and `maxHeight` aren't equal.
   * The `crop` argument should coincide with the smaller value. A smaller `maxWidth` indicates a `LEFT` or `RIGHT` crop, while
   * a smaller `maxHeight` indicates a `TOP` or `BOTTOM` crop. For example, `{ maxWidth: 5, maxHeight: 10, crop: LEFT }` will result
   * in an image with a width of 5 and height of 10, where the right side of the image is removed.
   *
   */
  crop?: InputMaybe<StorefrontCropRegion>;
  /**
   * Image height in pixels between 1 and 5760.
   *
   */
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Image width in pixels between 1 and 5760.
   *
   */
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Convert the source image into the preferred content type.
   * Supported conversions: `.svg` to `.png`, any file type to `.jpg`, and any file type to `.webp`.
   *
   */
  preferredContentType?: InputMaybe<StorefrontImageContentType>;
  /**
   * Image size multiplier for high-resolution retina displays. Must be within 1..3.
   *
   */
  scale?: InputMaybe<Scalars['Int']['input']>;
};

/** A language. */
export type StorefrontLanguage = {
  __typename?: 'StorefrontLanguage';
  /** The name of the language in the language itself. If the language uses capitalization, it is capitalized for a mid-sentence position. */
  endonymName: Scalars['String']['output'];
  /** The ISO code. */
  isoCode: StorefrontLanguageCode;
  /** The name of the language in the current language. */
  name: Scalars['String']['output'];
};

/** ISO 639-1 language codes supported by Shopify. */
export enum StorefrontLanguageCode {
  /** Afrikaans. */
  Af = 'AF',
  /** Akan. */
  Ak = 'AK',
  /** Amharic. */
  Am = 'AM',
  /** Arabic. */
  Ar = 'AR',
  /** Assamese. */
  As = 'AS',
  /** Azerbaijani. */
  Az = 'AZ',
  /** Belarusian. */
  Be = 'BE',
  /** Bulgarian. */
  Bg = 'BG',
  /** Bambara. */
  Bm = 'BM',
  /** Bangla. */
  Bn = 'BN',
  /** Tibetan. */
  Bo = 'BO',
  /** Breton. */
  Br = 'BR',
  /** Bosnian. */
  Bs = 'BS',
  /** Catalan. */
  Ca = 'CA',
  /** Chechen. */
  Ce = 'CE',
  /** Czech. */
  Cs = 'CS',
  /** Church Slavic. */
  Cu = 'CU',
  /** Welsh. */
  Cy = 'CY',
  /** Danish. */
  Da = 'DA',
  /** German. */
  De = 'DE',
  /** Dzongkha. */
  Dz = 'DZ',
  /** Ewe. */
  Ee = 'EE',
  /** Greek. */
  El = 'EL',
  /** English. */
  En = 'EN',
  /** Esperanto. */
  Eo = 'EO',
  /** Spanish. */
  Es = 'ES',
  /** Estonian. */
  Et = 'ET',
  /** Basque. */
  Eu = 'EU',
  /** Persian. */
  Fa = 'FA',
  /** Fulah. */
  Ff = 'FF',
  /** Finnish. */
  Fi = 'FI',
  /** Faroese. */
  Fo = 'FO',
  /** French. */
  Fr = 'FR',
  /** Western Frisian. */
  Fy = 'FY',
  /** Irish. */
  Ga = 'GA',
  /** Scottish Gaelic. */
  Gd = 'GD',
  /** Galician. */
  Gl = 'GL',
  /** Gujarati. */
  Gu = 'GU',
  /** Manx. */
  Gv = 'GV',
  /** Hausa. */
  Ha = 'HA',
  /** Hebrew. */
  He = 'HE',
  /** Hindi. */
  Hi = 'HI',
  /** Croatian. */
  Hr = 'HR',
  /** Hungarian. */
  Hu = 'HU',
  /** Armenian. */
  Hy = 'HY',
  /** Interlingua. */
  Ia = 'IA',
  /** Indonesian. */
  Id = 'ID',
  /** Igbo. */
  Ig = 'IG',
  /** Sichuan Yi. */
  Ii = 'II',
  /** Icelandic. */
  Is = 'IS',
  /** Italian. */
  It = 'IT',
  /** Japanese. */
  Ja = 'JA',
  /** Javanese. */
  Jv = 'JV',
  /** Georgian. */
  Ka = 'KA',
  /** Kikuyu. */
  Ki = 'KI',
  /** Kazakh. */
  Kk = 'KK',
  /** Kalaallisut. */
  Kl = 'KL',
  /** Khmer. */
  Km = 'KM',
  /** Kannada. */
  Kn = 'KN',
  /** Korean. */
  Ko = 'KO',
  /** Kashmiri. */
  Ks = 'KS',
  /** Kurdish. */
  Ku = 'KU',
  /** Cornish. */
  Kw = 'KW',
  /** Kyrgyz. */
  Ky = 'KY',
  /** Luxembourgish. */
  Lb = 'LB',
  /** Ganda. */
  Lg = 'LG',
  /** Lingala. */
  Ln = 'LN',
  /** Lao. */
  Lo = 'LO',
  /** Lithuanian. */
  Lt = 'LT',
  /** Luba-Katanga. */
  Lu = 'LU',
  /** Latvian. */
  Lv = 'LV',
  /** Malagasy. */
  Mg = 'MG',
  /** Māori. */
  Mi = 'MI',
  /** Macedonian. */
  Mk = 'MK',
  /** Malayalam. */
  Ml = 'ML',
  /** Mongolian. */
  Mn = 'MN',
  /** Marathi. */
  Mr = 'MR',
  /** Malay. */
  Ms = 'MS',
  /** Maltese. */
  Mt = 'MT',
  /** Burmese. */
  My = 'MY',
  /** Norwegian (Bokmål). */
  Nb = 'NB',
  /** North Ndebele. */
  Nd = 'ND',
  /** Nepali. */
  Ne = 'NE',
  /** Dutch. */
  Nl = 'NL',
  /** Norwegian Nynorsk. */
  Nn = 'NN',
  /** Norwegian. */
  No = 'NO',
  /** Oromo. */
  Om = 'OM',
  /** Odia. */
  Or = 'OR',
  /** Ossetic. */
  Os = 'OS',
  /** Punjabi. */
  Pa = 'PA',
  /** Polish. */
  Pl = 'PL',
  /** Pashto. */
  Ps = 'PS',
  /** Portuguese. */
  Pt = 'PT',
  /** Portuguese (Brazil). */
  PtBr = 'PT_BR',
  /** Portuguese (Portugal). */
  PtPt = 'PT_PT',
  /** Quechua. */
  Qu = 'QU',
  /** Romansh. */
  Rm = 'RM',
  /** Rundi. */
  Rn = 'RN',
  /** Romanian. */
  Ro = 'RO',
  /** Russian. */
  Ru = 'RU',
  /** Kinyarwanda. */
  Rw = 'RW',
  /** Sindhi. */
  Sd = 'SD',
  /** Northern Sami. */
  Se = 'SE',
  /** Sango. */
  Sg = 'SG',
  /** Sinhala. */
  Si = 'SI',
  /** Slovak. */
  Sk = 'SK',
  /** Slovenian. */
  Sl = 'SL',
  /** Shona. */
  Sn = 'SN',
  /** Somali. */
  So = 'SO',
  /** Albanian. */
  Sq = 'SQ',
  /** Serbian. */
  Sr = 'SR',
  /** Sundanese. */
  Su = 'SU',
  /** Swedish. */
  Sv = 'SV',
  /** Swahili. */
  Sw = 'SW',
  /** Tamil. */
  Ta = 'TA',
  /** Telugu. */
  Te = 'TE',
  /** Tajik. */
  Tg = 'TG',
  /** Thai. */
  Th = 'TH',
  /** Tigrinya. */
  Ti = 'TI',
  /** Turkmen. */
  Tk = 'TK',
  /** Tongan. */
  To = 'TO',
  /** Turkish. */
  Tr = 'TR',
  /** Tatar. */
  Tt = 'TT',
  /** Uyghur. */
  Ug = 'UG',
  /** Ukrainian. */
  Uk = 'UK',
  /** Urdu. */
  Ur = 'UR',
  /** Uzbek. */
  Uz = 'UZ',
  /** Vietnamese. */
  Vi = 'VI',
  /** Volapük. */
  Vo = 'VO',
  /** Wolof. */
  Wo = 'WO',
  /** Xhosa. */
  Xh = 'XH',
  /** Yiddish. */
  Yi = 'YI',
  /** Yoruba. */
  Yo = 'YO',
  /** Chinese. */
  Zh = 'ZH',
  /** Chinese (Simplified). */
  ZhCn = 'ZH_CN',
  /** Chinese (Traditional). */
  ZhTw = 'ZH_TW',
  /** Zulu. */
  Zu = 'ZU'
}

/** Information about the localized experiences configured for the shop. */
export type StorefrontLocalization = {
  __typename?: 'StorefrontLocalization';
  /** The list of countries with enabled localized experiences. */
  availableCountries: Array<StorefrontCountry>;
  /** The list of languages available for the active country. */
  availableLanguages: Array<StorefrontLanguage>;
  /** The country of the active localized experience. Use the `@inContext` directive to change this value. */
  country: StorefrontCountry;
  /** The language of the active localized experience. Use the `@inContext` directive to change this value. */
  language: StorefrontLanguage;
  /** The market including the country of the active localized experience. Use the `@inContext` directive to change this value. */
  market: StorefrontMarket;
};

/** Represents a location where product inventory is held. */
export type StorefrontLocation = StorefrontHasMetafields & StorefrontNode & {
  __typename?: 'StorefrontLocation';
  /** The address of the location. */
  address: StorefrontLocationAddress;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The name of the location. */
  name: Scalars['String']['output'];
};


/** Represents a location where product inventory is held. */
export type StorefrontLocationMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** Represents a location where product inventory is held. */
export type StorefrontLocationMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/**
 * Represents the address of a location.
 *
 */
export type StorefrontLocationAddress = {
  __typename?: 'StorefrontLocationAddress';
  /** The first line of the address for the location. */
  address1?: Maybe<Scalars['String']['output']>;
  /** The second line of the address for the location. */
  address2?: Maybe<Scalars['String']['output']>;
  /** The city of the location. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the location. */
  country?: Maybe<Scalars['String']['output']>;
  /** The country code of the location. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address for the location. */
  formatted: Array<Scalars['String']['output']>;
  /** The latitude coordinates of the location. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinates of the location. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The phone number of the location. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The province of the location. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The code for the province, state, or district of the address of the location.
   *
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The ZIP code of the location. */
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * An auto-generated type for paginating through multiple Locations.
 *
 */
export type StorefrontLocationConnection = {
  __typename?: 'StorefrontLocationConnection';
  /** A list of edges. */
  edges: Array<StorefrontLocationEdge>;
  /** A list of the nodes contained in LocationEdge. */
  nodes: Array<StorefrontLocation>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Location and a cursor during pagination.
 *
 */
export type StorefrontLocationEdge = {
  __typename?: 'StorefrontLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of LocationEdge. */
  node: StorefrontLocation;
};

/** The set of valid sort keys for the Location query. */
export enum StorefrontLocationSortKeys {
  /** Sort by the `city` value. */
  City = 'CITY',
  /** Sort by the `distance` value. */
  Distance = 'DISTANCE',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `name` value. */
  Name = 'NAME'
}

/** Represents a mailing address for customers and shipping. */
export type StorefrontMailingAddress = StorefrontNode & {
  __typename?: 'StorefrontMailingAddress';
  /** The first line of the address. Typically the street address or PO Box number. */
  address1?: Maybe<Scalars['String']['output']>;
  /**
   * The second line of the address. Typically the number of the apartment, suite, or unit.
   *
   */
  address2?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the city, district, village, or town.
   *
   */
  city?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the customer's company or organization.
   *
   */
  company?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the country.
   *
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   *
   * @deprecated Use `countryCodeV2` instead.
   */
  countryCode?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the country of the address.
   *
   * For example, US.
   *
   */
  countryCodeV2?: Maybe<StorefrontCountryCode>;
  /** The first name of the customer. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** A formatted version of the address, customized by the provided arguments. */
  formatted: Array<Scalars['String']['output']>;
  /** A comma-separated list of the values for city, province, and country. */
  formattedArea?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The last name of the customer. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The latitude coordinate of the customer address. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude coordinate of the customer address. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * The full name of the customer, based on firstName and lastName.
   *
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: Maybe<Scalars['String']['output']>;
  /** The region of the address, such as the province, state, or district. */
  province?: Maybe<Scalars['String']['output']>;
  /**
   * The two-letter code for the region.
   *
   * For example, ON.
   *
   */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** The zip or postal code of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};


/** Represents a mailing address for customers and shipping. */
export type StorefrontMailingAddressFormattedArgs = {
  withCompany?: InputMaybe<Scalars['Boolean']['input']>;
  withName?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple MailingAddresses.
 *
 */
export type StorefrontMailingAddressConnection = {
  __typename?: 'StorefrontMailingAddressConnection';
  /** A list of edges. */
  edges: Array<StorefrontMailingAddressEdge>;
  /** A list of the nodes contained in MailingAddressEdge. */
  nodes: Array<StorefrontMailingAddress>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one MailingAddress and a cursor during pagination.
 *
 */
export type StorefrontMailingAddressEdge = {
  __typename?: 'StorefrontMailingAddressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MailingAddressEdge. */
  node: StorefrontMailingAddress;
};

/** The input fields to create or update a mailing address. */
export type StorefrontMailingAddressInput = {
  /**
   * The first line of the address. Typically the street address or PO Box number.
   *
   */
  address1?: InputMaybe<Scalars['String']['input']>;
  /**
   * The second line of the address. Typically the number of the apartment, suite, or unit.
   *
   */
  address2?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the city, district, village, or town.
   *
   */
  city?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the customer's company or organization.
   *
   */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The name of the country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the customer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the customer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * A unique phone number for the customer.
   *
   * Formatted using E.164 standard. For example, _+16135551111_.
   *
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The region of the address, such as the province, state, or district. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** The zip or postal code of the address. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Manual discount applications capture the intentions of a discount that was manually created.
 *
 */
export type StorefrontManualDiscountApplication = StorefrontDiscountApplication & {
  __typename?: 'StorefrontManualDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: StorefrontDiscountApplicationAllocationMethod;
  /** The description of the application. */
  description?: Maybe<Scalars['String']['output']>;
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: StorefrontDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: StorefrontDiscountApplicationTargetType;
  /** The title of the application. */
  title: Scalars['String']['output'];
  /** The value of the discount application. */
  value: StorefrontPricingValue;
};

/** A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets). */
export type StorefrontMarket = StorefrontHasMetafields & StorefrontNode & {
  __typename?: 'StorefrontMarket';
  /**
   * A human-readable unique string for the market automatically generated from its title.
   *
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
};


/** A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets). */
export type StorefrontMarketMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets). */
export type StorefrontMarketMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/** Represents a media interface. */
export type StorefrontMedia = {
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: StorefrontMediaContentType;
  /** The presentation for a media. */
  presentation?: Maybe<StorefrontMediaPresentation>;
  /** The preview image for the media. */
  previewImage?: Maybe<StorefrontImage>;
};

/**
 * An auto-generated type for paginating through multiple Media.
 *
 */
export type StorefrontMediaConnection = {
  __typename?: 'StorefrontMediaConnection';
  /** A list of edges. */
  edges: Array<StorefrontMediaEdge>;
  /** A list of the nodes contained in MediaEdge. */
  nodes: Array<StorefrontMedia>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/** The possible content types for a media object. */
export enum StorefrontMediaContentType {
  /** An externally hosted video. */
  ExternalVideo = 'EXTERNAL_VIDEO',
  /** A Shopify hosted image. */
  Image = 'IMAGE',
  /** A 3d model. */
  Model_3D = 'MODEL_3D',
  /** A Shopify hosted video. */
  Video = 'VIDEO'
}

/**
 * An auto-generated type which holds one Media and a cursor during pagination.
 *
 */
export type StorefrontMediaEdge = {
  __typename?: 'StorefrontMediaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MediaEdge. */
  node: StorefrontMedia;
};

/** Host for a Media Resource. */
export enum StorefrontMediaHost {
  /** Host for Vimeo embedded videos. */
  Vimeo = 'VIMEO',
  /** Host for YouTube embedded videos. */
  Youtube = 'YOUTUBE'
}

/** Represents a Shopify hosted image. */
export type StorefrontMediaImage = StorefrontMedia & StorefrontNode & {
  __typename?: 'StorefrontMediaImage';
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The image for the media. */
  image?: Maybe<StorefrontImage>;
  /** The media content type. */
  mediaContentType: StorefrontMediaContentType;
  /** The presentation for a media. */
  presentation?: Maybe<StorefrontMediaPresentation>;
  /** The preview image for the media. */
  previewImage?: Maybe<StorefrontImage>;
};

/** A media presentation. */
export type StorefrontMediaPresentation = StorefrontNode & {
  __typename?: 'StorefrontMediaPresentation';
  /** A JSON object representing a presentation view. */
  asJson?: Maybe<Scalars['StorefrontJSON']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};


/** A media presentation. */
export type StorefrontMediaPresentationAsJsonArgs = {
  format: StorefrontMediaPresentationFormat;
};

/** The possible formats for a media presentation. */
export enum StorefrontMediaPresentationFormat {
  /** A media image presentation. */
  Image = 'IMAGE',
  /** A model viewer presentation. */
  ModelViewer = 'MODEL_VIEWER'
}

/**
 * A [navigation menu](https://help.shopify.com/manual/online-store/menus-and-links) representing a hierarchy
 * of hyperlinks (items).
 *
 */
export type StorefrontMenu = StorefrontNode & {
  __typename?: 'StorefrontMenu';
  /** The menu's handle. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The menu's child items. */
  items: Array<StorefrontMenuItem>;
  /** The count of items on the menu. */
  itemsCount: Scalars['Int']['output'];
  /** The menu's title. */
  title: Scalars['String']['output'];
};

/**
 * A menu item within a parent menu.
 *
 */
export type StorefrontMenuItem = StorefrontNode & {
  __typename?: 'StorefrontMenuItem';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The menu item's child items. */
  items: Array<StorefrontMenuItem>;
  /** The linked resource. */
  resource?: Maybe<StorefrontMenuItemResource>;
  /** The ID of the linked resource. */
  resourceId?: Maybe<Scalars['ID']['output']>;
  /** The menu item's tags to filter a collection. */
  tags: Array<Scalars['String']['output']>;
  /** The menu item's title. */
  title: Scalars['String']['output'];
  /** The menu item's type. */
  type: StorefrontMenuItemType;
  /** The menu item's URL. */
  url?: Maybe<Scalars['StorefrontURL']['output']>;
};

/**
 * The list of possible resources a `MenuItem` can reference.
 *
 */
export type StorefrontMenuItemResource = StorefrontArticle | StorefrontBlog | StorefrontCollection | StorefrontPage | StorefrontProduct | StorefrontShopPolicy;

/** A menu item type. */
export enum StorefrontMenuItemType {
  /** An article link. */
  Article = 'ARTICLE',
  /** A blog link. */
  Blog = 'BLOG',
  /** A catalog link. */
  Catalog = 'CATALOG',
  /** A collection link. */
  Collection = 'COLLECTION',
  /** A collection link. */
  Collections = 'COLLECTIONS',
  /** A frontpage link. */
  Frontpage = 'FRONTPAGE',
  /** An http link. */
  Http = 'HTTP',
  /** A page link. */
  Page = 'PAGE',
  /** A product link. */
  Product = 'PRODUCT',
  /** A search link. */
  Search = 'SEARCH',
  /** A shop policy link. */
  ShopPolicy = 'SHOP_POLICY'
}

/** The merchandise to be purchased at checkout. */
export type StorefrontMerchandise = StorefrontProductVariant;

/**
 * Metafields represent custom metadata attached to a resource. Metafields can be sorted into namespaces and are
 * comprised of keys, values, and value types.
 *
 */
export type StorefrontMetafield = StorefrontNode & {
  __typename?: 'StorefrontMetafield';
  /** The date and time when the storefront metafield was created. */
  createdAt: Scalars['StorefrontDateTime']['output'];
  /** The description of a metafield. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The unique identifier for the metafield within its namespace. */
  key: Scalars['String']['output'];
  /** The container for a group of metafields that the metafield is associated with. */
  namespace: Scalars['String']['output'];
  /** The type of resource that the metafield is attached to. */
  parentResource: StorefrontMetafieldParentResource;
  /** Returns a reference object if the metafield's type is a resource reference. */
  reference?: Maybe<StorefrontMetafieldReference>;
  /** A list of reference objects if the metafield's type is a resource reference list. */
  references?: Maybe<StorefrontMetafieldReferenceConnection>;
  /**
   * The type name of the metafield.
   * Refer to the list of [supported types](https://shopify.dev/apps/metafields/definitions/types).
   *
   */
  type: Scalars['String']['output'];
  /** The date and time when the metafield was last updated. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
  /** The data stored in the metafield. Always stored as a string, regardless of the metafield's type. */
  value: Scalars['String']['output'];
};


/**
 * Metafields represent custom metadata attached to a resource. Metafields can be sorted into namespaces and are
 * comprised of keys, values, and value types.
 *
 */
export type StorefrontMetafieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Possible error codes that can be returned by `MetafieldDeleteUserError`. */
export enum StorefrontMetafieldDeleteErrorCode {
  /** The owner ID is invalid. */
  InvalidOwner = 'INVALID_OWNER',
  /** Metafield not found. */
  MetafieldDoesNotExist = 'METAFIELD_DOES_NOT_EXIST'
}

/** An error that occurs during the execution of cart metafield deletion. */
export type StorefrontMetafieldDeleteUserError = StorefrontDisplayableError & {
  __typename?: 'StorefrontMetafieldDeleteUserError';
  /** The error code. */
  code?: Maybe<StorefrontMetafieldDeleteErrorCode>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * A filter used to view a subset of products in a collection matching a specific metafield value.
 *
 * Only the following metafield types are currently supported:
 * - `number_integer`
 * - `number_decimal`
 * - `single_line_text_field`
 * - `boolean` as of 2022-04.
 *
 */
export type StorefrontMetafieldFilter = {
  /** The key of the metafield to filter on. */
  key: Scalars['String']['input'];
  /** The namespace of the metafield to filter on. */
  namespace: Scalars['String']['input'];
  /** The value of the metafield. */
  value: Scalars['String']['input'];
};

/** A resource that the metafield belongs to. */
export type StorefrontMetafieldParentResource = StorefrontArticle | StorefrontBlog | StorefrontCart | StorefrontCollection | StorefrontCustomer | StorefrontLocation | StorefrontMarket | StorefrontOrder | StorefrontPage | StorefrontProduct | StorefrontProductVariant | StorefrontShop;

/**
 * Returns the resource which is being referred to by a metafield.
 *
 */
export type StorefrontMetafieldReference = StorefrontCollection | StorefrontGenericFile | StorefrontMediaImage | StorefrontMetaobject | StorefrontPage | StorefrontProduct | StorefrontProductVariant | StorefrontVideo;

/**
 * An auto-generated type for paginating through multiple MetafieldReferences.
 *
 */
export type StorefrontMetafieldReferenceConnection = {
  __typename?: 'StorefrontMetafieldReferenceConnection';
  /** A list of edges. */
  edges: Array<StorefrontMetafieldReferenceEdge>;
  /** A list of the nodes contained in MetafieldReferenceEdge. */
  nodes: Array<StorefrontMetafieldReference>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one MetafieldReference and a cursor during pagination.
 *
 */
export type StorefrontMetafieldReferenceEdge = {
  __typename?: 'StorefrontMetafieldReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetafieldReferenceEdge. */
  node: StorefrontMetafieldReference;
};

/** An error that occurs during the execution of `MetafieldsSet`. */
export type StorefrontMetafieldsSetUserError = StorefrontDisplayableError & {
  __typename?: 'StorefrontMetafieldsSetUserError';
  /** The error code. */
  code?: Maybe<StorefrontMetafieldsSetUserErrorCode>;
  /** The index of the array element that's causing the error. */
  elementIndex?: Maybe<Scalars['Int']['output']>;
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/** Possible error codes that can be returned by `MetafieldsSetUserError`. */
export enum StorefrontMetafieldsSetUserErrorCode {
  /** The input value is blank. */
  Blank = 'BLANK',
  /** The input value isn't included in the list. */
  Inclusion = 'INCLUSION',
  /** The owner ID is invalid. */
  InvalidOwner = 'INVALID_OWNER',
  /** The type is invalid. */
  InvalidType = 'INVALID_TYPE',
  /** The value is invalid for metafield type or for definition options. */
  InvalidValue = 'INVALID_VALUE',
  /** The input value should be less than or equal to the maximum value allowed. */
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  /** The input value needs to be blank. */
  Present = 'PRESENT',
  /** The input value is too long. */
  TooLong = 'TOO_LONG',
  /** The input value is too short. */
  TooShort = 'TOO_SHORT'
}

/** An instance of a user-defined model based on a MetaobjectDefinition. */
export type StorefrontMetaobject = StorefrontNode & {
  __typename?: 'StorefrontMetaobject';
  /** Accesses a field of the object by key. */
  field?: Maybe<StorefrontMetaobjectField>;
  /**
   * All object fields with defined values.
   * Omitted object keys can be assumed null, and no guarantees are made about field order.
   *
   */
  fields: Array<StorefrontMetaobjectField>;
  /** The unique handle of the metaobject. Useful as a custom ID. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The type of the metaobject. Defines the namespace of its associated metafields. */
  type: Scalars['String']['output'];
  /** The date and time when the metaobject was last updated. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
};


/** An instance of a user-defined model based on a MetaobjectDefinition. */
export type StorefrontMetaobjectFieldArgs = {
  key: Scalars['String']['input'];
};

/**
 * An auto-generated type for paginating through multiple Metaobjects.
 *
 */
export type StorefrontMetaobjectConnection = {
  __typename?: 'StorefrontMetaobjectConnection';
  /** A list of edges. */
  edges: Array<StorefrontMetaobjectEdge>;
  /** A list of the nodes contained in MetaobjectEdge. */
  nodes: Array<StorefrontMetaobject>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Metaobject and a cursor during pagination.
 *
 */
export type StorefrontMetaobjectEdge = {
  __typename?: 'StorefrontMetaobjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of MetaobjectEdge. */
  node: StorefrontMetaobject;
};

/** Provides the value of a Metaobject field. */
export type StorefrontMetaobjectField = {
  __typename?: 'StorefrontMetaobjectField';
  /** The field key. */
  key: Scalars['String']['output'];
  /** A referenced object if the field type is a resource reference. */
  reference?: Maybe<StorefrontMetafieldReference>;
  /** A list of referenced objects if the field type is a resource reference list. */
  references?: Maybe<StorefrontMetafieldReferenceConnection>;
  /**
   * The type name of the field.
   * See the list of [supported types](https://shopify.dev/apps/metafields/definitions/types).
   *
   */
  type: Scalars['String']['output'];
  /** The field value. */
  value?: Maybe<Scalars['String']['output']>;
};


/** Provides the value of a Metaobject field. */
export type StorefrontMetaobjectFieldReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The input fields used to retrieve a metaobject by handle. */
export type StorefrontMetaobjectHandleInput = {
  /** The handle of the metaobject. */
  handle: Scalars['String']['input'];
  /** The type of the metaobject. */
  type: Scalars['String']['input'];
};

/** Represents a Shopify hosted 3D model. */
export type StorefrontModel3d = StorefrontMedia & StorefrontNode & {
  __typename?: 'StorefrontModel3d';
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: StorefrontMediaContentType;
  /** The presentation for a media. */
  presentation?: Maybe<StorefrontMediaPresentation>;
  /** The preview image for the media. */
  previewImage?: Maybe<StorefrontImage>;
  /** The sources for a 3d model. */
  sources: Array<StorefrontModel3dSource>;
};

/** Represents a source for a Shopify hosted 3d model. */
export type StorefrontModel3dSource = {
  __typename?: 'StorefrontModel3dSource';
  /** The filesize of the 3d model. */
  filesize: Scalars['Int']['output'];
  /** The format of the 3d model. */
  format: Scalars['String']['output'];
  /** The MIME type of the 3d model. */
  mimeType: Scalars['String']['output'];
  /** The URL of the 3d model. */
  url: Scalars['String']['output'];
};

/** The input fields for a monetary value with currency. */
export type StorefrontMoneyInput = {
  /** Decimal money amount. */
  amount: Scalars['StorefrontDecimal']['input'];
  /** Currency of the money. */
  currencyCode: StorefrontCurrencyCode;
};

/**
 * A monetary value with currency.
 *
 */
export type StorefrontMoneyV2 = {
  __typename?: 'StorefrontMoneyV2';
  /** Decimal money amount. */
  amount: Scalars['StorefrontDecimal']['output'];
  /** Currency of the money. */
  currencyCode: StorefrontCurrencyCode;
};

/**
 * An object with an ID field to support global identification, in accordance with the
 * [Relay specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface).
 * This interface is used by the [node](https://shopify.dev/api/admin-graphql/unstable/queries/node)
 * and [nodes](https://shopify.dev/api/admin-graphql/unstable/queries/nodes) queries.
 *
 */
export type StorefrontNode = {
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
};

/** Represents a resource that can be published to the Online Store sales channel. */
export type StorefrontOnlineStorePublishable = {
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['StorefrontURL']['output']>;
};

/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type StorefrontOrder = StorefrontHasMetafields & StorefrontNode & {
  __typename?: 'StorefrontOrder';
  /** The address associated with the payment method. */
  billingAddress?: Maybe<StorefrontMailingAddress>;
  /** The reason for the order's cancellation. Returns `null` if the order wasn't canceled. */
  cancelReason?: Maybe<StorefrontOrderCancelReason>;
  /** The date and time when the order was canceled. Returns null if the order wasn't canceled. */
  canceledAt?: Maybe<Scalars['StorefrontDateTime']['output']>;
  /** The code of the currency used for the payment. */
  currencyCode: StorefrontCurrencyCode;
  /** The subtotal of line items and their discounts, excluding line items that have been removed. Does not contain order-level discounts, duties, shipping costs, or shipping discounts. Taxes aren't included unless the order is a taxes-included order. */
  currentSubtotalPrice: StorefrontMoneyV2;
  /** The total cost of duties for the order, including refunds. */
  currentTotalDuties?: Maybe<StorefrontMoneyV2>;
  /** The total amount of the order, including duties, taxes and discounts, minus amounts for line items that have been removed. */
  currentTotalPrice: StorefrontMoneyV2;
  /** The total of all taxes applied to the order, excluding taxes for returned line items. */
  currentTotalTax: StorefrontMoneyV2;
  /** A list of the custom attributes added to the order. */
  customAttributes: Array<StorefrontAttribute>;
  /** The locale code in which this specific order happened. */
  customerLocale?: Maybe<Scalars['String']['output']>;
  /** The unique URL that the customer can use to access the order. */
  customerUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** Discounts that have been applied on the order. */
  discountApplications: StorefrontDiscountApplicationConnection;
  /** Whether the order has had any edits applied or not. */
  edited: Scalars['Boolean']['output'];
  /** The customer's email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** The financial status of the order. */
  financialStatus?: Maybe<StorefrontOrderFinancialStatus>;
  /** The fulfillment status for the order. */
  fulfillmentStatus: StorefrontOrderFulfillmentStatus;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** List of the order’s line items. */
  lineItems: StorefrontOrderLineItemConnection;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /**
   * Unique identifier for the order that appears on the order.
   * For example, _#1000_ or _Store1001.
   *
   */
  name: Scalars['String']['output'];
  /** A unique numeric identifier for the order for use by shop owner and customer. */
  orderNumber: Scalars['Int']['output'];
  /** The total cost of duties charged at checkout. */
  originalTotalDuties?: Maybe<StorefrontMoneyV2>;
  /** The total price of the order before any applied edits. */
  originalTotalPrice: StorefrontMoneyV2;
  /** The customer's phone number for receiving SMS notifications. */
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * The date and time when the order was imported.
   * This value can be set to dates in the past when importing from other systems.
   * If no value is provided, it will be auto-generated based on current date and time.
   *
   */
  processedAt: Scalars['StorefrontDateTime']['output'];
  /** The address to where the order will be shipped. */
  shippingAddress?: Maybe<StorefrontMailingAddress>;
  /**
   * The discounts that have been allocated onto the shipping line by discount applications.
   *
   */
  shippingDiscountAllocations: Array<StorefrontDiscountAllocation>;
  /** The unique URL for the order's status page. */
  statusUrl: Scalars['StorefrontURL']['output'];
  /** Price of the order before shipping and taxes. */
  subtotalPrice?: Maybe<StorefrontMoneyV2>;
  /**
   * Price of the order before duties, shipping and taxes.
   * @deprecated Use `subtotalPrice` instead.
   */
  subtotalPriceV2?: Maybe<StorefrontMoneyV2>;
  /** List of the order’s successful fulfillments. */
  successfulFulfillments?: Maybe<Array<StorefrontFulfillment>>;
  /** The sum of all the prices of all the items in the order, duties, taxes and discounts included (must be positive). */
  totalPrice: StorefrontMoneyV2;
  /**
   * The sum of all the prices of all the items in the order, duties, taxes and discounts included (must be positive).
   * @deprecated Use `totalPrice` instead.
   */
  totalPriceV2: StorefrontMoneyV2;
  /** The total amount that has been refunded. */
  totalRefunded: StorefrontMoneyV2;
  /**
   * The total amount that has been refunded.
   * @deprecated Use `totalRefunded` instead.
   */
  totalRefundedV2: StorefrontMoneyV2;
  /** The total cost of shipping. */
  totalShippingPrice: StorefrontMoneyV2;
  /**
   * The total cost of shipping.
   * @deprecated Use `totalShippingPrice` instead.
   */
  totalShippingPriceV2: StorefrontMoneyV2;
  /** The total cost of taxes. */
  totalTax?: Maybe<StorefrontMoneyV2>;
  /**
   * The total cost of taxes.
   * @deprecated Use `totalTax` instead.
   */
  totalTaxV2?: Maybe<StorefrontMoneyV2>;
};


/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type StorefrontOrderDiscountApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type StorefrontOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type StorefrontOrderMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type StorefrontOrderMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};


/** An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information. */
export type StorefrontOrderSuccessfulFulfillmentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the reason for the order's cancellation. */
export enum StorefrontOrderCancelReason {
  /** The customer wanted to cancel the order. */
  Customer = 'CUSTOMER',
  /** Payment was declined. */
  Declined = 'DECLINED',
  /** The order was fraudulent. */
  Fraud = 'FRAUD',
  /** There was insufficient inventory. */
  Inventory = 'INVENTORY',
  /** The order was canceled for an unlisted reason. */
  Other = 'OTHER'
}

/**
 * An auto-generated type for paginating through multiple Orders.
 *
 */
export type StorefrontOrderConnection = {
  __typename?: 'StorefrontOrderConnection';
  /** A list of edges. */
  edges: Array<StorefrontOrderEdge>;
  /** A list of the nodes contained in OrderEdge. */
  nodes: Array<StorefrontOrder>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
  /** The total count of Orders. */
  totalCount: Scalars['StorefrontUnsignedInt64']['output'];
};

/**
 * An auto-generated type which holds one Order and a cursor during pagination.
 *
 */
export type StorefrontOrderEdge = {
  __typename?: 'StorefrontOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderEdge. */
  node: StorefrontOrder;
};

/** Represents the order's current financial status. */
export enum StorefrontOrderFinancialStatus {
  /** Displayed as **Authorized**. */
  Authorized = 'AUTHORIZED',
  /** Displayed as **Paid**. */
  Paid = 'PAID',
  /** Displayed as **Partially paid**. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Displayed as **Partially refunded**. */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** Displayed as **Pending**. */
  Pending = 'PENDING',
  /** Displayed as **Refunded**. */
  Refunded = 'REFUNDED',
  /** Displayed as **Voided**. */
  Voided = 'VOIDED'
}

/** Represents the order's aggregated fulfillment status for display purposes. */
export enum StorefrontOrderFulfillmentStatus {
  /** Displayed as **Fulfilled**. All of the items in the order have been fulfilled. */
  Fulfilled = 'FULFILLED',
  /** Displayed as **In progress**. Some of the items in the order have been fulfilled, or a request for fulfillment has been sent to the fulfillment service. */
  InProgress = 'IN_PROGRESS',
  /** Displayed as **On hold**. All of the unfulfilled items in this order are on hold. */
  OnHold = 'ON_HOLD',
  /** Displayed as **Open**. None of the items in the order have been fulfilled. Replaced by "UNFULFILLED" status. */
  Open = 'OPEN',
  /** Displayed as **Partially fulfilled**. Some of the items in the order have been fulfilled. */
  PartiallyFulfilled = 'PARTIALLY_FULFILLED',
  /** Displayed as **Pending fulfillment**. A request for fulfillment of some items awaits a response from the fulfillment service. Replaced by "IN_PROGRESS" status. */
  PendingFulfillment = 'PENDING_FULFILLMENT',
  /** Displayed as **Restocked**. All of the items in the order have been restocked. Replaced by "UNFULFILLED" status. */
  Restocked = 'RESTOCKED',
  /** Displayed as **Scheduled**. All of the unfulfilled items in this order are scheduled for fulfillment at later time. */
  Scheduled = 'SCHEDULED',
  /** Displayed as **Unfulfilled**. None of the items in the order have been fulfilled. */
  Unfulfilled = 'UNFULFILLED'
}

/** Represents a single line in an order. There is one line item for each distinct product variant. */
export type StorefrontOrderLineItem = {
  __typename?: 'StorefrontOrderLineItem';
  /** The number of entries associated to the line item minus the items that have been removed. */
  currentQuantity: Scalars['Int']['output'];
  /** List of custom attributes associated to the line item. */
  customAttributes: Array<StorefrontAttribute>;
  /** The discounts that have been allocated onto the order line item by discount applications. */
  discountAllocations: Array<StorefrontDiscountAllocation>;
  /** The total price of the line item, including discounts, and displayed in the presentment currency. */
  discountedTotalPrice: StorefrontMoneyV2;
  /** The total price of the line item, not including any discounts. The total price is calculated using the original unit price multiplied by the quantity, and it's displayed in the presentment currency. */
  originalTotalPrice: StorefrontMoneyV2;
  /** The number of products variants associated to the line item. */
  quantity: Scalars['Int']['output'];
  /** The title of the product combined with title of the variant. */
  title: Scalars['String']['output'];
  /** The product variant object associated to the line item. */
  variant?: Maybe<StorefrontProductVariant>;
};

/**
 * An auto-generated type for paginating through multiple OrderLineItems.
 *
 */
export type StorefrontOrderLineItemConnection = {
  __typename?: 'StorefrontOrderLineItemConnection';
  /** A list of edges. */
  edges: Array<StorefrontOrderLineItemEdge>;
  /** A list of the nodes contained in OrderLineItemEdge. */
  nodes: Array<StorefrontOrderLineItem>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one OrderLineItem and a cursor during pagination.
 *
 */
export type StorefrontOrderLineItemEdge = {
  __typename?: 'StorefrontOrderLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of OrderLineItemEdge. */
  node: StorefrontOrderLineItem;
};

/** The set of valid sort keys for the Order query. */
export enum StorefrontOrderSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `processed_at` value. */
  ProcessedAt = 'PROCESSED_AT',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `total_price` value. */
  TotalPrice = 'TOTAL_PRICE'
}

/** Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store. */
export type StorefrontPage = StorefrontHasMetafields & StorefrontNode & StorefrontOnlineStorePublishable & StorefrontTrackable & {
  __typename?: 'StorefrontPage';
  /** The description of the page, complete with HTML formatting. */
  body: Scalars['StorefrontHTML']['output'];
  /** Summary of the page body. */
  bodySummary: Scalars['String']['output'];
  /** The timestamp of the page creation. */
  createdAt: Scalars['StorefrontDateTime']['output'];
  /** A human-friendly unique string for the page automatically generated from its title. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** The page's SEO information. */
  seo?: Maybe<StorefrontSeo>;
  /** The title of the page. */
  title: Scalars['String']['output'];
  /** A URL parameters to be added to a page URL when it is linked from a GraphQL result. This allows for tracking the origin of the traffic. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
  /** The timestamp of the latest page update. */
  updatedAt: Scalars['StorefrontDateTime']['output'];
};


/** Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store. */
export type StorefrontPageMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store. */
export type StorefrontPageMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/**
 * An auto-generated type for paginating through multiple Pages.
 *
 */
export type StorefrontPageConnection = {
  __typename?: 'StorefrontPageConnection';
  /** A list of edges. */
  edges: Array<StorefrontPageEdge>;
  /** A list of the nodes contained in PageEdge. */
  nodes: Array<StorefrontPage>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Page and a cursor during pagination.
 *
 */
export type StorefrontPageEdge = {
  __typename?: 'StorefrontPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of PageEdge. */
  node: StorefrontPage;
};

/**
 * Returns information about pagination in a connection, in accordance with the
 * [Relay specification](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo).
 * For more information, please read our [GraphQL Pagination Usage Guide](https://shopify.dev/api/usage/pagination-graphql).
 *
 */
export type StorefrontPageInfo = {
  __typename?: 'StorefrontPageInfo';
  /** The cursor corresponding to the last node in edges. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Whether there are more pages to fetch following the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are any pages prior to the current page. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor corresponding to the first node in edges. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** The set of valid sort keys for the Page query. */
export enum StorefrontPageSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT'
}

/** A payment applied to a checkout. */
export type StorefrontPayment = StorefrontNode & {
  __typename?: 'StorefrontPayment';
  /** The amount of the payment. */
  amount: StorefrontMoneyV2;
  /**
   * The amount of the payment.
   * @deprecated Use `amount` instead.
   */
  amountV2: StorefrontMoneyV2;
  /** The billing address for the payment. */
  billingAddress?: Maybe<StorefrontMailingAddress>;
  /** The checkout to which the payment belongs. */
  checkout: StorefrontCheckout;
  /** The credit card used for the payment in the case of direct payments. */
  creditCard?: Maybe<StorefrontCreditCard>;
  /** A message describing a processing error during asynchronous processing. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * A client-side generated token to identify a payment and perform idempotent operations.
   * For more information, refer to
   * [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests).
   *
   */
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** The URL where the customer needs to be redirected so they can complete the 3D Secure payment flow. */
  nextActionUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** Whether the payment is still processing asynchronously. */
  ready: Scalars['Boolean']['output'];
  /** A flag to indicate if the payment is to be done in test mode for gateways that support it. */
  test: Scalars['Boolean']['output'];
  /** The actual transaction recorded by Shopify after having processed the payment with the gateway. */
  transaction?: Maybe<StorefrontTransaction>;
};

/** Settings related to payments. */
export type StorefrontPaymentSettings = {
  __typename?: 'StorefrontPaymentSettings';
  /** List of the card brands which the shop accepts. */
  acceptedCardBrands: Array<StorefrontCardBrand>;
  /** The url pointing to the endpoint to vault credit cards. */
  cardVaultUrl: Scalars['StorefrontURL']['output'];
  /** The country where the shop is located. */
  countryCode: StorefrontCountryCode;
  /** The three-letter code for the shop's primary currency. */
  currencyCode: StorefrontCurrencyCode;
  /** A list of enabled currencies (ISO 4217 format) that the shop accepts. Merchants can enable currencies from their Shopify Payments settings in the Shopify admin. */
  enabledPresentmentCurrencies: Array<StorefrontCurrencyCode>;
  /** The shop’s Shopify Payments account ID. */
  shopifyPaymentsAccountId?: Maybe<Scalars['String']['output']>;
  /** List of the digital wallets which the shop supports. */
  supportedDigitalWallets: Array<StorefrontDigitalWallet>;
};

/** The valid values for the types of payment token. */
export enum StorefrontPaymentTokenType {
  /** Apple Pay token type. */
  ApplePay = 'APPLE_PAY',
  /** Google Pay token type. */
  GooglePay = 'GOOGLE_PAY',
  /** Shopify Pay token type. */
  ShopifyPay = 'SHOPIFY_PAY',
  /** Stripe token type. */
  StripeVaultToken = 'STRIPE_VAULT_TOKEN',
  /** Vault payment token type. */
  Vault = 'VAULT'
}

/** Decides the distribution of results. */
export enum StorefrontPredictiveSearchLimitScope {
  /** Return results up to limit across all types. */
  All = 'ALL',
  /** Return results up to limit per type. */
  Each = 'EACH'
}

/**
 * A predictive search result represents a list of products, collections, pages, articles, and query suggestions
 * that matches the predictive search query.
 *
 */
export type StorefrontPredictiveSearchResult = {
  __typename?: 'StorefrontPredictiveSearchResult';
  /** The articles that match the search query. */
  articles: Array<StorefrontArticle>;
  /** The articles that match the search query. */
  collections: Array<StorefrontCollection>;
  /** The pages that match the search query. */
  pages: Array<StorefrontPage>;
  /** The products that match the search query. */
  products: Array<StorefrontProduct>;
  /** The query suggestions that are relevant to the search query. */
  queries: Array<StorefrontSearchQuerySuggestion>;
};

/** The types of search items to perform predictive search on. */
export enum StorefrontPredictiveSearchType {
  /** Returns matching articles. */
  Article = 'ARTICLE',
  /** Returns matching collections. */
  Collection = 'COLLECTION',
  /** Returns matching pages. */
  Page = 'PAGE',
  /** Returns matching products. */
  Product = 'PRODUCT',
  /** Returns matching query strings. */
  Query = 'QUERY'
}

/**
 * The input fields for a filter used to view a subset of products in a collection matching a specific price range.
 *
 */
export type StorefrontPriceRangeFilter = {
  /** The maximum price in the range. Empty indicates no max price. */
  max?: InputMaybe<Scalars['Float']['input']>;
  /** The minimum price in the range. Defaults to zero. */
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** The value of the percentage pricing object. */
export type StorefrontPricingPercentageValue = {
  __typename?: 'StorefrontPricingPercentageValue';
  /** The percentage value of the object. */
  percentage: Scalars['Float']['output'];
};

/** The price value (fixed or percentage) for a discount application. */
export type StorefrontPricingValue = StorefrontMoneyV2 | StorefrontPricingPercentageValue;

/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProduct = StorefrontHasMetafields & StorefrontNode & StorefrontOnlineStorePublishable & StorefrontTrackable & {
  __typename?: 'StorefrontProduct';
  /** Indicates if at least one product variant is available for sale. */
  availableForSale: Scalars['Boolean']['output'];
  /** List of collections a product belongs to. */
  collections: StorefrontCollectionConnection;
  /** The compare at price of the product across all variants. */
  compareAtPriceRange: StorefrontProductPriceRange;
  /** The date and time when the product was created. */
  createdAt: Scalars['StorefrontDateTime']['output'];
  /** Stripped description of the product, single line with HTML tags removed. */
  description: Scalars['String']['output'];
  /** The description of the product, complete with HTML formatting. */
  descriptionHtml: Scalars['StorefrontHTML']['output'];
  /**
   * The featured image for the product.
   *
   * This field is functionally equivalent to `images(first: 1)`.
   *
   */
  featuredImage?: Maybe<StorefrontImage>;
  /**
   * A human-friendly unique string for the Product automatically generated from its title.
   * They are used by the Liquid templating language to refer to objects.
   *
   */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** List of images associated with the product. */
  images: StorefrontImageConnection;
  /** Whether the product is a gift card. */
  isGiftCard: Scalars['Boolean']['output'];
  /** The media associated with the product. */
  media: StorefrontMediaConnection;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel. */
  onlineStoreUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** List of product options. */
  options: Array<StorefrontProductOption>;
  /** The price range. */
  priceRange: StorefrontProductPriceRange;
  /** A categorization that a product can be tagged with, commonly used for filtering and searching. */
  productType: Scalars['String']['output'];
  /** The date and time when the product was published to the channel. */
  publishedAt: Scalars['StorefrontDateTime']['output'];
  /** Whether the product can only be purchased with a selling plan. */
  requiresSellingPlan: Scalars['Boolean']['output'];
  /** A list of a product's available selling plan groups. A selling plan group represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans. */
  sellingPlanGroups: StorefrontSellingPlanGroupConnection;
  /** The product's SEO information. */
  seo: StorefrontSeo;
  /**
   * A comma separated list of tags that have been added to the product.
   * Additional access scope required for private apps: unauthenticated_read_product_tags.
   *
   */
  tags: Array<Scalars['String']['output']>;
  /** The product’s title. */
  title: Scalars['String']['output'];
  /** The total quantity of inventory in stock for this Product. */
  totalInventory?: Maybe<Scalars['Int']['output']>;
  /** A URL parameters to be added to a page URL when it is linked from a GraphQL result. This allows for tracking the origin of the traffic. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
  /**
   * The date and time when the product was last modified.
   * A product's `updatedAt` value can change for different reasons. For example, if an order
   * is placed for a product that has inventory tracking set up, then the inventory adjustment
   * is counted as an update.
   *
   */
  updatedAt: Scalars['StorefrontDateTime']['output'];
  /**
   * Find a product’s variant based on its selected options.
   * This is useful for converting a user’s selection of product options into a single matching variant.
   * If there is not a variant for the selected options, `null` will be returned.
   *
   */
  variantBySelectedOptions?: Maybe<StorefrontProductVariant>;
  /** List of the product’s variants. */
  variants: StorefrontProductVariantConnection;
  /** The product’s vendor name. */
  vendor: Scalars['String']['output'];
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductDescriptionArgs = {
  truncateAt?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontProductImageSortKeys>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontProductMediaSortKeys>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductOptionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductSellingPlanGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductVariantBySelectedOptionsArgs = {
  selectedOptions: Array<StorefrontSelectedOptionInput>;
};


/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
 * For example, a digital download (such as a movie, music or ebook file) also qualifies as a product, as do services (such as equipment rental, work for hire, customization of another product or an extended warranty).
 */
export type StorefrontProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<StorefrontProductVariantSortKeys>;
};

/** The set of valid sort keys for the ProductCollection query. */
export enum StorefrontProductCollectionSortKeys {
  /** Sort by the `best-selling` value. */
  BestSelling = 'BEST_SELLING',
  /** Sort by the `collection-default` value. */
  CollectionDefault = 'COLLECTION_DEFAULT',
  /** Sort by the `created` value. */
  Created = 'CREATED',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `manual` value. */
  Manual = 'MANUAL',
  /** Sort by the `price` value. */
  Price = 'PRICE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/**
 * An auto-generated type for paginating through multiple Products.
 *
 */
export type StorefrontProductConnection = {
  __typename?: 'StorefrontProductConnection';
  /** A list of edges. */
  edges: Array<StorefrontProductEdge>;
  /** A list of available filters. */
  filters: Array<StorefrontFilter>;
  /** A list of the nodes contained in ProductEdge. */
  nodes: Array<StorefrontProduct>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one Product and a cursor during pagination.
 *
 */
export type StorefrontProductEdge = {
  __typename?: 'StorefrontProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductEdge. */
  node: StorefrontProduct;
};

/**
 * The input fields for a filter used to view a subset of products in a collection.
 * By default, the `available` and `price` filters are enabled. Filters are customized with the Shopify Search & Discovery app.
 * Learn more about [customizing storefront filtering](https://help.shopify.com/manual/online-store/themes/customizing-themes/storefront-filters).
 *
 */
export type StorefrontProductFilter = {
  /** Filter on if the product is available for sale. */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** A range of prices to filter with-in. */
  price?: InputMaybe<StorefrontPriceRangeFilter>;
  /** A product metafield to filter on. */
  productMetafield?: InputMaybe<StorefrontMetafieldFilter>;
  /** The product type to filter on. */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** The product vendor to filter on. */
  productVendor?: InputMaybe<Scalars['String']['input']>;
  /** A product tag to filter on. */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** A variant metafield to filter on. */
  variantMetafield?: InputMaybe<StorefrontMetafieldFilter>;
  /** A variant option to filter on. */
  variantOption?: InputMaybe<StorefrontVariantOptionFilter>;
};

/** The set of valid sort keys for the ProductImage query. */
export enum StorefrontProductImageSortKeys {
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE'
}

/** The set of valid sort keys for the ProductMedia query. */
export enum StorefrontProductMediaSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE'
}

/**
 * Product property names like "Size", "Color", and "Material" that the customers can select.
 * Variants are selected based on permutations of these options.
 * 255 characters limit each.
 *
 */
export type StorefrontProductOption = StorefrontNode & {
  __typename?: 'StorefrontProductOption';
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The product option’s name. */
  name: Scalars['String']['output'];
  /** The corresponding value to the product option name. */
  values: Array<Scalars['String']['output']>;
};

/** The price range of the product. */
export type StorefrontProductPriceRange = {
  __typename?: 'StorefrontProductPriceRange';
  /** The highest variant's price. */
  maxVariantPrice: StorefrontMoneyV2;
  /** The lowest variant's price. */
  minVariantPrice: StorefrontMoneyV2;
};

/**
 * The recommendation intent that is used to generate product recommendations.
 * You can use intent to generate product recommendations according to different strategies.
 *
 */
export enum StorefrontProductRecommendationIntent {
  /** Offer customers products that are complementary to a product for which recommendations are to be fetched. An example is add-on products that display in a Pair it with section. */
  Complementary = 'COMPLEMENTARY',
  /** Offer customers a mix of products that are similar or complementary to a product for which recommendations are to be fetched. An example is substitutable products that display in a You may also like section. */
  Related = 'RELATED'
}

/** The set of valid sort keys for the Product query. */
export enum StorefrontProductSortKeys {
  /** Sort by the `best_selling` value. */
  BestSelling = 'BEST_SELLING',
  /** Sort by the `created_at` value. */
  CreatedAt = 'CREATED_AT',
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `price` value. */
  Price = 'PRICE',
  /** Sort by the `product_type` value. */
  ProductType = 'PRODUCT_TYPE',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `title` value. */
  Title = 'TITLE',
  /** Sort by the `updated_at` value. */
  UpdatedAt = 'UPDATED_AT',
  /** Sort by the `vendor` value. */
  Vendor = 'VENDOR'
}

/** A product variant represents a different version of a product, such as differing sizes or differing colors. */
export type StorefrontProductVariant = StorefrontHasMetafields & StorefrontNode & {
  __typename?: 'StorefrontProductVariant';
  /** Indicates if the product variant is available for sale. */
  availableForSale: Scalars['Boolean']['output'];
  /** The barcode (for example, ISBN, UPC, or GTIN) associated with the variant. */
  barcode?: Maybe<Scalars['String']['output']>;
  /** The compare at price of the variant. This can be used to mark a variant as on sale, when `compareAtPrice` is higher than `price`. */
  compareAtPrice?: Maybe<StorefrontMoneyV2>;
  /**
   * The compare at price of the variant. This can be used to mark a variant as on sale, when `compareAtPriceV2` is higher than `priceV2`.
   * @deprecated Use `compareAtPrice` instead.
   */
  compareAtPriceV2?: Maybe<StorefrontMoneyV2>;
  /** Whether a product is out of stock but still available for purchase (used for backorders). */
  currentlyNotInStock: Scalars['Boolean']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /**
   * Image associated with the product variant. This field falls back to the product image if no image is available.
   *
   */
  image?: Maybe<StorefrontImage>;
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** The product variant’s price. */
  price: StorefrontMoneyV2;
  /**
   * The product variant’s price.
   * @deprecated Use `price` instead.
   */
  priceV2: StorefrontMoneyV2;
  /** The product object that the product variant belongs to. */
  product: StorefrontProduct;
  /** The total sellable quantity of the variant for online sales channels. */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  /** Whether a customer needs to provide a shipping address when placing an order for the product variant. */
  requiresShipping: Scalars['Boolean']['output'];
  /** List of product options applied to the variant. */
  selectedOptions: Array<StorefrontSelectedOption>;
  /** Represents an association between a variant and a selling plan. Selling plan allocations describe which selling plans are available for each variant, and what their impact is on pricing. */
  sellingPlanAllocations: StorefrontSellingPlanAllocationConnection;
  /** The SKU (stock keeping unit) associated with the variant. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The in-store pickup availability of this variant by location. */
  storeAvailability: StorefrontStoreAvailabilityConnection;
  /** The product variant’s title. */
  title: Scalars['String']['output'];
  /** The unit price value for the variant based on the variant's measurement. */
  unitPrice?: Maybe<StorefrontMoneyV2>;
  /** The unit price measurement for the variant. */
  unitPriceMeasurement?: Maybe<StorefrontUnitPriceMeasurement>;
  /** The weight of the product variant in the unit system specified with `weight_unit`. */
  weight?: Maybe<Scalars['Float']['output']>;
  /** Unit of measurement for weight. */
  weightUnit: StorefrontWeightUnit;
};


/** A product variant represents a different version of a product, such as differing sizes or differing colors. */
export type StorefrontProductVariantMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** A product variant represents a different version of a product, such as differing sizes or differing colors. */
export type StorefrontProductVariantMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};


/** A product variant represents a different version of a product, such as differing sizes or differing colors. */
export type StorefrontProductVariantSellingPlanAllocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A product variant represents a different version of a product, such as differing sizes or differing colors. */
export type StorefrontProductVariantStoreAvailabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  near?: InputMaybe<StorefrontGeoCoordinateInput>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple ProductVariants.
 *
 */
export type StorefrontProductVariantConnection = {
  __typename?: 'StorefrontProductVariantConnection';
  /** A list of edges. */
  edges: Array<StorefrontProductVariantEdge>;
  /** A list of the nodes contained in ProductVariantEdge. */
  nodes: Array<StorefrontProductVariant>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one ProductVariant and a cursor during pagination.
 *
 */
export type StorefrontProductVariantEdge = {
  __typename?: 'StorefrontProductVariantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of ProductVariantEdge. */
  node: StorefrontProductVariant;
};

/** The set of valid sort keys for the ProductVariant query. */
export enum StorefrontProductVariantSortKeys {
  /** Sort by the `id` value. */
  Id = 'ID',
  /** Sort by the `position` value. */
  Position = 'POSITION',
  /**
   * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
   * Don't use this sort key when no search query is specified.
   *
   */
  Relevance = 'RELEVANCE',
  /** Sort by the `sku` value. */
  Sku = 'SKU',
  /** Sort by the `title` value. */
  Title = 'TITLE'
}

/** SEO information. */
export type StorefrontSeo = {
  __typename?: 'StorefrontSEO';
  /** The meta description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The SEO title. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Script discount applications capture the intentions of a discount that
 * was created by a Shopify Script.
 *
 */
export type StorefrontScriptDiscountApplication = StorefrontDiscountApplication & {
  __typename?: 'StorefrontScriptDiscountApplication';
  /** The method by which the discount's value is allocated to its entitled items. */
  allocationMethod: StorefrontDiscountApplicationAllocationMethod;
  /** Which lines of targetType that the discount is allocated over. */
  targetSelection: StorefrontDiscountApplicationTargetSelection;
  /** The type of line that the discount is applicable towards. */
  targetType: StorefrontDiscountApplicationTargetType;
  /** The title of the application as defined by the Script. */
  title: Scalars['String']['output'];
  /** The value of the discount application. */
  value: StorefrontPricingValue;
};

/** Specifies whether to perform a partial word match on the last search term. */
export enum StorefrontSearchPrefixQueryType {
  /** Perform a partial word match on the last search term. */
  Last = 'LAST',
  /** Don't perform a partial word match on the last search term. */
  None = 'NONE'
}

/** A search query suggestion. */
export type StorefrontSearchQuerySuggestion = StorefrontTrackable & {
  __typename?: 'StorefrontSearchQuerySuggestion';
  /** The text of the search query suggestion with highlighted HTML tags. */
  styledText: Scalars['String']['output'];
  /** The text of the search query suggestion. */
  text: Scalars['String']['output'];
  /** A URL parameters to be added to a page URL when it is linked from a GraphQL result. This allows for tracking the origin of the traffic. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
};

/**
 * A search result that matches the search query.
 *
 */
export type StorefrontSearchResultItem = StorefrontArticle | StorefrontPage | StorefrontProduct;

/**
 * An auto-generated type for paginating through multiple SearchResultItems.
 *
 */
export type StorefrontSearchResultItemConnection = {
  __typename?: 'StorefrontSearchResultItemConnection';
  /** A list of edges. */
  edges: Array<StorefrontSearchResultItemEdge>;
  /** A list of the nodes contained in SearchResultItemEdge. */
  nodes: Array<StorefrontSearchResultItem>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
  /** A list of available filters. */
  productFilters: Array<StorefrontFilter>;
  /** The total number of results. */
  totalCount: Scalars['Int']['output'];
};

/**
 * An auto-generated type which holds one SearchResultItem and a cursor during pagination.
 *
 */
export type StorefrontSearchResultItemEdge = {
  __typename?: 'StorefrontSearchResultItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SearchResultItemEdge. */
  node: StorefrontSearchResultItem;
};

/** The set of valid sort keys for the search query. */
export enum StorefrontSearchSortKeys {
  /** Sort by the `price` value. */
  Price = 'PRICE',
  /** Sort by relevance to the search terms. */
  Relevance = 'RELEVANCE'
}

/** The types of search items to perform search within. */
export enum StorefrontSearchType {
  /** Returns matching articles. */
  Article = 'ARTICLE',
  /** Returns matching pages. */
  Page = 'PAGE',
  /** Returns matching products. */
  Product = 'PRODUCT'
}

/** Specifies whether to display results for unavailable products. */
export enum StorefrontSearchUnavailableProductsType {
  /** Exclude unavailable products. */
  Hide = 'HIDE',
  /** Show unavailable products after all other matching results. This is the default. */
  Last = 'LAST',
  /** Show unavailable products in the order that they're found. */
  Show = 'SHOW'
}

/** Specifies the list of resource fields to search. */
export enum StorefrontSearchableField {
  /** Author of the page or article. */
  Author = 'AUTHOR',
  /** Body of the page or article or product description or collection description. */
  Body = 'BODY',
  /** Product type. */
  ProductType = 'PRODUCT_TYPE',
  /** Tag associated with the product or article. */
  Tag = 'TAG',
  /** Title of the page or article or product title or collection title. */
  Title = 'TITLE',
  /** Variant barcode. */
  VariantsBarcode = 'VARIANTS_BARCODE',
  /** Variant SKU. */
  VariantsSku = 'VARIANTS_SKU',
  /** Variant title. */
  VariantsTitle = 'VARIANTS_TITLE',
  /** Product vendor. */
  Vendor = 'VENDOR'
}

/**
 * Properties used by customers to select a product variant.
 * Products can have multiple options, like different sizes or colors.
 *
 */
export type StorefrontSelectedOption = {
  __typename?: 'StorefrontSelectedOption';
  /** The product option’s name. */
  name: Scalars['String']['output'];
  /** The product option’s value. */
  value: Scalars['String']['output'];
};

/** The input fields required for a selected option. */
export type StorefrontSelectedOptionInput = {
  /** The product option’s name. */
  name: Scalars['String']['input'];
  /** The product option’s value. */
  value: Scalars['String']['input'];
};

/** Represents how products and variants can be sold and purchased. */
export type StorefrontSellingPlan = {
  __typename?: 'StorefrontSellingPlan';
  /** The initial payment due for the purchase. */
  checkoutCharge: StorefrontSellingPlanCheckoutCharge;
  /** The description of the selling plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The name of the selling plan. For example, '6 weeks of prepaid granola, delivered weekly'. */
  name: Scalars['String']['output'];
  /** The selling plan options available in the drop-down list in the storefront. For example, 'Delivery every week' or 'Delivery every 2 weeks' specifies the delivery frequency options for the product. Individual selling plans contribute their options to the associated selling plan group. For example, a selling plan group might have an option called `option1: Delivery every`. One selling plan in that group could contribute `option1: 2 weeks` with the pricing for that option, and another selling plan could contribute `option1: 4 weeks`, with different pricing. */
  options: Array<StorefrontSellingPlanOption>;
  /** The price adjustments that a selling plan makes when a variant is purchased with a selling plan. */
  priceAdjustments: Array<StorefrontSellingPlanPriceAdjustment>;
  /** Whether purchasing the selling plan will result in multiple deliveries. */
  recurringDeliveries: Scalars['Boolean']['output'];
};

/** Represents an association between a variant and a selling plan. Selling plan allocations describe the options offered for each variant, and the price of the variant when purchased with a selling plan. */
export type StorefrontSellingPlanAllocation = {
  __typename?: 'StorefrontSellingPlanAllocation';
  /** The checkout charge amount due for the purchase. */
  checkoutChargeAmount: StorefrontMoneyV2;
  /** A list of price adjustments, with a maximum of two. When there are two, the first price adjustment goes into effect at the time of purchase, while the second one starts after a certain number of orders. A price adjustment represents how a selling plan affects pricing when a variant is purchased with a selling plan. Prices display in the customer's currency if the shop is configured for it. */
  priceAdjustments: Array<StorefrontSellingPlanAllocationPriceAdjustment>;
  /** The remaining balance charge amount due for the purchase. */
  remainingBalanceChargeAmount: StorefrontMoneyV2;
  /** A representation of how products and variants can be sold and purchased. For example, an individual selling plan could be '6 weeks of prepaid granola, delivered weekly'. */
  sellingPlan: StorefrontSellingPlan;
};

/**
 * An auto-generated type for paginating through multiple SellingPlanAllocations.
 *
 */
export type StorefrontSellingPlanAllocationConnection = {
  __typename?: 'StorefrontSellingPlanAllocationConnection';
  /** A list of edges. */
  edges: Array<StorefrontSellingPlanAllocationEdge>;
  /** A list of the nodes contained in SellingPlanAllocationEdge. */
  nodes: Array<StorefrontSellingPlanAllocation>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one SellingPlanAllocation and a cursor during pagination.
 *
 */
export type StorefrontSellingPlanAllocationEdge = {
  __typename?: 'StorefrontSellingPlanAllocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanAllocationEdge. */
  node: StorefrontSellingPlanAllocation;
};

/** The resulting prices for variants when they're purchased with a specific selling plan. */
export type StorefrontSellingPlanAllocationPriceAdjustment = {
  __typename?: 'StorefrontSellingPlanAllocationPriceAdjustment';
  /** The price of the variant when it's purchased without a selling plan for the same number of deliveries. For example, if a customer purchases 6 deliveries of $10.00 granola separately, then the price is 6 x $10.00 = $60.00. */
  compareAtPrice: StorefrontMoneyV2;
  /** The effective price for a single delivery. For example, for a prepaid subscription plan that includes 6 deliveries at the price of $48.00, the per delivery price is $8.00. */
  perDeliveryPrice: StorefrontMoneyV2;
  /** The price of the variant when it's purchased with a selling plan For example, for a prepaid subscription plan that includes 6 deliveries of $10.00 granola, where the customer gets 20% off, the price is 6 x $10.00 x 0.80 = $48.00. */
  price: StorefrontMoneyV2;
  /** The resulting price per unit for the variant associated with the selling plan. If the variant isn't sold by quantity or measurement, then this field returns `null`. */
  unitPrice?: Maybe<StorefrontMoneyV2>;
};

/** The initial payment due for the purchase. */
export type StorefrontSellingPlanCheckoutCharge = {
  __typename?: 'StorefrontSellingPlanCheckoutCharge';
  /** The charge type for the checkout charge. */
  type: StorefrontSellingPlanCheckoutChargeType;
  /** The charge value for the checkout charge. */
  value: StorefrontSellingPlanCheckoutChargeValue;
};

/** The percentage value of the price used for checkout charge. */
export type StorefrontSellingPlanCheckoutChargePercentageValue = {
  __typename?: 'StorefrontSellingPlanCheckoutChargePercentageValue';
  /** The percentage value of the price used for checkout charge. */
  percentage: Scalars['Float']['output'];
};

/** The checkout charge when the full amount isn't charged at checkout. */
export enum StorefrontSellingPlanCheckoutChargeType {
  /** The checkout charge is a percentage of the product or variant price. */
  Percentage = 'PERCENTAGE',
  /** The checkout charge is a fixed price amount. */
  Price = 'PRICE'
}

/** The portion of the price to be charged at checkout. */
export type StorefrontSellingPlanCheckoutChargeValue = StorefrontMoneyV2 | StorefrontSellingPlanCheckoutChargePercentageValue;

/**
 * An auto-generated type for paginating through multiple SellingPlans.
 *
 */
export type StorefrontSellingPlanConnection = {
  __typename?: 'StorefrontSellingPlanConnection';
  /** A list of edges. */
  edges: Array<StorefrontSellingPlanEdge>;
  /** A list of the nodes contained in SellingPlanEdge. */
  nodes: Array<StorefrontSellingPlan>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one SellingPlan and a cursor during pagination.
 *
 */
export type StorefrontSellingPlanEdge = {
  __typename?: 'StorefrontSellingPlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanEdge. */
  node: StorefrontSellingPlan;
};

/** A fixed amount that's deducted from the original variant price. For example, $10.00 off. */
export type StorefrontSellingPlanFixedAmountPriceAdjustment = {
  __typename?: 'StorefrontSellingPlanFixedAmountPriceAdjustment';
  /** The money value of the price adjustment. */
  adjustmentAmount: StorefrontMoneyV2;
};

/** A fixed price adjustment for a variant that's purchased with a selling plan. */
export type StorefrontSellingPlanFixedPriceAdjustment = {
  __typename?: 'StorefrontSellingPlanFixedPriceAdjustment';
  /** A new price of the variant when it's purchased with the selling plan. */
  price: StorefrontMoneyV2;
};

/** Represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans. */
export type StorefrontSellingPlanGroup = {
  __typename?: 'StorefrontSellingPlanGroup';
  /** A display friendly name for the app that created the selling plan group. */
  appName?: Maybe<Scalars['String']['output']>;
  /** The name of the selling plan group. */
  name: Scalars['String']['output'];
  /** Represents the selling plan options available in the drop-down list in the storefront. For example, 'Delivery every week' or 'Delivery every 2 weeks' specifies the delivery frequency options for the product. */
  options: Array<StorefrontSellingPlanGroupOption>;
  /** A list of selling plans in a selling plan group. A selling plan is a representation of how products and variants can be sold and purchased. For example, an individual selling plan could be '6 weeks of prepaid granola, delivered weekly'. */
  sellingPlans: StorefrontSellingPlanConnection;
};


/** Represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans. */
export type StorefrontSellingPlanGroupSellingPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An auto-generated type for paginating through multiple SellingPlanGroups.
 *
 */
export type StorefrontSellingPlanGroupConnection = {
  __typename?: 'StorefrontSellingPlanGroupConnection';
  /** A list of edges. */
  edges: Array<StorefrontSellingPlanGroupEdge>;
  /** A list of the nodes contained in SellingPlanGroupEdge. */
  nodes: Array<StorefrontSellingPlanGroup>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one SellingPlanGroup and a cursor during pagination.
 *
 */
export type StorefrontSellingPlanGroupEdge = {
  __typename?: 'StorefrontSellingPlanGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of SellingPlanGroupEdge. */
  node: StorefrontSellingPlanGroup;
};

/**
 * Represents an option on a selling plan group that's available in the drop-down list in the storefront.
 *
 * Individual selling plans contribute their options to the associated selling plan group. For example, a selling plan group might have an option called `option1: Delivery every`. One selling plan in that group could contribute `option1: 2 weeks` with the pricing for that option, and another selling plan could contribute `option1: 4 weeks`, with different pricing.
 */
export type StorefrontSellingPlanGroupOption = {
  __typename?: 'StorefrontSellingPlanGroupOption';
  /** The name of the option. For example, 'Delivery every'. */
  name: Scalars['String']['output'];
  /** The values for the options specified by the selling plans in the selling plan group. For example, '1 week', '2 weeks', '3 weeks'. */
  values: Array<Scalars['String']['output']>;
};

/** An option provided by a Selling Plan. */
export type StorefrontSellingPlanOption = {
  __typename?: 'StorefrontSellingPlanOption';
  /** The name of the option (ie "Delivery every"). */
  name?: Maybe<Scalars['String']['output']>;
  /** The value of the option (ie "Month"). */
  value?: Maybe<Scalars['String']['output']>;
};

/** A percentage amount that's deducted from the original variant price. For example, 10% off. */
export type StorefrontSellingPlanPercentagePriceAdjustment = {
  __typename?: 'StorefrontSellingPlanPercentagePriceAdjustment';
  /** The percentage value of the price adjustment. */
  adjustmentPercentage: Scalars['Int']['output'];
};

/** Represents by how much the price of a variant associated with a selling plan is adjusted. Each variant can have up to two price adjustments. If a variant has multiple price adjustments, then the first price adjustment applies when the variant is initially purchased. The second price adjustment applies after a certain number of orders (specified by the `orderCount` field) are made. If a selling plan doesn't have any price adjustments, then the unadjusted price of the variant is the effective price. */
export type StorefrontSellingPlanPriceAdjustment = {
  __typename?: 'StorefrontSellingPlanPriceAdjustment';
  /** The type of price adjustment. An adjustment value can have one of three types: percentage, amount off, or a new price. */
  adjustmentValue: StorefrontSellingPlanPriceAdjustmentValue;
  /** The number of orders that the price adjustment applies to. If the price adjustment always applies, then this field is `null`. */
  orderCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents by how much the price of a variant associated with a selling plan is adjusted. Each variant can have up to two price adjustments. */
export type StorefrontSellingPlanPriceAdjustmentValue = StorefrontSellingPlanFixedAmountPriceAdjustment | StorefrontSellingPlanFixedPriceAdjustment | StorefrontSellingPlanPercentagePriceAdjustment;

/** A shipping rate to be applied to a checkout. */
export type StorefrontShippingRate = {
  __typename?: 'StorefrontShippingRate';
  /** Human-readable unique identifier for this shipping rate. */
  handle: Scalars['String']['output'];
  /** Price of this shipping rate. */
  price: StorefrontMoneyV2;
  /**
   * Price of this shipping rate.
   * @deprecated Use `price` instead.
   */
  priceV2: StorefrontMoneyV2;
  /** Title of this shipping rate. */
  title: Scalars['String']['output'];
};

/** Shop represents a collection of the general settings and information about the shop. */
export type StorefrontShop = StorefrontHasMetafields & StorefrontNode & {
  __typename?: 'StorefrontShop';
  /** The shop's branding configuration. */
  brand?: Maybe<StorefrontBrand>;
  /** A description of the shop. */
  description?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Returns a metafield found by namespace and key. */
  metafield?: Maybe<StorefrontMetafield>;
  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   *
   */
  metafields: Array<Maybe<StorefrontMetafield>>;
  /** A string representing the way currency is formatted when the currency isn’t specified. */
  moneyFormat: Scalars['String']['output'];
  /** The shop’s name. */
  name: Scalars['String']['output'];
  /** Settings related to payments. */
  paymentSettings: StorefrontPaymentSettings;
  /** The primary domain of the shop’s Online Store. */
  primaryDomain: StorefrontDomain;
  /** The shop’s privacy policy. */
  privacyPolicy?: Maybe<StorefrontShopPolicy>;
  /** The shop’s refund policy. */
  refundPolicy?: Maybe<StorefrontShopPolicy>;
  /** The shop’s shipping policy. */
  shippingPolicy?: Maybe<StorefrontShopPolicy>;
  /** Countries that the shop ships to. */
  shipsToCountries: Array<StorefrontCountryCode>;
  /** The shop’s subscription policy. */
  subscriptionPolicy?: Maybe<StorefrontShopPolicyWithDefault>;
  /** The shop’s terms of service. */
  termsOfService?: Maybe<StorefrontShopPolicy>;
};


/** Shop represents a collection of the general settings and information about the shop. */
export type StorefrontShopMetafieldArgs = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
};


/** Shop represents a collection of the general settings and information about the shop. */
export type StorefrontShopMetafieldsArgs = {
  identifiers: Array<StorefrontHasMetafieldsIdentifier>;
};

/**
 * The input fields for submitting Shop Pay payment method information for checkout.
 *
 */
export type StorefrontShopPayWalletContentInput = {
  /** The customer's billing address. */
  billingAddress: StorefrontMailingAddressInput;
  /** Session token for transaction. */
  sessionToken: Scalars['String']['input'];
};

/** Policy that a merchant has configured for their store, such as their refund or privacy policy. */
export type StorefrontShopPolicy = StorefrontNode & {
  __typename?: 'StorefrontShopPolicy';
  /** Policy text, maximum size of 64kb. */
  body: Scalars['String']['output'];
  /** Policy’s handle. */
  handle: Scalars['String']['output'];
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** Policy’s title. */
  title: Scalars['String']['output'];
  /** Public URL to the policy. */
  url: Scalars['StorefrontURL']['output'];
};

/**
 * A policy for the store that comes with a default value, such as a subscription policy.
 * If the merchant hasn't configured a policy for their store, then the policy will return the default value.
 * Otherwise, the policy will return the merchant-configured value.
 *
 */
export type StorefrontShopPolicyWithDefault = {
  __typename?: 'StorefrontShopPolicyWithDefault';
  /** The text of the policy. Maximum size: 64KB. */
  body: Scalars['String']['output'];
  /** The handle of the policy. */
  handle: Scalars['String']['output'];
  /** The unique ID of the policy. A default policy doesn't have an ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The title of the policy. */
  title: Scalars['String']['output'];
  /** Public URL to the policy. */
  url: Scalars['StorefrontURL']['output'];
};

/**
 * The availability of a product variant at a particular location.
 * Local pick-up must be enabled in the  store's shipping settings, otherwise this will return an empty result.
 *
 */
export type StorefrontStoreAvailability = {
  __typename?: 'StorefrontStoreAvailability';
  /** Whether the product variant is in-stock at this location. */
  available: Scalars['Boolean']['output'];
  /** The location where this product variant is stocked at. */
  location: StorefrontLocation;
  /** Returns the estimated amount of time it takes for pickup to be ready (Example: Usually ready in 24 hours). */
  pickUpTime: Scalars['String']['output'];
  /** The quantity of the product variant in-stock at this location. */
  quantityAvailable: Scalars['Int']['output'];
};

/**
 * An auto-generated type for paginating through multiple StoreAvailabilities.
 *
 */
export type StorefrontStoreAvailabilityConnection = {
  __typename?: 'StorefrontStoreAvailabilityConnection';
  /** A list of edges. */
  edges: Array<StorefrontStoreAvailabilityEdge>;
  /** A list of the nodes contained in StoreAvailabilityEdge. */
  nodes: Array<StorefrontStoreAvailability>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one StoreAvailability and a cursor during pagination.
 *
 */
export type StorefrontStoreAvailabilityEdge = {
  __typename?: 'StorefrontStoreAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of StoreAvailabilityEdge. */
  node: StorefrontStoreAvailability;
};

/**
 * An auto-generated type for paginating through a list of Strings.
 *
 */
export type StorefrontStringConnection = {
  __typename?: 'StorefrontStringConnection';
  /** A list of edges. */
  edges: Array<StorefrontStringEdge>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one String and a cursor during pagination.
 *
 */
export type StorefrontStringEdge = {
  __typename?: 'StorefrontStringEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of StringEdge. */
  node: Scalars['String']['output'];
};

/** An error that occurred during cart submit for completion. */
export type StorefrontSubmissionError = {
  __typename?: 'StorefrontSubmissionError';
  /** The error code. */
  code: StorefrontSubmissionErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** The code of the error that occurred during cart submit for completion. */
export enum StorefrontSubmissionErrorCode {
  BuyerIdentityEmailIsInvalid = 'BUYER_IDENTITY_EMAIL_IS_INVALID',
  BuyerIdentityEmailRequired = 'BUYER_IDENTITY_EMAIL_REQUIRED',
  BuyerIdentityPhoneIsInvalid = 'BUYER_IDENTITY_PHONE_IS_INVALID',
  DeliveryAddress1Invalid = 'DELIVERY_ADDRESS1_INVALID',
  DeliveryAddress1Required = 'DELIVERY_ADDRESS1_REQUIRED',
  DeliveryAddress1TooLong = 'DELIVERY_ADDRESS1_TOO_LONG',
  DeliveryAddress2Invalid = 'DELIVERY_ADDRESS2_INVALID',
  DeliveryAddress2Required = 'DELIVERY_ADDRESS2_REQUIRED',
  DeliveryAddress2TooLong = 'DELIVERY_ADDRESS2_TOO_LONG',
  DeliveryAddressRequired = 'DELIVERY_ADDRESS_REQUIRED',
  DeliveryCityInvalid = 'DELIVERY_CITY_INVALID',
  DeliveryCityRequired = 'DELIVERY_CITY_REQUIRED',
  DeliveryCityTooLong = 'DELIVERY_CITY_TOO_LONG',
  DeliveryCompanyInvalid = 'DELIVERY_COMPANY_INVALID',
  DeliveryCompanyRequired = 'DELIVERY_COMPANY_REQUIRED',
  DeliveryCompanyTooLong = 'DELIVERY_COMPANY_TOO_LONG',
  DeliveryCountryRequired = 'DELIVERY_COUNTRY_REQUIRED',
  DeliveryFirstNameInvalid = 'DELIVERY_FIRST_NAME_INVALID',
  DeliveryFirstNameRequired = 'DELIVERY_FIRST_NAME_REQUIRED',
  DeliveryFirstNameTooLong = 'DELIVERY_FIRST_NAME_TOO_LONG',
  DeliveryInvalidPostalCodeForCountry = 'DELIVERY_INVALID_POSTAL_CODE_FOR_COUNTRY',
  DeliveryInvalidPostalCodeForZone = 'DELIVERY_INVALID_POSTAL_CODE_FOR_ZONE',
  DeliveryLastNameInvalid = 'DELIVERY_LAST_NAME_INVALID',
  DeliveryLastNameRequired = 'DELIVERY_LAST_NAME_REQUIRED',
  DeliveryLastNameTooLong = 'DELIVERY_LAST_NAME_TOO_LONG',
  DeliveryNoDeliveryAvailable = 'DELIVERY_NO_DELIVERY_AVAILABLE',
  DeliveryNoDeliveryAvailableForMerchandiseLine = 'DELIVERY_NO_DELIVERY_AVAILABLE_FOR_MERCHANDISE_LINE',
  DeliveryOptionsPhoneNumberInvalid = 'DELIVERY_OPTIONS_PHONE_NUMBER_INVALID',
  DeliveryOptionsPhoneNumberRequired = 'DELIVERY_OPTIONS_PHONE_NUMBER_REQUIRED',
  DeliveryPhoneNumberInvalid = 'DELIVERY_PHONE_NUMBER_INVALID',
  DeliveryPhoneNumberRequired = 'DELIVERY_PHONE_NUMBER_REQUIRED',
  DeliveryPostalCodeInvalid = 'DELIVERY_POSTAL_CODE_INVALID',
  DeliveryPostalCodeRequired = 'DELIVERY_POSTAL_CODE_REQUIRED',
  DeliveryZoneNotFound = 'DELIVERY_ZONE_NOT_FOUND',
  DeliveryZoneRequiredForCountry = 'DELIVERY_ZONE_REQUIRED_FOR_COUNTRY',
  Error = 'ERROR',
  MerchandiseLineLimitReached = 'MERCHANDISE_LINE_LIMIT_REACHED',
  MerchandiseNotApplicable = 'MERCHANDISE_NOT_APPLICABLE',
  MerchandiseNotEnoughStockAvailable = 'MERCHANDISE_NOT_ENOUGH_STOCK_AVAILABLE',
  MerchandiseOutOfStock = 'MERCHANDISE_OUT_OF_STOCK',
  MerchandiseProductNotPublished = 'MERCHANDISE_PRODUCT_NOT_PUBLISHED',
  NoDeliveryGroupSelected = 'NO_DELIVERY_GROUP_SELECTED',
  PaymentsAddress1Invalid = 'PAYMENTS_ADDRESS1_INVALID',
  PaymentsAddress1Required = 'PAYMENTS_ADDRESS1_REQUIRED',
  PaymentsAddress1TooLong = 'PAYMENTS_ADDRESS1_TOO_LONG',
  PaymentsAddress2Invalid = 'PAYMENTS_ADDRESS2_INVALID',
  PaymentsAddress2Required = 'PAYMENTS_ADDRESS2_REQUIRED',
  PaymentsAddress2TooLong = 'PAYMENTS_ADDRESS2_TOO_LONG',
  PaymentsBillingAddressZoneNotFound = 'PAYMENTS_BILLING_ADDRESS_ZONE_NOT_FOUND',
  PaymentsBillingAddressZoneRequiredForCountry = 'PAYMENTS_BILLING_ADDRESS_ZONE_REQUIRED_FOR_COUNTRY',
  PaymentsCityInvalid = 'PAYMENTS_CITY_INVALID',
  PaymentsCityRequired = 'PAYMENTS_CITY_REQUIRED',
  PaymentsCityTooLong = 'PAYMENTS_CITY_TOO_LONG',
  PaymentsCompanyInvalid = 'PAYMENTS_COMPANY_INVALID',
  PaymentsCompanyRequired = 'PAYMENTS_COMPANY_REQUIRED',
  PaymentsCompanyTooLong = 'PAYMENTS_COMPANY_TOO_LONG',
  PaymentsCountryRequired = 'PAYMENTS_COUNTRY_REQUIRED',
  PaymentsCreditCardBaseExpired = 'PAYMENTS_CREDIT_CARD_BASE_EXPIRED',
  PaymentsCreditCardBaseGatewayNotSupported = 'PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED',
  PaymentsCreditCardBaseInvalidStartDateOrIssueNumberForDebit = 'PAYMENTS_CREDIT_CARD_BASE_INVALID_START_DATE_OR_ISSUE_NUMBER_FOR_DEBIT',
  PaymentsCreditCardBrandNotSupported = 'PAYMENTS_CREDIT_CARD_BRAND_NOT_SUPPORTED',
  PaymentsCreditCardFirstNameBlank = 'PAYMENTS_CREDIT_CARD_FIRST_NAME_BLANK',
  PaymentsCreditCardGeneric = 'PAYMENTS_CREDIT_CARD_GENERIC',
  PaymentsCreditCardLastNameBlank = 'PAYMENTS_CREDIT_CARD_LAST_NAME_BLANK',
  PaymentsCreditCardMonthInclusion = 'PAYMENTS_CREDIT_CARD_MONTH_INCLUSION',
  PaymentsCreditCardNameInvalid = 'PAYMENTS_CREDIT_CARD_NAME_INVALID',
  PaymentsCreditCardNumberInvalid = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID',
  PaymentsCreditCardNumberInvalidFormat = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT',
  PaymentsCreditCardSessionId = 'PAYMENTS_CREDIT_CARD_SESSION_ID',
  PaymentsCreditCardVerificationValueBlank = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK',
  PaymentsCreditCardVerificationValueInvalidForCardType = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE',
  PaymentsCreditCardYearExpired = 'PAYMENTS_CREDIT_CARD_YEAR_EXPIRED',
  PaymentsCreditCardYearInvalidExpiryYear = 'PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR',
  PaymentsFirstNameInvalid = 'PAYMENTS_FIRST_NAME_INVALID',
  PaymentsFirstNameRequired = 'PAYMENTS_FIRST_NAME_REQUIRED',
  PaymentsFirstNameTooLong = 'PAYMENTS_FIRST_NAME_TOO_LONG',
  PaymentsInvalidPostalCodeForCountry = 'PAYMENTS_INVALID_POSTAL_CODE_FOR_COUNTRY',
  PaymentsInvalidPostalCodeForZone = 'PAYMENTS_INVALID_POSTAL_CODE_FOR_ZONE',
  PaymentsLastNameInvalid = 'PAYMENTS_LAST_NAME_INVALID',
  PaymentsLastNameRequired = 'PAYMENTS_LAST_NAME_REQUIRED',
  PaymentsLastNameTooLong = 'PAYMENTS_LAST_NAME_TOO_LONG',
  PaymentsMethodRequired = 'PAYMENTS_METHOD_REQUIRED',
  PaymentsMethodUnavailable = 'PAYMENTS_METHOD_UNAVAILABLE',
  PaymentsPhoneNumberInvalid = 'PAYMENTS_PHONE_NUMBER_INVALID',
  PaymentsPhoneNumberRequired = 'PAYMENTS_PHONE_NUMBER_REQUIRED',
  PaymentsPostalCodeInvalid = 'PAYMENTS_POSTAL_CODE_INVALID',
  PaymentsPostalCodeRequired = 'PAYMENTS_POSTAL_CODE_REQUIRED',
  PaymentsShopifyPaymentsRequired = 'PAYMENTS_SHOPIFY_PAYMENTS_REQUIRED',
  PaymentsUnacceptablePaymentAmount = 'PAYMENTS_UNACCEPTABLE_PAYMENT_AMOUNT',
  PaymentsWalletContentMissing = 'PAYMENTS_WALLET_CONTENT_MISSING',
  TaxesDeliveryGroupIdNotFound = 'TAXES_DELIVERY_GROUP_ID_NOT_FOUND',
  TaxesLineIdNotFound = 'TAXES_LINE_ID_NOT_FOUND',
  TaxesMustBeDefined = 'TAXES_MUST_BE_DEFINED'
}

/** Cart submit for checkout completion is successful. */
export type StorefrontSubmitAlreadyAccepted = {
  __typename?: 'StorefrontSubmitAlreadyAccepted';
  /** The ID of the cart completion attempt that will be used for polling for the result. */
  attemptId: Scalars['String']['output'];
};

/** Cart submit for checkout completion failed. */
export type StorefrontSubmitFailed = {
  __typename?: 'StorefrontSubmitFailed';
  /** The URL of the checkout for the cart. */
  checkoutUrl?: Maybe<Scalars['StorefrontURL']['output']>;
  /** The list of errors that occurred from executing the mutation. */
  errors: Array<StorefrontSubmissionError>;
};

/** Cart submit for checkout completion is already accepted. */
export type StorefrontSubmitSuccess = {
  __typename?: 'StorefrontSubmitSuccess';
  /** The ID of the cart completion attempt that will be used for polling for the result. */
  attemptId: Scalars['String']['output'];
};

/** Cart submit for checkout completion is throttled. */
export type StorefrontSubmitThrottled = {
  __typename?: 'StorefrontSubmitThrottled';
  /**
   * UTC date time string that indicates the time after which clients should make their next
   * poll request. Any poll requests sent before this time will be ignored. Use this value to schedule the
   * next poll request.
   *
   */
  pollAfter: Scalars['StorefrontDateTime']['output'];
};

/**
 * Specifies the fields required to complete a checkout with
 * a tokenized payment.
 *
 */
export type StorefrontTokenizedPaymentInputV3 = {
  /** The billing address for the payment. */
  billingAddress: StorefrontMailingAddressInput;
  /** A unique client generated key used to avoid duplicate charges. When a duplicate payment is found, the original is returned instead of creating a new one. For more information, refer to [Idempotent requests](https://shopify.dev/api/usage/idempotent-requests). */
  idempotencyKey: Scalars['String']['input'];
  /** Public Hash Key used for AndroidPay payments only. */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** The amount and currency of the payment. */
  paymentAmount: StorefrontMoneyInput;
  /** A simple string or JSON containing the required payment data for the tokenized payment. */
  paymentData: Scalars['String']['input'];
  /** Whether to execute the payment in test mode, if possible. Test mode isn't supported in production stores. Defaults to `false`. */
  test?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of payment token. */
  type: StorefrontPaymentTokenType;
};

/** Represents a resource that you can track the origin of the search traffic. */
export type StorefrontTrackable = {
  /** A URL parameters to be added to a page URL when it is linked from a GraphQL result. This allows for tracking the origin of the traffic. */
  trackingParameters?: Maybe<Scalars['String']['output']>;
};

/** An object representing exchange of money for a product or service. */
export type StorefrontTransaction = {
  __typename?: 'StorefrontTransaction';
  /** The amount of money that the transaction was for. */
  amount: StorefrontMoneyV2;
  /**
   * The amount of money that the transaction was for.
   * @deprecated Use `amount` instead.
   */
  amountV2: StorefrontMoneyV2;
  /** The kind of the transaction. */
  kind: StorefrontTransactionKind;
  /**
   * The status of the transaction.
   * @deprecated Use `statusV2` instead.
   */
  status: StorefrontTransactionStatus;
  /** The status of the transaction. */
  statusV2?: Maybe<StorefrontTransactionStatus>;
  /** Whether the transaction was done in test mode or not. */
  test: Scalars['Boolean']['output'];
};

/** The different kinds of order transactions. */
export enum StorefrontTransactionKind {
  /**
   * An amount reserved against the cardholder's funding source.
   * Money does not change hands until the authorization is captured.
   *
   */
  Authorization = 'AUTHORIZATION',
  /** A transfer of the money that was reserved during the authorization stage. */
  Capture = 'CAPTURE',
  /** Money returned to the customer when they have paid too much. */
  Change = 'CHANGE',
  /** An authorization for a payment taken with an EMV credit card reader. */
  EmvAuthorization = 'EMV_AUTHORIZATION',
  /** An authorization and capture performed together in a single step. */
  Sale = 'SALE'
}

/** Transaction statuses describe the status of a transaction. */
export enum StorefrontTransactionStatus {
  /** There was an error while processing the transaction. */
  Error = 'ERROR',
  /** The transaction failed. */
  Failure = 'FAILURE',
  /** The transaction is pending. */
  Pending = 'PENDING',
  /** The transaction succeeded. */
  Success = 'SUCCESS'
}

/**
 * The measurement used to calculate a unit price for a product variant (e.g. $9.99 / 100ml).
 *
 */
export type StorefrontUnitPriceMeasurement = {
  __typename?: 'StorefrontUnitPriceMeasurement';
  /** The type of unit of measurement for the unit price measurement. */
  measuredType?: Maybe<StorefrontUnitPriceMeasurementMeasuredType>;
  /** The quantity unit for the unit price measurement. */
  quantityUnit?: Maybe<StorefrontUnitPriceMeasurementMeasuredUnit>;
  /** The quantity value for the unit price measurement. */
  quantityValue: Scalars['Float']['output'];
  /** The reference unit for the unit price measurement. */
  referenceUnit?: Maybe<StorefrontUnitPriceMeasurementMeasuredUnit>;
  /** The reference value for the unit price measurement. */
  referenceValue: Scalars['Int']['output'];
};

/** The accepted types of unit of measurement. */
export enum StorefrontUnitPriceMeasurementMeasuredType {
  /** Unit of measurements representing areas. */
  Area = 'AREA',
  /** Unit of measurements representing lengths. */
  Length = 'LENGTH',
  /** Unit of measurements representing volumes. */
  Volume = 'VOLUME',
  /** Unit of measurements representing weights. */
  Weight = 'WEIGHT'
}

/** The valid units of measurement for a unit price measurement. */
export enum StorefrontUnitPriceMeasurementMeasuredUnit {
  /** 100 centiliters equals 1 liter. */
  Cl = 'CL',
  /** 100 centimeters equals 1 meter. */
  Cm = 'CM',
  /** Metric system unit of weight. */
  G = 'G',
  /** 1 kilogram equals 1000 grams. */
  Kg = 'KG',
  /** Metric system unit of volume. */
  L = 'L',
  /** Metric system unit of length. */
  M = 'M',
  /** Metric system unit of area. */
  M2 = 'M2',
  /** 1 cubic meter equals 1000 liters. */
  M3 = 'M3',
  /** 1000 milligrams equals 1 gram. */
  Mg = 'MG',
  /** 1000 milliliters equals 1 liter. */
  Ml = 'ML',
  /** 1000 millimeters equals 1 meter. */
  Mm = 'MM'
}

/** Systems of weights and measures. */
export enum StorefrontUnitSystem {
  /** Imperial system of weights and measures. */
  ImperialSystem = 'IMPERIAL_SYSTEM',
  /** Metric system of weights and measures. */
  MetricSystem = 'METRIC_SYSTEM'
}

/** A redirect on the online store. */
export type StorefrontUrlRedirect = StorefrontNode & {
  __typename?: 'StorefrontUrlRedirect';
  /** The ID of the URL redirect. */
  id: Scalars['ID']['output'];
  /** The old path to be redirected from. When the user visits this path, they'll be redirected to the target location. */
  path: Scalars['String']['output'];
  /** The target location where the user will be redirected to. */
  target: Scalars['String']['output'];
};

/**
 * An auto-generated type for paginating through multiple UrlRedirects.
 *
 */
export type StorefrontUrlRedirectConnection = {
  __typename?: 'StorefrontUrlRedirectConnection';
  /** A list of edges. */
  edges: Array<StorefrontUrlRedirectEdge>;
  /** A list of the nodes contained in UrlRedirectEdge. */
  nodes: Array<StorefrontUrlRedirect>;
  /** Information to aid in pagination. */
  pageInfo: StorefrontPageInfo;
};

/**
 * An auto-generated type which holds one UrlRedirect and a cursor during pagination.
 *
 */
export type StorefrontUrlRedirectEdge = {
  __typename?: 'StorefrontUrlRedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of UrlRedirectEdge. */
  node: StorefrontUrlRedirect;
};

/** Represents an error in the input of a mutation. */
export type StorefrontUserError = StorefrontDisplayableError & {
  __typename?: 'StorefrontUserError';
  /** The path to the input field that caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /** The error message. */
  message: Scalars['String']['output'];
};

/**
 * The input fields for a filter used to view a subset of products in a collection matching a specific variant option.
 *
 */
export type StorefrontVariantOptionFilter = {
  /** The name of the variant option to filter on. */
  name: Scalars['String']['input'];
  /** The value of the variant option to filter on. */
  value: Scalars['String']['input'];
};

/** Represents a Shopify hosted video. */
export type StorefrontVideo = StorefrontMedia & StorefrontNode & {
  __typename?: 'StorefrontVideo';
  /** A word or phrase to share the nature or contents of a media. */
  alt?: Maybe<Scalars['String']['output']>;
  /** A globally-unique ID. */
  id: Scalars['ID']['output'];
  /** The media content type. */
  mediaContentType: StorefrontMediaContentType;
  /** The presentation for a media. */
  presentation?: Maybe<StorefrontMediaPresentation>;
  /** The preview image for the media. */
  previewImage?: Maybe<StorefrontImage>;
  /** The sources for a video. */
  sources: Array<StorefrontVideoSource>;
};

/** Represents a source for a Shopify hosted video. */
export type StorefrontVideoSource = {
  __typename?: 'StorefrontVideoSource';
  /** The format of the video source. */
  format: Scalars['String']['output'];
  /** The height of the video. */
  height: Scalars['Int']['output'];
  /** The video MIME type. */
  mimeType: Scalars['String']['output'];
  /** The URL of the video. */
  url: Scalars['String']['output'];
  /** The width of the video. */
  width: Scalars['Int']['output'];
};

/** Units of measurement for weight. */
export enum StorefrontWeightUnit {
  /** Metric system unit of mass. */
  Grams = 'GRAMS',
  /** 1 kilogram equals 1000 grams. */
  Kilograms = 'KILOGRAMS',
  /** Imperial system unit of mass. */
  Ounces = 'OUNCES',
  /** 1 pound equals 16 ounces. */
  Pounds = 'POUNDS'
}

export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubmitOpeningSuggestionInput = {
  fileId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  openingId: Scalars['String']['input'];
};

export type SubmitOpeningSuggestionResponse = {
  __typename?: 'SubmitOpeningSuggestionResponse';
  suggestion: OpeningSuggestion;
};

export type TrackingInfo = {
  __typename?: 'TrackingInfo';
  company?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateMapmakerFileInput = {
  accessPolicy?: InputMaybe<MapmakerFileAccessPolicy>;
  fileId: Scalars['String']['input'];
  fileUpdatedAt: Scalars['String']['input'];
  inputs?: InputMaybe<Scalars['FeatureInputMap']['input']>;
  licensePolicy?: InputMaybe<MapmakerLicensePolicy>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputScale?: InputMaybe<Scalars['Float']['input']>;
  outputType?: InputMaybe<ProjectOutputType>;
};

export type UpdateMapmakerFileResponse = {
  __typename?: 'UpdateMapmakerFileResponse';
  file: MapmakerFile;
};

export type UpdateOpeningSuggestionInput = {
  fileId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: Scalars['OpeningSuggestionInput']['input'];
  openingId: Scalars['String']['input'];
};

export type UpdateOpeningSuggestionResponse = {
  __typename?: 'UpdateOpeningSuggestionResponse';
  suggestion: OpeningSuggestion;
};

export type WalgreensOrder = {
  __typename?: 'WalgreensOrder';
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  openingIds: Array<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  productDetails: Array<WalgreensOrderProduct>;
  promiseTime: Scalars['String']['output'];
  storeNum: Scalars['Int']['output'];
  user: MapmakerAccount;
  userId: Scalars['String']['output'];
};

export type WalgreensOrderProduct = {
  __typename?: 'WalgreensOrderProduct';
  imageDetails: Array<WalgreensOrderProductImage>;
  productId: Scalars['String']['output'];
};

export type WalgreensOrderProductImage = {
  __typename?: 'WalgreensOrderProductImage';
  qty: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type WalgreensOrderStatus = {
  __typename?: 'WalgreensOrderStatus';
  code?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['String']['output'];
  orderStatus?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type WalgreensProduct = {
  __typename?: 'WalgreensProduct';
  /** Board Back Color (Floating Frames only) */
  backerBoardColor?: Maybe<Scalars['String']['output']>;
  /** The number of times the image is printed for this product */
  boxQty?: Maybe<Scalars['String']['output']>;
  /** Dots Per Inch (Creative products only) */
  dpi?: Maybe<Scalars['Int']['output']>;
  /** Y || N (Creative products only) */
  multiImageIndicator?: Maybe<Scalars['String']['output']>;
  /** Offset height from edge of image for product */
  offsetHeight?: Maybe<Scalars['Float']['output']>;
  /** Offset width from edge of image for product */
  offsetWidth?: Maybe<Scalars['Float']['output']>;
  /** A portrait template url (Creative Products only) */
  portraitTemplateUrl?: Maybe<Scalars['String']['output']>;
  /** 4x6 Internet Print */
  productDesc?: Maybe<Scalars['String']['output']>;
  /** STDPR */
  productGroupId?: Maybe<Scalars['String']['output']>;
  /** The Product Id */
  productId?: Maybe<Scalars['String']['output']>;
  /** The price of the product, ex 0.01 */
  productPrice: Scalars['Float']['output'];
  /** 4x6 */
  productSize?: Maybe<Scalars['String']['output']>;
  /** Resolution height (Creative products only) */
  resHeight?: Maybe<Scalars['Int']['output']>;
  /** Resolution width (Creative products only) */
  resWidth?: Maybe<Scalars['Int']['output']>;
  /** A template url (Creative Products only) */
  templateUrl?: Maybe<Scalars['String']['output']>;
  /** Limit of Product per Order (Creative Products only) */
  vendorQtyLimit?: Maybe<Scalars['Int']['output']>;
  /** Wood Frame Color (Floating Frames only) */
  woodFrameColor?: Maybe<Scalars['String']['output']>;
};

export type WalgreensStore = {
  __typename?: 'WalgreensStore';
  city: Scalars['String']['output'];
  closeTime?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  distanceUnit?: Maybe<Scalars['String']['output']>;
  extendedHours?: Maybe<Scalars['String']['output']>;
  holidayEventName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  openTime?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  promiseTime: Scalars['String']['output'];
  state: Scalars['String']['output'];
  storeName?: Maybe<Scalars['String']['output']>;
  storeNum: Scalars['Int']['output'];
  street: Scalars['String']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type WalgreensStoresInput = {
  productDetails?: InputMaybe<Array<InputMaybe<ProductDetailsInput>>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type WalgreensSubmitOrderInput = {
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  openingIds: Array<InputMaybe<Scalars['String']['input']>>;
  phone: Scalars['String']['input'];
  productDetails: Array<OrderProductDetailsInput>;
  promiseTime: Scalars['String']['input'];
  storeNum: Scalars['Int']['input'];
};

export type WalgreensSubmitOrderResponse = {
  __typename?: 'WalgreensSubmitOrderResponse';
  walgreensOrderId: Scalars['String']['output'];
};

export type WalgreensValidateCouponInput = {
  couponCode: Scalars['String']['input'];
  productDetails: Array<ProductDetailsInput>;
};

export type WalgreensValidateCouponResponse = {
  __typename?: 'WalgreensValidateCouponResponse';
  orderDiscountPrice: Scalars['Float']['output'];
  orderTotalPrice: Scalars['Float']['output'];
};

export type Youtube = {
  __typename?: 'Youtube';
  _key?: Maybe<Scalars['String']['output']>;
  _type?: Maybe<Scalars['String']['output']>;
  videoId?: Maybe<Scalars['String']['output']>;
};

export type YoutubeFilter = {
  _key?: InputMaybe<StringFilter>;
  _type?: InputMaybe<StringFilter>;
  videoId?: InputMaybe<StringFilter>;
};

export type YoutubeSorting = {
  _key?: InputMaybe<SortOrder>;
  _type?: InputMaybe<SortOrder>;
  videoId?: InputMaybe<SortOrder>;
};

type MapmakerAccount_MapmakerAuthenticatedAccount_Fragment = { __typename?: 'MapmakerAuthenticatedAccount', id: string, mapmakerFileCount: number, email: string, stickerTokenBalance: number };

type MapmakerAccount_MapmakerUnauthenticatedAccount_Fragment = { __typename?: 'MapmakerUnauthenticatedAccount', id: string, mapmakerFileCount: number };

export type MapmakerAccountFragment = MapmakerAccount_MapmakerAuthenticatedAccount_Fragment | MapmakerAccount_MapmakerUnauthenticatedAccount_Fragment;

export type MapmakerAuthenticatedAccountFragment = { __typename?: 'MapmakerAuthenticatedAccount', email: string, stickerTokenBalance: number };

export type GetAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'MapmakerAuthenticatedAccount', id: string, mapmakerFileCount: number, email: string, stickerTokenBalance: number } | { __typename?: 'MapmakerUnauthenticatedAccount', id: string, mapmakerFileCount: number } | null };

export type MapmakerDesignLiteFragment = { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> };

export type MapmakerDesignHeavyFragment = { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> };

export type GetDesignQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDesignQuery = { __typename?: 'Query', design: { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } };

export type MapmakerFileBaseFragment = { __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number };

export type MapmakerFileLiteFragment = { __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } };

export type OpeningSuggestionFragment = { __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput };

export type MapmakerFileAccessFragment = { __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole };

export type MapmakerFileHeavyFragment = { __typename?: 'MapmakerFile', inputs: FeatureInputMap, id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, fileAccesses: Array<{ __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole }>, openingSuggestions: Array<{ __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput }>, design: { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } };

export type GetFileWithDesignQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetFileWithDesignQuery = { __typename?: 'Query', file?: { __typename?: 'MapmakerFile', inputs: FeatureInputMap, id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, fileAccesses: Array<{ __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole }>, openingSuggestions: Array<{ __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput }>, design: { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } } | null };

export type CreateFileMutationVariables = Exact<{
  input: CreateMapmakerFileInput;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createMapmakerFile: { __typename?: 'CreateMapmakerFileResponse', file: { __typename?: 'MapmakerFile', inputs: FeatureInputMap, id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, fileAccesses: Array<{ __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole }>, openingSuggestions: Array<{ __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput }>, design: { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } } } };

export type UpdateFileMutationVariables = Exact<{
  input: UpdateMapmakerFileInput;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateMapmakerFile: { __typename?: 'UpdateMapmakerFileResponse', file: { __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } } } };

export type UpdateFileHeavyMutationVariables = Exact<{
  input: UpdateMapmakerFileInput;
}>;


export type UpdateFileHeavyMutation = { __typename?: 'Mutation', updateMapmakerFile: { __typename?: 'UpdateMapmakerFileResponse', file: { __typename?: 'MapmakerFile', inputs: FeatureInputMap, id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, fileAccesses: Array<{ __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole }>, openingSuggestions: Array<{ __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput }>, design: { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } } } };

export type DeleteFileMutationVariables = Exact<{
  input: DeleteMapmakerFileInput;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteMapmakerFile: { __typename?: 'DeleteMapmakerFileResponse', file: { __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } } } };

export type StickerOrderItemFragment = { __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } };

export type StickerOrderFragment = { __typename?: 'StickerOrder', id: string, businessId: string, createdAt: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } }> };

export type GetStickerOrderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetStickerOrderQuery = { __typename?: 'Query', stickerOrder: { __typename?: 'StickerOrder', id: string, businessId: string, createdAt: string, outputType: ProjectOutputType, file: { __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } }, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } }> } };

export type GetStickerOrdersQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetStickerOrdersQuery = { __typename?: 'Query', stickerOrders: Array<{ __typename?: 'StickerOrder', id: string, businessId: string, createdAt: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } }> }> };

export type CreateStickerOrderMutationVariables = Exact<{
  input: CreateStickerOrderInput;
}>;


export type CreateStickerOrderMutation = { __typename?: 'Mutation', createStickerOrder: { __typename?: 'StickerOrder', id: string, businessId: string, createdAt: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } }> } };

export type PresignedImageUploadMutationVariables = Exact<{ [key: string]: never; }>;


export type PresignedImageUploadMutation = { __typename?: 'Mutation', presignedImageUpload?: { __typename?: 'PresignedPost', url: string, fields: any, expires: any } | null };

export type StickerVariantForPricingFragment = { __typename?: 'StorefrontProductVariant', id: string, title: string, priceV2: { __typename?: 'StorefrontMoneyV2', currencyCode: StorefrontCurrencyCode, amount: string }, stickerSizeClass?: { __typename?: 'StorefrontMetafield', value: string } | null, stickerOutputType?: { __typename?: 'StorefrontMetafield', value: string } | null, stickerTokens?: { __typename?: 'StorefrontMetafield', value: string } | null, tokenRedemptionVariant?: { __typename?: 'StorefrontMetafield', value: string } | null };

export type GetStickerProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStickerProductsQuery = { __typename?: 'Query', stickers?: { __typename?: 'StorefrontCollection', products: { __typename?: 'StorefrontProductConnection', edges: Array<{ __typename?: 'StorefrontProductEdge', node: { __typename?: 'StorefrontProduct', id: string, variants: { __typename?: 'StorefrontProductVariantConnection', edges: Array<{ __typename?: 'StorefrontProductVariantEdge', node: { __typename?: 'StorefrontProductVariant', id: string, title: string, priceV2: { __typename?: 'StorefrontMoneyV2', currencyCode: StorefrontCurrencyCode, amount: string }, stickerSizeClass?: { __typename?: 'StorefrontMetafield', value: string } | null, stickerOutputType?: { __typename?: 'StorefrontMetafield', value: string } | null, stickerTokens?: { __typename?: 'StorefrontMetafield', value: string } | null, tokenRedemptionVariant?: { __typename?: 'StorefrontMetafield', value: string } | null } }> } } }> } } | null };

export type StorefrontCheckoutLightFragment = { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, quantity: number } }> } };

export type StorefrontCartLightFragment = { __typename?: 'StorefrontCart', id: string, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', quantity: number, merchandise: { __typename?: 'StorefrontProductVariant', id: string } } | { __typename?: 'StorefrontComponentizableCartLine', quantity: number, merchandise: { __typename?: 'StorefrontProductVariant', id: string } } }> } };

export type StorefrontGetCheckoutLightQueryVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
}>;


export type StorefrontGetCheckoutLightQuery = { __typename?: 'Query', storefrontCheckout?: { __typename?: 'StorefrontAppliedGiftCard', id: string } | { __typename?: 'StorefrontArticle', id: string } | { __typename?: 'StorefrontBlog', id: string } | { __typename?: 'StorefrontCart', id: string } | { __typename?: 'StorefrontCartLine', id: string } | { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, quantity: number } }> } } | { __typename?: 'StorefrontCheckoutLineItem', id: string } | { __typename?: 'StorefrontCollection', id: string } | { __typename?: 'StorefrontComment', id: string } | { __typename?: 'StorefrontComponentizableCartLine', id: string } | { __typename?: 'StorefrontExternalVideo', id: string } | { __typename?: 'StorefrontGenericFile', id: string } | { __typename?: 'StorefrontLocation', id: string } | { __typename?: 'StorefrontMailingAddress', id: string } | { __typename?: 'StorefrontMarket', id: string } | { __typename?: 'StorefrontMediaImage', id: string } | { __typename?: 'StorefrontMediaPresentation', id: string } | { __typename?: 'StorefrontMenu', id: string } | { __typename?: 'StorefrontMenuItem', id: string } | { __typename?: 'StorefrontMetafield', id: string } | { __typename?: 'StorefrontMetaobject', id: string } | { __typename?: 'StorefrontModel3d', id: string } | { __typename?: 'StorefrontOrder', id: string } | { __typename?: 'StorefrontPage', id: string } | { __typename?: 'StorefrontPayment', id: string } | { __typename?: 'StorefrontProduct', id: string } | { __typename?: 'StorefrontProductOption', id: string } | { __typename?: 'StorefrontProductVariant', id: string } | { __typename?: 'StorefrontShop', id: string } | { __typename?: 'StorefrontShopPolicy', id: string } | { __typename?: 'StorefrontUrlRedirect', id: string } | { __typename?: 'StorefrontVideo', id: string } | null };

export type StorefrontGetCartLightQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type StorefrontGetCartLightQuery = { __typename?: 'Query', storefrontCart?: { __typename?: 'StorefrontAppliedGiftCard', id: string } | { __typename?: 'StorefrontArticle', id: string } | { __typename?: 'StorefrontBlog', id: string } | { __typename?: 'StorefrontCart', id: string, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', quantity: number, merchandise: { __typename?: 'StorefrontProductVariant', id: string } } | { __typename?: 'StorefrontComponentizableCartLine', quantity: number, merchandise: { __typename?: 'StorefrontProductVariant', id: string } } }> } } | { __typename?: 'StorefrontCartLine', id: string } | { __typename?: 'StorefrontCheckout', id: string } | { __typename?: 'StorefrontCheckoutLineItem', id: string } | { __typename?: 'StorefrontCollection', id: string } | { __typename?: 'StorefrontComment', id: string } | { __typename?: 'StorefrontComponentizableCartLine', id: string } | { __typename?: 'StorefrontExternalVideo', id: string } | { __typename?: 'StorefrontGenericFile', id: string } | { __typename?: 'StorefrontLocation', id: string } | { __typename?: 'StorefrontMailingAddress', id: string } | { __typename?: 'StorefrontMarket', id: string } | { __typename?: 'StorefrontMediaImage', id: string } | { __typename?: 'StorefrontMediaPresentation', id: string } | { __typename?: 'StorefrontMenu', id: string } | { __typename?: 'StorefrontMenuItem', id: string } | { __typename?: 'StorefrontMetafield', id: string } | { __typename?: 'StorefrontMetaobject', id: string } | { __typename?: 'StorefrontModel3d', id: string } | { __typename?: 'StorefrontOrder', id: string } | { __typename?: 'StorefrontPage', id: string } | { __typename?: 'StorefrontPayment', id: string } | { __typename?: 'StorefrontProduct', id: string } | { __typename?: 'StorefrontProductOption', id: string } | { __typename?: 'StorefrontProductVariant', id: string } | { __typename?: 'StorefrontShop', id: string } | { __typename?: 'StorefrontShopPolicy', id: string } | { __typename?: 'StorefrontUrlRedirect', id: string } | { __typename?: 'StorefrontVideo', id: string } | null };

export type StorefrontCreateCheckoutMutationVariables = Exact<{
  input: StorefrontCheckoutCreateInput;
}>;


export type StorefrontCreateCheckoutMutation = { __typename?: 'Mutation', storefrontCheckoutCreate?: { __typename?: 'StorefrontCheckoutCreatePayload', checkout?: { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | null } | null };

export type StorefrontCartCreateMutationVariables = Exact<{
  input: StorefrontCartInput;
}>;


export type StorefrontCartCreateMutation = { __typename?: 'Mutation', storefrontCartCreate?: { __typename?: 'StorefrontCartCreatePayload', cart?: { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } } | null } | null };

export type StorefrontAddCheckoutLineItemsMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  lineItems: Array<StorefrontCheckoutLineItemInput> | StorefrontCheckoutLineItemInput;
}>;


export type StorefrontAddCheckoutLineItemsMutation = { __typename?: 'Mutation', storefrontCheckoutLineItemsAdd?: { __typename?: 'StorefrontCheckoutLineItemsAddPayload', checkout?: { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | null } | null };

export type StorefrontAddCartLinesMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  lines: Array<StorefrontCartLineInput> | StorefrontCartLineInput;
}>;


export type StorefrontAddCartLinesMutation = { __typename?: 'Mutation', storefrontCartLinesAdd?: { __typename?: 'StorefrontCartLinesAddPayload', cart?: { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } } | null } | null };

export type BlogPostCardFragment = { __typename?: 'Post', _id?: string | null, title?: string | null, publishedAt?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null, author?: { __typename?: 'Author', name?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, mainImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', _id?: string | null, url?: string | null, path?: string | null, assetId?: string | null, extension?: string | null } | null } | null };

export type BlogPostFragment = { __typename?: 'Post', _id?: string | null, title?: string | null, publishedAt?: any | null, bodyRaw?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null, author?: { __typename?: 'Author', name?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, mainImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', _id?: string | null, url?: string | null, path?: string | null, assetId?: string | null, extension?: string | null } | null } | null };

export type BlogPostQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BlogPostQuery = { __typename?: 'Query', post: Array<{ __typename?: 'Post', _id?: string | null, title?: string | null, publishedAt?: any | null, bodyRaw?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null, author?: { __typename?: 'Author', name?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, mainImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', _id?: string | null, url?: string | null, path?: string | null, assetId?: string | null, extension?: string | null } | null } | null }>, recentPosts: Array<{ __typename?: 'Post', _id?: string | null, title?: string | null, publishedAt?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null, author?: { __typename?: 'Author', name?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, mainImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', _id?: string | null, url?: string | null, path?: string | null, assetId?: string | null, extension?: string | null } | null } | null }> };

export type AllPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPostsQuery = { __typename?: 'Query', allPost: Array<{ __typename?: 'Post', _id?: string | null, title?: string | null, publishedAt?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null, author?: { __typename?: 'Author', name?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, mainImage?: { __typename?: 'Image', asset?: { __typename?: 'SanityImageAsset', _id?: string | null, url?: string | null, path?: string | null, assetId?: string | null, extension?: string | null } | null } | null }> };

export type StorefrontCheckoutHeavyFragment = { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } };

export type StorefrontGetCheckoutHeavyQueryVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
}>;


export type StorefrontGetCheckoutHeavyQuery = { __typename?: 'Query', storefrontCheckout?: { __typename?: 'StorefrontAppliedGiftCard', id: string } | { __typename?: 'StorefrontArticle', id: string } | { __typename?: 'StorefrontBlog', id: string } | { __typename?: 'StorefrontCart', id: string } | { __typename?: 'StorefrontCartLine', id: string } | { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | { __typename?: 'StorefrontCheckoutLineItem', id: string } | { __typename?: 'StorefrontCollection', id: string } | { __typename?: 'StorefrontComment', id: string } | { __typename?: 'StorefrontComponentizableCartLine', id: string } | { __typename?: 'StorefrontExternalVideo', id: string } | { __typename?: 'StorefrontGenericFile', id: string } | { __typename?: 'StorefrontLocation', id: string } | { __typename?: 'StorefrontMailingAddress', id: string } | { __typename?: 'StorefrontMarket', id: string } | { __typename?: 'StorefrontMediaImage', id: string } | { __typename?: 'StorefrontMediaPresentation', id: string } | { __typename?: 'StorefrontMenu', id: string } | { __typename?: 'StorefrontMenuItem', id: string } | { __typename?: 'StorefrontMetafield', id: string } | { __typename?: 'StorefrontMetaobject', id: string } | { __typename?: 'StorefrontModel3d', id: string } | { __typename?: 'StorefrontOrder', id: string } | { __typename?: 'StorefrontPage', id: string } | { __typename?: 'StorefrontPayment', id: string } | { __typename?: 'StorefrontProduct', id: string } | { __typename?: 'StorefrontProductOption', id: string } | { __typename?: 'StorefrontProductVariant', id: string } | { __typename?: 'StorefrontShop', id: string } | { __typename?: 'StorefrontShopPolicy', id: string } | { __typename?: 'StorefrontUrlRedirect', id: string } | { __typename?: 'StorefrontVideo', id: string } | null };

export type StorefrontRemoveCheckoutLineItemsMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  lineItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type StorefrontRemoveCheckoutLineItemsMutation = { __typename?: 'Mutation', storefrontCheckoutLineItemsRemove?: { __typename?: 'StorefrontCheckoutLineItemsRemovePayload', checkout?: { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | null } | null };

export type StorefrontCartHeavyFragment = { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } };

export type StorefrontGetCartHeavyQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;


export type StorefrontGetCartHeavyQuery = { __typename?: 'Query', storefrontCart?: { __typename?: 'StorefrontAppliedGiftCard', id: string } | { __typename?: 'StorefrontArticle', id: string } | { __typename?: 'StorefrontBlog', id: string } | { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } } | { __typename?: 'StorefrontCartLine', id: string } | { __typename?: 'StorefrontCheckout', id: string } | { __typename?: 'StorefrontCheckoutLineItem', id: string } | { __typename?: 'StorefrontCollection', id: string } | { __typename?: 'StorefrontComment', id: string } | { __typename?: 'StorefrontComponentizableCartLine', id: string } | { __typename?: 'StorefrontExternalVideo', id: string } | { __typename?: 'StorefrontGenericFile', id: string } | { __typename?: 'StorefrontLocation', id: string } | { __typename?: 'StorefrontMailingAddress', id: string } | { __typename?: 'StorefrontMarket', id: string } | { __typename?: 'StorefrontMediaImage', id: string } | { __typename?: 'StorefrontMediaPresentation', id: string } | { __typename?: 'StorefrontMenu', id: string } | { __typename?: 'StorefrontMenuItem', id: string } | { __typename?: 'StorefrontMetafield', id: string } | { __typename?: 'StorefrontMetaobject', id: string } | { __typename?: 'StorefrontModel3d', id: string } | { __typename?: 'StorefrontOrder', id: string } | { __typename?: 'StorefrontPage', id: string } | { __typename?: 'StorefrontPayment', id: string } | { __typename?: 'StorefrontProduct', id: string } | { __typename?: 'StorefrontProductOption', id: string } | { __typename?: 'StorefrontProductVariant', id: string } | { __typename?: 'StorefrontShop', id: string } | { __typename?: 'StorefrontShopPolicy', id: string } | { __typename?: 'StorefrontUrlRedirect', id: string } | { __typename?: 'StorefrontVideo', id: string } | null };

export type StorefrontCartLinesRemoveMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  lineIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type StorefrontCartLinesRemoveMutation = { __typename?: 'Mutation', storefrontCartLinesRemove?: { __typename?: 'StorefrontCartLinesRemovePayload', cart?: { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } } | null } | null };

export type GetStickerOrdersForCartPageQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetStickerOrdersForCartPageQuery = { __typename?: 'Query', stickerOrders: Array<{ __typename?: 'StickerOrder', id: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, quantity: number, render: { __typename?: 'StickerRender', url: string } }>, file: { __typename?: 'MapmakerFile', id: string, backupVersion: string, name: string, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number }> } } }> };

export type StorefrontUpdateCheckoutAttributesMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  input: StorefrontCheckoutAttributesUpdateV2Input;
}>;


export type StorefrontUpdateCheckoutAttributesMutation = { __typename?: 'Mutation', storefrontCheckoutAttributesUpdateV2?: { __typename?: 'StorefrontCheckoutAttributesUpdateV2Payload', checkout?: { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | null } | null };

export type StorefrontCartNoteUpdateMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;


export type StorefrontCartNoteUpdateMutation = { __typename?: 'Mutation', storefrontCartNoteUpdate?: { __typename?: 'StorefrontCartNoteUpdatePayload', cart?: { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } } | null } | null };

type StorefrontDiscountApplication_StorefrontAutomaticDiscountApplication_Fragment = { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } };

type StorefrontDiscountApplication_StorefrontDiscountCodeApplication_Fragment = { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } };

type StorefrontDiscountApplication_StorefrontManualDiscountApplication_Fragment = { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } };

type StorefrontDiscountApplication_StorefrontScriptDiscountApplication_Fragment = { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } };

export type StorefrontDiscountApplicationFragment = StorefrontDiscountApplication_StorefrontAutomaticDiscountApplication_Fragment | StorefrontDiscountApplication_StorefrontDiscountCodeApplication_Fragment | StorefrontDiscountApplication_StorefrontManualDiscountApplication_Fragment | StorefrontDiscountApplication_StorefrontScriptDiscountApplication_Fragment;

export type StorefrontUpdateCheckoutLineItemsMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  lineItems: Array<StorefrontCheckoutLineItemUpdateInput> | StorefrontCheckoutLineItemUpdateInput;
}>;


export type StorefrontUpdateCheckoutLineItemsMutation = { __typename?: 'Mutation', storefrontCheckoutLineItemsUpdate?: { __typename?: 'StorefrontCheckoutLineItemsUpdatePayload', checkout?: { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | null } | null };

export type StorefrontUpdateCartLinesMutationVariables = Exact<{
  cartId: Scalars['ID']['input'];
  lines: Array<StorefrontCartLineUpdateInput> | StorefrontCartLineUpdateInput;
}>;


export type StorefrontUpdateCartLinesMutation = { __typename?: 'Mutation', storefrontCartLinesUpdate?: { __typename?: 'StorefrontCartLinesUpdatePayload', cart?: { __typename?: 'StorefrontCart', id: string, checkoutUrl: string, note?: string | null, cost: { __typename?: 'StorefrontCartCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, lines: { __typename?: 'StorefrontBaseCartLineConnection', edges: Array<{ __typename?: 'StorefrontBaseCartLineEdge', node: { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } | { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } } }> } } | null } | null };

export type StorefrontDiscountAllocationFragment = { __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } };

export type StorefrontCheckoutLineItemHeavyFragment = { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null };

type StorefrontCartLineHeavy_StorefrontCartLine_Fragment = { __typename?: 'StorefrontCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } };

type StorefrontCartLineHeavy_StorefrontComponentizableCartLine_Fragment = { __typename?: 'StorefrontComponentizableCartLine', id: string, quantity: number, cost: { __typename?: 'StorefrontCartLineCost', subtotalAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, attributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, merchandise: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } };

export type StorefrontCartLineHeavyFragment = StorefrontCartLineHeavy_StorefrontCartLine_Fragment | StorefrontCartLineHeavy_StorefrontComponentizableCartLine_Fragment;

export type StickerOrderForLineItemFragment = { __typename?: 'StickerOrder', id: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, quantity: number, render: { __typename?: 'StickerRender', url: string } }>, file: { __typename?: 'MapmakerFile', id: string, backupVersion: string, name: string, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number }> } } };

export type GetDesignsAndFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDesignsAndFilesQuery = { __typename?: 'Query', designs: Array<{ __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> }>, files: Array<{ __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } }>, sharedFiles: Array<{ __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } }> };

export type GetDesignsQueryVariables = Exact<{
  request?: InputMaybe<GetMapmakerDesignsRequest>;
}>;


export type GetDesignsQuery = { __typename?: 'Query', designs: Array<{ __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> }> };

export type NavigationByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  pageSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavigationByIdQuery = { __typename?: 'Query', allNavigation: Array<{ __typename?: 'Navigation', _id?: string | null, title?: string | null, children?: Array<{ __typename?: 'NavigationLink', _key?: string | null, title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, children?: Array<{ __typename?: 'NavigationLink', title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, children?: Array<{ __typename?: 'NavigationLink', title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null } | null> | null } | null> | null } | null> | null }>, allPage: Array<{ __typename?: 'Page', _id?: string | null, title?: string | null, contentRaw?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null }> };

export type CreateTicketMutationVariables = Exact<{
  input?: InputMaybe<CreateTicketInput>;
}>;


export type CreateTicketMutation = { __typename?: 'Mutation', createTicket?: { __typename?: 'CreateTicketResult', created: boolean } | null };

export type NavigationFragment = { __typename?: 'Navigation', _id?: string | null, title?: string | null, children?: Array<{ __typename?: 'NavigationLink', _key?: string | null, title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, children?: Array<{ __typename?: 'NavigationLink', title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, children?: Array<{ __typename?: 'NavigationLink', title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null } | null> | null } | null> | null } | null> | null };

export type NavigationLinkTargetFragment = { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null };

export type NavigationLinkFragment = { __typename?: 'NavigationLink', _key?: string | null, title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, children?: Array<{ __typename?: 'NavigationLink', title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null, children?: Array<{ __typename?: 'NavigationLink', title?: string | null, hidden?: boolean | null, target?: { __typename?: 'Page', _id?: string | null, title?: string | null, slug?: { __typename?: 'Slug', current?: string | null } | null } | null } | null> | null } | null> | null };

export type PageFragment = { __typename?: 'Page', _id?: string | null, title?: string | null, contentRaw?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null };

export type PageBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PageBySlugQuery = { __typename?: 'Query', allPage: Array<{ __typename?: 'Page', _id?: string | null, title?: string | null, contentRaw?: any | null, slug?: { __typename?: 'Slug', current?: string | null } | null }> };

export type GetReferenceQueryVariables = Exact<{
  ref: Scalars['String']['input'];
}>;


export type GetReferenceQuery = { __typename?: 'Query', sanityReference: { __typename?: 'SanityReferenceResult', id: string, slug: string } };

type MapLineItem_BasicLineItem_Fragment = { __typename?: 'BasicLineItem' };

type MapLineItem_MapLineItem_Fragment = { __typename?: 'MapLineItem', blueprintId: string };

type MapLineItem_StickerLineItem_Fragment = { __typename?: 'StickerLineItem' };

type MapLineItem_StickerTokenLineItem_Fragment = { __typename?: 'StickerTokenLineItem' };

export type MapLineItemFragment = MapLineItem_BasicLineItem_Fragment | MapLineItem_MapLineItem_Fragment | MapLineItem_StickerLineItem_Fragment | MapLineItem_StickerTokenLineItem_Fragment;

export type TrackingInfoFragment = { __typename?: 'TrackingInfo', company?: string | null, number?: string | null, url?: string | null };

export type FulfillmentFragment = { __typename?: 'Fulfillment', id: string, createdAt: any, deliveredAt?: any | null, trackingInfo: Array<{ __typename?: 'TrackingInfo', company?: string | null, number?: string | null, url?: string | null }> };

export type RefundFragment = { __typename?: 'Refund', id: string, createdAt: any, totalRefunded: number };

export type OrderDetailsFragment = { __typename?: 'Order', id: string, number: string, createdAt: any, cancelledAt?: any | null, subtotal: number, totalShipping: number, totalTax: number, total: number, billingAddressMatchesShippingAddress: boolean, billingAddressFormatted?: Array<string> | null, shippingAddressFormatted?: Array<string> | null, note?: string | null, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, createdAt: any, deliveredAt?: any | null, trackingInfo: Array<{ __typename?: 'TrackingInfo', company?: string | null, number?: string | null, url?: string | null }> }>, items: Array<{ __typename?: 'BasicLineItem', id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'MapLineItem', blueprintId: string, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerLineItem', stickerOrderId: string, tokensUsed: number, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerTokenLineItem', numTokens: number, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null }>, refunds: Array<{ __typename?: 'Refund', id: string, createdAt: any, totalRefunded: number }> };

type OrderItemDetails_BasicLineItem_Fragment = { __typename?: 'BasicLineItem', id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

type OrderItemDetails_MapLineItem_Fragment = { __typename?: 'MapLineItem', blueprintId: string, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

type OrderItemDetails_StickerLineItem_Fragment = { __typename?: 'StickerLineItem', stickerOrderId: string, tokensUsed: number, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

type OrderItemDetails_StickerTokenLineItem_Fragment = { __typename?: 'StickerTokenLineItem', numTokens: number, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

export type OrderItemDetailsFragment = OrderItemDetails_BasicLineItem_Fragment | OrderItemDetails_MapLineItem_Fragment | OrderItemDetails_StickerLineItem_Fragment | OrderItemDetails_StickerTokenLineItem_Fragment;

export type GetOrderQueryVariables = Exact<{
  number: Scalars['String']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, number: string, createdAt: any, cancelledAt?: any | null, subtotal: number, totalShipping: number, totalTax: number, total: number, billingAddressMatchesShippingAddress: boolean, billingAddressFormatted?: Array<string> | null, shippingAddressFormatted?: Array<string> | null, note?: string | null, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, createdAt: any, deliveredAt?: any | null, trackingInfo: Array<{ __typename?: 'TrackingInfo', company?: string | null, number?: string | null, url?: string | null }> }>, items: Array<{ __typename?: 'BasicLineItem', id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'MapLineItem', blueprintId: string, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerLineItem', stickerOrderId: string, tokensUsed: number, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerTokenLineItem', numTokens: number, id: string, name: string, attributes: any, originalUnitPrice: number, discountedUnitPrice: number, quantity: number, handle: string, description: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null }>, refunds: Array<{ __typename?: 'Refund', id: string, createdAt: any, totalRefunded: number }> } };

export type GetStickerOrdersForOrderDetailsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetStickerOrdersForOrderDetailsQuery = { __typename?: 'Query', stickerOrders: Array<{ __typename?: 'StickerOrder', id: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, quantity: number, render: { __typename?: 'StickerRender', url: string } }>, file: { __typename?: 'MapmakerFile', id: string, backupVersion: string, name: string } }> };

export type OrderLightFragment = { __typename?: 'Order', id: string, number: string, createdAt: any, cancelledAt?: any | null, subtotal: number, totalShipping: number, totalTax: number, total: number, shippingAddressFormatted?: Array<string> | null, items: Array<{ __typename?: 'BasicLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'MapLineItem', id: string, name: string, blueprintId: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerTokenLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null }> };

export type GetOrdersForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersForUserQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, number: string, createdAt: any, cancelledAt?: any | null, subtotal: number, totalShipping: number, totalTax: number, total: number, shippingAddressFormatted?: Array<string> | null, items: Array<{ __typename?: 'BasicLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'MapLineItem', id: string, name: string, blueprintId: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null } | { __typename?: 'StickerTokenLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null }> }> };

type OrderItemLight_BasicLineItem_Fragment = { __typename?: 'BasicLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

type OrderItemLight_MapLineItem_Fragment = { __typename?: 'MapLineItem', id: string, name: string, blueprintId: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

type OrderItemLight_StickerLineItem_Fragment = { __typename?: 'StickerLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

type OrderItemLight_StickerTokenLineItem_Fragment = { __typename?: 'StickerTokenLineItem', id: string, name: string, image?: { __typename?: 'Image', url: string, altText?: string | null } | null };

export type OrderItemLightFragment = OrderItemLight_BasicLineItem_Fragment | OrderItemLight_MapLineItem_Fragment | OrderItemLight_StickerLineItem_Fragment | OrderItemLight_StickerTokenLineItem_Fragment;

export type StickerOrderForStickerLineItemFragment = { __typename?: 'StickerOrder', id: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, quantity: number, render: { __typename?: 'StickerRender', url: string } }>, file: { __typename?: 'MapmakerFile', id: string, backupVersion: string, name: string } };

export type PrivacyPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivacyPolicyQuery = { __typename?: 'Query', storefrontShop: { __typename?: 'StorefrontShop', privacyPolicy?: { __typename?: 'StorefrontShopPolicy', title: string, body: string } | null } };

export type RefundPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type RefundPolicyQuery = { __typename?: 'Query', storefrontShop: { __typename?: 'StorefrontShop', refundPolicy?: { __typename?: 'StorefrontShopPolicy', title: string, body: string } | null } };

export type TermsOfServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type TermsOfServiceQuery = { __typename?: 'Query', storefrontShop: { __typename?: 'StorefrontShop', termsOfService?: { __typename?: 'StorefrontShopPolicy', title: string, body: string } | null } };

export type CreateRectangularPrintsForDownloadMutationVariables = Exact<{
  input?: InputMaybe<CreateRectangularPrintsRequest>;
}>;


export type CreateRectangularPrintsForDownloadMutation = { __typename?: 'Mutation', createRectangularPrints?: { __typename?: 'CreateRectangularPrintsResponse', prints?: Array<{ __typename?: 'RectangularPrintFile', key: string, url: string } | null> | null } | null };

export type StickerOfferFragment = { __typename?: 'StickerOffer', stickers: Array<{ __typename?: 'StickerOfferItem', openingId: string, sizeClass: StickerSizeClass, render: { __typename?: 'StickerRender', url: string } }> };

export type StickerOfferItemFragment = { __typename?: 'StickerOfferItem', openingId: string, sizeClass: StickerSizeClass, render: { __typename?: 'StickerRender', url: string } };

export type GetStickerOfferQueryVariables = Exact<{
  input: StickerOfferInput;
}>;


export type GetStickerOfferQuery = { __typename?: 'Query', stickerOffer: { __typename?: 'StickerOffer', stickers: Array<{ __typename?: 'StickerOfferItem', openingId: string, sizeClass: StickerSizeClass, render: { __typename?: 'StickerRender', url: string } }> } };

export type WalgreensProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type WalgreensProductsQuery = { __typename?: 'Query', walgreensProducts: Array<{ __typename?: 'WalgreensProduct', productId?: string | null, productPrice: number, productSize?: string | null }> };

export type WalgreensSubmitOrderMutationVariables = Exact<{
  input?: InputMaybe<WalgreensSubmitOrderInput>;
}>;


export type WalgreensSubmitOrderMutation = { __typename?: 'Mutation', walgreensSubmitOrder?: { __typename?: 'WalgreensSubmitOrderResponse', walgreensOrderId: string } | null };

export type WalgreensStoreFragment = { __typename?: 'WalgreensStore', storeNum: number, promiseTime: string, zip: string, city: string, state: string, street: string, phone: string, distance?: number | null, distanceUnit?: string | null, openTime?: string | null, closeTime?: string | null, timeZone?: string | null, tax?: number | null };

export type WalgreensStoresQueryVariables = Exact<{
  input: WalgreensStoresInput;
}>;


export type WalgreensStoresQuery = { __typename?: 'Query', walgreensStores: Array<{ __typename?: 'WalgreensStore', storeNum: number, promiseTime: string, zip: string, city: string, state: string, street: string, phone: string, distance?: number | null, distanceUnit?: string | null, openTime?: string | null, closeTime?: string | null, timeZone?: string | null, tax?: number | null }> };

export type CreateRectangularPrintsMutationVariables = Exact<{
  input?: InputMaybe<CreateRectangularPrintsRequest>;
}>;


export type CreateRectangularPrintsMutation = { __typename?: 'Mutation', createRectangularPrints?: { __typename?: 'CreateRectangularPrintsResponse', prints?: Array<{ __typename?: 'RectangularPrintFile', key: string, url: string } | null> | null } | null };

export type StorefrontProductPageProductFragment = { __typename?: 'StorefrontProduct', id: string, title: string, descriptionHtml: string, handle: string, tags: Array<string>, priceRange: { __typename?: 'StorefrontProductPriceRange', maxVariantPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, minVariantPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, options: Array<{ __typename?: 'StorefrontProductOption', id: string, name: string, values: Array<string> }>, images: { __typename?: 'StorefrontImageConnection', edges: Array<{ __typename?: 'StorefrontImageEdge', node: { __typename?: 'StorefrontImage', id?: string | null, altText?: string | null, tinySrc: string, mediumSrc: string, largeSrc: string } }> }, variants: { __typename?: 'StorefrontProductVariantConnection', edges: Array<{ __typename?: 'StorefrontProductVariantEdge', node: { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, availableForSale: boolean, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, image?: { __typename?: 'StorefrontImage', id?: string | null, altText?: string | null, tinySrc: string, mediumSrc: string, largeSrc: string } | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, personalizationType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBlueprintId?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBackground?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputScale?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerDefaultInputs?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } }> }, hideQuantity?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, personalizationType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, freeStickerTokens?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBlueprintId?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBackground?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputScale?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerDefaultInputs?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null };

export type StorefrontProductPageVariantFragment = { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, availableForSale: boolean, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, image?: { __typename?: 'StorefrontImage', id?: string | null, altText?: string | null, tinySrc: string, mediumSrc: string, largeSrc: string } | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, personalizationType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBlueprintId?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBackground?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputScale?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerDefaultInputs?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null };

export type StorefrontProductImageFragment = { __typename?: 'StorefrontImage', id?: string | null, altText?: string | null, tinySrc: string, mediumSrc: string, largeSrc: string };

export type StorefrontGetProductByHandleQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type StorefrontGetProductByHandleQuery = { __typename?: 'Query', product?: { __typename?: 'StorefrontProduct', id: string, title: string, descriptionHtml: string, handle: string, tags: Array<string>, priceRange: { __typename?: 'StorefrontProductPriceRange', maxVariantPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, minVariantPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } }, options: Array<{ __typename?: 'StorefrontProductOption', id: string, name: string, values: Array<string> }>, images: { __typename?: 'StorefrontImageConnection', edges: Array<{ __typename?: 'StorefrontImageEdge', node: { __typename?: 'StorefrontImage', id?: string | null, altText?: string | null, tinySrc: string, mediumSrc: string, largeSrc: string } }> }, variants: { __typename?: 'StorefrontProductVariantConnection', edges: Array<{ __typename?: 'StorefrontProductVariantEdge', node: { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, availableForSale: boolean, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, image?: { __typename?: 'StorefrontImage', id?: string | null, altText?: string | null, tinySrc: string, mediumSrc: string, largeSrc: string } | null, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, personalizationType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBlueprintId?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBackground?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputScale?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerDefaultInputs?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } }> }, hideQuantity?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, personalizationType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, freeStickerTokens?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBlueprintId?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerBackground?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerOutputScale?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null, mapmakerDefaultInputs?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } | null, stickerTokenProduct?: { __typename?: 'StorefrontProduct', id: string, variants: { __typename?: 'StorefrontProductVariantConnection', edges: Array<{ __typename?: 'StorefrontProductVariantEdge', node: { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }> } }> } } | null };

export type StickerTokenProductFragment = { __typename?: 'StorefrontProduct', id: string, variants: { __typename?: 'StorefrontProductVariantConnection', edges: Array<{ __typename?: 'StorefrontProductVariantEdge', node: { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }> } }> } };

export type StickerTokenVariantFragment = { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }> };

export type StickerTokensModalQueryVariables = Exact<{
  designId: Scalars['String']['input'];
  scale: Scalars['Float']['input'];
  outputType: ProjectOutputType;
}>;


export type StickerTokensModalQuery = { __typename?: 'Query', design: { __typename?: 'MapmakerDesign', id: string, name: string, regionType: string, regionTypePlural: string, stickerInfo: { __typename?: 'MapStickerInfo', count: number, tokens: number, sizeClassGroups: Array<{ __typename?: 'StickerSizeClassGroup', count: number, tokens: number, sizeClass: StickerSizeClass }> } }, stickerTokenProduct?: { __typename?: 'StorefrontProduct', id: string, variants: { __typename?: 'StorefrontProductVariantConnection', edges: Array<{ __typename?: 'StorefrontProductVariantEdge', node: { __typename?: 'StorefrontProductVariant', id: string, sku?: string | null, title: string, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }> } }> } } | null };

export type AddMapmakerFileAccessMutationVariables = Exact<{
  input: AddMapmakerFileAccessInput;
}>;


export type AddMapmakerFileAccessMutation = { __typename?: 'Mutation', addMapmakerFileAccess: { __typename?: 'AddMapmakerFileAccessResponse', fileAccess: { __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole } } };

export type DeleteMapmakerFileAccessMutationVariables = Exact<{
  input: DeleteMapmakerFileAccessInput;
}>;


export type DeleteMapmakerFileAccessMutation = { __typename?: 'Mutation', deleteMapmakerFileAccess: { __typename?: 'DeleteMapmakerFileAccessResponse', success: boolean } };

export type DeleteOpeningSuggestionMutationVariables = Exact<{
  input: DeleteOpeningSuggestionInput;
}>;


export type DeleteOpeningSuggestionMutation = { __typename?: 'Mutation', deleteOpeningSuggestion: { __typename?: 'DeleteOpeningSuggestionResponse', success: boolean } };

export type HideOpeningSuggestionMutationVariables = Exact<{
  input: HideOpeningSuggestionInput;
}>;


export type HideOpeningSuggestionMutation = { __typename?: 'Mutation', hideOpeningSuggestion: { __typename?: 'HideOpeningSuggestionResponse', suggestion: { __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput } } };

export type GetOpeningSuggestionQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
  suggestionId: Scalars['String']['input'];
}>;


export type GetOpeningSuggestionQuery = { __typename?: 'Query', openingSuggestion: { __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput } };

export type CreateOpeningSuggestionMutationVariables = Exact<{
  input: CreateOpeningSuggestionInput;
}>;


export type CreateOpeningSuggestionMutation = { __typename?: 'Mutation', createOpeningSuggestion: { __typename?: 'CreateOpeningSuggestionResponse', suggestion: { __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput } } };

export type UpdateOpeningSuggestionMutationVariables = Exact<{
  input: UpdateOpeningSuggestionInput;
}>;


export type UpdateOpeningSuggestionMutation = { __typename?: 'Mutation', updateOpeningSuggestion: { __typename?: 'UpdateOpeningSuggestionResponse', suggestion: { __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput } } };

export type SubmitOpeningSuggestionMutationVariables = Exact<{
  input: SubmitOpeningSuggestionInput;
}>;


export type SubmitOpeningSuggestionMutation = { __typename?: 'Mutation', submitOpeningSuggestion: { __typename?: 'SubmitOpeningSuggestionResponse', suggestion: { __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput } } };

export type StickerOrderForSandboxFragment = { __typename?: 'StickerOrder', id: string, businessId: string, createdAt: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } }>, file: { __typename?: 'MapmakerFile', id: string, inputs: FeatureInputMap, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, height: number, width: number, features: FeatureMap } } };

export type GetStickerOrdersForSandboxQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetStickerOrdersForSandboxQuery = { __typename?: 'Query', stickerOrders: Array<{ __typename?: 'StickerOrder', id: string, businessId: string, createdAt: string, outputType: ProjectOutputType, stickers: Array<{ __typename?: 'StickerOrderItem', openingId: string, sizeClass: StickerSizeClass, quantity: number, quantityWithMoney: number, quantityWithTokens: number, scale: number, render: { __typename?: 'StickerRender', url: string } }>, file: { __typename?: 'MapmakerFile', id: string, inputs: FeatureInputMap, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, height: number, width: number, features: FeatureMap } } }> };

export type RenderMutationVariables = Exact<{
  request: RenderRequest;
}>;


export type RenderMutation = { __typename?: 'Mutation', render: { __typename?: 'RenderResult', url: string } };

export type RenderableDesignFragment = { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, features: FeatureMap };

export type GetRenderableDesignQueryVariables = Exact<{
  designId: Scalars['String']['input'];
}>;


export type GetRenderableDesignQuery = { __typename?: 'Query', design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, features: FeatureMap } };

export type RenderableFileFragment = { __typename?: 'MapmakerFile', id: string, updatedAt: string, name: string, inputs: FeatureInputMap, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, features: FeatureMap } };

export type GetRenderableFileQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type GetRenderableFileQuery = { __typename?: 'Query', file?: { __typename?: 'MapmakerFile', id: string, updatedAt: string, name: string, inputs: FeatureInputMap, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, features: FeatureMap } } | null };

export type RenderableOpeningSuggestionFragment = { __typename?: 'OpeningSuggestion', id: string, fileId: string, openingId: string, input: OpeningSuggestionInput };

export type GetRenderableOpeningSuggestionQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
  openingId: Scalars['String']['input'];
  suggestionId: Scalars['String']['input'];
}>;


export type GetRenderableOpeningSuggestionQuery = { __typename?: 'Query', suggestion: { __typename?: 'OpeningSuggestion', id: string, fileId: string, openingId: string, input: OpeningSuggestionInput } };

export type RenderableFileListQueryVariables = Exact<{ [key: string]: never; }>;


export type RenderableFileListQuery = { __typename?: 'Query', mapmakerFiles: Array<{ __typename?: 'MapmakerFile', id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, design: { __typename?: 'MapmakerDesign', id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } }> };

export type RenderableFileHeavyQueryVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type RenderableFileHeavyQuery = { __typename?: 'Query', mapmakerFile?: { __typename?: 'MapmakerFile', inputs: FeatureInputMap, id: string, name: string, ownerId: string, designId: string, businessId: string, openingsWithImages: number, createdAt: string, updatedAt: string, previewImageUrl: string, accessPolicy: MapmakerFileAccessPolicy, viewerPolicy: MapmakerFileViewerPolicy, deleted: boolean, outputType: ProjectOutputType, outputScale: number, fileAccesses: Array<{ __typename?: 'MapmakerFileAccess', id: string, fileId: string, granteeId?: string | null, granteeEmail: string, granteeHasAccount: boolean, role: FileAccessRole }>, openingSuggestions: Array<{ __typename?: 'OpeningSuggestion', id: string, fileId: string, fileOwnerId: string, openingId: string, suggesterId: string, status: OpeningSuggestionStatus, submittedAt?: string | null, name: string, note?: string | null, input: OpeningSuggestionInput }>, design: { __typename?: 'MapmakerDesign', features: FeatureMap, id: string, businessId: string, name: string, thumbnailUrl: string, width: number, height: number, regionType: string, regionTypePlural: string, regionCount: number, keywords: Array<string>, outputOptions: Array<{ __typename?: 'ProjectOutputOption', type: ProjectOutputType, name: string, scale: number, inputs?: FeatureInputMap | null }> } } | null };

export type RedeemStickerTokenVoucherMutationVariables = Exact<{
  input: RedeemStickerTokenVoucherRequest;
}>;


export type RedeemStickerTokenVoucherMutation = { __typename?: 'Mutation', redeemStickerTokenVoucher: { __typename?: 'RedeemStickerTokenVoucherResponse', transaction: { __typename?: 'StickerTokenTransaction', tokens: number }, account: { __typename?: 'MapmakerAuthenticatedAccount', stickerTokenBalance: number, id: string } | { __typename?: 'MapmakerUnauthenticatedAccount', id: string } } };

export type AccountStickerTokenDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountStickerTokenDataQuery = { __typename?: 'Query', account?: { __typename?: 'MapmakerAuthenticatedAccount', stickerTokenBalance: number, id: string } | { __typename?: 'MapmakerUnauthenticatedAccount', id: string } | null, stickerTokenTransactions: Array<{ __typename?: 'StickerTokenTransaction', id: string, createdAt: string, reason: StickerTokenTransactionReason, tokens: number, startingBalance: number, endingBalance: number, note: string }> };

export type PresignedPostFragment = { __typename?: 'PresignedPost', url: string, fields: any, expires: any };

export type CreatePresignedPostMutationVariables = Exact<{
  folder?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePresignedPostMutation = { __typename?: 'Mutation', createPresignedPost?: { __typename?: 'PresignedPost', url: string, fields: any, expires: any } | null };

export type StorefrontReplaceCheckoutLineItemsMutationVariables = Exact<{
  checkoutId: Scalars['ID']['input'];
  lineItems: Array<StorefrontCheckoutLineItemInput> | StorefrontCheckoutLineItemInput;
}>;


export type StorefrontReplaceCheckoutLineItemsMutation = { __typename?: 'Mutation', storefrontCheckoutLineItemsReplace?: { __typename?: 'StorefrontCheckoutLineItemsReplacePayload', checkout?: { __typename?: 'StorefrontCheckout', id: string, completedAt?: string | null, webUrl: string, note?: string | null, requiresShipping: boolean, totalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalTax: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, subtotalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, totalPriceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, lineItemsSubtotalPrice: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplications: { __typename?: 'StorefrontDiscountApplicationConnection', edges: Array<{ __typename?: 'StorefrontDiscountApplicationEdge', node: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }> }, lineItems: { __typename?: 'StorefrontCheckoutLineItemConnection', edges: Array<{ __typename?: 'StorefrontCheckoutLineItemEdge', node: { __typename?: 'StorefrontCheckoutLineItem', id: string, title: string, quantity: number, unitPrice?: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | null, customAttributes: Array<{ __typename?: 'StorefrontAttribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'StorefrontDiscountAllocation', allocatedAmount: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, discountApplication: { __typename?: 'StorefrontAutomaticDiscountApplication', title: string, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontDiscountCodeApplication', code: string, applicable: boolean, targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontManualDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } | { __typename?: 'StorefrontScriptDiscountApplication', targetSelection: StorefrontDiscountApplicationTargetSelection, targetType: StorefrontDiscountApplicationTargetType, allocationMethod: StorefrontDiscountApplicationAllocationMethod, value: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode } | { __typename?: 'StorefrontPricingPercentageValue', percentage: number } } }>, variant?: { __typename?: 'StorefrontProductVariant', id: string, title: string, sku?: string | null, priceV2: { __typename?: 'StorefrontMoneyV2', amount: string, currencyCode: StorefrontCurrencyCode }, selectedOptions: Array<{ __typename?: 'StorefrontSelectedOption', name: string, value: string }>, image?: { __typename?: 'StorefrontImage', originalSrc: string, transformedSrc: string } | null, product: { __typename?: 'StorefrontProduct', id: string, handle: string, tblProductType?: { __typename?: 'StorefrontMetafield', key: string, value: string } | null } } | null } }> } } | null } | null };

export const MapmakerAuthenticatedAccountFragmentDoc = gql`
    fragment MapmakerAuthenticatedAccount on MapmakerAuthenticatedAccount {
  email
  stickerTokenBalance
}
    `;
export const MapmakerAccountFragmentDoc = gql`
    fragment MapmakerAccount on MapmakerAccount {
  id
  mapmakerFileCount
  ... on MapmakerAuthenticatedAccount {
    ...MapmakerAuthenticatedAccount
  }
}
    ${MapmakerAuthenticatedAccountFragmentDoc}`;
export const MapmakerFileBaseFragmentDoc = gql`
    fragment MapmakerFileBase on MapmakerFile {
  id
  name
  ownerId
  designId
  businessId
  openingsWithImages
  createdAt
  updatedAt
  previewImageUrl
  accessPolicy
  viewerPolicy
  deleted
  outputType
  outputScale
}
    `;
export const MapmakerDesignLiteFragmentDoc = gql`
    fragment MapmakerDesignLite on MapmakerDesign {
  id
  businessId
  name
  thumbnailUrl
  width
  height
  outputOptions {
    type
    name
    scale
    inputs
  }
  regionType
  regionTypePlural
  regionCount
  keywords
}
    `;
export const MapmakerFileLiteFragmentDoc = gql`
    fragment MapmakerFileLite on MapmakerFile {
  ...MapmakerFileBase
  design {
    ...MapmakerDesignLite
  }
}
    ${MapmakerFileBaseFragmentDoc}
${MapmakerDesignLiteFragmentDoc}`;
export const MapmakerFileAccessFragmentDoc = gql`
    fragment MapmakerFileAccess on MapmakerFileAccess {
  id
  fileId
  granteeId
  granteeEmail
  granteeHasAccount
  role
}
    `;
export const OpeningSuggestionFragmentDoc = gql`
    fragment OpeningSuggestion on OpeningSuggestion {
  id
  fileId
  fileOwnerId
  openingId
  suggesterId
  status
  submittedAt
  name
  note
  input
}
    `;
export const MapmakerDesignHeavyFragmentDoc = gql`
    fragment MapmakerDesignHeavy on MapmakerDesign {
  ...MapmakerDesignLite
  features
}
    ${MapmakerDesignLiteFragmentDoc}`;
export const MapmakerFileHeavyFragmentDoc = gql`
    fragment MapmakerFileHeavy on MapmakerFile {
  ...MapmakerFileLite
  inputs
  fileAccesses {
    ...MapmakerFileAccess
  }
  openingSuggestions {
    ...OpeningSuggestion
  }
  design {
    ...MapmakerDesignHeavy
  }
}
    ${MapmakerFileLiteFragmentDoc}
${MapmakerFileAccessFragmentDoc}
${OpeningSuggestionFragmentDoc}
${MapmakerDesignHeavyFragmentDoc}`;
export const StickerOrderItemFragmentDoc = gql`
    fragment StickerOrderItem on StickerOrderItem {
  openingId
  sizeClass
  quantity
  quantityWithMoney
  quantityWithTokens
  scale
  render {
    url
  }
}
    `;
export const StickerOrderFragmentDoc = gql`
    fragment StickerOrder on StickerOrder {
  id
  businessId
  createdAt
  outputType
  stickers {
    ...StickerOrderItem
  }
}
    ${StickerOrderItemFragmentDoc}`;
export const StickerVariantForPricingFragmentDoc = gql`
    fragment StickerVariantForPricing on StorefrontProductVariant {
  id
  title
  priceV2 {
    currencyCode
    amount
  }
  stickerSizeClass: metafield(namespace: "mapmaker", key: "sticker.sizeClass") {
    value
  }
  stickerOutputType: metafield(namespace: "mapmaker", key: "sticker.outputType") {
    value
  }
  stickerTokens: metafield(namespace: "mapmaker", key: "sticker.tokens") {
    value
  }
  tokenRedemptionVariant: metafield(
    namespace: "mapmaker"
    key: "sticker.tokenRedemptionVariant"
  ) {
    value
  }
}
    `;
export const StorefrontCheckoutLightFragmentDoc = gql`
    fragment StorefrontCheckoutLight on StorefrontCheckout {
  id
  completedAt
  lineItems(first: 100) {
    edges {
      node {
        id
        quantity
      }
    }
  }
}
    `;
export const StorefrontCartLightFragmentDoc = gql`
    fragment StorefrontCartLight on StorefrontCart {
  id
  lines(first: 100) {
    edges {
      node {
        quantity
        merchandise {
          ... on StorefrontProductVariant {
            id
          }
        }
      }
    }
  }
}
    `;
export const BlogPostCardFragmentDoc = gql`
    fragment BlogPostCard on Post {
  _id
  title
  slug {
    current
  }
  author {
    name
    slug {
      current
    }
  }
  mainImage {
    asset {
      _id
      url
      path
      assetId
      extension
    }
  }
  publishedAt
}
    `;
export const BlogPostFragmentDoc = gql`
    fragment BlogPost on Post {
  _id
  title
  slug {
    current
  }
  author {
    name
    slug {
      current
    }
  }
  mainImage {
    asset {
      _id
      url
      path
      assetId
      extension
    }
  }
  publishedAt
  bodyRaw
}
    `;
export const StorefrontDiscountApplicationFragmentDoc = gql`
    fragment StorefrontDiscountApplication on StorefrontDiscountApplication {
  targetSelection
  targetType
  allocationMethod
  value {
    ... on StorefrontMoneyV2 {
      amount
      currencyCode
    }
    ... on StorefrontPricingPercentageValue {
      percentage
    }
  }
  ... on StorefrontAutomaticDiscountApplication {
    title
  }
  ... on StorefrontDiscountCodeApplication {
    code
    applicable
  }
}
    `;
export const StorefrontDiscountAllocationFragmentDoc = gql`
    fragment StorefrontDiscountAllocation on StorefrontDiscountAllocation {
  allocatedAmount {
    amount
    currencyCode
  }
  discountApplication {
    ...StorefrontDiscountApplication
  }
}
    ${StorefrontDiscountApplicationFragmentDoc}`;
export const StorefrontCheckoutLineItemHeavyFragmentDoc = gql`
    fragment StorefrontCheckoutLineItemHeavy on StorefrontCheckoutLineItem {
  id
  title
  quantity
  unitPrice {
    amount
    currencyCode
  }
  customAttributes {
    key
    value
  }
  discountAllocations {
    ...StorefrontDiscountAllocation
  }
  variant {
    id
    title
    sku
    priceV2 {
      amount
      currencyCode
    }
    selectedOptions {
      name
      value
    }
    image {
      originalSrc
      transformedSrc(maxWidth: 512, crop: CENTER)
    }
    product {
      id
      handle
      tblProductType: metafield(namespace: "tbl", key: "productType") {
        key
        value
      }
    }
  }
}
    ${StorefrontDiscountAllocationFragmentDoc}`;
export const StorefrontCheckoutHeavyFragmentDoc = gql`
    fragment StorefrontCheckoutHeavy on StorefrontCheckout {
  id
  completedAt
  webUrl
  totalPrice {
    amount
    currencyCode
  }
  totalTax {
    amount
    currencyCode
  }
  subtotalPriceV2 {
    amount
    currencyCode
  }
  totalPriceV2 {
    amount
    currencyCode
  }
  note
  requiresShipping
  lineItemsSubtotalPrice {
    amount
    currencyCode
  }
  discountApplications(first: 100) {
    edges {
      node {
        ...StorefrontDiscountApplication
      }
    }
  }
  lineItems(first: 100) {
    edges {
      node {
        ...StorefrontCheckoutLineItemHeavy
      }
    }
  }
}
    ${StorefrontDiscountApplicationFragmentDoc}
${StorefrontCheckoutLineItemHeavyFragmentDoc}`;
export const StorefrontCartLineHeavyFragmentDoc = gql`
    fragment StorefrontCartLineHeavy on StorefrontBaseCartLine {
  id
  quantity
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
  }
  attributes {
    key
    value
  }
  merchandise {
    ... on StorefrontProductVariant {
      id
      title
      sku
      selectedOptions {
        name
        value
      }
      image {
        originalSrc
        transformedSrc(maxWidth: 512, crop: CENTER)
      }
      product {
        id
        handle
        tblProductType: metafield(namespace: "tbl", key: "productType") {
          key
          value
        }
      }
    }
  }
}
    `;
export const StorefrontCartHeavyFragmentDoc = gql`
    fragment StorefrontCartHeavy on StorefrontCart {
  id
  checkoutUrl
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
  }
  note
  lines(first: 100) {
    edges {
      node {
        ...StorefrontCartLineHeavy
      }
    }
  }
}
    ${StorefrontCartLineHeavyFragmentDoc}`;
export const StickerOrderForLineItemFragmentDoc = gql`
    fragment StickerOrderForLineItem on StickerOrder {
  id
  outputType
  stickers {
    openingId
    quantity
    render {
      url
    }
  }
  file {
    id
    backupVersion
    name
    outputType
    outputScale
    design {
      id
      outputOptions {
        type
        name
        scale
      }
    }
  }
}
    `;
export const NavigationLinkTargetFragmentDoc = gql`
    fragment NavigationLinkTarget on Page {
  _id
  title
  slug {
    current
  }
}
    `;
export const NavigationLinkFragmentDoc = gql`
    fragment NavigationLink on NavigationLink {
  _key
  title
  hidden
  target {
    ...NavigationLinkTarget
  }
  children {
    title
    hidden
    target {
      ...NavigationLinkTarget
    }
    children {
      title
      hidden
      target {
        ...NavigationLinkTarget
      }
    }
  }
}
    ${NavigationLinkTargetFragmentDoc}`;
export const NavigationFragmentDoc = gql`
    fragment Navigation on Navigation {
  _id
  title
  children {
    ...NavigationLink
  }
}
    ${NavigationLinkFragmentDoc}`;
export const PageFragmentDoc = gql`
    fragment Page on Page {
  _id
  title
  slug {
    current
  }
  contentRaw
}
    `;
export const TrackingInfoFragmentDoc = gql`
    fragment TrackingInfo on TrackingInfo {
  company
  number
  url
}
    `;
export const FulfillmentFragmentDoc = gql`
    fragment Fulfillment on Fulfillment {
  id
  createdAt
  deliveredAt
  trackingInfo {
    ...TrackingInfo
  }
}
    ${TrackingInfoFragmentDoc}`;
export const OrderItemDetailsFragmentDoc = gql`
    fragment OrderItemDetails on OrderItem {
  id
  name
  attributes
  originalUnitPrice
  discountedUnitPrice
  quantity
  handle
  description
  image {
    url
    altText
  }
  ... on MapLineItem {
    blueprintId
  }
  ... on StickerLineItem {
    stickerOrderId
    tokensUsed
  }
  ... on StickerTokenLineItem {
    numTokens
  }
}
    `;
export const RefundFragmentDoc = gql`
    fragment Refund on Refund {
  id
  createdAt
  totalRefunded
}
    `;
export const OrderDetailsFragmentDoc = gql`
    fragment OrderDetails on Order {
  id
  number
  createdAt
  cancelledAt
  subtotal
  totalShipping
  totalTax
  total
  billingAddressMatchesShippingAddress
  billingAddressFormatted
  shippingAddressFormatted
  note
  fulfillments {
    ...Fulfillment
  }
  items {
    ...OrderItemDetails
  }
  refunds {
    ...Refund
  }
}
    ${FulfillmentFragmentDoc}
${OrderItemDetailsFragmentDoc}
${RefundFragmentDoc}`;
export const MapLineItemFragmentDoc = gql`
    fragment MapLineItem on OrderItem {
  ... on MapLineItem {
    blueprintId
  }
}
    `;
export const OrderItemLightFragmentDoc = gql`
    fragment OrderItemLight on OrderItem {
  id
  name
  image {
    url
    altText
  }
  ...MapLineItem
}
    ${MapLineItemFragmentDoc}`;
export const OrderLightFragmentDoc = gql`
    fragment OrderLight on Order {
  id
  number
  createdAt
  cancelledAt
  subtotal
  totalShipping
  totalTax
  total
  shippingAddressFormatted
  items {
    ...OrderItemLight
  }
}
    ${OrderItemLightFragmentDoc}`;
export const StickerOrderForStickerLineItemFragmentDoc = gql`
    fragment StickerOrderForStickerLineItem on StickerOrder {
  id
  outputType
  stickers {
    openingId
    quantity
    render {
      url
    }
  }
  file {
    id
    backupVersion
    name
  }
}
    `;
export const StickerOfferItemFragmentDoc = gql`
    fragment StickerOfferItem on StickerOfferItem {
  openingId
  sizeClass
  render {
    url
  }
}
    `;
export const StickerOfferFragmentDoc = gql`
    fragment StickerOffer on StickerOffer {
  stickers {
    ...StickerOfferItem
  }
}
    ${StickerOfferItemFragmentDoc}`;
export const WalgreensStoreFragmentDoc = gql`
    fragment WalgreensStore on WalgreensStore {
  storeNum
  promiseTime
  zip
  city
  state
  street
  phone
  distance
  distanceUnit
  openTime
  closeTime
  timeZone
  tax
}
    `;
export const StorefrontProductImageFragmentDoc = gql`
    fragment StorefrontProductImage on StorefrontImage {
  id
  altText
  tinySrc: transformedSrc(maxWidth: 256)
  mediumSrc: transformedSrc(maxWidth: 1024)
  largeSrc: transformedSrc(maxWidth: 2048)
}
    `;
export const StorefrontProductPageVariantFragmentDoc = gql`
    fragment StorefrontProductPageVariant on StorefrontProductVariant {
  id
  sku
  title
  priceV2 {
    amount
    currencyCode
  }
  availableForSale
  image {
    ...StorefrontProductImage
  }
  selectedOptions {
    name
    value
  }
  personalizationType: metafield(
    namespace: "photomaps"
    key: "personalizationType"
  ) {
    key
    value
  }
  mapmakerBlueprintId: metafield(namespace: "mapmaker", key: "blueprintId") {
    key
    value
  }
  mapmakerBackground: metafield(namespace: "mapmaker", key: "background") {
    key
    value
  }
  mapmakerOutputType: metafield(namespace: "mapmaker", key: "outputType") {
    key
    value
  }
  mapmakerOutputScale: metafield(namespace: "mapmaker", key: "outputScale") {
    key
    value
  }
  mapmakerDefaultInputs: metafield(namespace: "mapmaker", key: "defaultInputs") {
    key
    value
  }
}
    ${StorefrontProductImageFragmentDoc}`;
export const StorefrontProductPageProductFragmentDoc = gql`
    fragment StorefrontProductPageProduct on StorefrontProduct {
  id
  title
  descriptionHtml
  handle
  tags
  priceRange {
    maxVariantPrice {
      amount
      currencyCode
    }
    minVariantPrice {
      amount
      currencyCode
    }
  }
  options {
    id
    name
    values
  }
  images(first: 30) {
    edges {
      node {
        ...StorefrontProductImage
      }
    }
  }
  variants(first: 100) {
    edges {
      node {
        ...StorefrontProductPageVariant
      }
    }
  }
  hideQuantity: metafield(namespace: "photomaps", key: "hideQuantity") {
    key
    value
  }
  personalizationType: metafield(
    namespace: "photomaps"
    key: "personalizationType"
  ) {
    key
    value
  }
  freeStickerTokens: metafield(namespace: "photomaps", key: "freeStickerTokens") {
    key
    value
  }
  mapmakerBlueprintId: metafield(namespace: "mapmaker", key: "blueprintId") {
    key
    value
  }
  mapmakerBackground: metafield(namespace: "mapmaker", key: "background") {
    key
    value
  }
  mapmakerOutputType: metafield(namespace: "mapmaker", key: "outputType") {
    key
    value
  }
  mapmakerOutputScale: metafield(namespace: "mapmaker", key: "outputScale") {
    key
    value
  }
  mapmakerDefaultInputs: metafield(namespace: "mapmaker", key: "defaultInputs") {
    key
    value
  }
}
    ${StorefrontProductImageFragmentDoc}
${StorefrontProductPageVariantFragmentDoc}`;
export const StickerTokenVariantFragmentDoc = gql`
    fragment StickerTokenVariant on StorefrontProductVariant {
  id
  sku
  title
  priceV2 {
    amount
    currencyCode
  }
  selectedOptions {
    name
    value
  }
}
    `;
export const StickerTokenProductFragmentDoc = gql`
    fragment StickerTokenProduct on StorefrontProduct {
  id
  variants(first: 100) {
    edges {
      node {
        ...StickerTokenVariant
      }
    }
  }
}
    ${StickerTokenVariantFragmentDoc}`;
export const StickerOrderForSandboxFragmentDoc = gql`
    fragment StickerOrderForSandbox on StickerOrder {
  id
  businessId
  createdAt
  outputType
  stickers {
    openingId
    sizeClass
    quantity
    quantityWithMoney
    quantityWithTokens
    scale
    render {
      url
    }
  }
  file {
    id
    inputs
    design {
      id
      businessId
      height
      width
      features
    }
  }
}
    `;
export const RenderableDesignFragmentDoc = gql`
    fragment RenderableDesign on MapmakerDesign {
  id
  businessId
  name
  width
  height
  regionType
  regionTypePlural
  regionCount
  features
}
    `;
export const RenderableFileFragmentDoc = gql`
    fragment RenderableFile on MapmakerFile {
  id
  updatedAt
  name
  inputs
  design {
    ...RenderableDesign
  }
}
    ${RenderableDesignFragmentDoc}`;
export const RenderableOpeningSuggestionFragmentDoc = gql`
    fragment RenderableOpeningSuggestion on OpeningSuggestion {
  id
  fileId
  openingId
  input
}
    `;
export const PresignedPostFragmentDoc = gql`
    fragment PresignedPost on PresignedPost {
  url
  fields
  expires
}
    `;
export const GetAccountDocument = gql`
    query getAccount {
  account {
    ...MapmakerAccount
  }
}
    ${MapmakerAccountFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetDesignDocument = gql`
    query getDesign($id: String!) {
  design: mapmakerDesign(id: $id) {
    ...MapmakerDesignHeavy
  }
}
    ${MapmakerDesignHeavyFragmentDoc}`;

/**
 * __useGetDesignQuery__
 *
 * To run a query within a React component, call `useGetDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDesignQuery(baseOptions: Apollo.QueryHookOptions<GetDesignQuery, GetDesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignQuery, GetDesignQueryVariables>(GetDesignDocument, options);
      }
export function useGetDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignQuery, GetDesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignQuery, GetDesignQueryVariables>(GetDesignDocument, options);
        }
export type GetDesignQueryHookResult = ReturnType<typeof useGetDesignQuery>;
export type GetDesignLazyQueryHookResult = ReturnType<typeof useGetDesignLazyQuery>;
export type GetDesignQueryResult = Apollo.QueryResult<GetDesignQuery, GetDesignQueryVariables>;
export const GetFileWithDesignDocument = gql`
    query getFileWithDesign($id: String!) {
  file: mapmakerFile(id: $id) {
    ...MapmakerFileHeavy
  }
}
    ${MapmakerFileHeavyFragmentDoc}`;

/**
 * __useGetFileWithDesignQuery__
 *
 * To run a query within a React component, call `useGetFileWithDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileWithDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileWithDesignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileWithDesignQuery(baseOptions: Apollo.QueryHookOptions<GetFileWithDesignQuery, GetFileWithDesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileWithDesignQuery, GetFileWithDesignQueryVariables>(GetFileWithDesignDocument, options);
      }
export function useGetFileWithDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileWithDesignQuery, GetFileWithDesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileWithDesignQuery, GetFileWithDesignQueryVariables>(GetFileWithDesignDocument, options);
        }
export type GetFileWithDesignQueryHookResult = ReturnType<typeof useGetFileWithDesignQuery>;
export type GetFileWithDesignLazyQueryHookResult = ReturnType<typeof useGetFileWithDesignLazyQuery>;
export type GetFileWithDesignQueryResult = Apollo.QueryResult<GetFileWithDesignQuery, GetFileWithDesignQueryVariables>;
export const CreateFileDocument = gql`
    mutation createFile($input: CreateMapmakerFileInput!) {
  createMapmakerFile(input: $input) {
    file {
      ...MapmakerFileHeavy
    }
  }
}
    ${MapmakerFileHeavyFragmentDoc}`;
export type CreateFileMutationFn = Apollo.MutationFunction<CreateFileMutation, CreateFileMutationVariables>;

/**
 * __useCreateFileMutation__
 *
 * To run a mutation, you first call `useCreateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileMutation, { data, loading, error }] = useCreateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileMutation, CreateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileMutation, CreateFileMutationVariables>(CreateFileDocument, options);
      }
export type CreateFileMutationHookResult = ReturnType<typeof useCreateFileMutation>;
export type CreateFileMutationResult = Apollo.MutationResult<CreateFileMutation>;
export type CreateFileMutationOptions = Apollo.BaseMutationOptions<CreateFileMutation, CreateFileMutationVariables>;
export const UpdateFileDocument = gql`
    mutation updateFile($input: UpdateMapmakerFileInput!) {
  updateMapmakerFile(input: $input) {
    file {
      ...MapmakerFileLite
    }
  }
}
    ${MapmakerFileLiteFragmentDoc}`;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const UpdateFileHeavyDocument = gql`
    mutation updateFileHeavy($input: UpdateMapmakerFileInput!) {
  updateMapmakerFile(input: $input) {
    file {
      ...MapmakerFileHeavy
    }
  }
}
    ${MapmakerFileHeavyFragmentDoc}`;
export type UpdateFileHeavyMutationFn = Apollo.MutationFunction<UpdateFileHeavyMutation, UpdateFileHeavyMutationVariables>;

/**
 * __useUpdateFileHeavyMutation__
 *
 * To run a mutation, you first call `useUpdateFileHeavyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileHeavyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileHeavyMutation, { data, loading, error }] = useUpdateFileHeavyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileHeavyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileHeavyMutation, UpdateFileHeavyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileHeavyMutation, UpdateFileHeavyMutationVariables>(UpdateFileHeavyDocument, options);
      }
export type UpdateFileHeavyMutationHookResult = ReturnType<typeof useUpdateFileHeavyMutation>;
export type UpdateFileHeavyMutationResult = Apollo.MutationResult<UpdateFileHeavyMutation>;
export type UpdateFileHeavyMutationOptions = Apollo.BaseMutationOptions<UpdateFileHeavyMutation, UpdateFileHeavyMutationVariables>;
export const DeleteFileDocument = gql`
    mutation deleteFile($input: DeleteMapmakerFileInput!) {
  deleteMapmakerFile(input: $input) {
    file {
      ...MapmakerFileLite
    }
  }
}
    ${MapmakerFileLiteFragmentDoc}`;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const GetStickerOrderDocument = gql`
    query getStickerOrder($id: String!) {
  stickerOrder(id: $id) {
    ...StickerOrder
    file {
      ...MapmakerFileLite
    }
  }
}
    ${StickerOrderFragmentDoc}
${MapmakerFileLiteFragmentDoc}`;

/**
 * __useGetStickerOrderQuery__
 *
 * To run a query within a React component, call `useGetStickerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStickerOrderQuery(baseOptions: Apollo.QueryHookOptions<GetStickerOrderQuery, GetStickerOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerOrderQuery, GetStickerOrderQueryVariables>(GetStickerOrderDocument, options);
      }
export function useGetStickerOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerOrderQuery, GetStickerOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerOrderQuery, GetStickerOrderQueryVariables>(GetStickerOrderDocument, options);
        }
export type GetStickerOrderQueryHookResult = ReturnType<typeof useGetStickerOrderQuery>;
export type GetStickerOrderLazyQueryHookResult = ReturnType<typeof useGetStickerOrderLazyQuery>;
export type GetStickerOrderQueryResult = Apollo.QueryResult<GetStickerOrderQuery, GetStickerOrderQueryVariables>;
export const GetStickerOrdersDocument = gql`
    query getStickerOrders($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrder
  }
}
    ${StickerOrderFragmentDoc}`;

/**
 * __useGetStickerOrdersQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStickerOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetStickerOrdersQuery, GetStickerOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerOrdersQuery, GetStickerOrdersQueryVariables>(GetStickerOrdersDocument, options);
      }
export function useGetStickerOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerOrdersQuery, GetStickerOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerOrdersQuery, GetStickerOrdersQueryVariables>(GetStickerOrdersDocument, options);
        }
export type GetStickerOrdersQueryHookResult = ReturnType<typeof useGetStickerOrdersQuery>;
export type GetStickerOrdersLazyQueryHookResult = ReturnType<typeof useGetStickerOrdersLazyQuery>;
export type GetStickerOrdersQueryResult = Apollo.QueryResult<GetStickerOrdersQuery, GetStickerOrdersQueryVariables>;
export const CreateStickerOrderDocument = gql`
    mutation createStickerOrder($input: CreateStickerOrderInput!) {
  createStickerOrder(input: $input) {
    ...StickerOrder
  }
}
    ${StickerOrderFragmentDoc}`;
export type CreateStickerOrderMutationFn = Apollo.MutationFunction<CreateStickerOrderMutation, CreateStickerOrderMutationVariables>;

/**
 * __useCreateStickerOrderMutation__
 *
 * To run a mutation, you first call `useCreateStickerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStickerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStickerOrderMutation, { data, loading, error }] = useCreateStickerOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStickerOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateStickerOrderMutation, CreateStickerOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStickerOrderMutation, CreateStickerOrderMutationVariables>(CreateStickerOrderDocument, options);
      }
export type CreateStickerOrderMutationHookResult = ReturnType<typeof useCreateStickerOrderMutation>;
export type CreateStickerOrderMutationResult = Apollo.MutationResult<CreateStickerOrderMutation>;
export type CreateStickerOrderMutationOptions = Apollo.BaseMutationOptions<CreateStickerOrderMutation, CreateStickerOrderMutationVariables>;
export const PresignedImageUploadDocument = gql`
    mutation presignedImageUpload {
  presignedImageUpload {
    url
    fields
    expires
  }
}
    `;
export type PresignedImageUploadMutationFn = Apollo.MutationFunction<PresignedImageUploadMutation, PresignedImageUploadMutationVariables>;

/**
 * __usePresignedImageUploadMutation__
 *
 * To run a mutation, you first call `usePresignedImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePresignedImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [presignedImageUploadMutation, { data, loading, error }] = usePresignedImageUploadMutation({
 *   variables: {
 *   },
 * });
 */
export function usePresignedImageUploadMutation(baseOptions?: Apollo.MutationHookOptions<PresignedImageUploadMutation, PresignedImageUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PresignedImageUploadMutation, PresignedImageUploadMutationVariables>(PresignedImageUploadDocument, options);
      }
export type PresignedImageUploadMutationHookResult = ReturnType<typeof usePresignedImageUploadMutation>;
export type PresignedImageUploadMutationResult = Apollo.MutationResult<PresignedImageUploadMutation>;
export type PresignedImageUploadMutationOptions = Apollo.BaseMutationOptions<PresignedImageUploadMutation, PresignedImageUploadMutationVariables>;
export const GetStickerProductsDocument = gql`
    query getStickerProducts {
  stickers: storefrontCollectionByHandle(handle: "sticker-products") {
    products(first: 10, sortKey: PRICE) {
      edges {
        node {
          id
          variants(first: 20) {
            edges {
              node {
                ...StickerVariantForPricing
              }
            }
          }
        }
      }
    }
  }
}
    ${StickerVariantForPricingFragmentDoc}`;

/**
 * __useGetStickerProductsQuery__
 *
 * To run a query within a React component, call `useGetStickerProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStickerProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetStickerProductsQuery, GetStickerProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerProductsQuery, GetStickerProductsQueryVariables>(GetStickerProductsDocument, options);
      }
export function useGetStickerProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerProductsQuery, GetStickerProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerProductsQuery, GetStickerProductsQueryVariables>(GetStickerProductsDocument, options);
        }
export type GetStickerProductsQueryHookResult = ReturnType<typeof useGetStickerProductsQuery>;
export type GetStickerProductsLazyQueryHookResult = ReturnType<typeof useGetStickerProductsLazyQuery>;
export type GetStickerProductsQueryResult = Apollo.QueryResult<GetStickerProductsQuery, GetStickerProductsQueryVariables>;
export const StorefrontGetCheckoutLightDocument = gql`
    query storefrontGetCheckoutLight($checkoutId: ID!) {
  storefrontCheckout: storefrontNode(id: $checkoutId) {
    id
    ... on StorefrontCheckout {
      ...StorefrontCheckoutLight
    }
  }
}
    ${StorefrontCheckoutLightFragmentDoc}`;

/**
 * __useStorefrontGetCheckoutLightQuery__
 *
 * To run a query within a React component, call `useStorefrontGetCheckoutLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetCheckoutLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetCheckoutLightQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */
export function useStorefrontGetCheckoutLightQuery(baseOptions: Apollo.QueryHookOptions<StorefrontGetCheckoutLightQuery, StorefrontGetCheckoutLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontGetCheckoutLightQuery, StorefrontGetCheckoutLightQueryVariables>(StorefrontGetCheckoutLightDocument, options);
      }
export function useStorefrontGetCheckoutLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontGetCheckoutLightQuery, StorefrontGetCheckoutLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontGetCheckoutLightQuery, StorefrontGetCheckoutLightQueryVariables>(StorefrontGetCheckoutLightDocument, options);
        }
export type StorefrontGetCheckoutLightQueryHookResult = ReturnType<typeof useStorefrontGetCheckoutLightQuery>;
export type StorefrontGetCheckoutLightLazyQueryHookResult = ReturnType<typeof useStorefrontGetCheckoutLightLazyQuery>;
export type StorefrontGetCheckoutLightQueryResult = Apollo.QueryResult<StorefrontGetCheckoutLightQuery, StorefrontGetCheckoutLightQueryVariables>;
export const StorefrontGetCartLightDocument = gql`
    query storefrontGetCartLight($cartId: ID!) {
  storefrontCart: storefrontNode(id: $cartId) {
    id
    ... on StorefrontCart {
      ...StorefrontCartLight
    }
  }
}
    ${StorefrontCartLightFragmentDoc}`;

/**
 * __useStorefrontGetCartLightQuery__
 *
 * To run a query within a React component, call `useStorefrontGetCartLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetCartLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetCartLightQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useStorefrontGetCartLightQuery(baseOptions: Apollo.QueryHookOptions<StorefrontGetCartLightQuery, StorefrontGetCartLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontGetCartLightQuery, StorefrontGetCartLightQueryVariables>(StorefrontGetCartLightDocument, options);
      }
export function useStorefrontGetCartLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontGetCartLightQuery, StorefrontGetCartLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontGetCartLightQuery, StorefrontGetCartLightQueryVariables>(StorefrontGetCartLightDocument, options);
        }
export type StorefrontGetCartLightQueryHookResult = ReturnType<typeof useStorefrontGetCartLightQuery>;
export type StorefrontGetCartLightLazyQueryHookResult = ReturnType<typeof useStorefrontGetCartLightLazyQuery>;
export type StorefrontGetCartLightQueryResult = Apollo.QueryResult<StorefrontGetCartLightQuery, StorefrontGetCartLightQueryVariables>;
export const StorefrontCreateCheckoutDocument = gql`
    mutation storefrontCreateCheckout($input: StorefrontCheckoutCreateInput!) {
  storefrontCheckoutCreate(input: $input) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;
export type StorefrontCreateCheckoutMutationFn = Apollo.MutationFunction<StorefrontCreateCheckoutMutation, StorefrontCreateCheckoutMutationVariables>;

/**
 * __useStorefrontCreateCheckoutMutation__
 *
 * To run a mutation, you first call `useStorefrontCreateCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCreateCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontCreateCheckoutMutation, { data, loading, error }] = useStorefrontCreateCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontCreateCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontCreateCheckoutMutation, StorefrontCreateCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontCreateCheckoutMutation, StorefrontCreateCheckoutMutationVariables>(StorefrontCreateCheckoutDocument, options);
      }
export type StorefrontCreateCheckoutMutationHookResult = ReturnType<typeof useStorefrontCreateCheckoutMutation>;
export type StorefrontCreateCheckoutMutationResult = Apollo.MutationResult<StorefrontCreateCheckoutMutation>;
export type StorefrontCreateCheckoutMutationOptions = Apollo.BaseMutationOptions<StorefrontCreateCheckoutMutation, StorefrontCreateCheckoutMutationVariables>;
export const StorefrontCartCreateDocument = gql`
    mutation storefrontCartCreate($input: StorefrontCartInput!) {
  storefrontCartCreate(input: $input) {
    cart {
      ...StorefrontCartHeavy
    }
  }
}
    ${StorefrontCartHeavyFragmentDoc}`;
export type StorefrontCartCreateMutationFn = Apollo.MutationFunction<StorefrontCartCreateMutation, StorefrontCartCreateMutationVariables>;

/**
 * __useStorefrontCartCreateMutation__
 *
 * To run a mutation, you first call `useStorefrontCartCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCartCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontCartCreateMutation, { data, loading, error }] = useStorefrontCartCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontCartCreateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontCartCreateMutation, StorefrontCartCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontCartCreateMutation, StorefrontCartCreateMutationVariables>(StorefrontCartCreateDocument, options);
      }
export type StorefrontCartCreateMutationHookResult = ReturnType<typeof useStorefrontCartCreateMutation>;
export type StorefrontCartCreateMutationResult = Apollo.MutationResult<StorefrontCartCreateMutation>;
export type StorefrontCartCreateMutationOptions = Apollo.BaseMutationOptions<StorefrontCartCreateMutation, StorefrontCartCreateMutationVariables>;
export const StorefrontAddCheckoutLineItemsDocument = gql`
    mutation storefrontAddCheckoutLineItems($checkoutId: ID!, $lineItems: [StorefrontCheckoutLineItemInput!]!) {
  storefrontCheckoutLineItemsAdd(checkoutId: $checkoutId, lineItems: $lineItems) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;
export type StorefrontAddCheckoutLineItemsMutationFn = Apollo.MutationFunction<StorefrontAddCheckoutLineItemsMutation, StorefrontAddCheckoutLineItemsMutationVariables>;

/**
 * __useStorefrontAddCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontAddCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontAddCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontAddCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontAddCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useStorefrontAddCheckoutLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontAddCheckoutLineItemsMutation, StorefrontAddCheckoutLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontAddCheckoutLineItemsMutation, StorefrontAddCheckoutLineItemsMutationVariables>(StorefrontAddCheckoutLineItemsDocument, options);
      }
export type StorefrontAddCheckoutLineItemsMutationHookResult = ReturnType<typeof useStorefrontAddCheckoutLineItemsMutation>;
export type StorefrontAddCheckoutLineItemsMutationResult = Apollo.MutationResult<StorefrontAddCheckoutLineItemsMutation>;
export type StorefrontAddCheckoutLineItemsMutationOptions = Apollo.BaseMutationOptions<StorefrontAddCheckoutLineItemsMutation, StorefrontAddCheckoutLineItemsMutationVariables>;
export const StorefrontAddCartLinesDocument = gql`
    mutation storefrontAddCartLines($cartId: ID!, $lines: [StorefrontCartLineInput!]!) {
  storefrontCartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ...StorefrontCartHeavy
    }
  }
}
    ${StorefrontCartHeavyFragmentDoc}`;
export type StorefrontAddCartLinesMutationFn = Apollo.MutationFunction<StorefrontAddCartLinesMutation, StorefrontAddCartLinesMutationVariables>;

/**
 * __useStorefrontAddCartLinesMutation__
 *
 * To run a mutation, you first call `useStorefrontAddCartLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontAddCartLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontAddCartLinesMutation, { data, loading, error }] = useStorefrontAddCartLinesMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useStorefrontAddCartLinesMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontAddCartLinesMutation, StorefrontAddCartLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontAddCartLinesMutation, StorefrontAddCartLinesMutationVariables>(StorefrontAddCartLinesDocument, options);
      }
export type StorefrontAddCartLinesMutationHookResult = ReturnType<typeof useStorefrontAddCartLinesMutation>;
export type StorefrontAddCartLinesMutationResult = Apollo.MutationResult<StorefrontAddCartLinesMutation>;
export type StorefrontAddCartLinesMutationOptions = Apollo.BaseMutationOptions<StorefrontAddCartLinesMutation, StorefrontAddCartLinesMutationVariables>;
export const BlogPostDocument = gql`
    query blogPost($slug: String!) {
  post: allPost(where: {slug: {current: {eq: $slug}}}) {
    ...BlogPost
  }
  recentPosts: allPost(sort: [{publishedAt: DESC}]) {
    ...BlogPostCard
  }
}
    ${BlogPostFragmentDoc}
${BlogPostCardFragmentDoc}`;

/**
 * __useBlogPostQuery__
 *
 * To run a query within a React component, call `useBlogPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBlogPostQuery(baseOptions: Apollo.QueryHookOptions<BlogPostQuery, BlogPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, options);
      }
export function useBlogPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostQuery, BlogPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, options);
        }
export type BlogPostQueryHookResult = ReturnType<typeof useBlogPostQuery>;
export type BlogPostLazyQueryHookResult = ReturnType<typeof useBlogPostLazyQuery>;
export type BlogPostQueryResult = Apollo.QueryResult<BlogPostQuery, BlogPostQueryVariables>;
export const AllPostsDocument = gql`
    query allPosts {
  allPost(sort: [{publishedAt: DESC}]) {
    ...BlogPostCard
  }
}
    ${BlogPostCardFragmentDoc}`;

/**
 * __useAllPostsQuery__
 *
 * To run a query within a React component, call `useAllPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPostsQuery(baseOptions?: Apollo.QueryHookOptions<AllPostsQuery, AllPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPostsQuery, AllPostsQueryVariables>(AllPostsDocument, options);
      }
export function useAllPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPostsQuery, AllPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPostsQuery, AllPostsQueryVariables>(AllPostsDocument, options);
        }
export type AllPostsQueryHookResult = ReturnType<typeof useAllPostsQuery>;
export type AllPostsLazyQueryHookResult = ReturnType<typeof useAllPostsLazyQuery>;
export type AllPostsQueryResult = Apollo.QueryResult<AllPostsQuery, AllPostsQueryVariables>;
export const StorefrontGetCheckoutHeavyDocument = gql`
    query storefrontGetCheckoutHeavy($checkoutId: ID!) {
  storefrontCheckout: storefrontNode(id: $checkoutId) {
    id
    ... on StorefrontCheckout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;

/**
 * __useStorefrontGetCheckoutHeavyQuery__
 *
 * To run a query within a React component, call `useStorefrontGetCheckoutHeavyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetCheckoutHeavyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetCheckoutHeavyQuery({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *   },
 * });
 */
export function useStorefrontGetCheckoutHeavyQuery(baseOptions: Apollo.QueryHookOptions<StorefrontGetCheckoutHeavyQuery, StorefrontGetCheckoutHeavyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontGetCheckoutHeavyQuery, StorefrontGetCheckoutHeavyQueryVariables>(StorefrontGetCheckoutHeavyDocument, options);
      }
export function useStorefrontGetCheckoutHeavyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontGetCheckoutHeavyQuery, StorefrontGetCheckoutHeavyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontGetCheckoutHeavyQuery, StorefrontGetCheckoutHeavyQueryVariables>(StorefrontGetCheckoutHeavyDocument, options);
        }
export type StorefrontGetCheckoutHeavyQueryHookResult = ReturnType<typeof useStorefrontGetCheckoutHeavyQuery>;
export type StorefrontGetCheckoutHeavyLazyQueryHookResult = ReturnType<typeof useStorefrontGetCheckoutHeavyLazyQuery>;
export type StorefrontGetCheckoutHeavyQueryResult = Apollo.QueryResult<StorefrontGetCheckoutHeavyQuery, StorefrontGetCheckoutHeavyQueryVariables>;
export const StorefrontRemoveCheckoutLineItemsDocument = gql`
    mutation storefrontRemoveCheckoutLineItems($checkoutId: ID!, $lineItemIds: [ID!]!) {
  storefrontCheckoutLineItemsRemove(
    checkoutId: $checkoutId
    lineItemIds: $lineItemIds
  ) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;
export type StorefrontRemoveCheckoutLineItemsMutationFn = Apollo.MutationFunction<StorefrontRemoveCheckoutLineItemsMutation, StorefrontRemoveCheckoutLineItemsMutationVariables>;

/**
 * __useStorefrontRemoveCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontRemoveCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontRemoveCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontRemoveCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontRemoveCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItemIds: // value for 'lineItemIds'
 *   },
 * });
 */
export function useStorefrontRemoveCheckoutLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontRemoveCheckoutLineItemsMutation, StorefrontRemoveCheckoutLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontRemoveCheckoutLineItemsMutation, StorefrontRemoveCheckoutLineItemsMutationVariables>(StorefrontRemoveCheckoutLineItemsDocument, options);
      }
export type StorefrontRemoveCheckoutLineItemsMutationHookResult = ReturnType<typeof useStorefrontRemoveCheckoutLineItemsMutation>;
export type StorefrontRemoveCheckoutLineItemsMutationResult = Apollo.MutationResult<StorefrontRemoveCheckoutLineItemsMutation>;
export type StorefrontRemoveCheckoutLineItemsMutationOptions = Apollo.BaseMutationOptions<StorefrontRemoveCheckoutLineItemsMutation, StorefrontRemoveCheckoutLineItemsMutationVariables>;
export const StorefrontGetCartHeavyDocument = gql`
    query storefrontGetCartHeavy($cartId: ID!) {
  storefrontCart: storefrontNode(id: $cartId) {
    id
    ... on StorefrontCart {
      ...StorefrontCartHeavy
    }
  }
}
    ${StorefrontCartHeavyFragmentDoc}`;

/**
 * __useStorefrontGetCartHeavyQuery__
 *
 * To run a query within a React component, call `useStorefrontGetCartHeavyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetCartHeavyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetCartHeavyQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useStorefrontGetCartHeavyQuery(baseOptions: Apollo.QueryHookOptions<StorefrontGetCartHeavyQuery, StorefrontGetCartHeavyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontGetCartHeavyQuery, StorefrontGetCartHeavyQueryVariables>(StorefrontGetCartHeavyDocument, options);
      }
export function useStorefrontGetCartHeavyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontGetCartHeavyQuery, StorefrontGetCartHeavyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontGetCartHeavyQuery, StorefrontGetCartHeavyQueryVariables>(StorefrontGetCartHeavyDocument, options);
        }
export type StorefrontGetCartHeavyQueryHookResult = ReturnType<typeof useStorefrontGetCartHeavyQuery>;
export type StorefrontGetCartHeavyLazyQueryHookResult = ReturnType<typeof useStorefrontGetCartHeavyLazyQuery>;
export type StorefrontGetCartHeavyQueryResult = Apollo.QueryResult<StorefrontGetCartHeavyQuery, StorefrontGetCartHeavyQueryVariables>;
export const StorefrontCartLinesRemoveDocument = gql`
    mutation storefrontCartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  storefrontCartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ...StorefrontCartHeavy
    }
  }
}
    ${StorefrontCartHeavyFragmentDoc}`;
export type StorefrontCartLinesRemoveMutationFn = Apollo.MutationFunction<StorefrontCartLinesRemoveMutation, StorefrontCartLinesRemoveMutationVariables>;

/**
 * __useStorefrontCartLinesRemoveMutation__
 *
 * To run a mutation, you first call `useStorefrontCartLinesRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCartLinesRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontCartLinesRemoveMutation, { data, loading, error }] = useStorefrontCartLinesRemoveMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      lineIds: // value for 'lineIds'
 *   },
 * });
 */
export function useStorefrontCartLinesRemoveMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontCartLinesRemoveMutation, StorefrontCartLinesRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontCartLinesRemoveMutation, StorefrontCartLinesRemoveMutationVariables>(StorefrontCartLinesRemoveDocument, options);
      }
export type StorefrontCartLinesRemoveMutationHookResult = ReturnType<typeof useStorefrontCartLinesRemoveMutation>;
export type StorefrontCartLinesRemoveMutationResult = Apollo.MutationResult<StorefrontCartLinesRemoveMutation>;
export type StorefrontCartLinesRemoveMutationOptions = Apollo.BaseMutationOptions<StorefrontCartLinesRemoveMutation, StorefrontCartLinesRemoveMutationVariables>;
export const GetStickerOrdersForCartPageDocument = gql`
    query getStickerOrdersForCartPage($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrderForLineItem
  }
}
    ${StickerOrderForLineItemFragmentDoc}`;

/**
 * __useGetStickerOrdersForCartPageQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersForCartPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersForCartPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersForCartPageQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStickerOrdersForCartPageQuery(baseOptions: Apollo.QueryHookOptions<GetStickerOrdersForCartPageQuery, GetStickerOrdersForCartPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerOrdersForCartPageQuery, GetStickerOrdersForCartPageQueryVariables>(GetStickerOrdersForCartPageDocument, options);
      }
export function useGetStickerOrdersForCartPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerOrdersForCartPageQuery, GetStickerOrdersForCartPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerOrdersForCartPageQuery, GetStickerOrdersForCartPageQueryVariables>(GetStickerOrdersForCartPageDocument, options);
        }
export type GetStickerOrdersForCartPageQueryHookResult = ReturnType<typeof useGetStickerOrdersForCartPageQuery>;
export type GetStickerOrdersForCartPageLazyQueryHookResult = ReturnType<typeof useGetStickerOrdersForCartPageLazyQuery>;
export type GetStickerOrdersForCartPageQueryResult = Apollo.QueryResult<GetStickerOrdersForCartPageQuery, GetStickerOrdersForCartPageQueryVariables>;
export const StorefrontUpdateCheckoutAttributesDocument = gql`
    mutation storefrontUpdateCheckoutAttributes($checkoutId: ID!, $input: StorefrontCheckoutAttributesUpdateV2Input!) {
  storefrontCheckoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;
export type StorefrontUpdateCheckoutAttributesMutationFn = Apollo.MutationFunction<StorefrontUpdateCheckoutAttributesMutation, StorefrontUpdateCheckoutAttributesMutationVariables>;

/**
 * __useStorefrontUpdateCheckoutAttributesMutation__
 *
 * To run a mutation, you first call `useStorefrontUpdateCheckoutAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontUpdateCheckoutAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontUpdateCheckoutAttributesMutation, { data, loading, error }] = useStorefrontUpdateCheckoutAttributesMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontUpdateCheckoutAttributesMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontUpdateCheckoutAttributesMutation, StorefrontUpdateCheckoutAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontUpdateCheckoutAttributesMutation, StorefrontUpdateCheckoutAttributesMutationVariables>(StorefrontUpdateCheckoutAttributesDocument, options);
      }
export type StorefrontUpdateCheckoutAttributesMutationHookResult = ReturnType<typeof useStorefrontUpdateCheckoutAttributesMutation>;
export type StorefrontUpdateCheckoutAttributesMutationResult = Apollo.MutationResult<StorefrontUpdateCheckoutAttributesMutation>;
export type StorefrontUpdateCheckoutAttributesMutationOptions = Apollo.BaseMutationOptions<StorefrontUpdateCheckoutAttributesMutation, StorefrontUpdateCheckoutAttributesMutationVariables>;
export const StorefrontCartNoteUpdateDocument = gql`
    mutation storefrontCartNoteUpdate($cartId: ID!, $note: String!) {
  storefrontCartNoteUpdate(cartId: $cartId, note: $note) {
    cart {
      ...StorefrontCartHeavy
    }
  }
}
    ${StorefrontCartHeavyFragmentDoc}`;
export type StorefrontCartNoteUpdateMutationFn = Apollo.MutationFunction<StorefrontCartNoteUpdateMutation, StorefrontCartNoteUpdateMutationVariables>;

/**
 * __useStorefrontCartNoteUpdateMutation__
 *
 * To run a mutation, you first call `useStorefrontCartNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontCartNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontCartNoteUpdateMutation, { data, loading, error }] = useStorefrontCartNoteUpdateMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useStorefrontCartNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontCartNoteUpdateMutation, StorefrontCartNoteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontCartNoteUpdateMutation, StorefrontCartNoteUpdateMutationVariables>(StorefrontCartNoteUpdateDocument, options);
      }
export type StorefrontCartNoteUpdateMutationHookResult = ReturnType<typeof useStorefrontCartNoteUpdateMutation>;
export type StorefrontCartNoteUpdateMutationResult = Apollo.MutationResult<StorefrontCartNoteUpdateMutation>;
export type StorefrontCartNoteUpdateMutationOptions = Apollo.BaseMutationOptions<StorefrontCartNoteUpdateMutation, StorefrontCartNoteUpdateMutationVariables>;
export const StorefrontUpdateCheckoutLineItemsDocument = gql`
    mutation storefrontUpdateCheckoutLineItems($checkoutId: ID!, $lineItems: [StorefrontCheckoutLineItemUpdateInput!]!) {
  storefrontCheckoutLineItemsUpdate(
    checkoutId: $checkoutId
    lineItems: $lineItems
  ) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;
export type StorefrontUpdateCheckoutLineItemsMutationFn = Apollo.MutationFunction<StorefrontUpdateCheckoutLineItemsMutation, StorefrontUpdateCheckoutLineItemsMutationVariables>;

/**
 * __useStorefrontUpdateCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontUpdateCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontUpdateCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontUpdateCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontUpdateCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useStorefrontUpdateCheckoutLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontUpdateCheckoutLineItemsMutation, StorefrontUpdateCheckoutLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontUpdateCheckoutLineItemsMutation, StorefrontUpdateCheckoutLineItemsMutationVariables>(StorefrontUpdateCheckoutLineItemsDocument, options);
      }
export type StorefrontUpdateCheckoutLineItemsMutationHookResult = ReturnType<typeof useStorefrontUpdateCheckoutLineItemsMutation>;
export type StorefrontUpdateCheckoutLineItemsMutationResult = Apollo.MutationResult<StorefrontUpdateCheckoutLineItemsMutation>;
export type StorefrontUpdateCheckoutLineItemsMutationOptions = Apollo.BaseMutationOptions<StorefrontUpdateCheckoutLineItemsMutation, StorefrontUpdateCheckoutLineItemsMutationVariables>;
export const StorefrontUpdateCartLinesDocument = gql`
    mutation storefrontUpdateCartLines($cartId: ID!, $lines: [StorefrontCartLineUpdateInput!]!) {
  storefrontCartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ...StorefrontCartHeavy
    }
  }
}
    ${StorefrontCartHeavyFragmentDoc}`;
export type StorefrontUpdateCartLinesMutationFn = Apollo.MutationFunction<StorefrontUpdateCartLinesMutation, StorefrontUpdateCartLinesMutationVariables>;

/**
 * __useStorefrontUpdateCartLinesMutation__
 *
 * To run a mutation, you first call `useStorefrontUpdateCartLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontUpdateCartLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontUpdateCartLinesMutation, { data, loading, error }] = useStorefrontUpdateCartLinesMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      lines: // value for 'lines'
 *   },
 * });
 */
export function useStorefrontUpdateCartLinesMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontUpdateCartLinesMutation, StorefrontUpdateCartLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontUpdateCartLinesMutation, StorefrontUpdateCartLinesMutationVariables>(StorefrontUpdateCartLinesDocument, options);
      }
export type StorefrontUpdateCartLinesMutationHookResult = ReturnType<typeof useStorefrontUpdateCartLinesMutation>;
export type StorefrontUpdateCartLinesMutationResult = Apollo.MutationResult<StorefrontUpdateCartLinesMutation>;
export type StorefrontUpdateCartLinesMutationOptions = Apollo.BaseMutationOptions<StorefrontUpdateCartLinesMutation, StorefrontUpdateCartLinesMutationVariables>;
export const GetDesignsAndFilesDocument = gql`
    query getDesignsAndFiles {
  designs: mapmakerDesigns {
    ...MapmakerDesignLite
  }
  files: mapmakerFiles {
    ...MapmakerFileLite
  }
  sharedFiles: sharedMapmakerFiles {
    ...MapmakerFileLite
  }
}
    ${MapmakerDesignLiteFragmentDoc}
${MapmakerFileLiteFragmentDoc}`;

/**
 * __useGetDesignsAndFilesQuery__
 *
 * To run a query within a React component, call `useGetDesignsAndFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignsAndFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignsAndFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDesignsAndFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetDesignsAndFilesQuery, GetDesignsAndFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignsAndFilesQuery, GetDesignsAndFilesQueryVariables>(GetDesignsAndFilesDocument, options);
      }
export function useGetDesignsAndFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignsAndFilesQuery, GetDesignsAndFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignsAndFilesQuery, GetDesignsAndFilesQueryVariables>(GetDesignsAndFilesDocument, options);
        }
export type GetDesignsAndFilesQueryHookResult = ReturnType<typeof useGetDesignsAndFilesQuery>;
export type GetDesignsAndFilesLazyQueryHookResult = ReturnType<typeof useGetDesignsAndFilesLazyQuery>;
export type GetDesignsAndFilesQueryResult = Apollo.QueryResult<GetDesignsAndFilesQuery, GetDesignsAndFilesQueryVariables>;
export const GetDesignsDocument = gql`
    query getDesigns($request: GetMapmakerDesignsRequest) {
  designs: mapmakerDesigns(request: $request) {
    ...MapmakerDesignLite
  }
}
    ${MapmakerDesignLiteFragmentDoc}`;

/**
 * __useGetDesignsQuery__
 *
 * To run a query within a React component, call `useGetDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetDesignsQuery(baseOptions?: Apollo.QueryHookOptions<GetDesignsQuery, GetDesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignsQuery, GetDesignsQueryVariables>(GetDesignsDocument, options);
      }
export function useGetDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignsQuery, GetDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignsQuery, GetDesignsQueryVariables>(GetDesignsDocument, options);
        }
export type GetDesignsQueryHookResult = ReturnType<typeof useGetDesignsQuery>;
export type GetDesignsLazyQueryHookResult = ReturnType<typeof useGetDesignsLazyQuery>;
export type GetDesignsQueryResult = Apollo.QueryResult<GetDesignsQuery, GetDesignsQueryVariables>;
export const NavigationByIdDocument = gql`
    query navigationById($id: String!, $pageSlug: String) {
  allNavigation(where: {id: {current: {eq: $id}}}) {
    ...Navigation
  }
  allPage(where: {slug: {current: {eq: $pageSlug}}}) {
    ...Page
  }
}
    ${NavigationFragmentDoc}
${PageFragmentDoc}`;

/**
 * __useNavigationByIdQuery__
 *
 * To run a query within a React component, call `useNavigationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageSlug: // value for 'pageSlug'
 *   },
 * });
 */
export function useNavigationByIdQuery(baseOptions: Apollo.QueryHookOptions<NavigationByIdQuery, NavigationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationByIdQuery, NavigationByIdQueryVariables>(NavigationByIdDocument, options);
      }
export function useNavigationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationByIdQuery, NavigationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationByIdQuery, NavigationByIdQueryVariables>(NavigationByIdDocument, options);
        }
export type NavigationByIdQueryHookResult = ReturnType<typeof useNavigationByIdQuery>;
export type NavigationByIdLazyQueryHookResult = ReturnType<typeof useNavigationByIdLazyQuery>;
export type NavigationByIdQueryResult = Apollo.QueryResult<NavigationByIdQuery, NavigationByIdQueryVariables>;
export const CreateTicketDocument = gql`
    mutation createTicket($input: CreateTicketInput) {
  createTicket(input: $input) {
    created
  }
}
    `;
export type CreateTicketMutationFn = Apollo.MutationFunction<CreateTicketMutation, CreateTicketMutationVariables>;

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTicketMutation, CreateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTicketMutation, CreateTicketMutationVariables>(CreateTicketDocument, options);
      }
export type CreateTicketMutationHookResult = ReturnType<typeof useCreateTicketMutation>;
export type CreateTicketMutationResult = Apollo.MutationResult<CreateTicketMutation>;
export type CreateTicketMutationOptions = Apollo.BaseMutationOptions<CreateTicketMutation, CreateTicketMutationVariables>;
export const PageBySlugDocument = gql`
    query pageBySlug($slug: String!) {
  allPage(where: {slug: {current: {eq: $slug}}}) {
    ...Page
  }
}
    ${PageFragmentDoc}`;

/**
 * __usePageBySlugQuery__
 *
 * To run a query within a React component, call `usePageBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePageBySlugQuery(baseOptions: Apollo.QueryHookOptions<PageBySlugQuery, PageBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageBySlugQuery, PageBySlugQueryVariables>(PageBySlugDocument, options);
      }
export function usePageBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageBySlugQuery, PageBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageBySlugQuery, PageBySlugQueryVariables>(PageBySlugDocument, options);
        }
export type PageBySlugQueryHookResult = ReturnType<typeof usePageBySlugQuery>;
export type PageBySlugLazyQueryHookResult = ReturnType<typeof usePageBySlugLazyQuery>;
export type PageBySlugQueryResult = Apollo.QueryResult<PageBySlugQuery, PageBySlugQueryVariables>;
export const GetReferenceDocument = gql`
    query getReference($ref: String!) {
  sanityReference(input: {ref: $ref}) {
    id
    slug
  }
}
    `;

/**
 * __useGetReferenceQuery__
 *
 * To run a query within a React component, call `useGetReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferenceQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetReferenceQuery(baseOptions: Apollo.QueryHookOptions<GetReferenceQuery, GetReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferenceQuery, GetReferenceQueryVariables>(GetReferenceDocument, options);
      }
export function useGetReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferenceQuery, GetReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferenceQuery, GetReferenceQueryVariables>(GetReferenceDocument, options);
        }
export type GetReferenceQueryHookResult = ReturnType<typeof useGetReferenceQuery>;
export type GetReferenceLazyQueryHookResult = ReturnType<typeof useGetReferenceLazyQuery>;
export type GetReferenceQueryResult = Apollo.QueryResult<GetReferenceQuery, GetReferenceQueryVariables>;
export const GetOrderDocument = gql`
    query getOrder($number: String!) {
  order(number: $number) {
    ...OrderDetails
  }
}
    ${OrderDetailsFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetStickerOrdersForOrderDetailsDocument = gql`
    query getStickerOrdersForOrderDetails($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrderForStickerLineItem
  }
}
    ${StickerOrderForStickerLineItemFragmentDoc}`;

/**
 * __useGetStickerOrdersForOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersForOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersForOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersForOrderDetailsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStickerOrdersForOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStickerOrdersForOrderDetailsQuery, GetStickerOrdersForOrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerOrdersForOrderDetailsQuery, GetStickerOrdersForOrderDetailsQueryVariables>(GetStickerOrdersForOrderDetailsDocument, options);
      }
export function useGetStickerOrdersForOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerOrdersForOrderDetailsQuery, GetStickerOrdersForOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerOrdersForOrderDetailsQuery, GetStickerOrdersForOrderDetailsQueryVariables>(GetStickerOrdersForOrderDetailsDocument, options);
        }
export type GetStickerOrdersForOrderDetailsQueryHookResult = ReturnType<typeof useGetStickerOrdersForOrderDetailsQuery>;
export type GetStickerOrdersForOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetStickerOrdersForOrderDetailsLazyQuery>;
export type GetStickerOrdersForOrderDetailsQueryResult = Apollo.QueryResult<GetStickerOrdersForOrderDetailsQuery, GetStickerOrdersForOrderDetailsQueryVariables>;
export const GetOrdersForUserDocument = gql`
    query getOrdersForUser {
  orders {
    ...OrderLight
  }
}
    ${OrderLightFragmentDoc}`;

/**
 * __useGetOrdersForUserQuery__
 *
 * To run a query within a React component, call `useGetOrdersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrdersForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersForUserQuery, GetOrdersForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersForUserQuery, GetOrdersForUserQueryVariables>(GetOrdersForUserDocument, options);
      }
export function useGetOrdersForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersForUserQuery, GetOrdersForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersForUserQuery, GetOrdersForUserQueryVariables>(GetOrdersForUserDocument, options);
        }
export type GetOrdersForUserQueryHookResult = ReturnType<typeof useGetOrdersForUserQuery>;
export type GetOrdersForUserLazyQueryHookResult = ReturnType<typeof useGetOrdersForUserLazyQuery>;
export type GetOrdersForUserQueryResult = Apollo.QueryResult<GetOrdersForUserQuery, GetOrdersForUserQueryVariables>;
export const PrivacyPolicyDocument = gql`
    query privacyPolicy {
  storefrontShop {
    privacyPolicy {
      title
      body
    }
  }
}
    `;

/**
 * __usePrivacyPolicyQuery__
 *
 * To run a query within a React component, call `usePrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivacyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, options);
      }
export function usePrivacyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, options);
        }
export type PrivacyPolicyQueryHookResult = ReturnType<typeof usePrivacyPolicyQuery>;
export type PrivacyPolicyLazyQueryHookResult = ReturnType<typeof usePrivacyPolicyLazyQuery>;
export type PrivacyPolicyQueryResult = Apollo.QueryResult<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>;
export const RefundPolicyDocument = gql`
    query refundPolicy {
  storefrontShop {
    refundPolicy {
      title
      body
    }
  }
}
    `;

/**
 * __useRefundPolicyQuery__
 *
 * To run a query within a React component, call `useRefundPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useRefundPolicyQuery(baseOptions?: Apollo.QueryHookOptions<RefundPolicyQuery, RefundPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefundPolicyQuery, RefundPolicyQueryVariables>(RefundPolicyDocument, options);
      }
export function useRefundPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefundPolicyQuery, RefundPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefundPolicyQuery, RefundPolicyQueryVariables>(RefundPolicyDocument, options);
        }
export type RefundPolicyQueryHookResult = ReturnType<typeof useRefundPolicyQuery>;
export type RefundPolicyLazyQueryHookResult = ReturnType<typeof useRefundPolicyLazyQuery>;
export type RefundPolicyQueryResult = Apollo.QueryResult<RefundPolicyQuery, RefundPolicyQueryVariables>;
export const TermsOfServiceDocument = gql`
    query termsOfService {
  storefrontShop {
    termsOfService {
      title
      body
    }
  }
}
    `;

/**
 * __useTermsOfServiceQuery__
 *
 * To run a query within a React component, call `useTermsOfServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsOfServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsOfServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useTermsOfServiceQuery(baseOptions?: Apollo.QueryHookOptions<TermsOfServiceQuery, TermsOfServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TermsOfServiceQuery, TermsOfServiceQueryVariables>(TermsOfServiceDocument, options);
      }
export function useTermsOfServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TermsOfServiceQuery, TermsOfServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TermsOfServiceQuery, TermsOfServiceQueryVariables>(TermsOfServiceDocument, options);
        }
export type TermsOfServiceQueryHookResult = ReturnType<typeof useTermsOfServiceQuery>;
export type TermsOfServiceLazyQueryHookResult = ReturnType<typeof useTermsOfServiceLazyQuery>;
export type TermsOfServiceQueryResult = Apollo.QueryResult<TermsOfServiceQuery, TermsOfServiceQueryVariables>;
export const CreateRectangularPrintsForDownloadDocument = gql`
    mutation createRectangularPrintsForDownload($input: CreateRectangularPrintsRequest) {
  createRectangularPrints(input: $input) {
    prints {
      key
      url
    }
  }
}
    `;
export type CreateRectangularPrintsForDownloadMutationFn = Apollo.MutationFunction<CreateRectangularPrintsForDownloadMutation, CreateRectangularPrintsForDownloadMutationVariables>;

/**
 * __useCreateRectangularPrintsForDownloadMutation__
 *
 * To run a mutation, you first call `useCreateRectangularPrintsForDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRectangularPrintsForDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRectangularPrintsForDownloadMutation, { data, loading, error }] = useCreateRectangularPrintsForDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRectangularPrintsForDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateRectangularPrintsForDownloadMutation, CreateRectangularPrintsForDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRectangularPrintsForDownloadMutation, CreateRectangularPrintsForDownloadMutationVariables>(CreateRectangularPrintsForDownloadDocument, options);
      }
export type CreateRectangularPrintsForDownloadMutationHookResult = ReturnType<typeof useCreateRectangularPrintsForDownloadMutation>;
export type CreateRectangularPrintsForDownloadMutationResult = Apollo.MutationResult<CreateRectangularPrintsForDownloadMutation>;
export type CreateRectangularPrintsForDownloadMutationOptions = Apollo.BaseMutationOptions<CreateRectangularPrintsForDownloadMutation, CreateRectangularPrintsForDownloadMutationVariables>;
export const GetStickerOfferDocument = gql`
    query getStickerOffer($input: StickerOfferInput!) {
  stickerOffer(input: $input) {
    ...StickerOffer
  }
}
    ${StickerOfferFragmentDoc}`;

/**
 * __useGetStickerOfferQuery__
 *
 * To run a query within a React component, call `useGetStickerOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOfferQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStickerOfferQuery(baseOptions: Apollo.QueryHookOptions<GetStickerOfferQuery, GetStickerOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerOfferQuery, GetStickerOfferQueryVariables>(GetStickerOfferDocument, options);
      }
export function useGetStickerOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerOfferQuery, GetStickerOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerOfferQuery, GetStickerOfferQueryVariables>(GetStickerOfferDocument, options);
        }
export type GetStickerOfferQueryHookResult = ReturnType<typeof useGetStickerOfferQuery>;
export type GetStickerOfferLazyQueryHookResult = ReturnType<typeof useGetStickerOfferLazyQuery>;
export type GetStickerOfferQueryResult = Apollo.QueryResult<GetStickerOfferQuery, GetStickerOfferQueryVariables>;
export const WalgreensProductsDocument = gql`
    query walgreensProducts {
  walgreensProducts {
    productId
    productPrice
    productSize
  }
}
    `;

/**
 * __useWalgreensProductsQuery__
 *
 * To run a query within a React component, call `useWalgreensProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalgreensProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalgreensProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalgreensProductsQuery(baseOptions?: Apollo.QueryHookOptions<WalgreensProductsQuery, WalgreensProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalgreensProductsQuery, WalgreensProductsQueryVariables>(WalgreensProductsDocument, options);
      }
export function useWalgreensProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalgreensProductsQuery, WalgreensProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalgreensProductsQuery, WalgreensProductsQueryVariables>(WalgreensProductsDocument, options);
        }
export type WalgreensProductsQueryHookResult = ReturnType<typeof useWalgreensProductsQuery>;
export type WalgreensProductsLazyQueryHookResult = ReturnType<typeof useWalgreensProductsLazyQuery>;
export type WalgreensProductsQueryResult = Apollo.QueryResult<WalgreensProductsQuery, WalgreensProductsQueryVariables>;
export const WalgreensSubmitOrderDocument = gql`
    mutation walgreensSubmitOrder($input: WalgreensSubmitOrderInput) {
  walgreensSubmitOrder(input: $input) {
    walgreensOrderId
  }
}
    `;
export type WalgreensSubmitOrderMutationFn = Apollo.MutationFunction<WalgreensSubmitOrderMutation, WalgreensSubmitOrderMutationVariables>;

/**
 * __useWalgreensSubmitOrderMutation__
 *
 * To run a mutation, you first call `useWalgreensSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWalgreensSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [walgreensSubmitOrderMutation, { data, loading, error }] = useWalgreensSubmitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalgreensSubmitOrderMutation(baseOptions?: Apollo.MutationHookOptions<WalgreensSubmitOrderMutation, WalgreensSubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WalgreensSubmitOrderMutation, WalgreensSubmitOrderMutationVariables>(WalgreensSubmitOrderDocument, options);
      }
export type WalgreensSubmitOrderMutationHookResult = ReturnType<typeof useWalgreensSubmitOrderMutation>;
export type WalgreensSubmitOrderMutationResult = Apollo.MutationResult<WalgreensSubmitOrderMutation>;
export type WalgreensSubmitOrderMutationOptions = Apollo.BaseMutationOptions<WalgreensSubmitOrderMutation, WalgreensSubmitOrderMutationVariables>;
export const WalgreensStoresDocument = gql`
    query walgreensStores($input: WalgreensStoresInput!) {
  walgreensStores(input: $input) {
    ...WalgreensStore
  }
}
    ${WalgreensStoreFragmentDoc}`;

/**
 * __useWalgreensStoresQuery__
 *
 * To run a query within a React component, call `useWalgreensStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalgreensStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalgreensStoresQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWalgreensStoresQuery(baseOptions: Apollo.QueryHookOptions<WalgreensStoresQuery, WalgreensStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalgreensStoresQuery, WalgreensStoresQueryVariables>(WalgreensStoresDocument, options);
      }
export function useWalgreensStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalgreensStoresQuery, WalgreensStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalgreensStoresQuery, WalgreensStoresQueryVariables>(WalgreensStoresDocument, options);
        }
export type WalgreensStoresQueryHookResult = ReturnType<typeof useWalgreensStoresQuery>;
export type WalgreensStoresLazyQueryHookResult = ReturnType<typeof useWalgreensStoresLazyQuery>;
export type WalgreensStoresQueryResult = Apollo.QueryResult<WalgreensStoresQuery, WalgreensStoresQueryVariables>;
export const CreateRectangularPrintsDocument = gql`
    mutation createRectangularPrints($input: CreateRectangularPrintsRequest) {
  createRectangularPrints(input: $input) {
    prints {
      key
      url
    }
  }
}
    `;
export type CreateRectangularPrintsMutationFn = Apollo.MutationFunction<CreateRectangularPrintsMutation, CreateRectangularPrintsMutationVariables>;

/**
 * __useCreateRectangularPrintsMutation__
 *
 * To run a mutation, you first call `useCreateRectangularPrintsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRectangularPrintsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRectangularPrintsMutation, { data, loading, error }] = useCreateRectangularPrintsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRectangularPrintsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRectangularPrintsMutation, CreateRectangularPrintsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRectangularPrintsMutation, CreateRectangularPrintsMutationVariables>(CreateRectangularPrintsDocument, options);
      }
export type CreateRectangularPrintsMutationHookResult = ReturnType<typeof useCreateRectangularPrintsMutation>;
export type CreateRectangularPrintsMutationResult = Apollo.MutationResult<CreateRectangularPrintsMutation>;
export type CreateRectangularPrintsMutationOptions = Apollo.BaseMutationOptions<CreateRectangularPrintsMutation, CreateRectangularPrintsMutationVariables>;
export const StorefrontGetProductByHandleDocument = gql`
    query storefrontGetProductByHandle($handle: String!) {
  product: storefrontProductByHandle(handle: $handle) {
    ...StorefrontProductPageProduct
  }
  stickerTokenProduct: storefrontProduct(handle: "sticker-tokens") {
    ...StickerTokenProduct
  }
}
    ${StorefrontProductPageProductFragmentDoc}
${StickerTokenProductFragmentDoc}`;

/**
 * __useStorefrontGetProductByHandleQuery__
 *
 * To run a query within a React component, call `useStorefrontGetProductByHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontGetProductByHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontGetProductByHandleQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useStorefrontGetProductByHandleQuery(baseOptions: Apollo.QueryHookOptions<StorefrontGetProductByHandleQuery, StorefrontGetProductByHandleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorefrontGetProductByHandleQuery, StorefrontGetProductByHandleQueryVariables>(StorefrontGetProductByHandleDocument, options);
      }
export function useStorefrontGetProductByHandleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorefrontGetProductByHandleQuery, StorefrontGetProductByHandleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorefrontGetProductByHandleQuery, StorefrontGetProductByHandleQueryVariables>(StorefrontGetProductByHandleDocument, options);
        }
export type StorefrontGetProductByHandleQueryHookResult = ReturnType<typeof useStorefrontGetProductByHandleQuery>;
export type StorefrontGetProductByHandleLazyQueryHookResult = ReturnType<typeof useStorefrontGetProductByHandleLazyQuery>;
export type StorefrontGetProductByHandleQueryResult = Apollo.QueryResult<StorefrontGetProductByHandleQuery, StorefrontGetProductByHandleQueryVariables>;
export const StickerTokensModalDocument = gql`
    query stickerTokensModal($designId: String!, $scale: Float!, $outputType: ProjectOutputType!) {
  design: mapmakerDesign(id: $designId) {
    id
    name
    regionType
    regionTypePlural
    stickerInfo(scale: $scale, outputType: $outputType) {
      count
      tokens
      sizeClassGroups {
        count
        tokens
        sizeClass
      }
    }
  }
  stickerTokenProduct: storefrontProduct(handle: "sticker-tokens") {
    ...StickerTokenProduct
  }
}
    ${StickerTokenProductFragmentDoc}`;

/**
 * __useStickerTokensModalQuery__
 *
 * To run a query within a React component, call `useStickerTokensModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStickerTokensModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStickerTokensModalQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *      scale: // value for 'scale'
 *      outputType: // value for 'outputType'
 *   },
 * });
 */
export function useStickerTokensModalQuery(baseOptions: Apollo.QueryHookOptions<StickerTokensModalQuery, StickerTokensModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StickerTokensModalQuery, StickerTokensModalQueryVariables>(StickerTokensModalDocument, options);
      }
export function useStickerTokensModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StickerTokensModalQuery, StickerTokensModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StickerTokensModalQuery, StickerTokensModalQueryVariables>(StickerTokensModalDocument, options);
        }
export type StickerTokensModalQueryHookResult = ReturnType<typeof useStickerTokensModalQuery>;
export type StickerTokensModalLazyQueryHookResult = ReturnType<typeof useStickerTokensModalLazyQuery>;
export type StickerTokensModalQueryResult = Apollo.QueryResult<StickerTokensModalQuery, StickerTokensModalQueryVariables>;
export const AddMapmakerFileAccessDocument = gql`
    mutation addMapmakerFileAccess($input: AddMapmakerFileAccessInput!) {
  addMapmakerFileAccess(input: $input) {
    fileAccess {
      ...MapmakerFileAccess
    }
  }
}
    ${MapmakerFileAccessFragmentDoc}`;
export type AddMapmakerFileAccessMutationFn = Apollo.MutationFunction<AddMapmakerFileAccessMutation, AddMapmakerFileAccessMutationVariables>;

/**
 * __useAddMapmakerFileAccessMutation__
 *
 * To run a mutation, you first call `useAddMapmakerFileAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMapmakerFileAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMapmakerFileAccessMutation, { data, loading, error }] = useAddMapmakerFileAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMapmakerFileAccessMutation(baseOptions?: Apollo.MutationHookOptions<AddMapmakerFileAccessMutation, AddMapmakerFileAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMapmakerFileAccessMutation, AddMapmakerFileAccessMutationVariables>(AddMapmakerFileAccessDocument, options);
      }
export type AddMapmakerFileAccessMutationHookResult = ReturnType<typeof useAddMapmakerFileAccessMutation>;
export type AddMapmakerFileAccessMutationResult = Apollo.MutationResult<AddMapmakerFileAccessMutation>;
export type AddMapmakerFileAccessMutationOptions = Apollo.BaseMutationOptions<AddMapmakerFileAccessMutation, AddMapmakerFileAccessMutationVariables>;
export const DeleteMapmakerFileAccessDocument = gql`
    mutation deleteMapmakerFileAccess($input: DeleteMapmakerFileAccessInput!) {
  deleteMapmakerFileAccess(input: $input) {
    success
  }
}
    `;
export type DeleteMapmakerFileAccessMutationFn = Apollo.MutationFunction<DeleteMapmakerFileAccessMutation, DeleteMapmakerFileAccessMutationVariables>;

/**
 * __useDeleteMapmakerFileAccessMutation__
 *
 * To run a mutation, you first call `useDeleteMapmakerFileAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMapmakerFileAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMapmakerFileAccessMutation, { data, loading, error }] = useDeleteMapmakerFileAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMapmakerFileAccessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMapmakerFileAccessMutation, DeleteMapmakerFileAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMapmakerFileAccessMutation, DeleteMapmakerFileAccessMutationVariables>(DeleteMapmakerFileAccessDocument, options);
      }
export type DeleteMapmakerFileAccessMutationHookResult = ReturnType<typeof useDeleteMapmakerFileAccessMutation>;
export type DeleteMapmakerFileAccessMutationResult = Apollo.MutationResult<DeleteMapmakerFileAccessMutation>;
export type DeleteMapmakerFileAccessMutationOptions = Apollo.BaseMutationOptions<DeleteMapmakerFileAccessMutation, DeleteMapmakerFileAccessMutationVariables>;
export const DeleteOpeningSuggestionDocument = gql`
    mutation deleteOpeningSuggestion($input: DeleteOpeningSuggestionInput!) {
  deleteOpeningSuggestion(input: $input) {
    success
  }
}
    `;
export type DeleteOpeningSuggestionMutationFn = Apollo.MutationFunction<DeleteOpeningSuggestionMutation, DeleteOpeningSuggestionMutationVariables>;

/**
 * __useDeleteOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useDeleteOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpeningSuggestionMutation, { data, loading, error }] = useDeleteOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOpeningSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpeningSuggestionMutation, DeleteOpeningSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpeningSuggestionMutation, DeleteOpeningSuggestionMutationVariables>(DeleteOpeningSuggestionDocument, options);
      }
export type DeleteOpeningSuggestionMutationHookResult = ReturnType<typeof useDeleteOpeningSuggestionMutation>;
export type DeleteOpeningSuggestionMutationResult = Apollo.MutationResult<DeleteOpeningSuggestionMutation>;
export type DeleteOpeningSuggestionMutationOptions = Apollo.BaseMutationOptions<DeleteOpeningSuggestionMutation, DeleteOpeningSuggestionMutationVariables>;
export const HideOpeningSuggestionDocument = gql`
    mutation hideOpeningSuggestion($input: HideOpeningSuggestionInput!) {
  hideOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${OpeningSuggestionFragmentDoc}`;
export type HideOpeningSuggestionMutationFn = Apollo.MutationFunction<HideOpeningSuggestionMutation, HideOpeningSuggestionMutationVariables>;

/**
 * __useHideOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useHideOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideOpeningSuggestionMutation, { data, loading, error }] = useHideOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHideOpeningSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<HideOpeningSuggestionMutation, HideOpeningSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideOpeningSuggestionMutation, HideOpeningSuggestionMutationVariables>(HideOpeningSuggestionDocument, options);
      }
export type HideOpeningSuggestionMutationHookResult = ReturnType<typeof useHideOpeningSuggestionMutation>;
export type HideOpeningSuggestionMutationResult = Apollo.MutationResult<HideOpeningSuggestionMutation>;
export type HideOpeningSuggestionMutationOptions = Apollo.BaseMutationOptions<HideOpeningSuggestionMutation, HideOpeningSuggestionMutationVariables>;
export const GetOpeningSuggestionDocument = gql`
    query getOpeningSuggestion($fileId: String!, $openingId: String!, $suggestionId: String!) {
  openingSuggestion(
    fileId: $fileId
    openingId: $openingId
    suggestionId: $suggestionId
  ) {
    ...OpeningSuggestion
  }
}
    ${OpeningSuggestionFragmentDoc}`;

/**
 * __useGetOpeningSuggestionQuery__
 *
 * To run a query within a React component, call `useGetOpeningSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpeningSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpeningSuggestionQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      openingId: // value for 'openingId'
 *      suggestionId: // value for 'suggestionId'
 *   },
 * });
 */
export function useGetOpeningSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetOpeningSuggestionQuery, GetOpeningSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpeningSuggestionQuery, GetOpeningSuggestionQueryVariables>(GetOpeningSuggestionDocument, options);
      }
export function useGetOpeningSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpeningSuggestionQuery, GetOpeningSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpeningSuggestionQuery, GetOpeningSuggestionQueryVariables>(GetOpeningSuggestionDocument, options);
        }
export type GetOpeningSuggestionQueryHookResult = ReturnType<typeof useGetOpeningSuggestionQuery>;
export type GetOpeningSuggestionLazyQueryHookResult = ReturnType<typeof useGetOpeningSuggestionLazyQuery>;
export type GetOpeningSuggestionQueryResult = Apollo.QueryResult<GetOpeningSuggestionQuery, GetOpeningSuggestionQueryVariables>;
export const CreateOpeningSuggestionDocument = gql`
    mutation createOpeningSuggestion($input: CreateOpeningSuggestionInput!) {
  createOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${OpeningSuggestionFragmentDoc}`;
export type CreateOpeningSuggestionMutationFn = Apollo.MutationFunction<CreateOpeningSuggestionMutation, CreateOpeningSuggestionMutationVariables>;

/**
 * __useCreateOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useCreateOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpeningSuggestionMutation, { data, loading, error }] = useCreateOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpeningSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpeningSuggestionMutation, CreateOpeningSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpeningSuggestionMutation, CreateOpeningSuggestionMutationVariables>(CreateOpeningSuggestionDocument, options);
      }
export type CreateOpeningSuggestionMutationHookResult = ReturnType<typeof useCreateOpeningSuggestionMutation>;
export type CreateOpeningSuggestionMutationResult = Apollo.MutationResult<CreateOpeningSuggestionMutation>;
export type CreateOpeningSuggestionMutationOptions = Apollo.BaseMutationOptions<CreateOpeningSuggestionMutation, CreateOpeningSuggestionMutationVariables>;
export const UpdateOpeningSuggestionDocument = gql`
    mutation updateOpeningSuggestion($input: UpdateOpeningSuggestionInput!) {
  updateOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${OpeningSuggestionFragmentDoc}`;
export type UpdateOpeningSuggestionMutationFn = Apollo.MutationFunction<UpdateOpeningSuggestionMutation, UpdateOpeningSuggestionMutationVariables>;

/**
 * __useUpdateOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useUpdateOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpeningSuggestionMutation, { data, loading, error }] = useUpdateOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpeningSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpeningSuggestionMutation, UpdateOpeningSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpeningSuggestionMutation, UpdateOpeningSuggestionMutationVariables>(UpdateOpeningSuggestionDocument, options);
      }
export type UpdateOpeningSuggestionMutationHookResult = ReturnType<typeof useUpdateOpeningSuggestionMutation>;
export type UpdateOpeningSuggestionMutationResult = Apollo.MutationResult<UpdateOpeningSuggestionMutation>;
export type UpdateOpeningSuggestionMutationOptions = Apollo.BaseMutationOptions<UpdateOpeningSuggestionMutation, UpdateOpeningSuggestionMutationVariables>;
export const SubmitOpeningSuggestionDocument = gql`
    mutation submitOpeningSuggestion($input: SubmitOpeningSuggestionInput!) {
  submitOpeningSuggestion(input: $input) {
    suggestion {
      ...OpeningSuggestion
    }
  }
}
    ${OpeningSuggestionFragmentDoc}`;
export type SubmitOpeningSuggestionMutationFn = Apollo.MutationFunction<SubmitOpeningSuggestionMutation, SubmitOpeningSuggestionMutationVariables>;

/**
 * __useSubmitOpeningSuggestionMutation__
 *
 * To run a mutation, you first call `useSubmitOpeningSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOpeningSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOpeningSuggestionMutation, { data, loading, error }] = useSubmitOpeningSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOpeningSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOpeningSuggestionMutation, SubmitOpeningSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOpeningSuggestionMutation, SubmitOpeningSuggestionMutationVariables>(SubmitOpeningSuggestionDocument, options);
      }
export type SubmitOpeningSuggestionMutationHookResult = ReturnType<typeof useSubmitOpeningSuggestionMutation>;
export type SubmitOpeningSuggestionMutationResult = Apollo.MutationResult<SubmitOpeningSuggestionMutation>;
export type SubmitOpeningSuggestionMutationOptions = Apollo.BaseMutationOptions<SubmitOpeningSuggestionMutation, SubmitOpeningSuggestionMutationVariables>;
export const GetStickerOrdersForSandboxDocument = gql`
    query getStickerOrdersForSandbox($ids: [String!]!) {
  stickerOrders(ids: $ids) {
    ...StickerOrderForSandbox
  }
}
    ${StickerOrderForSandboxFragmentDoc}`;

/**
 * __useGetStickerOrdersForSandboxQuery__
 *
 * To run a query within a React component, call `useGetStickerOrdersForSandboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStickerOrdersForSandboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStickerOrdersForSandboxQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetStickerOrdersForSandboxQuery(baseOptions: Apollo.QueryHookOptions<GetStickerOrdersForSandboxQuery, GetStickerOrdersForSandboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStickerOrdersForSandboxQuery, GetStickerOrdersForSandboxQueryVariables>(GetStickerOrdersForSandboxDocument, options);
      }
export function useGetStickerOrdersForSandboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStickerOrdersForSandboxQuery, GetStickerOrdersForSandboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStickerOrdersForSandboxQuery, GetStickerOrdersForSandboxQueryVariables>(GetStickerOrdersForSandboxDocument, options);
        }
export type GetStickerOrdersForSandboxQueryHookResult = ReturnType<typeof useGetStickerOrdersForSandboxQuery>;
export type GetStickerOrdersForSandboxLazyQueryHookResult = ReturnType<typeof useGetStickerOrdersForSandboxLazyQuery>;
export type GetStickerOrdersForSandboxQueryResult = Apollo.QueryResult<GetStickerOrdersForSandboxQuery, GetStickerOrdersForSandboxQueryVariables>;
export const RenderDocument = gql`
    mutation render($request: RenderRequest!) {
  render(request: $request) {
    url
  }
}
    `;
export type RenderMutationFn = Apollo.MutationFunction<RenderMutation, RenderMutationVariables>;

/**
 * __useRenderMutation__
 *
 * To run a mutation, you first call `useRenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderMutation, { data, loading, error }] = useRenderMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useRenderMutation(baseOptions?: Apollo.MutationHookOptions<RenderMutation, RenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenderMutation, RenderMutationVariables>(RenderDocument, options);
      }
export type RenderMutationHookResult = ReturnType<typeof useRenderMutation>;
export type RenderMutationResult = Apollo.MutationResult<RenderMutation>;
export type RenderMutationOptions = Apollo.BaseMutationOptions<RenderMutation, RenderMutationVariables>;
export const GetRenderableDesignDocument = gql`
    query getRenderableDesign($designId: String!) {
  design: mapmakerDesign(id: $designId) {
    ...RenderableDesign
  }
}
    ${RenderableDesignFragmentDoc}`;

/**
 * __useGetRenderableDesignQuery__
 *
 * To run a query within a React component, call `useGetRenderableDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderableDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderableDesignQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useGetRenderableDesignQuery(baseOptions: Apollo.QueryHookOptions<GetRenderableDesignQuery, GetRenderableDesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderableDesignQuery, GetRenderableDesignQueryVariables>(GetRenderableDesignDocument, options);
      }
export function useGetRenderableDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderableDesignQuery, GetRenderableDesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderableDesignQuery, GetRenderableDesignQueryVariables>(GetRenderableDesignDocument, options);
        }
export type GetRenderableDesignQueryHookResult = ReturnType<typeof useGetRenderableDesignQuery>;
export type GetRenderableDesignLazyQueryHookResult = ReturnType<typeof useGetRenderableDesignLazyQuery>;
export type GetRenderableDesignQueryResult = Apollo.QueryResult<GetRenderableDesignQuery, GetRenderableDesignQueryVariables>;
export const GetRenderableFileDocument = gql`
    query getRenderableFile($fileId: String!) {
  file: mapmakerFile(id: $fileId) {
    ...RenderableFile
  }
}
    ${RenderableFileFragmentDoc}`;

/**
 * __useGetRenderableFileQuery__
 *
 * To run a query within a React component, call `useGetRenderableFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderableFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderableFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetRenderableFileQuery(baseOptions: Apollo.QueryHookOptions<GetRenderableFileQuery, GetRenderableFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderableFileQuery, GetRenderableFileQueryVariables>(GetRenderableFileDocument, options);
      }
export function useGetRenderableFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderableFileQuery, GetRenderableFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderableFileQuery, GetRenderableFileQueryVariables>(GetRenderableFileDocument, options);
        }
export type GetRenderableFileQueryHookResult = ReturnType<typeof useGetRenderableFileQuery>;
export type GetRenderableFileLazyQueryHookResult = ReturnType<typeof useGetRenderableFileLazyQuery>;
export type GetRenderableFileQueryResult = Apollo.QueryResult<GetRenderableFileQuery, GetRenderableFileQueryVariables>;
export const GetRenderableOpeningSuggestionDocument = gql`
    query getRenderableOpeningSuggestion($fileId: String!, $openingId: String!, $suggestionId: String!) {
  suggestion: openingSuggestion(
    fileId: $fileId
    openingId: $openingId
    suggestionId: $suggestionId
  ) {
    ...RenderableOpeningSuggestion
  }
}
    ${RenderableOpeningSuggestionFragmentDoc}`;

/**
 * __useGetRenderableOpeningSuggestionQuery__
 *
 * To run a query within a React component, call `useGetRenderableOpeningSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderableOpeningSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderableOpeningSuggestionQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      openingId: // value for 'openingId'
 *      suggestionId: // value for 'suggestionId'
 *   },
 * });
 */
export function useGetRenderableOpeningSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetRenderableOpeningSuggestionQuery, GetRenderableOpeningSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderableOpeningSuggestionQuery, GetRenderableOpeningSuggestionQueryVariables>(GetRenderableOpeningSuggestionDocument, options);
      }
export function useGetRenderableOpeningSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderableOpeningSuggestionQuery, GetRenderableOpeningSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderableOpeningSuggestionQuery, GetRenderableOpeningSuggestionQueryVariables>(GetRenderableOpeningSuggestionDocument, options);
        }
export type GetRenderableOpeningSuggestionQueryHookResult = ReturnType<typeof useGetRenderableOpeningSuggestionQuery>;
export type GetRenderableOpeningSuggestionLazyQueryHookResult = ReturnType<typeof useGetRenderableOpeningSuggestionLazyQuery>;
export type GetRenderableOpeningSuggestionQueryResult = Apollo.QueryResult<GetRenderableOpeningSuggestionQuery, GetRenderableOpeningSuggestionQueryVariables>;
export const RenderableFileListDocument = gql`
    query renderableFileList {
  mapmakerFiles {
    ...MapmakerFileLite
  }
}
    ${MapmakerFileLiteFragmentDoc}`;

/**
 * __useRenderableFileListQuery__
 *
 * To run a query within a React component, call `useRenderableFileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderableFileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderableFileListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRenderableFileListQuery(baseOptions?: Apollo.QueryHookOptions<RenderableFileListQuery, RenderableFileListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderableFileListQuery, RenderableFileListQueryVariables>(RenderableFileListDocument, options);
      }
export function useRenderableFileListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderableFileListQuery, RenderableFileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderableFileListQuery, RenderableFileListQueryVariables>(RenderableFileListDocument, options);
        }
export type RenderableFileListQueryHookResult = ReturnType<typeof useRenderableFileListQuery>;
export type RenderableFileListLazyQueryHookResult = ReturnType<typeof useRenderableFileListLazyQuery>;
export type RenderableFileListQueryResult = Apollo.QueryResult<RenderableFileListQuery, RenderableFileListQueryVariables>;
export const RenderableFileHeavyDocument = gql`
    query renderableFileHeavy($fileId: String!) {
  mapmakerFile(id: $fileId) {
    ...MapmakerFileHeavy
  }
}
    ${MapmakerFileHeavyFragmentDoc}`;

/**
 * __useRenderableFileHeavyQuery__
 *
 * To run a query within a React component, call `useRenderableFileHeavyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderableFileHeavyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderableFileHeavyQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRenderableFileHeavyQuery(baseOptions: Apollo.QueryHookOptions<RenderableFileHeavyQuery, RenderableFileHeavyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderableFileHeavyQuery, RenderableFileHeavyQueryVariables>(RenderableFileHeavyDocument, options);
      }
export function useRenderableFileHeavyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderableFileHeavyQuery, RenderableFileHeavyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderableFileHeavyQuery, RenderableFileHeavyQueryVariables>(RenderableFileHeavyDocument, options);
        }
export type RenderableFileHeavyQueryHookResult = ReturnType<typeof useRenderableFileHeavyQuery>;
export type RenderableFileHeavyLazyQueryHookResult = ReturnType<typeof useRenderableFileHeavyLazyQuery>;
export type RenderableFileHeavyQueryResult = Apollo.QueryResult<RenderableFileHeavyQuery, RenderableFileHeavyQueryVariables>;
export const RedeemStickerTokenVoucherDocument = gql`
    mutation redeemStickerTokenVoucher($input: RedeemStickerTokenVoucherRequest!) {
  redeemStickerTokenVoucher(input: $input) {
    transaction {
      tokens
    }
    account {
      id
      ... on MapmakerAuthenticatedAccount {
        stickerTokenBalance
      }
    }
  }
}
    `;
export type RedeemStickerTokenVoucherMutationFn = Apollo.MutationFunction<RedeemStickerTokenVoucherMutation, RedeemStickerTokenVoucherMutationVariables>;

/**
 * __useRedeemStickerTokenVoucherMutation__
 *
 * To run a mutation, you first call `useRedeemStickerTokenVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemStickerTokenVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemStickerTokenVoucherMutation, { data, loading, error }] = useRedeemStickerTokenVoucherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedeemStickerTokenVoucherMutation(baseOptions?: Apollo.MutationHookOptions<RedeemStickerTokenVoucherMutation, RedeemStickerTokenVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemStickerTokenVoucherMutation, RedeemStickerTokenVoucherMutationVariables>(RedeemStickerTokenVoucherDocument, options);
      }
export type RedeemStickerTokenVoucherMutationHookResult = ReturnType<typeof useRedeemStickerTokenVoucherMutation>;
export type RedeemStickerTokenVoucherMutationResult = Apollo.MutationResult<RedeemStickerTokenVoucherMutation>;
export type RedeemStickerTokenVoucherMutationOptions = Apollo.BaseMutationOptions<RedeemStickerTokenVoucherMutation, RedeemStickerTokenVoucherMutationVariables>;
export const AccountStickerTokenDataDocument = gql`
    query accountStickerTokenData {
  account {
    id
    ... on MapmakerAuthenticatedAccount {
      stickerTokenBalance
    }
  }
  stickerTokenTransactions {
    id
    createdAt
    reason
    tokens
    startingBalance
    endingBalance
    note
  }
}
    `;

/**
 * __useAccountStickerTokenDataQuery__
 *
 * To run a query within a React component, call `useAccountStickerTokenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStickerTokenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStickerTokenDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountStickerTokenDataQuery(baseOptions?: Apollo.QueryHookOptions<AccountStickerTokenDataQuery, AccountStickerTokenDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountStickerTokenDataQuery, AccountStickerTokenDataQueryVariables>(AccountStickerTokenDataDocument, options);
      }
export function useAccountStickerTokenDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountStickerTokenDataQuery, AccountStickerTokenDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountStickerTokenDataQuery, AccountStickerTokenDataQueryVariables>(AccountStickerTokenDataDocument, options);
        }
export type AccountStickerTokenDataQueryHookResult = ReturnType<typeof useAccountStickerTokenDataQuery>;
export type AccountStickerTokenDataLazyQueryHookResult = ReturnType<typeof useAccountStickerTokenDataLazyQuery>;
export type AccountStickerTokenDataQueryResult = Apollo.QueryResult<AccountStickerTokenDataQuery, AccountStickerTokenDataQueryVariables>;
export const CreatePresignedPostDocument = gql`
    mutation createPresignedPost($folder: String) {
  createPresignedPost(folder: $folder) {
    ...PresignedPost
  }
}
    ${PresignedPostFragmentDoc}`;
export type CreatePresignedPostMutationFn = Apollo.MutationFunction<CreatePresignedPostMutation, CreatePresignedPostMutationVariables>;

/**
 * __useCreatePresignedPostMutation__
 *
 * To run a mutation, you first call `useCreatePresignedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePresignedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPresignedPostMutation, { data, loading, error }] = useCreatePresignedPostMutation({
 *   variables: {
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useCreatePresignedPostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePresignedPostMutation, CreatePresignedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePresignedPostMutation, CreatePresignedPostMutationVariables>(CreatePresignedPostDocument, options);
      }
export type CreatePresignedPostMutationHookResult = ReturnType<typeof useCreatePresignedPostMutation>;
export type CreatePresignedPostMutationResult = Apollo.MutationResult<CreatePresignedPostMutation>;
export type CreatePresignedPostMutationOptions = Apollo.BaseMutationOptions<CreatePresignedPostMutation, CreatePresignedPostMutationVariables>;
export const StorefrontReplaceCheckoutLineItemsDocument = gql`
    mutation storefrontReplaceCheckoutLineItems($checkoutId: ID!, $lineItems: [StorefrontCheckoutLineItemInput!]!) {
  storefrontCheckoutLineItemsReplace(
    checkoutId: $checkoutId
    lineItems: $lineItems
  ) {
    checkout {
      ...StorefrontCheckoutHeavy
    }
  }
}
    ${StorefrontCheckoutHeavyFragmentDoc}`;
export type StorefrontReplaceCheckoutLineItemsMutationFn = Apollo.MutationFunction<StorefrontReplaceCheckoutLineItemsMutation, StorefrontReplaceCheckoutLineItemsMutationVariables>;

/**
 * __useStorefrontReplaceCheckoutLineItemsMutation__
 *
 * To run a mutation, you first call `useStorefrontReplaceCheckoutLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStorefrontReplaceCheckoutLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storefrontReplaceCheckoutLineItemsMutation, { data, loading, error }] = useStorefrontReplaceCheckoutLineItemsMutation({
 *   variables: {
 *      checkoutId: // value for 'checkoutId'
 *      lineItems: // value for 'lineItems'
 *   },
 * });
 */
export function useStorefrontReplaceCheckoutLineItemsMutation(baseOptions?: Apollo.MutationHookOptions<StorefrontReplaceCheckoutLineItemsMutation, StorefrontReplaceCheckoutLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StorefrontReplaceCheckoutLineItemsMutation, StorefrontReplaceCheckoutLineItemsMutationVariables>(StorefrontReplaceCheckoutLineItemsDocument, options);
      }
export type StorefrontReplaceCheckoutLineItemsMutationHookResult = ReturnType<typeof useStorefrontReplaceCheckoutLineItemsMutation>;
export type StorefrontReplaceCheckoutLineItemsMutationResult = Apollo.MutationResult<StorefrontReplaceCheckoutLineItemsMutation>;
export type StorefrontReplaceCheckoutLineItemsMutationOptions = Apollo.BaseMutationOptions<StorefrontReplaceCheckoutLineItemsMutation, StorefrontReplaceCheckoutLineItemsMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AsideOrBlockOrContentImageOrScreenshotOrYoutube": [
      "Aside",
      "Block",
      "ContentImage",
      "Screenshot",
      "Youtube"
    ],
    "BlockOrContentImageOrYoutube": [
      "Block",
      "ContentImage",
      "Youtube"
    ],
    "Document": [
      "Author",
      "Navigation",
      "Page",
      "Post",
      "SanityFileAsset",
      "SanityImageAsset"
    ],
    "MapmakerAccount": [
      "MapmakerAuthenticatedAccount",
      "MapmakerUnauthenticatedAccount"
    ],
    "OrderItem": [
      "BasicLineItem",
      "MapLineItem",
      "StickerLineItem",
      "StickerTokenLineItem"
    ],
    "StorefrontBaseCartLine": [
      "StorefrontCartLine",
      "StorefrontComponentizableCartLine"
    ],
    "StorefrontCartCompletionAction": [
      "StorefrontCompletePaymentChallenge"
    ],
    "StorefrontCartCompletionAttemptResult": [
      "StorefrontCartCompletionActionRequired",
      "StorefrontCartCompletionFailed",
      "StorefrontCartCompletionProcessing",
      "StorefrontCartCompletionSuccess"
    ],
    "StorefrontCartDiscountAllocation": [
      "StorefrontCartAutomaticDiscountAllocation",
      "StorefrontCartCodeDiscountAllocation",
      "StorefrontCartCustomDiscountAllocation"
    ],
    "StorefrontCartSubmitForCompletionResult": [
      "StorefrontSubmitAlreadyAccepted",
      "StorefrontSubmitFailed",
      "StorefrontSubmitSuccess",
      "StorefrontSubmitThrottled"
    ],
    "StorefrontDeliveryAddress": [
      "StorefrontMailingAddress"
    ],
    "StorefrontDiscountApplication": [
      "StorefrontAutomaticDiscountApplication",
      "StorefrontDiscountCodeApplication",
      "StorefrontManualDiscountApplication",
      "StorefrontScriptDiscountApplication"
    ],
    "StorefrontDisplayableError": [
      "StorefrontCartUserError",
      "StorefrontCheckoutUserError",
      "StorefrontCustomerUserError",
      "StorefrontMetafieldDeleteUserError",
      "StorefrontMetafieldsSetUserError",
      "StorefrontUserError"
    ],
    "StorefrontHasMetafields": [
      "StorefrontArticle",
      "StorefrontBlog",
      "StorefrontCart",
      "StorefrontCollection",
      "StorefrontCustomer",
      "StorefrontLocation",
      "StorefrontMarket",
      "StorefrontOrder",
      "StorefrontPage",
      "StorefrontProduct",
      "StorefrontProductVariant",
      "StorefrontShop"
    ],
    "StorefrontMedia": [
      "StorefrontExternalVideo",
      "StorefrontMediaImage",
      "StorefrontModel3d",
      "StorefrontVideo"
    ],
    "StorefrontMenuItemResource": [
      "StorefrontArticle",
      "StorefrontBlog",
      "StorefrontCollection",
      "StorefrontPage",
      "StorefrontProduct",
      "StorefrontShopPolicy"
    ],
    "StorefrontMerchandise": [
      "StorefrontProductVariant"
    ],
    "StorefrontMetafieldParentResource": [
      "StorefrontArticle",
      "StorefrontBlog",
      "StorefrontCart",
      "StorefrontCollection",
      "StorefrontCustomer",
      "StorefrontLocation",
      "StorefrontMarket",
      "StorefrontOrder",
      "StorefrontPage",
      "StorefrontProduct",
      "StorefrontProductVariant",
      "StorefrontShop"
    ],
    "StorefrontMetafieldReference": [
      "StorefrontCollection",
      "StorefrontGenericFile",
      "StorefrontMediaImage",
      "StorefrontMetaobject",
      "StorefrontPage",
      "StorefrontProduct",
      "StorefrontProductVariant",
      "StorefrontVideo"
    ],
    "StorefrontNode": [
      "StorefrontAppliedGiftCard",
      "StorefrontArticle",
      "StorefrontBlog",
      "StorefrontCart",
      "StorefrontCartLine",
      "StorefrontCheckout",
      "StorefrontCheckoutLineItem",
      "StorefrontCollection",
      "StorefrontComment",
      "StorefrontComponentizableCartLine",
      "StorefrontExternalVideo",
      "StorefrontGenericFile",
      "StorefrontLocation",
      "StorefrontMailingAddress",
      "StorefrontMarket",
      "StorefrontMediaImage",
      "StorefrontMediaPresentation",
      "StorefrontMenu",
      "StorefrontMenuItem",
      "StorefrontMetafield",
      "StorefrontMetaobject",
      "StorefrontModel3d",
      "StorefrontOrder",
      "StorefrontPage",
      "StorefrontPayment",
      "StorefrontProduct",
      "StorefrontProductOption",
      "StorefrontProductVariant",
      "StorefrontShop",
      "StorefrontShopPolicy",
      "StorefrontUrlRedirect",
      "StorefrontVideo"
    ],
    "StorefrontOnlineStorePublishable": [
      "StorefrontArticle",
      "StorefrontBlog",
      "StorefrontCollection",
      "StorefrontPage",
      "StorefrontProduct"
    ],
    "StorefrontPricingValue": [
      "StorefrontMoneyV2",
      "StorefrontPricingPercentageValue"
    ],
    "StorefrontSearchResultItem": [
      "StorefrontArticle",
      "StorefrontPage",
      "StorefrontProduct"
    ],
    "StorefrontSellingPlanCheckoutChargeValue": [
      "StorefrontMoneyV2",
      "StorefrontSellingPlanCheckoutChargePercentageValue"
    ],
    "StorefrontSellingPlanPriceAdjustmentValue": [
      "StorefrontSellingPlanFixedAmountPriceAdjustment",
      "StorefrontSellingPlanFixedPriceAdjustment",
      "StorefrontSellingPlanPercentagePriceAdjustment"
    ],
    "StorefrontTrackable": [
      "StorefrontArticle",
      "StorefrontCollection",
      "StorefrontPage",
      "StorefrontProduct",
      "StorefrontSearchQuerySuggestion"
    ]
  }
};
      export default result;
    